import { customerMessages } from './customer'
import { offlineMessages } from './offline'
import { homeExtraMessages } from './home-extra'
import { apiErrorMessages } from './api-errors'
import { repairMessages } from './repairs'
import { activityHistoryMessages } from './activity-history'
import { liveMessages } from './live'
import { consoleMessages } from './console'
import { pricingMessages } from './pricing'
import { journeyMessages } from './journey'
import { journeyFieldMessages } from './journey-field'
import { toDarija } from './darija-terms'
import { applyShortLabels } from './short-labels'

const baseMessages = {
  fr: {
    common: {
      back: 'Retour',
      copied: 'Copié.',
      steps: 'Étapes',
      completed: 'terminé',
      language: 'Langue',
      french: 'Français',
      english: 'Anglais',
      arabic: 'Arabe',
      moroccan: 'Darija marocaine',
      profile: 'Profil',
      logout: 'Se déconnecter',
      accountActions: 'Mon compte',
      healthySync: 'Tout est envoyé',
      admin: 'Admin',
      agent: 'Agent',
      courier: 'Livreur',
      partner: 'Partenaire',
      partners: 'Partenaires',
      agents: 'Agents',
      relay: 'Point',
      platform: 'Plateforme',
      account: 'Compte',
      fieldManager: 'Manager terrain',
      workflow: 'Workflow',
      startPilot: 'Lancer un pilote',
      installApp: 'Installer l’application',
      installFromBrowser: 'Installation possible avec Chrome',
      phoneNumber: 'Numéro de téléphone',
      verificationCode: 'Code reçu',
      resend: 'Renvoyer',
      resendIn: 'Renvoyer dans {seconds} s',
      codeSentTo: 'Code envoyé au {phone}',
      pleaseWait: 'Un instant…',
      date: 'Date',
      retry: 'Réessayer',
      filtering: 'Filtré par',
      searchPackages: 'Référence, destinataire, point…',
      verifyAndContinue: 'Valider et continuer',
      sendVerificationCode: 'Recevoir un code',
      continue: 'Continuer',
      previous: 'Précédent',
      next: 'Suivant',
      loadMore: 'Voir plus',
      loadingMore: 'Chargement…',
      pageOf: 'Page {current} / {last}',
      pageOfTotal: 'Page {current} / {last} · {total} colis',
      filter: 'Filtrer',
      reset: 'Tout effacer',
      all: 'Tout',
      allStates: 'Toutes les étapes',
      today: 'Aujourd’hui',
      thisWeek: 'Cette semaine',
      thisMonth: 'Ce mois',
      city: 'Ville',
      notProvided: 'Non renseigné',
      showFullText: 'Afficher l’adresse complète',
      showLess: 'Réduire',
      required: 'Obligatoire',
      selectedFile: 'Fichier choisi',
      selectedPdf: 'Document PDF choisi',
      addFile: 'Ajouter un fichier',
      replace: 'Remplacer',
      choose: 'Choisir',
      chooseFile: 'Choisir un fichier',
      edit: 'Modifier',
    save: 'Enregistrer',
    saved: 'Enregistré',
    saving: 'Enregistrement…',
      refresh: 'Actualiser',
      confirm: 'Confirmer',
      confirmAction: 'Confirmer',
      cancel: 'Annuler',
      close: 'Fermer',
      suspend: 'Suspendre',
      reactivate: 'Réactiver',
      approve: 'Accepter',
      reject: 'Refuser',
      action: 'Action',
      actions: 'Actions',
      type: 'Type',
      amount: 'Montant',
      reason: 'Raison',
      status: 'Statut',
      viewDetail: 'Voir détail',
      loadingImpossible: 'Chargement impossible',
      openMenu: 'Ouvrir le menu',
      workspaceShell: 'Espace de travail',
      search: 'Rechercher...',
      user: 'Utilisateur',
      identifier: 'Identifiant',
      email: 'Email',
      loading: 'Chargement',
      logisticsControl: 'Contrôle logistique',
      navigation: 'Navigation',
      offlineMode: 'Mode hors ligne: les actions terrain seront mises en attente.',
      rowsRange: '{first}-{last} sur {total}',
      rowsReceived: '{count} reçu(s)',
      copiedWithLabel: '{label} copié.',
      copy: 'Copier',
      reasonCodes: {
        policyViolation: 'Violation de politique',
        fraudSuspected: 'Fraude suspectée',
        inactivity: 'Inactivité',
        escrowInsufficient: 'Escrow insuffisant',
        other: 'Autre'
      },
      cod: 'COD',
      kyc: 'KYC',
      ok: 'OK',
      mad: 'MAD',
      platformName: '3asass',
      agentPrefix: 'Agent :',
      partnerPrefix: 'Partenaire :',
      packageId: 'Identifiant du colis',
      deliveryId: 'Identifiant de livraison',
      residenceIdPrefix: 'résidence:'
    },
    packageType: {
      normal: 'Standard',
      untracked: 'Sans suivi',
      pickup: 'Dépôt client'
    },
    sampleDashboard: {
      title: 'Tableau de bord',
      description: 'Shell applicatif générique avec états de chargement réutilisables.',
      foundation: 'Fondation',
      skeletons: 'Squelettes',
      emptyState: 'État vide',
      placeholderTitle: 'Contenu temporaire',
      placeholderDescription: 'Cette page évite volontairement les modules métier.'
    },
    sampleSettings: {
      title: 'Paramètres',
      description: 'Contrôles génériques pour vérifier les composants partagés.',
      interface: 'Interface',
      interfaceDescription: 'Champs neutres pour vérifier les composants.',
      textInput: 'Champ texte',
      textarea: 'Zone de texte',
      selectOption: 'Sélectionner une option',
      default: 'Défaut',
      compact: 'Compact',
      enableOption: 'Activer l’option générique',
      application: 'Application',
      applicationDescription: 'Exemples PWA et notifications.',
      notificationExample: 'Exemple de notification',
      showToast: 'Afficher toast',
      offlinePage: 'Page hors ligne'
    },
    contact: {
      backHome: 'Retour à l’accueil',
      label: 'Lancer un pilote',
      title: 'Cadrez un pilote 3asass sur une zone réelle.',
      description: 'Le pilote doit montrer une chose simple : moins de portes à visiter, moins d’échecs, plus de preuves et un paiement à la livraison plus facile à vérifier.',
      cityZone: 'Ville ou zone pilote',
      cityZoneValue: 'Marrakech, Casablanca, Rabat...',
      packageVolume: 'Volume colis estimé',
      packageVolumeValue: 'Colis par jour ou par semaine',
      residenceNetwork: 'Réseau de points',
      residenceNetworkValue: 'Nombre de bâtiments ou gardiens',
      currentOperation: 'Opération actuelle',
      currentOperationValue: 'Échecs, paiements à la livraison, retours, preuves',
      formTitle: 'Demande pilote',
      formDescription: 'Ce formulaire n’est pas encore relié. L’envoi est désactivé pour le moment.',
      company: 'Société',
      companyPlaceholder: 'Nom de l’entreprise',
      contact: 'Contact',
      contactPlaceholder: 'Nom, téléphone ou email',
      pilotZone: 'Zone pilote',
      pilotZonePlaceholder: 'Ville, quartier, nombre de points',
      volumeContext: 'Volume et contexte',
      volumeContextPlaceholder: 'Exemple : 300 colis par semaine, beaucoup d’argent à encaisser, beaucoup d’échecs…',
      submitSoon: 'Envoyer la demande bientôt',
      disabledNote: 'Aucun message n’est envoyé pour l’instant.'
    },
    auth: {
      phoneInvalid: 'Entrez un numéro avec l’indicatif du pays, par exemple +212600000000.',
      fieldTitle: 'Connexion',
      fieldDescription: 'Entrez votre numéro de téléphone.',
      agentTitle: 'Connexion agent',
      agentDescription: 'Entrez le numéro enregistré pour votre point.',
      agentTestPhone: 'Agent test local : +212600000010',
      courierTitle: 'Connexion livreur',
      courierDescription: 'Entrez votre numéro de téléphone. Si vous n’avez pas de compte, il sera créé.',
      courierTestPhone: 'Livreur test local : +212600000020',
      adminTitle: 'Connexion admin',
      adminDescription: 'L’accès opérations exige un mot de passe et une vérification Authenticator.',
      workEmail: 'E-mail professionnel',
      password: 'Mot de passe',
      adminTest: 'Admin test local : admin{\'@\'}example.com / password',
      setupAuthenticator: 'Configurer Authenticator',
      setupAuthenticatorDescription: 'Ouvrez Google Authenticator ou Authy, ajoutez un compte, puis scannez ce QR code.',
      authenticatorQrAlt: 'QR code de configuration Authenticator',
      openSetupLink: 'Ouvrir le lien de configuration',
      secretKey: 'Clé secrète',
      copy: 'Copier',
      authenticatorCode: 'Code Authenticator',
      activate2fa: 'Activer 2FA et entrer',
      verify2fa: 'Vérifier le code 2FA'
    },
    maps: {
      position: 'Position',
      currentLocation: 'Votre position',
      currentLocationUnavailable: 'Impossible de trouver votre position.',
      addressNotFound: 'Adresse introuvable.',
      routeCalculating: 'Recherche de l’itinéraire…',
      routeUnavailable: 'Itinéraire indisponible.',
      basemapLabel: 'Type de carte',
      basemap_streets: 'Rues',
      basemap_light: 'Claire',
      basemap_dark: 'Sombre',
      basemap_satellite: 'Satellite',
      basemapFallback: 'La carte détaillée n’est pas disponible. Une carte simple est affichée.',
      openGoogleMaps: 'Ouvrir dans Google Maps',
      regionLabel: 'Carte',
      routeRegionLabel: 'Carte de l’itinéraire vers {place}',
      basemapHint: 'Choisissez la carte qui se lit le mieux.',
      locateMe: 'Où suis-je ?',
      expand: 'Agrandir la carte',
      collapse: 'Réduire la carte',
      zoomIn: 'Agrandir',
      zoomOut: 'Réduire',
      credits: 'Sources de la carte',
      destination: 'Destination',
      departure: 'Départ',
      navigate: 'Y aller',
      arrivalLabel: 'arrivée vers',
      kind: { agent: 'Agent', residence: 'Point', parcel: 'Colis', collection: 'Point de collecte', place: 'Lieu', return: 'Point de retour', pickupPoint: 'Point de collecte', deliveryPoint: 'Point de livraison' },
      stopNumber: 'Arrêt {number}',
      previousStop: 'Arrêt d’avant',
      nextStop: 'Arrêt suivant',
      pointsCount: '{count} points sur la carte',
      pointsListLabel: 'Points',
      selectOnMap: 'Touchez un repère pour voir les détails.',
      previousPoint: 'Point précédent',
      nextPoint: 'Point suivant'
    },
    geolocation: {
      label: 'Ma position',
      title: 'Où vous êtes',
      notCaptured: 'Position non prise',
      unavailable: 'Impossible de trouver votre position',
 insecureConnection: 'La position ne marche qu’avec une connexion sécurisée (https). Ouvrez l’application en https.',

 permissionRequired: 'Autorisez la localisation dans le navigateur, puis appuyez sur « Prendre ma position ».',
      capture: 'Prendre ma position',
      capturing: 'Recherche…'
    },
    category: {
      badge: 'Bienvenue sur 3asass',
      title: 'Que cherchez-vous ?',
      description: 'Choisissez le service dont vous avez besoin.',
      enter: 'Entrer',
      comingSoon: 'Bientôt',
      footer: '3asass — La livraison simple, près de chez vous.',
      cards: {
        logistics: {
          title: 'Logistique',
          description: 'Livraison près de chez vous : agents, livreurs et suivi en direct.'
        },
        services: {
          title: 'Services',
          description: 'Des services pour les immeubles et leurs habitants.'
        },
        marketplace: {
          title: 'Marché',
          description: 'Un espace pour acheter et vendre entre habitants et commerçants.'
        }
      }
    },
    home: {
      hero: {
        badge: 'Solution logistique innovante',
        titleBefore: 'Réduisez les',
        titleHighlight: 'échecs',
        titleAfter: ' de livraison.',
        description: 'Nous transformons les gardiens d’immeuble en points de livraison. Le livreur dépose le colis chez un gardien de confiance, le destinataire est prévenu par WhatsApp, la preuve est prise, et l’argent à encaisser reste suivi.'
      },
      tracking: {
        placeholder: 'Code du colis',
        aria: 'Code du colis',
        submit: 'Suivre mon colis'
      },
      returnRequest: {
        title: 'Demander un retour',
        description: 'Vous avez reçu un colis et vous voulez le rendre ? Envoyez-nous une demande.'
      },
      dashboard: {
        title: 'Pulse admin',
        live: 'Live',
        delivered24h: 'Livrés (24h)',
        deliveredTrend: '+12.5% vs hier',
        codSecured: 'COD sécurisé',
        reconcileToday: 'À réconcilier aujourd’hui',
        packageRef: 'Colis #3AS-2041',
        inTransit: 'En route',
        receivedGuardian: 'Reçu gardien',
        notified: 'Notifié',
        exceptionAlert: '1 exception détectée sur la zone Anfa.',
        view: 'Voir'
      },
      problem: {
        titleBefore: 'Le dernier kilomètre est',
        titleHighlight: 'brisé',
        description: 'Les livreurs n’ont pas besoin de plus d’appels. Ils ont besoin d’un point relais fiable. 3asass convertit une présence déjà disponible en point de contrôle traçable.',
        cards: {
          failures: {
            title: 'Échecs de livraison récurrents',
            desc: 'Livreurs qui attendent devant des portes fermées.'
          },
          transparency: {
            title: 'Manque de transparence',
            desc: 'Colis marqués échoués sans contexte fiable.'
          },
          cash: {
            title: 'Gestion du cash (COD)',
            desc: 'Cash collecté très difficile à contrôler et rapprocher.'
          },
          time: {
            title: 'Temps livreur perdu',
            desc: 'Retours et litiges dispersés entre appels et WhatsApp.'
          }
        }
      },
      lifecycle: {
        badge: 'Lifecycle 3asass',
        titleLine1: 'Le colis au centre',
        titleLine2: 'de l’opération.',
        description: 'À chaque étape, 3asass sait qui a le colis, dans quelle résidence il se trouve, quelle preuve existe, quel cash a été collecté et quelle commission est due.',
        cta: 'Découvrir la doc technique',
        items: {
          created: {
            state: 'CRÉÉ',
            label: 'Importé depuis le marchand'
          },
          dropped: {
            state: 'DÉPOSÉ',
            label: 'Scanné par le livreur au relais'
          },
          received: {
            state: 'REÇU',
            label: 'Confirmé par le gardien'
          },
          out: {
            state: 'EN COURS',
            label: 'Résident notifié'
          },
          delivered: {
            state: 'LIVRÉ',
            label: 'POD et commission validées'
          }
        }
      },
      surfaces: {
        titleLine1: 'Trois surfaces,',
        titleLine2: 'une seule vérité.',
        description: 'Chaque acteur dispose d’un outil optimisé pour son flux de travail, synchronisé en temps réel.',
        agent: {
          title: 'Agent PWA',
          subtitle: 'Pour le gardien',
          metric: '42 colis',
          items: {
            scan: 'Scanner le QR code',
            notify: 'Notifier le résident',
            proof: 'Capturer signature + photo',
            wallet: 'Demander retrait wallet'
          }
        },
        courier: {
          title: 'Courier PWA',
          subtitle: 'Pour le livreur',
          metric: '8 dépôts',
          items: {
            route: 'Voir les relais à visiter',
            scan: 'Scanner le lot',
            photos: 'Photographier les colis',
            close: 'Fermer la tournée'
          }
        },
        admin: {
          title: 'Portail admin',
          subtitle: 'Pour les opérations',
          metric: '3 litiges',
          items: {
            track: 'Suivre tous les colis',
            proofs: 'Voir les preuves',
            wallets: 'Régler les wallets',
            audit: 'Auditer les exceptions'
          }
        }
      },
      proof: {
        titleLine1: 'La preuve au coeur',
        titleLine2: 'de la confiance.',
        description: 'La preuve de livraison n’est pas un détail : elle protège l’opérateur, le marchand, le résident et le gardien. Même sans réseau, les actions restent enregistrées localement et synchronisées plus tard.',
        guarantee: '100% de traçabilité garantie',
        items: {
          signature: 'Signature résident',
          photo: 'Photo colis',
          gps: 'Position GPS',
          cod: 'Montant COD',
          offline: 'Sync offline',
          whatsapp: 'Message WhatsApp'
        }
      },
      portalCards: {
        title: 'Choisissez votre espace',
        description: 'Choisissez qui vous êtes pour continuer.',
        agent: {
          title: 'Agent',
          description: 'Recevez les colis, remettez-les et suivez votre argent.',
          cta: 'Installer l’application'
        },
        courier: {
          title: 'Livreur',
          description: 'Déposez les colis, récupérez les retours et suivez vos tournées.',
          cta: 'Installer l’application'
        },
        admin: {
          title: 'Administration',
          description: 'Suivez l’activité, les agents et la plateforme.',
          cta: 'Espace administration'
        },
        partner: {
          title: 'Partenaire',
          description: 'Suivez vos colis, vos factures et votre compte.',
          cta: 'Espace partenaire'
        },
        user: {
          title: 'Client',
          description: 'Envoyez un colis et suivez-le.',
          cta: 'Espace client'
        }
      }
    },
    download: {
      badge: 'Application pour téléphone',
      agentTitle: 'Installer l’application agent',
      courierTitle: 'Installer l’application livreur',
      agentDescription: 'Installez 3asass sur votre téléphone, puis connectez-vous avec votre numéro.',
      courierDescription: 'Installez 3asass sur votre téléphone pour scanner les colis, confirmer les dépôts et suivre les retours.',
      login: 'Continuer vers la connexion',
      loginTitle: 'Se connecter',
      loginDescription: 'Entrez dans votre espace avec votre numéro de téléphone.',
      installTitle: 'Installer',
      installDescription: 'Mettez l’application sur votre téléphone.',
      installFallback: 'Avec Chrome, l’installation est directe. Avec Firefox ou Safari, utilisez le menu du navigateur pour ajouter l’application à l’écran d’accueil.',
      installHelp: {
        button: 'Installer depuis ce navigateur',
        title: 'Installer 3asass',
        description: 'Si l’installation ne démarre pas toute seule, utilisez le menu du navigateur.',
        steps: {
          chromiumMenu: 'Ouvrez le menu du navigateur (les trois points, en haut ou en bas).',
          chromiumInstall: 'Touchez « Installer l’application » ou « Ajouter à l’écran d’accueil ».',
          firefoxMenu: 'Ouvrez le menu de Firefox.',
          firefoxAdd: 'Touchez « Installer » ou « Ajouter à l’écran d’accueil ».',
          safariShare: 'Sur iPhone, touchez le bouton Partager dans Safari.',
          safariAdd: 'Choisissez « Sur l’écran d’accueil », puis confirmez.'
        }
      },
      panelTitle: 'Installation rapide',
      panelDescription: 'L’application s’installe depuis Chrome, sans passer par un magasin d’applications.',
      menuDescription: 'Accès rapide aux interfaces 3asass.',
      workflowMenuDescription: 'Voir le fonctionnement du cycle colis.',
      agentMenuDescription: 'Installer et ouvrir l’espace agent.',
      courierMenuDescription: 'Installer et ouvrir l’espace livreur.',
      partnerMenuDescription: 'Se connecter au portail expéditeur.',
      contactMenuDescription: 'Contacter l’équipe pour lancer un pilote.',
      adminMenuDescription: 'Accès réservé aux opérations.',
      steps: {
        open: 'Ouvrez cette page dans Chrome sur votre téléphone.',
        install: 'Touchez « Installer l’application » ou « Ajouter à l’écran d’accueil ».',
        login: 'Ouvrez l’icône 3asass et connectez-vous avec votre numéro.'
      },
      cards: {
        installTitle: 'Une icône sur votre téléphone',
        installText: '3asass s’ouvre comme une vraie application.',
        offlineTitle: 'Sans connexion',
        offlineText: 'Sans réseau, vos actions sont gardées puis envoyées dès que la connexion revient.',
        secureTitle: 'Connexion sûre',
        secureText: 'Vous entrez avec un code envoyé sur votre téléphone. Vos données sont protégées.'
      }
    },
    state: {
      created: 'Créé',
      en_route: 'En route',
      dropped: 'Déposé',
      received: 'Reçu',
      out_for_delivery: 'En livraison',
      delivered: 'Livré',
      returned: 'Rendu à l’expéditeur',
      returnedHint: 'Le colis a été rendu à l’expéditeur.',
      failed: 'Échec',
      return_requested: 'Retour demandé',
      return_deposited: 'Retour déposé',
      return_collected: 'Retour récupéré',
      disputed: 'En litige',
      cancelled: 'Annulé',
      awaiting_pickup: 'À déposer',
      pickup_ready: 'Prêt à récupérer'
    },
    dashboard: {
      agentLabel: 'Agent',
      agentTitle: 'Colis à traiter',
      agentDescription: 'Réception, livraison, problèmes et argent depuis votre point.',
      courierLabel: 'Livreur',
      courierTitle: 'Ma tournée du jour',
      courierDescription: 'Scannez les colis chez l’agent, prenez une photo, puis terminez le dépôt.',
      startDrop: 'Commencer un dépôt',
      packageSearchPlaceholder: 'Code, destinataire, téléphone, adresse…',
      loadingPackages: 'Chargement…',
      loadingRoute: 'Chargement…',
      noPackagesWithFilters: 'Aucun colis ne correspond à ces filtres.',
      loadAgentPackagesFailed: 'Impossible de charger vos colis.',
      loadAgentWalletFailed: 'Impossible de charger votre portefeuille.',
      loadRouteFailed: 'Impossible de charger la tournée.',
      backendActionPending: 'Cette action n’est pas encore disponible.',
      actionQueued: 'Action gardée sur le téléphone. Elle sera envoyée avec la connexion.',
      actionSynced: 'Action envoyée.',
      actionRejected: 'L’action n’a pas été acceptée.',
      returnRequestedByResident: 'Le retour doit d’abord être demandé depuis la page de suivi ou par l’équipe. Ensuite vous pourrez le déposer.',
      enRouteStarted: 'Vous êtes en route vers le point.',
      bulkStartDelivery: 'Partir livrer ({count})',
      bulkMarkEnRoute: 'En route ({count})',
      loadTodayDeliveriesFailed: 'Impossible de charger les livraisons du jour.'
    },
    adminDashboard: {
      label: 'Tableau de bord',
      title: 'L’activité en direct',
      description: 'Repérez ce qui bloque, suivez les agents actifs, ouvrez les colis urgents et passez aux règlements ou à l’historique.',
      backendUnavailable: 'Service indisponible',
      loadFailed: 'Impossible de charger le tableau de bord.',
      loadQueueFailed: 'Impossible de charger la liste des colis.',
      notAvailable: '—',
      refreshHint: 'Mise à jour toutes les 30 s',
      importCsv: 'Importer un fichier CSV',
      createPackage: 'Créer un colis',
      loadingQueue: 'Chargement…',
      emptyQueue: 'Aucun colis pour ce filtre.',
      kpis: {
        handoverTime: 'Temps de remise',
        handoverHelp: 'À venir : du dépôt à la réception.',
        firstAttempt: 'Réussis du premier coup',
        firstAttemptHelp: 'Livrés aujourd’hui comparés aux problèmes ouverts.',
        podCompletion: 'Preuves complètes',
        podHelp: '{count} preuves reçues',
        activeAgents: 'Agents actifs',
        activeAgentsHelp: 'Comptes d’agents actifs en ce moment.',
        exceptionRate: 'Part des problèmes',
        exceptionHelp: '{count} colis à traiter'
      },
      search: {
        label: 'Chercher un colis',
        title: 'Trouvez et ouvrez vite',
        placeholder: 'Référence, destinataire, téléphone, agent, point…',
        submit: 'Chercher'
      },
      filters: {
        active: 'En cours',
        dropped: 'Déposés',
        received: 'Reçus',
        out: 'En livraison',
        returns: 'Retours',
        exceptions: 'Problèmes'
      },
      decisions: {
        title: 'À décider',
        cancellations: 'Demandes d’annulation',
        cancellationsHint: 'Un client veut faire revenir son colis',
        reports: 'Problèmes signalés',
        reportsHint: 'Signalements de clients après livraison, et retours sans compte',
        incidents: 'Retours bloqués',
        incidentsHint: 'Un retour en chemin a rencontré un problème',
        none: 'Rien n’attend votre décision.',
        returnsInProgress: '{count} retour en chemin | {count} retours en chemin'
      },
      exceptions: {
        label: 'Urgent',
        title: 'Problèmes à traiter',
        empty: 'Aucun problème ouvert.',
        open: 'Voir tous les problèmes'
      },
      cod: {
        label: 'Argent à encaisser',
        description: 'Total à encaisser pour les colis affichés.'
      },
      agents: {
        label: 'Carte des agents',
        title: 'Zones couvertes',
        cityLine: '{agents} agent(s) · {deliveries} livraison(s) en cours',
        activeDeliveries: '{count} en cours'
      },
      settlement: {
        label: 'Règlement',
        title: 'Préparer le règlement',
        description: 'Regardez l’aperçu, vérifiez les montants et lancez le règlement si l’écart est acceptable.',
        open: 'Ouvrir les règlements'
      },
      audit: {
        label: 'Historique',
        title: 'Qui a fait quoi',
        description: 'Voyez les actions de l’équipe, les changements d’étape, les raisons et les événements sensibles.',
        open: 'Ouvrir l’historique'
      },
      snapshot: {
        active: 'En cours',
        delivered: 'Livrés aujourd’hui',
        proofs: 'Preuves'
      }
    },
    platformConfig: {
      courierWaitInput: 'Attente max. d’un livreur (minutes)',
      courierWaitHelp: 'Au-delà, le colis prêt chez le gardien apparaît dans les exceptions. Entre 15 et 1440 minutes (120 = 2 h).',
      requestAcceptInput: 'Temps laissé au gardien pour répondre (minutes)',
      requestAcceptHelp: 'Passé ce délai, la demande est refusée pour lui et le client choisit un autre point. Entre 5 et 1440 minutes (30 = 30 min, 720 = 12 h).',
      label: 'Admin finance',
      title: 'Configuration financière',
      description: 'Fixez les frais du partenaire, la commission de l’agent pour chaque remise, le paiement du livreur après réception au point, et les frais du client notés au dépôt.',
      loadFailed: 'Impossible de charger la configuration.',
      saveFailed: 'Impossible d’enregistrer la configuration.',
      saved: 'Configuration financière enregistrée.',
      actionImpossible: 'Action impossible',
      partnerFee: 'Frais du partenaire',
      partnerFeeDescription: 'Montant retiré du crédit du partenaire pour chaque colis livré et réglé.',
      agentCommission: 'Commission agent',
      agentCommissionDescription: 'Montant ajouté pour chaque remise terminée par un agent, au dépôt du client ou à la livraison finale.',
      platformRevenue: 'Revenu plateforme',
      platformRevenueDescription: 'Estimation pour un colis partenaire : les frais moins deux commissions d’agent et la commission du livreur.',
      settlementSettings: 'Paramètres de règlement',
      nextSettlements: 'Montants appliqués aux prochains règlements',
      lastRead: 'Dernière lecture {time}',
      partnerFeeInput: 'Frais du partenaire par livraison (MAD)',
      partnerFeeHelp: 'Exemple : 15 MAD sera stocké comme 1500 centimes.',
      agentCommissionInput: 'Commission agent par livraison (MAD)',
      agentCommissionHelp: 'Exemple : 10 MAD est crédité après chaque remise éligible terminée par un agent.',
      courierCommissionInput: 'Commission livreur par colis reçu (MAD)',
      courierCommissionHelp: 'Payée une seule fois après confirmation de réception par le gardien de destination. Le tarif est figé à la création; les retours ne sont pas rémunérés.',
      negativeTitle: 'Configuration non rentable',
      negativeDescription: 'Les commissions de l’agent et du livreur dépassent les frais du partenaire. L’aller ferait perdre {amount} par colis.',
      exampleTitle: 'Exemple avec ces valeurs',
      exampleDescription: 'Colis partenaire : frais {partnerFee}, deux commissions d’agent de {agentCommission}, commission du livreur {courierCommission}, gain estimé {platformRevenue}.',
      existingSettlementsNote: 'Les colis déjà réglés ne sont pas recalculés. Ces montants s’appliquent aux prochains runs de règlement.'
    },
    adminExceptions: {
      courierLateTitle: 'Colis en attente d’un livreur ({count})',
      courierLateHint: 'Prêts chez le gardien depuis plus de {wait}. Envoyez un livreur ou appelez le gardien.',
      courierLateWaiting: 'En attente depuis {time}',
      label: 'File exceptions',
      title: 'Incidents à traiter',
      description: 'Échecs et litiges signalés par les agents, les livreurs ou l’équipe.',
      exception: 'Exception',
      exceptionCode: 'Code exception',
      open: 'Ouvertes',
      failedPage: 'Échouées page',
      disputesPage: 'Litiges page',
      searchPlaceholder: 'Code, destinataire, téléphone, adresse, agent...',
      emptyTitle: 'Aucune exception',
      emptyDescription: 'Les colis échoués ou litigieux apparaîtront ici.',
      loadFailed: 'Impossible de charger la file exceptions.',
      resolved: 'Exception traitée.',
      resolutionRejected: 'La décision n’a pas été acceptée.',
      resolutionDescription: 'Ajoutez une note opérationnelle. Elle sera enregistrée dans l\'audit trail.',
      resolutionPlaceholder: 'Décision admin, appel client, justification...',
      resolutionHelp: 'Minimum 3 caractères. Les overrides sans note sont refusés.'
    },
    settlements: {
      title: 'Règlements',
      description: 'Regardez les colis terminés pas encore réglés, retirez les frais des colis livrés, ajoutez les commissions des agents, puis clôturez.',
      loadFailed: 'Impossible de charger les règlements.',
      loadDetailFailed: 'Impossible de charger ce règlement.',
      runFailed: 'Impossible de lancer le règlement.',
      runStarted: 'Règlement lancé.',
      reviewWarning: 'Certains colis sont à vérifier.',
      running: 'Règlement en cours…',
      run: 'Lancer le règlement',
      backToSettlements: 'Retour règlements',
      detailTitle: 'Détails du règlement',
      toSettle: 'À régler',
      toSettleDescription: 'Colis terminés, pas encore réglés.',
      partnerDebitDescription: 'Frais à retirer du crédit des partenaires.',
      agentCommissionDescription: 'Montant ajouté à ce que l’agent peut retirer.',
      operationalRule: 'Comment ça marche',
      ruleTitle: 'Le règlement clôture les colis terminés',
      ruleDescription: 'Un colis livré débite le partenaire, paie l’agent et rapporte à la plateforme. Un colis échoué, annulé ou retourné est clos sans frais.',
      permanentAudit: 'Gardé dans l’historique',
      history: 'Historique',
      runsTitle: 'Règlements faits',
      runColumn: 'Règlement',
      deliveries: 'Livraisons',
      partnerFees: 'Frais des partenaires',
      agentCommissions: 'Commissions des agents',
      completedAt: 'Terminé le',
      failedCount: '{count} échec(s)',
      emptyRuns: 'Aucun règlement pour l’instant.',
      runCount: '{count} règlement(s)',
      settledDeliveries: 'Livraisons réglées',
      partnerDebit: 'Retrait sur le crédit des partenaires',
      partnerCreditConsumed: 'Crédit des partenaires utilisé.',
      agentBalanceCredited: 'Montant ajouté à ce que les agents peuvent retirer.',
      completedOn: 'Terminé le {date}',
      toReview: 'À vérifier',
      unsettledLines: 'Lignes non réglées toutes seules',
      unknownDelivery: 'Livraison inconnue',
      partnerNotProvided: 'Partenaire non indiqué',
      errorNotProvided: 'Erreur non indiquée',
      requiredFee: 'Frais à payer',
      currentCredit: 'Crédit actuel',
      estimatedAvailable: 'Disponible (estimé)',
      fixAndRerun: 'Réglez le problème, puis relancez le règlement.',
      includedDeliveries: 'Livraisons incluses',
      deliveredAt: 'Livré le',
      noPartner: 'Pas de partenaire',
      noAttachedPackages: 'Aucun colis dans ce règlement.',
      creditDebits: 'Retraits sur le crédit',
      creditedCommissions: 'Commissions ajoutées',
      recordedRevenue: 'Gains enregistrés',
      noPartnerDebit: 'Aucun retrait sur les partenaires.',
      noAgentCommission: 'Aucune commission d’agent.',
      noPlatformRevenue: 'Aucun gain pour la plateforme.',
      status: {
        completed: 'Terminé',
        running: 'En cours',
        pendingReview: 'À vérifier',
        failed: 'Échec'
      }
    },
    auditViewer: {
      outcomes: {
        success: 'Réussi',
        warning: 'À surveiller',
        error: 'Échec'
      },
      label: 'Historique',
      title: 'Calendrier des actions',
      description: 'Voyez les actions importantes jour par jour. Filtrez par rôle, action, sujet ou raison, puis ouvrez le détail.',
      loadFailed: 'Impossible de charger l’historique.',
      clearDates: 'Effacer dates',
      clearFilters: 'Effacer filtres',
      applyFilters: 'Appliquer',
      roles: {
        system: 'Système'
      },
      views: {
        calendar: 'Calendrier',
        table: 'Tableau'
      },
      columns: {
        time: 'Temps',
        actor: 'Acteur',
        role: 'Rôle',
        action: 'Action',
        subject: 'Sujet',
        reason: 'Raison',
        status: 'Statut'
      },
      filters: {
        role: 'Rôle',
        allRoles: 'Tous les rôles',
        action: 'Action',
        actionPlaceholder: 'Changement d’étape, connexion, modification…',
        subject: 'Sujet',
        subjectPlaceholder: 'Colis, agent, portefeuille…',
        reason: 'Code de la raison',
        reasonPlaceholder: 'LOST, ADMIN_OVERRIDE...',
        period: 'Période',
        from: 'Depuis',
        to: 'Jusqu’à'
      },
      stats: {
        visibleEvents: 'Événements visibles',
        issues: 'Avec attention',
        actors: 'Acteurs'
      },
      legend: {
        label: 'Couleurs',
        package: 'Colis',
        exception: 'Problème',
        wallet: 'Portefeuille',
        agent: 'Utilisateur',
        auth: 'Connexion',
        system: 'Système'
      },
      calendar: {
        label: 'Calendrier audit',
        title: 'Actions par date',
        range: 'Période',
        loading: 'Chargement',
        synced: 'Synchronisé',
        today: 'Aujourd’hui',
        month: 'Mois',
        week: 'Semaine',
        list: 'Liste'
      },
      focus: {
        label: 'Événement sélectionné',
        empty: 'Touchez un événement du calendrier ou une ligne du tableau pour voir le détail.'
      },
      quickSearch: {
        label: 'Recherche rapide',
        placeholder: 'Acteur, action, sujet, raison...',
        help: 'La recherche s’applique au calendrier et au tableau.'
      },
      table: {
        searchPlaceholder: 'Rechercher acteur, action, sujet, raison...',
        emptyTitle: 'Rien dans l’historique',
        emptyDescription: 'Les actions importantes apparaîtront ici.'
      }
    },
    handovers: {
      searchPlaceholder: 'Référence, colis, livreur, agent…',
      agentLabel: 'Arrivées',
      agentTitle: 'Arrivées',
      agentDescription: 'Ouvrez une arrivée pour choisir les colis à accepter, ajouter les photos et saisir le code du livreur.',
      courierLabel: 'Mes dépôts',
      courierTitle: 'Historique des dépôts',
      courierDescription: 'Retrouvez chaque dépôt chez un agent, les colis déposés et le code à montrer si besoin.',
      handover: 'Arrivée',
      courierFallback: 'Livreur',
      total: 'Total',
      received: 'Reçus',
      alreadyReceived: 'Déjà reçus',
      pendingToReceive: 'À recevoir',
      waiting: 'En attente',
      codTotal: 'À encaisser',
      cod: 'À encaisser',
      pending: 'À recevoir',
      partial: 'En partie',
      dropped: 'Déposé',
      loading: 'Chargement…',
      loadingDetail: 'Chargement…',
      noResults: 'Rien ne correspond à votre recherche.',
      emptyAgent: 'Rien à recevoir pour l’instant. Quand un livreur dépose des colis pour vous, ils apparaîtront ici.',
      emptyCourier: 'Vous n’avez encore fait aucun dépôt.',
      loadFailed: 'Impossible de charger la liste.',
      courierLoadFailed: 'Impossible de charger vos dépôts.',
      newDrop: 'Nouveau dépôt',
      newCode: 'Nouveau code',
      codeRefreshed: 'Nouveau code prêt.',
      codeRefreshFailed: 'Impossible de créer un nouveau code.',
      detailTitle: 'Détail de l’arrivée',
      backToHandovers: 'Arrivées',
      keepCodeVisible: 'Gardez ce code à l’écran tant que l’agent n’a pas reçu tous les colis.',
      confirmationTitle: 'Confirmer l’arrivée',
      confirmationDescription: 'Recevez les colis choisis.',
      dropProgress: 'Envoi en cours. Gardez cette page ouverte.',
      selectedSummary: '{packages} colis · {photos} photo(s)',
      packageCounts: '{packages} colis · {received} reçu(s) · {pending} en attente',
      expiresAt: 'Valable jusqu’à {time}',
      batchPackages: 'Colis de ce dépôt',
      parcelReturningHint: 'Ce colis est en retour : vous le retrouverez dès que l’agent l’aura déposé.',
      batchAgent: 'Agent de ce dépôt',
      batchAgentHelp: 'Tous les colis scannés ici doivent avoir cet agent.',
      packagesToAccept: 'Colis à accepter',
      packagesToAcceptDescription: 'Retirez seulement les colis que vous ne recevez pas maintenant. Ils resteront pour plus tard.',
      noneSelected: 'Aucun colis choisi. Remettez au moins un colis.',
      nonCod: 'Rien à encaisser',
      removeFromReception: 'Ne pas recevoir ce colis',
      removedCount: '{count} colis retiré(s)',
      removeFromBatch: 'Retirer',
      removedFromBatch: 'Colis retiré.',
      restore: 'Remettre',
      alreadyReceivedCount: '{count} colis de cette arrivée sont déjà reçus.',
      receptionPhotos: 'Photos des colis reçus',
      receptionPhotosHelp: 'Obligatoire. Prenez au moins une photo des colis reçus.',
      physicalCode: 'Code du livreur',
      physicalCodeHelp: 'Comparez ce code avec l’écran du livreur avant de recevoir.',
      senderCode: 'Code pour l’expéditeur',
      senderCodeHelp: 'L’expéditeur donne ce code à l’agent quand il dépose le colis.',
      resendSenderCode: 'Renvoyer le code',
      resendOnlyWhileWaiting: 'Possible seulement tant que le colis attend l’expéditeur.',
      senderCodeResending: 'Envoi…',
      senderCodeResent: 'Le code a été renvoyé à l’expéditeur.',
      senderCodeResendFailed: 'Impossible de renvoyer le code.',
      confirmPackages: 'Confirmer {count} colis',
      notFound: 'Arrivée introuvable.',
      photoRequired: 'Ajoutez au moins une photo.',
      noDeliverySelected: 'Aucun colis choisi à recevoir.',
      receiveRejected: 'La réception n’a pas été acceptée. Réessayez.',
      receiveSuccess: '{count} colis reçu(s).',
      invalidCourierDrop: 'Ce colis ne peut pas être déposé depuis cet écran.',
      duplicatePackage: 'Ce colis est déjà dans la liste.',
      agentRequired: 'Ce colis n’a pas encore d’agent. Demandez à l’équipe 3asass d’en choisir un, puis scannez-le de nouveau.',
      agentMismatch: 'Ce colis est pour {packageAgent}. Ce dépôt est pour {batchAgent}.',
      readyToDrop: 'Prêt à déposer.',
      addedToBatch: 'Colis ajouté.',
      dropPhotoRequired: 'Ajoutez au moins une photo des colis.',
      scanAtLeastOne: 'Scannez au moins un colis.',
      singleAgentRequired: 'Un dépôt ne peut contenir que des colis du même agent.',
      deliveryMissing: 'Ce colis n’a pas de livraison.',
      deliveryMissingInBatch: 'Un des colis n’a pas de livraison.',
      codeMessage: '{reference} · Code : {code}',
      dropRejected: 'Le dépôt n’a pas été accepté. Réessayez.',
      failedCount: '{count} colis refusé(s). Corrigez puis réessayez.',
      droppedCount: '{count} colis déposé(s).',
      dropPhotos: 'Photos des colis déposés',
      dropPhotosHelp: 'Prenez au moins une photo des colis.',
      showCodeToAgent: 'Montrez ce code à l’agent. Il doit le saisir sur son écran pour confirmer la réception.',
      doneHint: 'L’agent a reçu ces colis. Il n’y a plus rien à faire.',
      removedFromReception: 'Colis retiré.',
      readyToReceiveOne: 'Colis prêt à recevoir.',
      scanOneFirst: 'Scannez d’abord un colis déposé.',
      singleReceiveLabel: 'Recevoir un colis',
      singleReceiveTitle: 'Scanner un colis',
      singleReceiveDescription: 'Recevez un seul colis avec le code donné par le livreur.',
      selectedPackage: 'Colis choisi',
      linkedHandover: 'Arrivée liée : {reference}',
      askCourierCode: 'Demandez au livreur le code affiché sur son écran.',
      confirmOnePackage: 'Confirmer ce colis',
      scanOneEmpty: 'Scannez le QR code d’un colis déposé, ou tapez son code.',
      confirmDrop: 'Confirmer le dépôt',
      stepScan: 'Scanner',
      stepPackages: 'Colis',
      stepPhoto: 'Photo',
      stepCode: 'Code',
      stepSignature: 'Signature',
      stepConfirm: 'Valider',
      nextStep: 'Ensuite : {step}',
      sessionMismatch: 'Ce colis est dans une autre arrivée. Scannez les colis d’une seule arrivée à la fois.',
      scanMoreHelp: 'Scannez un autre colis ou passez à l’étape suivante.',
      scannedCount: '{count} colis scannés',
      dropComplete: 'Dépôt terminé',
      dropQueued: 'Dépôt gardé sur le téléphone. Il sera envoyé dès que la connexion revient.',
      startNewDrop: 'Nouveau dépôt'
    },
    courierEarnings: {
      title: 'Mes gains de livreur',
      balance: 'Gains confirmés',
      completed: 'Colis reçus cette semaine',
      help: 'Vos gains de l’aller sont ajoutés quand l’agent de destination confirme la réception. Les retours ne sont pas payés.'
    },
    profile: {
      connectedAccount: 'Les informations de votre compte.',
      operationalDescription: 'Modifiez vos informations de travail.',
      actionFailed: 'Ça n’a pas marché',
      fullNameRequired: 'Le nom est obligatoire.',
      phoneInvalid: 'Entrez un numéro avec l’indicatif du pays, par exemple +212600000000.',
      residenceRequired: 'Choisissez votre point.',
      saved: 'Profil enregistré.',
      saveFailed: 'Impossible d’enregistrer le profil.',
      loadFailed: 'Impossible de charger votre profil.',
      chooseDocument: 'Choisissez au moins un document à remplacer.',
      kycSaved: 'Documents enregistrés. Un administrateur doit vérifier votre identité de nouveau.',
      kycSaveFailed: 'Impossible d’enregistrer les documents.',
      kycDocuments: 'Documents d’identité',
      editKycImages: 'Changer les photos des documents',
      replaceNeededFiles: 'Remplacez seulement les fichiers utiles. Tout changement doit être revérifié.',
      displayName: 'Nom affiché',
      saveName: 'Enregistrer'
    },
    pod: {
      validationTitle: 'Confirmation de la livraison',
      validationDescription: 'Envoi de la preuve, de l’argent encaissé et de votre commission…',
      label: 'Remise au destinataire',
      captureProof: 'Prendre la preuve',
      description: 'La signature, la photo, votre position et l’argent encaissé sont obligatoires avant d’envoyer.',
      loadingPackage: 'Chargement du colis…',
      deliveryMissing: 'Livraison introuvable.',
      signatureRequired: 'La signature est obligatoire.',
      photoRequired: 'La photo est obligatoire.',
      geolocationRequired: 'Activez la localisation, puis appuyez sur « Prendre ma position ».',
      cashRequired: 'Indiquez l’argent encaissé.',
      cashInvalid: 'Le montant n’est pas valable.',
      cashExpected: 'Le montant doit être {amount}.',
      queued: 'Preuve gardée sur le téléphone. Elle partira dès que la connexion revient.',
      synced: 'Preuve envoyée.',
      rejected: 'Preuve refusée. Vérifiez les champs, puis réessayez.',
      dropPhoto: 'Photo de la remise',
      dropPhotoHelp: 'La photo est réduite sur le téléphone puis envoyée.',
      cod: 'À encaisser',
      cashCollection: 'Argent encaissé',
      expectedAmount: 'Montant à encaisser : {amount}',
      noCod: 'Rien à encaisser pour ce colis.',
      cashPlaceholder: 'Argent encaissé',
      noCashPlaceholder: 'Rien à encaisser',
      cashMismatch: 'Le montant doit être exactement celui demandé.',
      validateDelivery: 'Confirmer la livraison',
      stepProof: 'Preuve',
      stepSignature: 'Signature'
    },
    bulkPod: {
      podAction: 'Preuves ({count})',
      title: 'Remettre plusieurs colis',
      label: 'Une seule preuve',
      description: 'Une photo, une signature et votre position pour tous les colis choisis.',
      selectedSummary: '{count} colis choisi(s)',
      proofOnce: 'La même preuve sera utilisée pour chaque colis.',
      remove: 'Retirer',
      removed: 'Colis retiré.',
      submit: 'Confirmer ({count})',
      confirmTitle: 'Envoi en cours',
      confirmDescription: 'Chaque colis sera marqué livré avec sa preuve.',
      resultTitle: 'Preuves enregistrées',
      resultSummary: '{count} colis livré(s)',
      queued: 'Pas de connexion : les preuves seront envoyées dès que possible.',
      backToPackages: 'Retour aux colis',
      reasonNotAvailable: 'Ce colis n’est pas dans votre liste.',
      missingTargets: 'Aucun colis choisi.'
    },
    packages: {
      title: 'Tous les colis',
      description: 'Cherchez, filtrez et suivez les colis.',
      importCsv: 'Importer CSV',
      create: 'Créer colis',
      currentPage: 'Page courante',
      created: 'Créés',
      active: 'Actifs',
      issues: 'Anomalies',
      codPage: 'Montant dû',
      searchPlaceholder: 'Référence, destinataire, téléphone…',
      emptyTitle: 'Aucun colis',
      emptyDescription: 'Les colis créés apparaîtront ici.',
      packages: 'Colis',
      package: 'Colis',
      open: 'Ouvrir',
      recipient: 'Destinataire',
      unknownRecipient: 'Destinataire inconnu',
      relay: 'Point',
      assignedAgent: 'Agent assigné',
      state: 'État',
      type: 'Type',
      residence: 'Point',
      createdAt: 'Créé le',
      createdFrom: 'Créé depuis',
      createdTo: 'Créé jusqu’à',
      unassigned: 'Non assigné',
      csvTitle: 'Importer un manifeste CSV',
      csvDescription: 'Crée des colis en lot. Les lignes valides créent aussi leur livraison en état créé.',
      expectedColumns: 'Colonnes attendues',
      expectedColumnsDescription: 'residence_id, cod_amount_mad, recipient_name, recipient_phone, recipient_address. operator_tracking_ref, internal_ref, partner_id et agent_id sont optionnels.',
      codMadHelp: 'Écrivez le montant en dirhams, par exemple 125 pour 125 MAD. Il est converti tout seul.',
      template: 'Modèle',
      csvFile: 'Fichier CSV',
      skipped: 'Ignorés',
      errors: 'Erreurs',
      line: 'Ligne',
      status: 'Statut',
      reference: 'Référence',
      detail: 'Détail',
      close: 'Fermer',
      importing: 'Import...',
      agentLabel: 'Agent:'
    },
    parcelMap: {
      subtitle: 'Vos colis et vos collectes sur une seule carte.',
      agentSubtitle: 'Vos colis sur une seule carte.',
      listLabel: 'Colis et collectes',
      parcelPoint: 'Où va le colis',
      collectionPoint: 'Où le récupérer',
      open: 'Ouvrir',
      searchPlaceholder: 'Référence, destinataire ou adresse…',
      widenHint: 'Bougez la carte ou cherchez pour voir plus loin.',
      showAll: 'Tout afficher',
      selectHint: 'Touchez un colis sur la carte pour le voir ici.',
      empty: 'Aucun colis sur la carte',
      emptyHint: 'Les colis apparaîtront ici quand leur adresse sera trouvée.'
    },
    courierPickups: {
      title: 'Collectes',
      subtitle: 'Récupérez des colis chez les agents ou chez les expéditeurs',
      tabPending: 'À collecter',
      tabCollected: 'Collectés',
      pendingEmpty: 'Aucune collecte en attente',
      pendingEmptyHint: 'Les nouvelles collectes apparaîtront ici.',
      collectedEmpty: 'Aucune collecte terminée',
      pointLabel: 'Point de dépôt',
      parcelCount: '{count} colis',
      distanceKm: '{distance} km',
      collectTitle: 'Récupérer le colis',
      collectStepScan: 'Scanner',
      collectStepCode: 'Code',
      collectStepConfirm: 'Valider',
      codeLabel: 'Code de remise',
      codePrompt: 'Entrez le code que l’agent vous montre',
      codeWrong: 'Code incorrect',
      codeExpired: 'Code expiré',
      codeExpiredHint: 'Demandez un nouveau code à l’agent, puis actualisez.',
      codeMissing: 'Pas de code à saisir',
      collectPhotos: 'Photos de la collecte',
      collectPhotosHelp: 'Photographiez les colis que l’agent vous remet.',
      collectPhotoRequired: 'Ajoutez une photo des colis remis.',
      collectConfirm: 'Récupérer {count} colis',
      collectSuccess: 'Colis récupéré. Direction la destination.',
      sessionTitle: 'Collecte',
      sessionReference: 'Référence {ref}',
      sessionEmpty: 'Aucun colis dans cette collecte.',
      refreshCode: 'Actualiser le code',
      goToPoint: 'Ouvrir l’itinéraire',
      senderLocationCapturedAtCollection: 'Votre position est prise automatiquement à l’étape de la photo.',
      senderProofSummary: 'Une photo et votre position confirmeront la collecte à cette adresse.',
      releasePickup: 'Annuler ma réservation',
      releaseSuccess: 'Réservation annulée. Un autre livreur peut la prendre.',
    },
    packageDetail: {
      recipientPayment: 'Paiement par le destinataire',
      paidFee: 'Vous avez payé',
      notFound: 'Colis introuvable',
      loadFailed: 'Impossible de charger le colis.',
      loadDetailFailed: 'Impossible de charger les détails du colis.',
      detail: 'Détails du colis',
      returnCourier: 'Livreur du retour',
      tabTimeline: 'Suivi',
      tabProofs: 'Preuves',
      tabMap: 'Carte',
      tabReferences: 'Références',
      createdOn: 'Créé le {date}',
      backToList: 'Liste des colis',
      copied: 'Copié.',
      copyReference: 'Copier la référence',
      copyPhone: 'Copier le numéro',
      publicTracking: 'Page de suivi publique',
      myPackages: 'Mes colis',
      route: 'Tournée',
      deliveryState: 'Étape de la livraison',
      assignedAgent: 'Agent choisi',
      selectAgent: 'Choisir un agent',
      reassignNote: 'Note pour expliquer le changement',
      reassignAgent: 'Changer d’agent',
      returnPoint: 'Point de retour', returnPointTitle: 'Choisir où le client reprendra le colis', returnPointHint: 'Le point d’origine reste {original}. Choisissez un point actif et expliquez pourquoi.', returnPointReason: 'Pourquoi changer le point de retour ?', assignReturnPoint: 'Choisir ce point de retour', returnPointAssigned: 'Point de retour choisi.', returnPointAssignFailed: 'Impossible de choisir ce point de retour.',
      exception: 'Problème',
      none: 'Aucun',
      recipient: 'Destinataire',
      phone: 'Téléphone',
      deliveryAddress: 'Adresse de livraison',
      references: 'Références',
      packageIdentifiers: 'Références du colis',
      courierQrScan: 'QR code à scanner par le livreur',
      downloadQr: 'Télécharger le QR code',
      qrUnavailable: 'QR code indisponible.',
      internalQrReference: 'Référence interne / QR',
      internalReference: 'Référence interne :',
      operatorReference: 'Référence de suivi :',
      technicalIds: 'Identifiants techniques',
      show: 'Afficher',
      hide: 'Masquer',
      delivery: 'Livraison',
      milestones: 'Étapes du colis',
      dropped: 'Déposé',
      relayDropped: 'Déposé au point',
      received: 'Reçu',
      agentReceived: 'Reçu par l’agent',
      outForDelivery: 'En livraison',
      delivered: 'Livré',
      noMilestones: 'Aucune étape enregistrée pour l’instant.',
      backendActions: 'Actions possibles',
      availableActions: 'Actions possibles',
      runnable: 'possible(s)',
      noActions: 'Aucune action possible à cette étape.',
      timeline: 'Suivi',
      operationalHistory: 'Historique du colis',
      adminNotePrompt: 'Une note est obligatoire pour cette action',
      adminNoteRequired: 'La note est obligatoire.',
      selectActiveAgent: 'Choisissez un agent actif.',
      deliveryActionSynced: 'Action enregistrée.',
      backendRejected: 'L’action n’a pas été acceptée.',
      agentUpdated: 'L’agent a été changé.',
      reassignmentRejected: 'Le changement d’agent n’a pas été accepté.',
      agentDescription: 'Suivi de l’agent, de la réception jusqu’à la livraison ou au problème.',
      courierDescription: 'Suivi du livreur, de la création jusqu’au dépôt au point.',
      enRoute: 'En route',
      enRouteDescription: 'Le livreur est parti et se dirige vers le point.',
      progression: 'Avancement',
      relayAddress: 'Point et adresse',
      relayMap: 'Carte du point',
      routeToDrop: 'Itinéraire vers le point de livraison',
      routeToPickup: 'Itinéraire vers la collecte',
      routeToReturnPoint: 'Itinéraire vers le point de retour',
      takePickupPhoto: 'Photographier le colis chez l’expéditeur',
      confirmPickup: 'Confirmer la collecte',
      senderReturnSaved: 'Colis rendu à l’expéditeur',
      senderReturnComplete: 'Le retour est terminé.',
      senderReturnHelp: 'Remettez le colis à l’expéditeur en main propre, puis enregistrez une photo et votre position.',
      takeSenderReturnPhoto: 'Prendre la photo de la remise',
      senderReturnTo: 'À remettre à l’expéditeur',
      senderReturnStepSender: 'Expéditeur',
      senderReturnPhoto: 'Photo de la remise',
      senderReturnPhotoHelp: 'Prenez le colis et la personne en photo si possible.',
      senderReturnPhotoFirst: 'Ajoutez d’abord la photo',
      senderReturnUnavailable: 'Ce colis n’est pas à remettre à l’expéditeur.',
      backToParcel: 'Retour au colis',
      senderReturnFailed: 'La remise n’a pas été enregistrée. Vérifiez votre position et la connexion, puis réessayez.',
      pickupLocationRequired: 'Autorisez la localisation pour confirmer la collecte.',
      pickupProofSaved: 'Collecte confirmée. Preuve enregistrée.',
      pickupProofFailed: 'La collecte n’a pas pu être confirmée. Vérifiez la photo et la position, puis réessayez.',
      dropProofs: 'Preuves de dépôt',
      uploadedPhotos: 'Photos envoyées',
      noDropProof: 'Aucune preuve de dépôt pour ce colis.',
      returnDepositPhotos: 'Photos du dépôt du retour',
      returnCollectionPhotos: 'Photos de la récupération du retour',
      returnRequests: 'Demandes de retour',
      returnIncidents: 'Problèmes de retour',
      returnRequestsForPackage: 'Demandes pour ce colis',
      noReturnRequests: 'Aucune demande de retour pour ce colis.',
      approveReturnRequest: 'Accepter et lancer le retour',
      rejectReturnRequest: 'Refuser',
      returnApprovePrompt: 'Note pour accepter ce retour',
      returnRejectPrompt: 'Note pour refuser ce retour',
      returnApproved: 'Demande de retour acceptée.',
      returnRejected: 'Demande de retour refusée.',
      reviewedAt: 'Réponse le',
      adminNote: 'Note',
      returnStatuses: {
        pending: 'En attente',
        approved: 'Acceptée',
        rejected: 'Refusée'
      },
      packageCreated: 'Colis créé',
      packageCreatedDescription: 'Le colis est enregistré pour la livraison.',
      dropConfirmed: 'Dépôt confirmé',
      dropConfirmedDescription: 'Le livreur a scanné le colis au point et terminé le dépôt.',
      system: 'Système',
      courier: 'Livreur',
      actions: {
        en_route: 'En route',
        mark_en_route: 'En route',
        drop: 'Dépôt du livreur',
        cancel: 'Annuler',
        receive: 'Réception par l’agent',
        notify_resident: 'Prévenir le destinataire',
        start_delivery: 'Partir livrer',
        report_exception: 'Signaler un problème',
        capture_pod: 'Remettre au destinataire',
        request_return: 'Demander le retour',
        open_dispute: 'Ouvrir un litige',
        retry_by_admin: 'Réessayer',
        return_to_sender: 'Rendre à l’expéditeur',
        deposit_return: 'Retour déposé',
        collect_return: 'Retour récupéré',
        resolve_as_delivered: 'Régler : livré',
        resolve_as_failed: 'Régler : échec',
        confirm_failed: 'Confirmer l’échec',
        accept_damaged: 'Accepter avec une note',
        clear_agent: 'Dégager l’agent',
        confirm_loss_agent_fault: 'Perte due à l’agent',
        declare_cod_loss: 'Déclarer la perte'
      },
      collectionTitle: 'Collecte',
      collectionOpen: 'Voir la collecte et le code',
      arrivalTitle: 'Arrivée',
      arrivalOpen: 'Voir l’arrivée et le code du livreur'
    },
    returnRequests: {
      label: 'Signalements et retours',
      title: 'Problèmes signalés et retours',
      description: '{count} demande(s) dans la file actuelle : signalements de clients après livraison, et retours demandés sans compte.',
      loadFailed: 'Impossible de charger les demandes de retour.',
      empty: 'Aucun signalement ni retour pour ce filtre.',
      packageCode: 'Code colis',
      requester: 'Demandeur',
      requestedAt: 'Demandé le',
      reviewedFrom: 'Revu depuis',
      reviewedTo: 'Revu jusqu’au',
      searchPlaceholder: 'Code colis, nom, téléphone, adresse, note...',
      reviewTitle: 'Traiter la demande',
      approveTitle: 'Accepter et lancer le retour',
      rejectTitle: 'Refuser : le colis reste livré',
      reviewDescription: 'Ajoute une note interne avant de confirmer cette décision.',
      reviewNotePlaceholder: 'Note admin pour cette demande'
    },
    returnIncidents: {
      title: 'Incidents de retour', description: 'Les colis restent sous la garde actuelle jusqu’à la reprise ou à la clôture.',
      loadFailed: 'Impossible de charger les incidents.', empty: 'Aucun incident de retour.', reportedBy: 'Signalé par', custodian: 'Responsable actuel',
      custodyAtReport: 'État au signalement', resolution: 'Décision', viewEvidence: 'Voir la preuve photo', reasonPlaceholder: 'Motif de la décision admin (8 caractères minimum)',
      chooseCourier: 'Choisir un livreur actif', resume: 'Reprendre le retour', reassign: 'Changer de livreur après la remise', closeLost: 'Clôturer comme perdu',
      actionFailed: 'La décision a échoué.', resumeSuccess: 'Retour repris.', reassignSuccess: 'Retour réassigné au nouveau livreur.', 'close-lostSuccess': 'Retour clôturé comme perdu.',
      statuses: { open: 'À traiter', resumed: 'Repris', reassigned: 'Livreur changé', closed_lost: 'Perdu' }
    },
    cancellationRequests: {
      title: 'Demandes d’annulation', description: 'Un colis déjà dans le réseau ne s’annule qu’après un retour physique à l’expéditeur.',
      loadFailed: 'Impossible de charger les demandes.', empty: 'Aucune demande d’annulation.', askedAt: 'Demandé le', stateWhenAsked: 'État à la demande',
      parcelNow: 'Colis actuellement', decisionNote: 'Décision', notePlaceholder: 'Motif de la décision (8 caractères minimum)',
      approve: 'Approuver et renvoyer', reject: 'Refuser', approveSuccess: 'Annulation approuvée, le colis repart vers l’expéditeur.', rejectSuccess: 'Demande refusée.',
      actionFailed: 'La décision a échoué.', pendingCount: '{count} demande(s) en attente.',
      waitForRelay: 'Le colis est en route. Attendez qu’il arrive dans un point relais pour pouvoir l’approuver.',
      awaitingPhysicalReturn: 'Approuvé. En attente du retour physique à l’expéditeur.', returnedAt: 'Rendu à l’expéditeur le {at}.',
      statuses: { pending: 'À traiter', approved: 'Retour en cours', rejected: 'Refusé', completed: 'Annulé' }
    },
    packageCreate: {
      intake: 'Ajouter des colis',
      title: 'Créer un colis',
      description: 'Crée le colis opérateur et sa livraison initiale en état créé.',
      actionDenied: 'Action refusée',
      referenceDestination: 'Référence et destination',
      operatorReference: 'Référence opérateur',
      operatorReferenceHelp: 'Optionnelle. Générée automatiquement si elle est vide.',
      internalReference: 'Référence interne',
      generatedIfEmpty: 'Générée si vide',
      internalReferenceHelp: 'Optionnelle. Utilisée par 3asass pour le QR et les scans.',
      assignment: 'Affectation',
      relayAgentPayment: 'Relais, agent et paiement',
      relayResidence: 'Résidence relais',
      collectionMode: 'Collecte depuis',
      relayOrigin: 'Point relais de collecte',
      senderAddressOrigin: 'Adresse de l’expéditeur',
      pickupPoint: 'Point relais',
      senderName: 'Nom de l’expéditeur',
      senderPhone: 'Téléphone de l’expéditeur',
      senderAddress: 'Adresse de collecte',
      originCsvHelp: 'Utilisez sender_address avec nom, téléphone et adresse, ou relay avec nom, téléphone et pickup_agent_id.',
      senderPinNotice: 'Le code de dépôt du colis sera envoyé par WhatsApp au numéro de l’expéditeur.',
      assignedAgent: 'Agent assigné',
      backendAutoAssign: 'Choix automatique',
      assignedAgentHelp: 'Facultatif. Si vide, l’agent actif le moins chargé de ce point est choisi.',
      noActiveAgent: 'Aucun agent actif disponible pour cette résidence.',
      noPartner: 'Aucun partenaire',
      partnerHelp: 'Optionnel. Utilisé pour suivre le crédit partenaire et les frais de livraison.',
      codAmountMad: 'Montant COD en MAD',
      recipient: 'Destinataire',
      deliveryContact: 'Coordonnées de livraison',
      recipientName: 'Nom destinataire',
      recipientPhone: 'Téléphone E.164',
      recipientAddress: 'Adresse destinataire',
      creating: 'Création...',
      create: 'Créer colis',
      afterCreation: 'Après création',
      backendDoes: 'Ce qui se passe ensuite',
      backendCreatesDelivery: 'Une livraison est créée toute seule, à l’étape « créé ».',
      backendAssignsAgent: 'Nous essayons de choisir un agent actif du même point, le moins chargé.',
      backendIdempotency: 'Si vous envoyez deux fois par erreur, un seul colis est créé.',
      referenceExplanation: 'Référence opérateur = la référence externe du vendeur, générée si elle est absente. Référence interne = notre référence courte pour QR, scan et support.',
      validationResidence: 'Sélectionne une résidence relais.',
      validationRecipientName: 'Nom destinataire obligatoire.',
      validationRecipientPhone: 'Téléphone destinataire obligatoire.',
      validationRecipientAddress: 'Adresse destinataire obligatoire.',
      validationCod: 'Le montant COD doit être un nombre positif ou 0.',
      creationFailed: 'Création impossible.',
      normalMode: 'Normal',
      excelMode: 'Excel / CSV',
      addPartnerCreditWarning: 'Ajoutez du crédit partenaire avant de créer d\'autres colis payants.'
    },
    agentCreatePackage: {
      title: 'Nouveau colis',
      subtitle: 'Scannez ou tapez le code du colis, puis remplissez les informations.',
    backToDashboard: 'Accueil',
    back: 'Retour',
    qrMode: 'Scanner le QR code',
      qrModeHint: 'Avec la caméra du téléphone',
      textMode: 'Taper le code',
      textModeHint: 'Tapez ou collez le code',
      enterTextLabel: 'Code du colis',
      textModePlaceholder: 'Tapez ou collez le code ici…',
      processText: 'Lire le code',
      scannedCode: 'Code lu',
      copyCode: 'Copier le code',
      autoExtract: 'Remplir automatiquement',
      trackingCode: 'Référence de suivi',
      trackingCodePlaceholder: 'Référence lue',
      recipientName: 'Nom du destinataire',
      recipientNamePlaceholder: 'Nom complet',
      recipientPhone: 'Téléphone',
      recipientPhonePlaceholder: '+212600000000',
      recipientAddress: 'Adresse',
      recipientAddressPlaceholder: 'Adresse complète',
      createPackage: 'Créer le colis',
      creating: 'Création…',
      success: 'Colis créé.',
      failed: 'Le colis n’a pas pu être créé.',
      copied: 'Copié.',
      copyFailed: 'Impossible de copier.',
      enterCode: 'Entrez un code.',
      extracted: 'Les champs ont été remplis.',
      extractFailed: 'Impossible de remplir les champs. Écrivez le nom, le téléphone et l’adresse, un par ligne.',
      validationRecipientName: 'Le nom du destinataire est obligatoire.',
      validationRecipientPhone: 'Le téléphone du destinataire est obligatoire.',
      validationRecipientAddress: 'L’adresse du destinataire est obligatoire.',
      photoProof: 'Photo du colis',
      validationPhoto: 'La photo du colis est obligatoire.',
      ocrCamera: 'Caméra',
      ocrUpload: 'Photo',
      ocrManual: 'Taper',
      ocrCapture: 'Lire le texte',
      ocrProcessing: 'Lecture en cours…',
      ocrRetake: 'Reprendre',
      ocrUseText: 'Utiliser ce texte',
      ocrSelectImage: 'Choisir une photo',
      ocrSelectImageHint: 'Photo du colis pour lire le texte',
      ocrReupload: 'Autre photo',
      ocrManualPlaceholder: 'Tapez ou collez le texte ici…',
      ocrCameraInit: 'Ouverture de la caméra…',
      ocrRetry: 'Réessayer',
      ocrConfirmUse: 'Utiliser ces informations',
      ocrTakePhoto: 'Prendre une photo'
    },
    agentCreate: {
      onboarding: 'Inscription de l’agent',
      title: 'Créer un agent',
      description: 'Créer le compte pending, rattacher la résidence, puis collecter les documents KYC.',
      agentList: 'Liste agents',
      actionDenied: 'Action refusée',
      information: 'Informations',
      operationalProfile: 'Profil opérationnel',
      fullName: 'Nom complet',
      e164Phone: 'Téléphone E.164',
      language: 'Langue',
      residence: 'Résidence',
      kyc: 'KYC',
      fieldDocuments: 'Documents collectés terrain',
      identityDocument: 'Pièce d’identité',
      identityDocumentHelp: 'JPG, PNG ou PDF. Maximum 5 MB.',
      residenceProof: 'Justificatif de résidence',
      residenceProofHelp: 'JPG, PNG ou PDF. Peut être ajouté plus tard.',
      facePhoto: 'Photo visage',
      facePhotoHelp: 'JPG ou PNG. Maximum 2 MB.',
      creating: 'Création...',
      create: 'Créer agent',
      missingKyc: 'Les documents KYC sont obligatoires.',
      creationFailed: 'Création impossible.'
    },
    agentOnboarding: {
      label: 'Inscription de l’agent',
      title: 'Complétez votre profil',
      description: 'Votre compte est en attente. Vous pourrez recevoir des colis, scanner et voir votre argent après la validation de l’équipe.',
      actionFailed: 'Ça n’a pas marché',
      identitySection: 'Vos informations',
      fullName: 'Nom complet',
      phone: 'Téléphone',
      preferredLanguage: 'Langue',
      residenceZone: 'Votre point',
      documentsSection: 'Documents d’identité',
      documentsDescription: 'Ajoutez ou remplacez les documents demandés. Tout changement doit être revérifié par l’équipe.',
      identityDocument: 'Carte d’identité',
      proofOfResidence: 'Justificatif de domicile',
      facePhoto: 'Photo du visage',
      currentDocument: 'Document actuel',
      currentPhoto: 'Photo actuelle',
      openCurrentDocument: 'Voir le document actuel',
      openCurrentPhoto: 'Voir la photo actuelle',
      noCurrentDocument: 'Aucun document',
      noCurrentPhoto: 'Aucune photo',
      saveDocuments: 'Enregistrer les documents',
      documentsSaved: 'Documents enregistrés. L’équipe doit les vérifier de nouveau.',
      chooseDocument: 'Choisissez au moins un document à remplacer.',
      validationState: 'Où en est votre dossier',
      profileCompleted: 'Profil complet',
      identityDocReceived: 'Carte d’identité reçue',
      residenceProofReceived: 'Justificatif de domicile reçu',
      photoReceived: 'Photo reçue',
      kycValidated: 'Identité vérifiée par l’équipe',
      escrowRecorded: 'Caution enregistrée',
      saveProfile: 'Enregistrer mon profil',
      saving: 'Enregistrement…',
      chooseResidence: 'Choisissez votre point.',
      chooseName: 'Entrez votre nom complet.',
      choosePhone: 'Entrez votre numéro de téléphone.',
      saveFailed: 'Impossible d’enregistrer le profil.',
      kycSaveFailed: 'Impossible d’enregistrer les documents.',
      loadFailed: 'Impossible de charger vos informations.'
    },
    scanner: {
      title: 'Scanner un colis',
      hint: 'Visez le code QR du colis, ou tapez son code.',
      looking: 'Recherche du colis…',
      notFound: 'Aucun colis avec ce code pour vous.',
      failed: 'Impossible de vérifier le code. Réessayez.',
      again: 'Scanner un autre colis',
      details: 'Voir le colis',
      reportProblem: 'Signaler un problème',
      steps: {
        customer_handover: 'Prendre le colis du client',
        show_collection_code: 'Montrer le code au livreur',
        receive_arrival: 'Recevoir le colis',
        start_delivery: 'Aller livrer',
        deliver: 'Remettre au destinataire',
        deposit_return: 'Déposer le retour',
        return_arrived: 'Le colis est chez moi',
        hand_back_to_customer: 'Rendre au client',
        drop_off: 'Déposer chez l’agent',
        collect_session: 'Ouvrir la collecte',
        accept_return: 'Accepter ce retour',
        collect_return: 'Récupérer le retour',
        confirm_sender_return: 'Remettre à l’expéditeur'
      },
      waiting: {
        waiting_courier: 'Ce colis attend le livreur.',
        coming_courier: 'Le livreur apporte ce colis.',
        delivered: 'Ce colis est livré. Rien à faire.',
        cancelled: 'Ce colis est annulé.',
        with_team: 'L’équipe s’occupe d’un problème sur ce colis.',
        return_in_progress: 'Ce colis est en retour. Rien à faire pour vous maintenant.',
        nothing: 'Rien à faire avec ce colis pour le moment.'
      }
    },
    senderReturns: {
      title: 'Colis qui reviennent ({count})',
      comingBack: 'Le livreur ramène ce colis. Appuyez quand il est chez vous.',
      arrived: 'Le colis est chez moi',
      arrivedDone: 'Le client est prévenu. Il peut venir le chercher.',
      askCode: 'Demandez au client son code à 4 chiffres.',
      stepCustomer: 'Client',
      stepProof: 'Code et photo',
      codeFirst: 'Entrez le code du client',
      photo: 'Photo de la remise',
      photoHelp: 'Prenez le colis et le client en photo si possible.',
      unavailable: 'Ce colis n’est pas prêt à être rendu au client.',
      backToReturns: 'Retour aux colis qui reviennent',
      handBack: 'Rendre au client',
      handedBack: 'Colis rendu au client.',
      retry: 'Réessayer',
      failed: 'Non enregistré. Réessayez.'
    },
    simpleStatus: {
      requested: 'Demandé',
      dropped_off: 'Déposé',
      on_the_way: 'En route',
      delivered: 'Livré',
      returned: 'Rendu à l’expéditeur',
      returnedHint: 'Le colis a été rendu à l’expéditeur.',
      problem: 'Il y a un problème, nous nous en occupons',
      problemHint: 'Notre équipe s’en occupe. Nous vous tiendrons informé.',
      cancelled: 'Annulé',
      journey: 'Étapes du colis',
      returnJourney: 'Étapes du retour',
      returnRequested: 'Retour demandé',
      returnAtDestination: 'Chez l’agent',
      returnOnWay: 'Retour en route',
      returnReady: 'Prêt à récupérer',
      returnReceived: 'Rendu au client'
    },
    pageTitles: {
      pickupsShort: 'Dépôts',
      home: 'Accueil',
      packages: 'Colis',
      packageDetail: 'Colis',
      scan: 'Recevoir un colis',
      createPackage: 'Nouveau colis',
      handovers: 'Arrivées',
      handoverDetail: 'Arrivée',
      pickups: 'Dépôts',
      pickupScan: 'Recevoir du client',
      pickupHandover: 'Remettre au livreur',
      pickupSession: 'Colis pour le livreur',
      returns: 'Retours',
      pod: 'Remettre au destinataire',
      bulkPod: 'Remettre plusieurs colis',
      returnDeposit: 'Recevoir un retour',
      exception: 'Signaler un problème',
      sync: 'Envoi des données',
      wallet: 'Mes gains',
      profile: 'Mon profil',
      dropSessions: 'Mes dépôts',
      dropSessionsShort: 'Dépôts',
      dropSessionDetail: 'Dépôt',
      drop: 'Déposer chez un agent',
      collections: 'Collectes',
      collectionDetail: 'Collecte',
      returnCollect: 'Récupérer un retour',
      scanner: 'Scanner',
      senderReturn: 'Remise à l’expéditeur',
      requests: 'Demandes',
      requestNew: 'Envoyer un colis',
      requestDetail: 'Demande',
      dropOffs: 'Mes dépôts',
      payments: 'Paiements',
      courierMap: 'Carte des colis',
      agentMap: 'Carte des colis',
      back: 'Retour',
      menu: 'Menu'
    },
    pickupRequests: {
      loadFailed: 'Impossible de charger les demandes. Réessayez.',
      title: 'Nouvelles demandes ({count})',
      customer: 'Client',
      goingTo: 'Pour',
      call: 'Appeler le client',
      answerBy: 'Répondez avant {time}',
      accept: 'Accepter',
      decline: 'Refuser',
      declineConfirm: 'Refuser cette demande ? Le client devra choisir un autre point.',
      keep: 'Garder',
      declineYes: 'Oui, refuser',
      accepted: 'Demande acceptée. Le client va vous apporter le colis.',
      declined: 'Demande refusée.',
      answerFailed: 'Votre réponse n’a pas été envoyée. Réessayez.'
    },
    agentPickups: {
      title: 'Dépôts des clients',
      subtitle: 'Colis que les clients vous remettent en main propre',
      /** Badge on a parcel card that names the customer handing the parcel over. */
      clientLabel: 'Client',
      /** Second line of a pickup card: where the parcel goes once it leaves the point. */
      deliverTo: 'Destination',
      tabIncoming: 'À recevoir',
      tabReady: 'À remettre',
      tabSessions: 'Collectes',
      incomingEmpty: 'Aucun colis à recevoir',
      incomingEmptyHint: 'Les clients apparaîtront ici dès qu’ils choisiront votre point pour déposer un colis.',
      readyEmpty: 'Aucun colis à remettre',
      readyEmptyHint: 'Confirmez le dépôt d’un client pour proposer son colis à un livreur.',
      sessionsEmpty: 'Aucune collecte',
      sessionsEmptyHint: 'Les collectes apparaissent quand un client vous remet un colis.',
      scanTitle: 'Scanner les colis',
      scanStepPackages: 'Colis',
      scanStepPhoto: 'Photo',
      scanStepConfirm: 'Validation',
      scanHint: 'Scannez les colis un par un, puis prenez une photo avant de confirmer.',
      scanSelected: '{count} colis choisi(s)',
      scanRemove: 'Retirer ce colis',
      scanClearAll: 'Tout retirer',
      confirmHandover: 'Confirmer le dépôt',
      customerPresent: 'Le client est là et m’a remis ce colis',
      signatureRequired: 'La signature du client est obligatoire.',
      geolocationMissing: 'Votre position est introuvable. Activez la localisation.',
      photoRequired: 'Une photo est obligatoire.',
      photoBatchHint: 'Une seule photo suffit pour tous les colis.',
      parcelNotYours: 'Ce colis n’est pas dans votre liste.',
      reasonNotPickupPackage: 'Ce colis n’est pas un colis déposé par un client.',
      reasonAgentMismatch: 'Ce colis est lié à un autre point.',
      reasonAlreadyPickupReady: 'Ce colis est déjà prêt pour le livreur.',
      reasonInvalidState: 'Cette confirmation n’est pas possible à cette étape du colis.',
      reasonPodRejected: 'La preuve a été refusée pour ce colis.',
      reasonCodeInvalid: 'Code incorrect. Redemandez-le au client.',
      reasonCodeLocked: 'Trop de mauvais codes. Réessayez dans 15 minutes.',
      customerCodeTitle: 'Code du client',
      customerCodeHint: 'Demandez au client le code à 4 chiffres affiché dans son application.',
      customerCodeMissing: 'Entrez le code à 4 chiffres de chaque colis.',
      notReadyForCollection: 'Ce colis n’est pas encore prêt pour le livreur.',
      queuedOffline: 'Pas de connexion : la confirmation sera envoyée plus tard.',
      sessionTitle: 'Collecte',
      sessionReference: 'Référence {ref}',
      sessionParcelCount: '{count} colis',
      sessionEmpty: 'Aucun colis dans cette collecte.',
      createSession: 'Préparer la collecte',
      sessionCreated: 'Collecte prête. Montrez le code au livreur.',
      code: 'Code de remise',
      codeHint: 'Donnez ce code au livreur. Il est valable 15 minutes.',
      doneHint: 'Le livreur a pris ces colis. Il n’y a plus rien à faire.',
      codeCopied: 'Code copié',
      codeRefreshed: 'Nouveau code prêt',
      codeRefreshQueued: 'Nouveau code gardé. Il marchera dès que la connexion revient.',
      codeExpiresAt: 'Valable 15 minutes',
      codeExpired: 'Le code a expiré. Créez-en un nouveau.',
      codeMissing: 'Pas de code valable',
      codeInvalid: 'Code incorrect',
      codeSixDigits: 'Le code a 6 chiffres.',
      waitForCourier: 'Le livreur arrive',
      showCodeToCourier: 'Montrez ce code au livreur',
      assignedLivreur: 'Livreur choisi',
      livreurRequired: 'Choisissez le livreur qui viendra chercher ces colis.',
      noActiveLivreur: 'Aucun livreur disponible',
      reassignLivreur: 'Changer de livreur',
      reassignDone: 'Le livreur a été changé.',
      excludeParcel: 'Retirer ce colis',
      includedParcels: '{count} colis dedans',
      handoverTitle: 'Dépôt du client',
      handoverHint: 'Vérifiez le colis et le client avant de confirmer.',
      typeBadgePickup: 'Dépôt client',
      fromCustomer: 'Déposé par le client',
      tabCollected: 'Récupérées',
      statusWaiting: 'En attente du livreur',
      statusCollected: 'Récupérée par le livreur',
      collectedEmpty: 'Aucune collecte terminée',
      collectedEmptyHint: 'Les collectes que le livreur a terminées apparaîtront ici.',
      parcelsNoSession: 'Colis prêts sans collecte',
      openSessionHint: 'Ouvrir pour voir le code',
    },
    wallet: {
      label: 'Mon portefeuille',
      title: 'Mon argent',
      description: 'Votre solde, vos commissions et vos mouvements d’argent.',
      backendUnavailable: 'Service indisponible',
      noBackendAgent: 'Aucun agent trouvé',
      noBackendAgentDescription: 'Le portefeuille s’affichera dès qu’un agent existe.',
      profit: 'Mes gains',
      totalCommissionDescription: 'Total des commissions gagnées sur les colis livrés.',
      packagesCount: '{count} colis',
      noDeliveredProfit: 'Pas encore de gains',
      noDeliveredProfitDescription: 'La commission de chaque colis livré s’ajoutera ici.',
      history: 'Historique',
      movements: 'Mouvements',
      filters: {
        profit: 'Gains',
        cod: 'Argent encaissé',
        withdrawal: 'Retraits',
        all: 'Tout'
      },
      searchPlaceholder: 'Chercher un colis, un type…',
      loadingHistory: 'Chargement…',
      noEntries: 'Aucun mouvement',
      noEntriesDescription: 'Aucun mouvement ne correspond à ce filtre.',
      wallet: 'Portefeuille',
      summary: 'Résumé',
      availableToSettle: 'Disponible maintenant',
      pendingPayout: 'En attente de paiement',
      completedThisWeek: 'Terminés cette semaine',
      availableFromApi: 'Solde disponible',
      reservedCod: 'Argent à encaisser',
      withdrawableBalance: 'Solde à retirer',
      deliveredWeek: 'Livrés cette semaine',
      statuses: {
        credited: 'Ajouté',
        pending: 'En attente',
        withdrawn: 'Retiré'
      },
      movementsCount: '{count} mouvements',
      loadFailed: 'Impossible de charger le portefeuille.',
      courierFinance: 'Mon argent',
      collections: 'Argent encaissé',
      courierDescription: 'Vos commissions et paiements liés à vos tournées.',
      courierUnavailable: 'Portefeuille bientôt disponible',
      courierUnavailableDescription: 'Le portefeuille livreur n’est pas encore disponible.',
      requestWithdrawal: 'Demander un retrait',
      withdrawalAmount: 'Montant en MAD',
      withdrawalMethod: 'Comment être payé',
      withdrawalNote: 'Note (facultatif)',
      mobileWallet: 'Portefeuille mobile',
      bankTransfer: 'Virement bancaire',
      withdrawalHelp: 'Le montant est mis de côté tout de suite. L’équipe 3asass confirme le paiement ou refuse la demande.',
      withdrawalSubmitted: 'Demande envoyée. Le montant reste de côté jusqu’à la décision de l’équipe.',
      withdrawalFailed: 'Impossible d’envoyer la demande de retrait.',
      withdrawalAmountInvalid: 'Entrez un montant supérieur à zéro.',
      withdrawalQueue: 'Demandes de retrait',
      withdrawalQueueHelp: 'Vérifiez le montant et la personne à payer. Pour payer, entrez la référence du virement. Pour refuser, entrez la raison.',
      withdrawalQueueEmpty: 'Aucune demande de retrait.',
      withdrawalDecisionInput: 'Référence du paiement ou raison du refus',
      withdrawalDecisionHint: 'Ce champ sert de référence si vous payez, et de raison si vous refusez.',
      markPaid: 'Marquer comme payé',
      rejectWithdrawal: 'Refuser la demande',
      withdrawalPaid: 'Paiement enregistré.',
      withdrawalRejected: 'Demande refusée. L’argent est de nouveau dans le solde.',
      withdrawalStatuses: { pending: 'En attente', paid: 'Payé', rejected: 'Refusé' }
    },
    adminAgentDetail: {
      sheet: 'Fiche de l’agent',
      backendUnavailable: 'Service indisponible',
      actionDenied: 'Action refusée',
      loadFailed: 'Impossible de charger l’agent.',
      actionFailed: 'Ça n’a pas marché.',
      mediaLoadFailed: 'Impossible de charger les documents d’identité.',
      copyAgentId: 'Copier l’identifiant de l’agent',
      copyResidenceId: 'Copier l’identifiant du point',
      activation: 'Activation',
      ready: 'Prêt',
      pending: 'En attente',
      status: 'Statut: {status}',
      wallet: 'Portefeuille',
      guaranteeAvailable: 'Caution disponible',
      reserved: 'Réservé',
      withdrawableAmount: 'Retirable',
      relay: 'Point',
      performance: 'Performance',
      deliveriesLabel: 'Livraisons',
      successRateLabel: 'Taux de succès',
      deliveries: 'Livraisons: {count}',
      success: 'Succès: {rate}%',
      exceptions: 'Problèmes : {rate}%',
      checklist: 'À vérifier',
      preactivation: 'Avant l’activation',
      missing: 'Manquant',
      activate: 'Activer',
      kyc: 'Identité',
      agentDocuments: 'Documents de l’agent',
      identityDocument: 'Pièce d’identité',
      identityDocumentHelp: 'Document national ou équivalent.',
      residenceProof: 'Justificatif de résidence',
      residenceProofHelp: 'Facture, attestation ou preuve sur place.',
      facePhoto: 'Photo visage',
      facePhotoHelp: 'Photo claire de l’agent.',
      validateKyc: 'Valider l’identité',
      agentInfo: 'Informations de l’agent',
      profileDetails: 'Détails du profil',
      agentInfoHelp: 'Changez le profil sans recréer le compte.',
      saveInfo: 'Enregistrer',
      escrow: 'Caution',
      cashManagement: 'Argent remis',
      escrowHelp: 'Notez l’argent que l’agent a remis au responsable terrain.',
      amountMad: 'Montant (MAD)',
      escrowNote: 'Note obligatoire, par ex. : caution de départ reçue en espèces',
      record: 'Enregistrer',
      escrowRule: 'Montant supérieur à 0 MAD et note d’au moins 10 caractères',
      escrowHistory: 'Historique des cautions',
      escrowHistoryHelp: 'Recharges de caution enregistrées dans le portefeuille.',
      noEscrow: 'Aucune caution enregistrée pour cet agent.',
      statusActions: 'Changer le statut',
      statusActionsHelp: 'Suspension temporaire ou arrêt définitif.',
      reactivate: 'Réactiver',
      suspensionReason: 'Raison de la suspension',
      requiredReason: 'La raison est obligatoire',
      suspend: 'Suspendre',
      confirmationName: 'Nom complet, pour désactiver',
      disable: 'Désactiver',
      suspensionRule: 'Suspension : raison de 10 caractères au moins. Désactivation : la même raison et le nom complet exact.',
      reassignResidence: 'Changer le point',
      reassign: 'Changer',
      returnsCap: 'Limite de retours',
      adjust: 'Modifier',
      unavailableDate: 'Date inconnue',
      profileCompleted: 'Profil complet',
      identityDoc: 'Carte d’identité',
      residenceProofShort: 'Justificatif de domicile',
      facePhotoShort: 'Photo du visage',
      kycValidated: 'Identité confirmée',
      escrowRecorded: 'Caution enregistrée'
    },
    adminCourierDetail: {
      sheet: 'Fiche du livreur',
      backendUnavailable: 'Service indisponible',
      actionDenied: 'Action refusée',
      loadFailed: 'Impossible de charger le livreur.',
      suspendFailed: 'Suspension impossible.',
      reactivateFailed: 'Réactivation impossible.',
      dropsToday: 'Drops aujourd’hui',
      dropsTodayHelp: 'Dépôts enregistrés sur la journée.',
      lastActivity: 'Dernière activité',
      account: 'Compte',
      noActivity: 'Aucune activité',
      dateUnavailable: 'Date non disponible',
      dropHistory: 'Historique drops',
      dropHistoryHelp: 'Les derniers dépôts du jour apparaîtront ici.',
      noDetailedDrops: 'Aucun dépôt détaillé pour ce livreur.',
      suspension: 'Suspension',
      suspensionHelp: 'Coupe tout de suite l’accès du livreur.',
      reasonPlaceholder: 'Motif obligatoire, minimum 10 caractères',
      suspend: 'Suspendre le livreur',
      suspensionRule: 'La suspension demande un motif de 10 caractères minimum.',
      reactivation: 'Réactivation',
      reactivationHelp: 'Possible seulement si le livreur est suspendu.',
      reactivate: 'Réactiver le livreur'
    },
    adminLists: {
      relayAgents: 'Agents des points',
      agentManagement: 'Gestion agents',
      agentDescription: 'Suivi opérationnel des gardiens, KYC, charge active et soldes wallet.',
      createAgent: 'Créer agent',
      active: 'Actifs',
      pending: 'En attente',
      suspended: 'Suspendus',
      withdrawable: 'Retirable',
      status: 'Statut',
      load: 'Charge',
      relay: 'Point',
      loadAgentsFailed: 'Impossible de charger les agents.',
      agentSearch: 'Nom, téléphone, point…',
      noAgents: 'Aucun agent',
      agentsEmpty: 'Les agents créés apparaîtront ici.',
      copyAgentId: 'Copier l’ID agent',
      copyResidenceId: 'Copier l’ID résidence',
      validated: 'Validé',
      toValidate: 'À valider',
      activeCount: '{count} active(s)',
      couriersTitle: 'Livreurs',
      couriersDescription: 'Suivi des comptes livreurs, des suspensions et des dépôts.',
      dropsToday: 'Drops aujourd’hui',
      lastActivity: 'Dernière activité',
      dropsDay: 'Drops jour',
      accounts: 'Comptes',
      courierSearch: 'Nom ou téléphone...',
      noCouriers: 'Aucun livreur',
      couriersEmpty: 'Les livreurs créés par OTP apparaîtront ici.',
      loadCouriersFailed: 'Impossible de charger les livreurs.',
      noActivity: 'Aucune activité',
      statuses: {
        pending: 'En attente',
        active: 'Actif',
        suspended: 'Suspendu',
        disabled: 'Désactivé'
      }
    },
    residences: {
      relay: 'Relais',
      title: 'Résidences',
      description: 'Gérez les points disponibles pour choisir les agents et recevoir les colis.',
      add: 'Ajouter résidence',
      total: 'Total',
      active: 'Actives',
      inactiveCount: '{count} désactivées',
      linkedAgents: 'Agents liés',
      linkedPackages: 'Colis liés',
      tableView: 'Tableau',
      mapView: 'Carte',
      mapTitle: 'Carte des résidences',
      mapSubtitle: 'Tous les relais disponibles',
      mapDescription: 'Voyez les points sur la carte, choisissez-en un et ouvrez sa fiche.',
      coverage: 'Couverture',
      mappableCount: '{count} résidences avec coordonnées GPS.',
      selectedRelay: 'Relais sélectionné',
      address: 'Adresse',
      gps: 'GPS',
      actions: 'Actions',
      inactive: 'Désactivée',
      searchPlaceholder: 'Nom, adresse, ville...',
      emptyTitle: 'Aucune résidence',
      emptyDescription: 'Ajoutez une résidence pour commencer l’affectation des colis.',
      edit: 'Modifier',
      deactivate: 'Désactiver',
      editTitle: 'Modifier résidence',
      addTitle: 'Ajouter résidence',
      residenceId: 'ID résidence',
      osmSearch: 'Recherche OpenStreetMap',
      osmPlaceholder: 'Résidence, rue, quartier, ville...',
      searchRequired: 'Saisis une adresse ou un nom de résidence.',
      noMoroccoResult: 'Aucun résultat trouvé au Maroc.',
      geolocationUnavailable: 'La géolocalisation navigateur n’est pas disponible.',
      geolocationFailed: 'Impossible de récupérer la position navigateur.',
      morocco: 'Maroc',
      name: 'Nom',
      latitude: 'Latitude',
      longitude: 'Longitude',
      activeCheckbox: 'Active',
      mapHelp: 'Clique sur la carte pour placer le marqueur. Tu peux aussi zoomer et déplacer la carte.',
      openOsm: 'Ouvrir dans OpenStreetMap',
      osmDisclaimer: 'Les données d’adresse viennent d’OpenStreetMap. Vérifie toujours l’adresse avant l’enregistrement.',
      create: 'Créer',
      validationRequired: 'Nom, adresse et ville sont obligatoires.',
      invalidLatitude: 'Latitude invalide.',
      invalidLongitude: 'Longitude invalide.',
      actionFailed: 'Action impossible.'
    },
    publicTracking: {
      unavailable: 'Suivi indisponible',
      unavailableMessage: 'Ce code est introuvable, ou le suivi est indisponible pour le moment.',
      label: 'Suivi du colis',
      backHome: 'Retour à l’accueil',
      package: 'Colis',
      recipient: 'Destinataire :',
      hiddenRecipient: 'Caché jusqu’à l’arrivée au point',
      operatorReference: 'Référence de suivi :',
      relay: 'Point de livraison',
      relayPending: 'Le point sera visible quand l’agent aura reçu le colis.',
      agent: 'Agent',
      agentPending: 'Visible quand le colis arrive au point',
      dates: 'Dates',
      dropped: 'Déposé :',
      received: 'Reçu :',
      out: 'En livraison :',
      delivered: 'Livré :',
      map: 'Carte',
      relayPosition: 'Où se trouve le point',
      trackingTimeline: 'Avancement du colis',
      createdTitle: 'Colis créé',
      createdDescription: 'Le colis est enregistré.',
      en_route: 'En route :',
      enRouteTitle: 'En route vers le point',
      enRouteDescription: 'Le livreur a pris le colis et va vers le point.',
      droppedTitle: 'Déposé au point',
      droppedDescription: 'Le livreur a déposé le colis au point.',
      receivedTitle: 'Reçu par l’agent',
      receivedDescription: 'L’agent a confirmé qu’il a reçu le colis.',
      outTitle: 'En livraison',
      outDescription: 'Le colis est en route vers le destinataire.',
      deliveredTitle: 'Livré',
      deliveredDescription: 'Le colis a été remis, avec une preuve de livraison.',
      failedTitle: 'Livraison non réussie',
      failedDescription: 'La livraison n’a pas réussi.',
      noMapBeforeReceived: 'La carte apparaît quand l’agent a reçu le colis.',
      returnRequest: 'Demande de retour',
      returnRequestTitle: 'Demander un retour',
      returnPageDescription: 'Entrez vos coordonnées et le code du colis. L’équipe vérifie votre demande avant de lancer le retour.',
      returnName: 'Votre nom complet',
      returnPhone: 'Votre téléphone',
      returnAddress: 'Votre adresse',
      returnPackageCode: 'Code du colis',
      returnNote: 'Message pour l’équipe',
      returnSubmit: 'Envoyer ma demande',
      returnFormRequired: 'Le nom, le téléphone, l’adresse et le code du colis sont obligatoires.',
      returnSubmitted: 'Demande envoyée.',
      returnSubmittedDetail: 'Nous avons bien reçu votre demande. L’équipe 3asass la vérifie avant de lancer le retour.',
      returnFailed: 'Impossible d’envoyer la demande.'
    },
    documents: {
      view: 'Voir le document',
      unavailable: 'Document indisponible'
    },
    exception: {
      title: 'Signaler un problème',
      reason: 'Raison',
      operationalNote: 'Détails (facultatif)',
      submit: 'Envoyer',
      queued: 'Problème gardé sur le téléphone. Il sera envoyé avec la connexion.',
      synced: 'Problème envoyé.',
      rejected: 'Le problème n’a pas été accepté. Réessayez.',
      notAllowedForState: 'Vous ne pouvez signaler aucun problème à cette étape.',
      recipientAbsent: 'Destinataire absent',
      refused: 'Destinataire a refusé',
      damagedAtReceipt: 'Abîmé à la réception',
      damagedAtDelivery: 'Abîmé pendant le trajet',
      lost: 'Colis perdu',
      wrongContent: 'Contenu non conforme ou suspect',
      unreachable: 'Destinataire injoignable',
      adminOverride: 'Modifié par l’administration',
      returnApproved: 'Retour accepté',
      returnRejected: 'Retour refusé',
      photoLabel: 'Photo du problème',
      photoHelp: 'Facultatif, mais conseillé. Prenez une photo qui montre le problème.',
      agentLabel: 'Problème avec un colis',
      agentTitle: 'Signaler un problème',
      agentEligibleStates: 'Possible quand le colis est reçu, en livraison, en échec ou en litige.',
      noPackageSelected: 'Aucun colis choisi. Retournez à la fiche du colis et choisissez « Signaler un problème ».',
      courierLabel: 'Problème au dépôt',
      courierTitle: 'Signaler un problème',
      courierDescription: 'À utiliser si un colis déposé chez l’agent a un problème avant sa réception.'
    },
    podMedia: {
      signedPod: 'Preuve signée',
      operationalProofs: 'Preuves de livraison',
      courierDropPhoto: 'Photo du dépôt par le livreur',
      courierDropPhotoAlt: 'Photo du dépôt {index}',
      noDropPhoto: 'Pas de photo de dépôt',
      courierPickupPhoto: 'Photos de la collecte',
      courierPickupPhotoAlt: 'Photo de la collecte {index}',
      noCourierPickupPhoto: 'Pas de photo de collecte',
      receptionPhotos: 'Photos de la réception',
      receptionPhotoAlt: 'Photo de réception {index}',
      noReceptionPhoto: 'Pas de photo de réception',
      deliveryPhoto: 'Photo de la livraison',
      noPhoto: 'Pas de photo',
      signature: 'Signature du destinataire',
      noSignature: 'Pas de signature',
      customerHandoverPhotos: 'Photos du dépôt par le client',
      customerHandoverPhotoAlt: 'Photo du dépôt par le client {index}',
      customerHandoverSignature: 'Signature du client (dépôt chez l’agent)',
      noCustomerHandoverSignature: 'Pas de signature du client.',
      noCustomerHandoverPhoto: 'Pas de photo du dépôt par le client',
      exceptionsAndReturns: 'Problèmes et retours',
      incidentProofs: 'Preuves du problème',
      exceptionPhotos: 'Photos du problème',
      exceptionPhotoAlt: 'Photo du problème {index}',
      noExceptionPhoto: 'Pas de photo du problème',
      returnAgentPhotos: 'Photos du retour chez l’agent',
      returnAgentPhotoAlt: 'Photo du retour chez l’agent {index}',
      noReturnAgentPhoto: 'Pas de photo du retour chez l’agent',
      returnCourierPhotos: 'Photos du retour pris par le livreur',
      returnCourierPhotoAlt: 'Photo du retour pris par le livreur {index}',
      senderReturnPhotos: 'Photos du colis rendu à l’expéditeur',
      senderReturnPhotoAlt: 'Photo du colis rendu à l’expéditeur {index}',
      noReturnCourierPhoto: 'Pas de photo du retour pris par le livreur'
    },
    timeline: {
      history: 'Historique du colis',
      lifecycle: 'Étapes',
      empty: 'Aucun événement pour ce colis.',
      gpsPosition: 'Position sur la carte',
      viewGps: 'Voir la position',
      transitions: {
        awaitingPickupToPickupReady: 'Dépôt du client chez l’agent confirmé',
        pickupReadyToEnRoute: 'Colis pris par le livreur chez l’agent',
        pickupToCancelled: 'Dépôt annulé',
        pickupReadyToReceived: 'Colis reçu du client au relais',
        enRouteToDropped: 'Colis déposé au relais par le livreur',
        droppedToReceived: 'Colis reçu au relais',
        receivedToOut: 'En livraison',
        receivedToOutHold: 'Le destinataire est là : remise commencée',
        outToDelivered: 'Remis au destinataire',
        outToDeliveredHold: 'Retiré par le destinataire',
        toFailed: 'Livraison échouée',
        toReturnRequested: 'Retour lancé',
        returnRequestedToDeposited: 'Colis retourné déposé au relais',
        depositedToCollected: 'Colis retourné pris par le livreur',
        toDisputed: 'Litige ouvert',
        disputedToDelivered: 'Litige réglé : livré',
        disputedToFailed: 'Litige réglé : échec',
        failedToReceived: 'Nouvelle tentative de livraison',
        toCancelled: 'Colis annulé',
        createdToEnRoute: 'Colis pris chez l’expéditeur'
      },
      actions: {
        transition: 'Changement d’étape',
        en_route: 'En route vers le point',
        partner_return: 'Retour au partenaire',
        state_changed: 'Changement d’étape'
      },
      descriptions: {
        partnerReturn: 'Le partenaire a confirmé qu’il a bien reçu le colis retourné.',
        auditEvent: 'Action enregistrée dans l’historique.',
        system: 'Système'
      },
      showAll: '+{count} étapes',
      showLess: 'Réduire'
    },
    podUpload: {
      title: 'Preuves de livraison',
      assets: 'Fichiers de preuve',
      addPhoto: 'Ajouter une photo',
      ready: 'Prêt',
      missing: 'Manquant',
      uploaded: 'Envoyé'
    },
    logisticsUi: {
      photo: 'Photo',
      takePhoto: 'Prendre une photo',
      upload: 'Choisir un fichier',
      removePhoto: 'Retirer la photo',
      compression: 'Un instant…',
      noFileSelected: 'Aucun fichier choisi',
      compressionUnavailable: 'La photo n’a pas pu être réduite. La photo d’origine est utilisée.',
      photosSelected: '{count} photo(s) choisie(s)',
      photoLimitReached: 'Vous avez atteint la limite de {max} photos.',
      removeAllPhotos: 'Retirer toutes les photos',
      proofPhoto: 'Photo {index}',
      qrScanner: {
        label: 'Scanner de QR code',
        httpsRequired: 'La caméra ne marche qu’en connexion sécurisée (HTTPS). Tapez le code ci-dessous.',
        cameraUnavailable: 'La caméra n’est pas disponible sur cet appareil.',
        cameraDenied: 'L’accès à la caméra a été refusé, ou la caméra n’a pas démarré.'
      },
      packageVerification: 'Vérifier le colis',
      start: 'Démarrer',
      stop: 'Arrêter',
      qrHelp: 'Mettez la caméra devant le QR code du colis.',
      manualPackageCode: 'Ou tapez le code du colis',
      confirm: 'Confirmer',
      signaturePad: 'Espace pour signer',
      proofOfDelivery: 'Preuve de livraison',
      clear: 'Effacer',
      signatureReady: 'Signature prise.',
      signatureTooSmall: 'La signature est trop petite. Signez plus grand dans le cadre.',
      signatureRequired: 'La signature du client est obligatoire.'
    },
    sync: {
      synced: 'Envoyé',
      pending: 'En attente',
      syncing: 'Envoi en cours',
      failed: 'Envoi échoué',
      conflict: 'Problème à vérifier',
      conflictProofRetained: 'La preuve reste sur ce téléphone. Demandez une vérification avant de la renvoyer.',
      inProgressRetry: 'Le serveur travaille encore. Réessayez dans quelques secondes. Votre preuve est gardée.',
      offline: 'Pas de connexion',
      title: 'Envoi des données',
      description: 'Quand il n’y a pas de réseau, vos actions sont gardées sur le téléphone et envoyées dès que la connexion revient.',
      emptyQueue: 'Rien à envoyer',
      syncNow: 'Envoyer maintenant'
    },
    nav: {
      groups: { operations: 'Activité', network: 'Réseau', finance: 'Argent', system: 'Système' },
      overview: 'Vue globale',
      settings: 'Paramètres',
      packages: 'Colis',
      createPackage: 'Créer',
      returnRequests: 'Signalements et retours',
      returnIncidents: 'Retours bloqués',
      cancellationRequests: 'Demandes d’annulation',
      orderRequests: 'Demandes plateforme',
      partners: 'Partenaires',
      customers: 'Clients',
      exceptions: 'Problèmes',
      agents: 'Agents',
      residences: 'Points',
      couriers: 'Livreurs',
      settlements: 'Règlements',
      withdrawals: 'Retraits',
      platformConfig: 'Configuration',
      audit: 'Historique',
      route: 'Tournée',
      drop: 'Dépôt',
      sessions: 'Remises',
      handovers: 'Arrivées',
      returns: 'Retours',
      scan: 'Scanner',
      sync: 'Envoi',
      balance: 'Solde',
      home: 'Accueil',
      money: 'Argent',
      pickups: 'Dépôts'
    },
    pwa: {
      home: 'Accueil',
      roles: {
        agent: 'Agent',
        courier: 'Livreur',
        customer: 'Client',
      },
      greeting: 'Bonjour {name}',
      greetingFallback: 'Bonjour',
      buckets: {
        action: 'À faire',
        problems: 'Problèmes',
        done: 'Terminés',
        incoming: 'À venir',
        ready: 'Prêts à remettre',
        pickup: 'À récupérer',
      },
      scan: 'Scanner',
      packagesNav: 'Colis',
      pickups: 'Dépôts',
      lifecycle: { all: 'Toutes les étapes' },
      filters: { title: 'Filtrer', stageHint: 'Affichez seulement les colis à une étape.' },
      returns: 'Retours',
      money: 'Argent',
      profile: 'Mon profil',
      logout: 'Se déconnecter',
      online: 'Connecté',
      offline: 'Pas de connexion',
      wallet: {
        available: 'Solde disponible',
        reservedCod: 'Argent à encaisser',
        weeklyDelivered: 'Livrés cette semaine',
        earnings: 'Mes gains',
        perParcel: 'Par colis',
        seeEarnings: 'Voir mes gains',
        viewDetails: 'Voir le détail',
      },
      actions: {
        scan: 'Scanner',
        scanDesc: 'Avec le QR code',
        more: 'Autres actions ({count})',
        create: 'Créer',
        createDesc: 'Nouveau colis',
        handovers: 'Arrivées',
        handoversDesc: 'Colis reçus',
        returns: 'Retours',
        returnsDesc: 'Colis renvoyés',
      },
      todayDeliveries: {
        title: 'À livrer aujourd’hui',
        empty: 'Aucun colis à livrer aujourd’hui.',
        cod: 'À encaisser',
        phone: 'Téléphone',
        address: 'Adresse',
      },
      packages: {
        title: 'Mes colis',
        searchPlaceholder: 'Chercher un colis…',
        filterAll: 'Tous',
        filterPending: 'En attente',
        filterInProgress: 'En cours',
        filterDelivered: 'Livrés',
        empty: 'Aucun colis trouvé.',
        loadFailed: 'Impossible de charger les colis.',
        bulk: {
          title: 'Choisir plusieurs colis',
          hint: 'Cochez plusieurs colis, puis faites l’action une seule fois.',
          enter: 'Choisir des colis',
          exit: 'Terminer',
          selectLoaded: 'Tout choisir ({count})',
          selectedCount: '{count} colis choisis',
          noEligible: 'Aucun de ces colis ne peut faire cette action.',
          clear: 'Tout décocher',
          remove: 'Retirer',
          reviewTitle: 'Colis choisis',
          reviewEmpty: 'Vous n’avez rien choisi pour l’instant.'
        },
      },
    },
    partners: {
      title: 'Partenaires',
      description: 'Comptes des expéditeurs, crédit, statut et frais de livraison.',
      partner: 'Partenaire',
      create: 'Nouveau partenaire',
      createPartner: 'Créer un partenaire',
      editPartner: 'Modifier le partenaire',
      companyName: 'Société',
      contactName: 'Nom du contact',
      contactPhone: 'Téléphone du contact',
      contactEmail: 'E-mail du contact',
      contact: 'Contact',
      agent: 'Agent',
      credit: 'Crédit',
      creditBalance: 'Solde du crédit',
      lowCreditThresholdMad: 'Crédit minimum avant alerte (MAD)',
      threshold: 'Minimum',
      activePartners: 'Partenaires actifs',
      lowCredit: 'Crédit bas',
      creditBlocked: 'Crédit épuisé',
      availableCredit: 'Crédit disponible',
      reservedFees: 'Frais mis de côté',
      balanceLabel: 'Solde',
      totalCredit: 'Crédit total',
      backToList: 'Liste des partenaires',
      addCredit: 'Ajouter du crédit',
      recordTopup: 'Enregistrer la recharge',
      amount: 'Montant',
      amountMad: 'Montant (MAD)',
      note: 'Note',
      postedAt: 'Date',
      postedFrom: 'Depuis',
      postedTo: 'Jusqu’à',
      entryType: 'Type',
      searchPlaceholder: 'Société, contact, e-mail, téléphone…',
      creditSearchPlaceholder: 'Référence, note, destinataire…',
      emptyTitle: 'Aucun partenaire',
      emptyDescription: 'Les partenaires créés apparaîtront ici.',
      noCreditEntries: 'Aucun mouvement de crédit',
      noCreditEntriesDescription: 'Les recharges et les frais de livraison apparaîtront ici.',
      noPartner: 'Sans partenaire',
      portalPassword: 'Mot de passe de l’espace partenaire',
      portalPasswordUpdate: 'Nouveau mot de passe',
      portalPasswordHelp: 'Facultatif. 12 caractères au moins. Si vide, l’accès n’est ni créé ni modifié.',
      portalPasswordInvalid: 'Le mot de passe doit avoir au moins 12 caractères.',
      portalEnabled: 'Accès activé',
      portalDisabled: 'Accès désactivé',
      actionFailed: 'Ça n’a pas marché.',
      companyRequired: 'Le nom de la société est obligatoire.',
      contactRequired: 'Le nom du contact est obligatoire.',
      phoneRequired: 'Le téléphone est obligatoire.',
      emailRequired: 'L’e-mail est obligatoire.',
      thresholdInvalid: 'Le minimum doit être un montant positif.',
      amountInvalid: 'Le montant doit être supérieur à zéro.',
      noteRequired: 'Ajoutez une note claire.',
      requested: 'Demandé',
      copyPartnerId: 'Copier l’identifiant du partenaire',
      unsettledExposure: 'Colis pas encore réglés',
      balanceAfterExposure: 'Solde après ces colis',
      needsCreditAttention: 'Crédit à surveiller',
      creditOperational: 'Crédit suffisant',
      submittedByPartner: 'Envoyés par ce partenaire',
      creditActivity: 'Mouvements du crédit',
      topupsAndFees: 'Recharges et frais de livraison',
      financeViewHelp: 'Aperçu rapide avant d’ouvrir le détail.',
      credited: 'Ajouté',
      feesDebited: 'Frais retirés',
      pendingTopup: 'Recharge en attente',
      latestMovement: 'Dernier mouvement',
      noCreditMovement: 'Aucun mouvement pour l’instant.',
      topupRequests: 'Demandes de recharge',
      reviewQueue: 'À traiter',
      partnerAccess: 'Accès du partenaire',
      statusActions: 'Changer le statut',
      statusActionsHelp: 'Décidez si ce partenaire peut se connecter et créer des colis.',
      portalActive: 'L’accès du partenaire est actif.',
      portalSuspended: 'L’accès du partenaire est suspendu pour le moment.',
      portalClosed: 'Le compte du partenaire est fermé.',
      statusImpact: 'Un partenaire suspendu ou fermé ne peut plus créer de colis. Son historique reste visible pour l’équipe.',
      searchTopupRequests: 'Chercher une demande de recharge…',
      noTopupRequests: 'Aucune demande de recharge',
      noTopupRequestsDescription: 'Les demandes de recharge des partenaires apparaîtront ici.',
      bankTransferReceived: 'Virement bancaire reçu.',
      approveTopupRequest: 'Accepter la demande de recharge',
      rejectTopupRequest: 'Refuser la demande de recharge',
      request: 'Demande',
      noPartnerNote: 'Pas de note du partenaire.',
      rejectRequestPlaceholder: 'Expliquez pourquoi vous refusez…',
      approveRequest: 'Accepter la demande',
      rejectRequest: 'Refuser la demande',
      suspendPartner: 'Suspendre le partenaire',
      closePartner: 'Fermer le compte',
      reactivatePartner: 'Réactiver le partenaire',
      suspendPartnerHelp: 'Bloque pour un temps l’accès du partenaire et la création de colis.',
      closePartnerHelp: 'Ferme le compte et bloque tout. À utiliser seulement si la collaboration est terminée.',
      reactivatePartnerHelp: 'Rend l’accès au partenaire. Il peut créer des colis si son crédit est suffisant.',
      statusReasonRequired: 'Écrivez une raison claire d’au moins 10 caractères.',
      statusReasonPlaceholder: 'Expliquez pourquoi vous faites cette action…',
      active: 'Actif',
      suspended: 'Suspendu',
      closed: 'Fermé',
      status: {
        active: 'Actif',
        suspended: 'Suspendu',
        closed: 'Fermé'
      },
      entry: {
        credit_topup: 'Recharge',
        partner_fee_debit: 'Frais de livraison',
        credit_adjustment: 'Correction du crédit'
      }
    },
    adminCustomers: {
      title: 'Clients',
      subtitle: 'Comptes clients et crédit de livraison',
      searchPlaceholder: 'Chercher un client…',
      empty: 'Aucun client trouvé.',
      balance: 'Solde',
      available: 'Disponible',
      exposed: 'Mis de côté',
      threshold: 'Seuil d’alerte',
      totalPackages: 'Colis au total',
      deliveredPackages: 'Colis livrés',
      lastSync: 'Dernière mise à jour',
      lastActivity: 'Dernière activité',
      detailTitle: 'Fiche du client',
      detailSubtitle: 'Crédit, livraisons et demandes de recharge',
      contact: 'Contact',
      customerSince: 'Client depuis',
      packagesSection: 'Colis du client',
      orderRequestsSection: 'Demandes d’envoi',
      returnsSection: 'Demandes de retour',
      creditLedger: 'Mouvements du crédit',
      creditLedgerEmpty: 'Aucun mouvement de crédit.',
      creditRequests: 'Demandes de recharge',
      creditRequestsEmpty: 'Aucune demande de recharge.',
      topupTitle: 'Demande de recharge',
      topupAmount: 'Montant',
      topupNote: 'Motif',
      topupSubmit: 'Envoyer au client',
      approveRequest: 'Accepter',
      rejectRequest: 'Refuser',
      adminNote: 'Note de l’équipe',
      adminNotePlaceholder: 'Visible seulement par l’équipe',
      entryTypeCreditTopup: 'Recharge',
      entryTypeDeliveryFeeDebit: 'Frais de livraison',
      entryTypeCreditAdjustment: 'Correction du crédit',
      requestStatusPending: 'En attente',
      requestStatusApproved: 'Acceptée',
      requestStatusRejected: 'Refusée',
      pickupEnabled: 'Dépôts de clients',
      pickupEnabledHint: 'Les clients pourront choisir cet agent comme point de dépôt.',
      pickupEnabledOn: 'Activé',
      pickupEnabledOff: 'Désactivé',
      configPickupTypeEnabled: 'Dépôts de clients (général)',
      configPickupTypeEnabledHint: 'Interrupteur général. Désactivé : aucun point de dépôt n’est proposé et aucun colis client n’est créé.',
      configCustomerFee: 'Prix d’une livraison pour le client',
      configCustomerFeeHint: 'Ce prix est noté quand un agent accepte le colis d’un client. Ce n’est pas une preuve de paiement.',
      configSaved: 'Réglage enregistré',
      orderRequestPickupPoint: 'Point de dépôt',
      orderRequestPickupHint: 'Le client a déjà choisi son point de dépôt. Gardez-le ou choisissez-en un autre.',
      orderRequestSelectPickupPoint: 'Point de dépôt',
      orderRequestNoPoints: 'Aucun agent ne peut prendre ce colis.',
      orderRequestPickupNone: 'Livraison directe à l’adresse',
      packagePickupPoint: 'Point de dépôt',
      packagePickupAgent: 'Agent',
      packageHandoverAt: 'Remis à l’agent le',
      packageCollectedAt: 'Pris par le livreur le',
      customerCreditExhausted: 'Crédit épuisé : le client doit recharger.',
    },
    partnerPortal: {
      portal: 'Espace partenaire',
      dashboard: 'Accueil',
      dashboardDescription: 'Suivez votre crédit, vos colis envoyés et les livraisons en cours.',
      loginTitle: 'Connexion partenaire',
      loginDescription: 'Accès réservé aux partenaires créés par l’équipe 3asass.',
      login: 'Se connecter',
      submitPackage: 'Ajouter un colis',
      submitDescription: 'Créez un colis pour votre client. Votre compte partenaire est ajouté automatiquement.',
      myPackages: 'Mes colis',
      myPackagesDescription: 'Vos colis avec leur étape, leur point de livraison et le montant à encaisser.',
      packageDetail: 'Détails du colis',
      timeline: 'Suivi',
      packageProgress: 'Où en est le colis',
      timelineCreatedTitle: 'Colis créé',
      timelineCreatedDescription: 'Le colis est enregistré dans 3asass et attend d’être pris en charge.',
      timelineDroppedTitle: 'Déposé au point',
      timelineDroppedDescription: 'Le livreur a déposé le colis au point prévu.',
      timelineReceivedTitle: 'Reçu par l’agent',
      timelineReceivedDescription: 'L’agent a confirmé qu’il a bien reçu le colis.',
      timelineOutTitle: 'En livraison',
      timelineOutDescription: 'Le colis part vers le destinataire.',
      timelineDeliveredTitle: 'Livré',
      timelineDeliveredDescription: 'Le colis est livré, avec la preuve de livraison.',
      timelineReturnRequestedTitle: 'Retour demandé',
      timelineReturnRequestedDescription: 'Une demande de retour a été acceptée par l’équipe.',
      timelineReturnDepositedTitle: 'Retour déposé',
      timelineReturnDepositedDescription: 'L’agent a déposé le colis retourné, prêt à être récupéré.',
      timelineReturnCollectedTitle: 'Retour récupéré',
      timelineReturnCollectedDescription: 'Le retour est récupéré. Il attend votre confirmation.',
      partnerConfirmed: 'Confirmé par le partenaire',
      returnReception: 'Réception du retour',
      waitingReturnPackages: 'Retours à confirmer',
      waitingReturnPackagesDescription: 'Colis revenus chez vous, en attente de votre confirmation.',
      confirmReturnReceived: 'Confirmer la réception du retour',
      confirmReturnReceivedDescription: 'Confirmez seulement après avoir reçu le colis en main.',
      returnAlreadyConfirmed: 'Retour déjà confirmé',
      returnConfirmedAt: 'Confirmé le {date}',
      returnReceiptConfirmed: 'Réception du retour confirmée.',
      returnReceiptFailed: 'Impossible de confirmer la réception.',
      noWaitingReturns: 'Aucun retour à confirmer.',
      timelinePartnerReturnReceivedTitle: 'Retour reçu par le partenaire',
      timelinePartnerReturnReceivedDescription: 'Le partenaire a confirmé qu’il a repris le colis.',
      podVisibilityTitle: 'Preuves de livraison',
      podReadyTitle: 'Preuve disponible',
      podHiddenTitle: 'Preuve pas encore disponible',
      podVisibilityDescription: 'Les preuves de ce colis sont ci-dessous. Touchez une preuve pour l’agrandir.',
      podPendingDescription: 'Les preuves apparaîtront ici au fur et à mesure des étapes du colis.',
      podDeliveredEmpty: 'Le colis est livré, mais aucune preuve n’est encore disponible.',
      podPendingEmpty: 'Aucune preuve pour l’instant.',
      deliveryPhoto: 'Photo de la livraison',
      signature: 'Signature',
      dropPhoto: 'Photo du dépôt',
      receptionPhoto: 'Photo de la réception',
      exceptionPhoto: 'Photo du problème',
      creditAccount: 'Mon crédit',
      creditDescription: 'Recharges, frais et corrections sur votre compte partenaire.',
      reports: 'Rapports',
      reportsDescription: 'Résumé du mois : colis, réussite, délais et frais.',
      profileTitle: 'Profil partenaire',
      profileDescription: 'Changez les informations de l’entreprise, les contacts et le mot de passe.',
      companyInfo: 'Informations de l’entreprise',
      contactCard: 'Contact',
      portalEnabled: 'Accès activé',
      portalDisabled: 'Accès désactivé',
      security: 'Sécurité',
      changePassword: 'Changer le mot de passe',
      passwordDescription: 'Le mot de passe doit avoir au moins 12 caractères.',
      currentPassword: 'Mot de passe actuel',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      passwordsDoNotMatch: 'Les deux mots de passe ne sont pas identiques.',
      saveProfile: 'Enregistrer',
      savePassword: 'Changer le mot de passe',
      profileSaved: 'Profil enregistré.',
      passwordSaved: 'Mot de passe changé.',
      profileSaveFailed: 'Impossible d’enregistrer le profil.',
      passwordSaveFailed: 'Impossible de changer le mot de passe.',
      actionFailed: 'Ça n’a pas marché',
      lowCreditWarning: 'Votre crédit est sous le minimum de {amount}. Contactez l’équipe 3asass pour le recharger.',
      submittedToday: 'Envoyés aujourd’hui',
      reservedFees: 'Frais mis de côté',
      reservedFeesDescription: 'Frais des colis pas encore réglés',
      available: 'Disponible',
      availableAfterFees: 'Après les frais mis de côté',
      successToday: 'Réussis aujourd’hui',
      deliveredToday: '{count} livré(s) aujourd’hui',
      recentPackages: 'Derniers colis',
      viewAll: 'Voir tout',
      noPackagesSubmitted: 'Aucun colis pour l’instant.',
      quickTracking: 'Suivi rapide',
      packageReference: 'Référence du colis',
      track: 'Suivre',
      residences: 'Points',
      chooseFromMap: 'Choisir sur la carte',
      openRelayMapDescription: 'Ouvrez la carte des points avant de créer votre prochain colis.',
      openMap: 'Ouvrir la carte',
      inProgress: 'En cours',
      failed: 'Échecs',
      creditBalance: 'Solde du crédit',
      threshold: 'Minimum',
      reservedFeesShort: 'Frais mis de côté',
      availableCredit: 'Crédit disponible',
      usableForNewPackages: 'Utilisable pour les nouveaux colis',
      topupRequest: 'Demande de recharge',
      requestMoreCredit: 'Demander plus de crédit',
      topupDescription: 'Indiquez le montant voulu, puis faites le virement bancaire. L’équipe ajoute le crédit quand le paiement est confirmé.',
      amountInMad: 'Montant en MAD',
      note: 'Note',
      notePlaceholder: 'Référence du virement, date prévue…',
      sendRequest: 'Envoyer la demande',
      topupSent: 'Demande envoyée. Faites le virement avec la référence ci-dessous.',
      bankTransferInstructions: 'Comment faire le virement',
      beneficiary: 'Bénéficiaire',
      reference: 'Référence',
      validation: 'Confirmation',
      adminConfirmsPayment: 'L’équipe confirme quand le paiement est reçu.',
      searchRequests: 'Chercher une demande…',
      noTopupRequests: 'Aucune demande de recharge',
      noTopupRequestsDescription: 'Vos demandes de recharge apparaîtront ici.',
      requested: 'Demandé le',
      status: 'Statut',
      adminNote: 'Note de l’équipe',
      creditHistory: 'Historique du crédit',
      transactions: 'Mouvements',
      creditHistoryDescription: 'Recharges, frais de livraison et solde après chaque mouvement.',
      exportCsv: 'Télécharger en CSV',
      balance: 'Solde',
      monthlyReports: 'Rapports du mois',
      noPackageActivity: 'Aucun mouvement de colis',
      availableForNewPackages: 'Disponible pour les nouveaux colis',
      addCreditBeforePackages: 'Ajoutez du crédit avant de créer d’autres colis payants.',
      creationMode: 'Façon de créer',
      onePackage: 'Un colis',
      excelCsvImport: 'Depuis un fichier Excel / CSV',
      normal: 'Un par un',
      normalCreateHelp: 'Pour créer un seul colis à la main.',
      excelCreateHelp: 'Pour créer plusieurs colis depuis un fichier prêt.',
      selectedResidence: 'Point choisi',
      selectResidenceOnMap: 'Choisir un point sur la carte',
      selectResidenceOnMapDescription: 'Touchez un repère pour utiliser ce point pour ce colis.',
      residencesMap: 'Carte des points',
      availableRelayPoints: 'Points disponibles',
      residencesMapDescription: 'Voyez les points actifs sur la carte avant de choisir où envoyer vos colis.',
      coverage: 'Zones couvertes',
      gpsResidences: '{count} point(s) ont une position GPS.',
      selectedRelay: 'Point choisi',
      useForPackage: 'Utiliser pour un colis',
      submitted: 'Envoyés',
      packagesCreatedThisMonth: 'Colis créés ce mois-ci',
      delivered: 'Livrés',
      successRate: '{rate} % de réussite',
      packagesClosedAsFailed: 'Colis clos en échec',
      averageTime: 'Durée moyenne',
      createdToDelivered: 'De la création à la livraison',
      feesCharged: 'Frais facturés',
      partnerFeesSettledThisMonth: 'Frais réglés ce mois-ci',
      loadReportFailed: 'Impossible de charger le rapport.',
      downloadReportFailed: 'Impossible de télécharger le fichier CSV.',
      packagesThisMonthAppearHere: 'Les colis créés ce mois-ci apparaîtront ici.',
      state: 'Étape',
      created: 'Créé le',
      deliveredAt: 'Livré le',
      hours: 'Heures',
      cod: 'À encaisser',
      loadFailed: 'Impossible de charger votre espace.'
    },
    returns: {
      title: 'Retours',
      agentLabel: 'Agent',
      courierLabel: 'Livreur',
      agentDescription: 'Colis à recevoir du destinataire, ou déjà déposés chez vous.',
      courierDescription: 'Retours à récupérer chez l’agent, et retours déjà récupérés.',
      loading: 'Chargement…',
      empty: 'Aucun colis en retour pour l’instant.',
      loadFailed: 'Impossible de charger la liste.',
      startDeposit: 'Scanner un retour à déposer',
      startCollection: 'Scanner un retour à récupérer',
      agentDepositTitle: 'Déposer un retour',
      agentDepositProgress: 'Envoi des photos…',
      agentDepositPageLabel: 'Retour chez l’agent',
      agentDepositHeading: 'Déposer un retour',
      agentDepositDescription: 'Scannez le colis, prenez une photo de son état, puis confirmez.',
      courierCollectTitle: 'Récupérer un retour',
      courierCollectProgress: 'Envoi des photos…',
      courierCollectPageLabel: 'Retour du livreur',
      courierCollectHeading: 'Récupérer un retour',
      courierCollectDescription: 'Scannez les retours chez l’agent, prenez une photo, puis confirmez.',
      returnPhotos: 'Photos du retour',
      returnPhotosHelp: 'Obligatoire. Prenez au moins une photo de l’état du colis.',
      returnCollectionPhotos: 'Photos du retour récupéré',
      returnCollectionPhotosHelp: 'Obligatoire. Prenez au moins une photo du retour.',
      removeFromBatch: 'Retirer',
      removedFromBatch: 'Retour retiré.',
      invalidAgentReturn: 'Ce colis ne peut pas être déposé en retour depuis cet écran.',
      invalidCourierReturn: 'Ce retour ne peut pas être récupéré depuis cet écran.',
      duplicateReturn: 'Ce retour est déjà dans la liste.',
      readyToDeposit: 'Prêt à déposer.',
      readyToCollect: 'Prêt à récupérer.',
      added: 'Retour ajouté.',
      notFound: 'Aucun colis trouvé avec ce code.',
      photoRequired: 'Ajoutez au moins une photo du retour.',
      collectionPhotoRequired: 'Ajoutez au moins une photo du retour récupéré.',
      scanAtLeastOne: 'Scannez au moins un retour.',
      deliveryMissing: 'Ce colis n’a pas de livraison.',
      depositing: 'Dépôt en cours…',
      collecting: 'Récupération en cours…',
      queuedDeposit: 'Retour gardé sur le téléphone. Il sera envoyé avec la connexion.',
      queuedCollection: 'Récupération gardée sur le téléphone. Elle sera envoyée avec la connexion.',
      deposited: 'Retour déposé.',
      collected: 'Retour récupéré.',
      depositRejected: 'Le dépôt n’a pas été accepté. Réessayez.',
      collectionRejected: 'La récupération n’a pas été acceptée. Réessayez.',
      rejectedCount: '{count} retour(s) refusé(s).',
      depositedCount: '{count} retour(s) déposé(s).',
      collectedCount: '{count} retour(s) récupéré(s).',
      depositComplete: 'Retour déposé',
      collectionComplete: 'Retour récupéré',
      startNewDeposit: 'Déposer un autre retour',
      startNewCollection: 'Récupérer un autre retour',
      confirmDeposit: 'Confirmer le dépôt',
      confirmCollection: 'Confirmer la récupération',
      statusSync: 'Envoi',
      statusDeposited: 'Déposé',
      statusCollected: 'Récupéré',
      statusQueued: 'Pas de connexion',
      statusFailed: 'Erreur',
      statusPending: 'En attente',
      confirmationSummary: '{returns} retour(s) · {photos} photo(s)',
      viewDetails: 'Voir le détail'
    },
    layout: {
      adminControl: 'Espace administration',
      operationsPortal: 'Espace de travail',
      secureAccess: 'Connexion sécurisée',
      roleEntry: 'Un seul compte pour toutes vos applications.',
      authDescription: 'Connectez-vous une fois : votre compte ouvre l’application de votre travail.',
      fieldOtp: 'Connexion par code',
      fieldOtpDescription: 'Les agents et les livreurs se connectent avec un code envoyé sur leur téléphone.',
      admin2fa: 'Double vérification',
      admin2faDescription: 'L’administration demande un mot de passe et un code de vérification.',
      operationsConsole: 'Console 3asass.ma',
      backToRoles: 'Retour au choix de l’espace'
    },
    errors: {
      requestFailed: 'Ça n’a pas marché',
      loadingFailed: 'Impossible de charger',
      unauthenticated: 'Votre session est terminée. Connectez-vous de nouveau.',
      notFoundTitle: 'Page introuvable',
      notFoundDescription: 'Cette page n’existe pas.',
      goHome: 'Retour à l’accueil',
      noData: 'Rien à afficher',
      resultsWillAppear: 'Les résultats s’afficheront ici.',
      search: 'Chercher…'
    },
    actions: {
      scan_reception: 'Scanner le colis reçu',
      confirm_reception: 'Confirmer la réception',
      start_delivery: 'Partir livrer',
      capture_pod: 'Remettre au destinataire',
      report_exception: 'Signaler un problème',
      request_return: 'Demander le retour',
      deposit_return: 'Déposer le retour',
      mark_en_route: 'En route',
      scan_drop: 'Scanner le dépôt',
      capture_lot_photo: 'Photo des colis',
      confirm_handover: 'Code de l’agent',
      close_drop: 'Terminer le dépôt',
      collect_return: 'Récupérer le retour',
      confirm_sender_return: 'Remettre à l’expéditeur',
      view_pod: 'Voir la preuve',
      open_litigation: 'Ouvrir un litige',
      retry_by_admin: 'Relancer la livraison',
      return_to_sender: 'Rendre à l’expéditeur',
      resolve_as_delivered: 'Régler : livré',
      resolve_as_failed: 'Régler : échec',
      confirm_failed: 'Confirmer l’échec',
      accept_damaged: 'Accepter avec une note',
      clear_agent: 'Dégager l’agent',
      confirm_loss_agent_fault: 'Perte due à l’agent',
      declare_cod_loss: 'Déclarer la perte',
      cancel: 'Annuler',
      run_settlement: 'Lancer le règlement',
      confirm_customer_handover: 'Confirmer la remise',
      create_pickup_handover: 'Préparer la remise',
      collect_pickup: 'Récupérer'
    },
    walletEntryTypes: {
      commission_earned: 'Commission gagnée',
      cod_reserve: 'Argent à encaisser',
      cod_release: 'Argent encaissé libéré',
      cod_loss: 'Argent perdu',
      float_topup: 'Recharge',
      platform_fee: 'Frais 3asass',
      withdrawal_request: 'Demande de retrait',
      withdrawal_paid: 'Retrait payé',
      withdrawal_reversal: 'Retrait annulé'
    },
    user: {
      login: {
        title: 'Espace client',
        help: 'Connectez-vous avec votre compte 3asass.',
        submit: 'Se connecter',
        no_account: 'Pas encore de compte ?',
        signup: 'Créer un compte'
      },
      dashboard: {
        welcome: 'Bonjour {name}',
        user: 'Client',
        cards: {
          packages: {
            title: 'Mes colis',
            desc: 'Suivez vos envois facilement.'
          },
          tracking: {
            title: 'Suivi en direct',
            desc: 'Voyez où est votre colis.'
          },
          placeholder: {
            title: 'Bientôt',
            desc: 'D’autres fonctions arrivent bientôt.'
          }
        },
        coming_soon: {
          title: 'Bientôt disponible',
          desc: 'D’autres fonctions arrivent bientôt.'
        }
      },
      nav: {
        dashboard: 'Accueil',
        profile: 'Mon profil'
      },
      logout: 'Se déconnecter'
    },
    platform: {
      dashboard: {
        title: 'Espace plateforme',
        welcome: 'Bonjour {name}',
        user: 'Utilisateur',
        cards: {
          landing: {
            title: 'Plateforme 3asass',
            desc: 'Accédez à la plateforme centrale 3asass.'
          },
          placeholder: {
            title: 'Bientôt',
            desc: 'D’autres fonctions arrivent bientôt.'
          }
        },
        coming_soon: {
          title: 'Bientôt disponible',
          desc: 'D’autres fonctions arrivent bientôt.'
        }
      },
      nav: {
        dashboard: 'Accueil',
        requests: 'Mes demandes',
        returnRequests: 'Signalements',
        packages: 'Colis',
      },
      logout: 'Se déconnecter',
      requests: {
        title: 'Mes demandes',
        submitter: 'Envoyée par',
        description: '{count} demande(s)',
        newTitle: 'Nouvelle demande',
        newDescription: 'Envoyez une demande pour qu’un agent prenne votre colis.',
        newRequest: 'Nouvelle demande',
        backToList: 'Retour à la liste',
        whatNext: 'Et maintenant ?',
        nextPending: 'Nous vérifions votre demande. Vous serez prévenu dès qu’elle est acceptée.',
        nextRejected: 'Cette demande a été refusée.',
        nextConverted: 'Votre colis est créé. Suivez-le ci-dessous.',
        nextCancelled: 'Vous avez annulé cette demande.',
        keyFacts: 'L’essentiel',
        changeDestination: 'Changer la destination',
        cancelRequest: 'Annuler la demande',
        deleteRequest: 'Supprimer la demande',
        cancelParcel: 'Annuler le colis',
        cancelParcelBlocked: 'Le colis a déjà été remis. Il ne peut plus être annulé.',
        cancelRequestConfirmTitle: 'Annuler cette demande ?',
        cancelRequestConfirmBody: 'La demande sera annulée. Aucun colis ne sera créé.',
        deleteRequestConfirmTitle: 'Supprimer cette demande ?',
        deleteRequestConfirmBody: 'La demande sera supprimée pour toujours.',
        cancelParcelConfirmTitle: 'Annuler ce colis ?',
        cancelParcelConfirmBody: 'Le colis n’a pas encore été déposé. Il sera annulé.',
        confirmCancelAction: 'Oui, annuler',
        confirmDeleteAction: 'Oui, supprimer',
        confirmChangeAction: 'Confirmer',
        outcomeCancelled: 'Demande annulée',
        outcomeDeleted: 'Demande supprimée',
        outcomeParcelCancelled: 'Colis annulé. Il n’avait pas encore été déposé.',
        outcomeDestinationChanged: 'Destination changée',
        changeDestinationTitle: 'Nouvelle destination',
        changeDestinationHint: 'Choisissez le point qui recevra le colis.',
        editDetails: 'Modifier les informations',
        changePickup: 'Changer le point de dépôt',
        changePickupTitle: 'Nouveau point de dépôt',
        changePickupHint: 'Choisissez l’agent chez qui vous déposerez le colis.',
        noAlternativePickupHint: 'Aucun autre point de dépôt n’est disponible pour le moment. Réessayez plus tard ou contactez-nous.',
        confirmPickupAction: 'Confirmer ce point',
        outcomePickupChanged: 'Point de dépôt changé',
        currentlyLabel: 'Actuellement',
        moreDetails: 'Plus de détails',
        requestFacts: 'Informations de la demande',
        reference: 'Référence',
        submittedOn: 'Envoyée le',
        cashOnDelivery: 'À payer à la livraison',
        relay: 'Point de livraison',
        zone: 'Quartier',
        amountDue: 'Montant à payer',
        followPackage: 'Suivre le colis',
        deliveryPoint: 'Point de livraison',
        deliveryPointHint: 'Choisissez le point où vous voulez recevoir votre colis. Notre équipe confirmera votre choix.',
        noResidencesHint: 'Aucun point n’est disponible pour le moment. Vous pouvez quand même envoyer la demande.',
        detailTitle: 'Détails de la demande',
        stepHandOverTitle: 'Où vous déposez le colis',
        stepRecipientTitle: 'Qui reçoit le colis',
        stepRecipientHint: 'Le livreur appelle ce numéro avant de passer. Donnez une adresse complète.',
        pickupAddress: 'Votre adresse',
        pickupSearchAddress: 'Adresse à chercher',
        pickupAddressHint: 'Facultatif. Sert à trouver les points les plus proches de chez vous. Vous déposez le colis au point que vous choisissez.',
        recipient: 'Destinataire',
        recipientName: 'Nom du destinataire',
        recipientPhone: 'Téléphone',
        createdAt: 'Créée le',
        recipientAddress: 'Adresse de livraison',
        recipientAddressHint: 'Le livreur ira à cette adresse.',
        notes: 'Notes',
        notesPlaceholder: 'Autres informations…',
        notesHint: 'Facultatif : étage, code de l’immeuble, heure préférée…',
        submit: 'Envoyer la demande',
        summarySelected: 'Point de dépôt choisi : {point}',
        summaryUnselected: 'Aucun point choisi. Il sera attribué quand la demande sera acceptée.',
        created: 'Demande envoyée',
        createFailed: 'La demande n’a pas été envoyée',
        loadFailed: 'Impossible de charger',
        rejectionReason: 'Raison du refus',
        convertedPackage: 'Colis créé',
        viewPackage: 'Voir le colis',
        approve: 'Accepter',
        reject: 'Refuser',
        approved: 'Demande acceptée',
        rejected: 'Demande refusée',
        actionFailed: 'Ça n’a pas marché',
        approveTitle: 'Accepter la demande',
        approveDescription: 'Choisissez le point.',
        rejectTitle: 'Refuser la demande',
        rejectDescription: 'Indiquez la raison du refus.',
        residence: 'Point (identifiant)',
        residencePlaceholder: 'Identifiant du point',
        selectResidence: 'Choisir un point sur la carte',
        residencesLoadFailed: 'Impossible de charger les points',
        selectedResidenceInfo: 'Le point choisi sur la carte sera lié à cette demande.',
        destinationRequired: 'Choisissez le point de destination. Sans lui, la demande ne peut pas être acceptée.',
        customerCredit: 'Crédit du client',
        codAmount: 'Montant à encaisser (centimes)',
        codPlaceholder: '0',
        adminLabel: 'Demandes',
        adminTitle: 'Demandes des clients',
        searchPlaceholder: 'Chercher…',
        empty: 'Aucune demande pour l’instant',
        statuses: {
          pending: 'En attente',
          approved: 'Acceptée',
          rejected: 'Refusée',
          converted: 'Colis créé',
          cancelled: 'Annulée',
          declined: 'Changez de point',
        },
      },
      packages: {
        label: 'Mes colis',
        title: 'Mes colis',
        description: '{count} colis',
        empty: 'Aucun colis pour l’instant',
        loadFailed: 'Impossible de charger les colis',
        createdAt: 'Créé le',
        trackingCode: 'Code de suivi',
        relay: 'Point de livraison',
        track: 'Suivre',
        requestReturn: 'Demander un retour',
        requestCancellation: 'Demander l’annulation',
        cancelRequestTitle: 'Annuler le colis',
        cancelRequestExplainer: 'Le colis n’est plus chez vous. Nous demandons l’accord de l’équipe, puis le colis vous est rendu avant d’être annulé.',
        cancelRequestReason: 'Raison (facultatif)',
        cancelRequestSubmit: 'Envoyer la demande',
        cancelRequestSubmitted: 'Demande d’annulation envoyée.',
        cancelRequestFailed: 'Impossible d’envoyer la demande.',
        cancelRequestPending: 'Nous regardons votre demande. Le colis continue sa route jusqu’à notre réponse.',
        cancelRequestApproved: 'Annulation acceptée. Le colis revient vers vous. Ouvrez les instructions de retour pour voir le point et votre code quand le colis arrive.',
        cancelRequestRejected: 'Annulation refusée. Regardez le suivi pour voir où en est le colis.',
        cancelRequestCompleted: 'Colis annulé et récupéré.',
        packageInfo: 'Informations du colis',
        recipient: 'Destinataire',
        relayName: 'Nom du point',
        city: 'Ville',
        relayAddress: 'Adresse du point',
        timeline: 'Suivi',
        noTimeline: 'Pas encore de suivi',
        assignedAgent: 'Agent',
      },
      returnRequests: {
        title: 'Mes signalements',
        description: '{count} signalement(s)',
        loadFailed: 'Impossible de charger les signalements',
        empty: 'Aucun signalement pour l’instant',
        searchPlaceholder: 'Chercher par code, nom, téléphone ou adresse…',
        packageCode: 'Colis',
        packageStatus: 'Étape du colis',
        status: 'Réponse au signalement',
        requestedAt: 'Demandé le',
        reviewedAt: 'Réponse le',
        openPackage: 'Voir le colis',
      },
    },
    platformPickup: {
      pendingTitle: 'Mes dépôts',
      pendingHint: 'Suivez vos colis à déposer et annulez ceux qui attendent encore votre confirmation.',
      chosenPoint: 'Point choisi',
      awaitingApproval: 'En attente de réponse',
      filterAll: 'Tous',
      filterCancellable: 'Annulables',
      listSummary: '{total} dépôt(s) · {cancellable} annulable(s)',
      cancellableBadge: 'Annulable',
      agentLabel: 'Agent',
      noPickupsTitle: 'Aucun dépôt en cours',
      noPickupsDescription: 'Vos colis à déposer apparaîtront ici dès que vous en créerez un.',
      noneCancellableTitle: 'Rien à annuler',
      cancelBlockedHint: 'Vous ne pouvez plus annuler : l’agent a déjà pris le colis.',
      backToPackages: 'Voir mes colis',
      stepTitle: 'Choisissez où déposer votre colis',
      stepHint: 'Vous déposez le colis chez un agent. Ensuite un livreur le prend et l’apporte à destination.',
      stepLabel: 'Point de dépôt',
      pickPoint: 'Choisir un point de dépôt',
      changePoint: 'Changer de point',
      noPoints: 'Aucun point de dépôt disponible',
      noPointsHint: 'Aucun agent près de cette adresse ne prend de colis pour l’instant.',
      noPointsDisabled: 'Le dépôt n’est pas encore disponible.',
      searchArea: 'Chercher dans cette zone',
      useMyLocation: 'Utiliser ma position',
      locating: 'Recherche de votre position…',
      locationLocated: 'Position trouvée. Les points sont classés autour de vous.',
      locationUnsupported: 'Votre navigateur ne peut pas trouver votre position.', locationInsecure: 'La position ne marche qu’avec une connexion sécurisée (https).',
      locationDenied: 'Accès à la position refusé. Autorisez-le, ou tapez votre adresse.',
      locationTimeout: 'La recherche de votre position a pris trop de temps. Réessayez, ou tapez votre adresse.',
      mapInstruction: 'Touchez la carte ou déplacez le repère pour changer la zone de recherche.',
      radiusKm: '{distance} km autour de vous',
      pointDistance: 'à {distance} km',
      pointSelected: 'Point choisi',
      nearest: 'Le plus proche',
      residenceOnly: 'Seulement dans ma résidence',
      cardTitle: 'Point de dépôt',
      cardWaiting: 'Attend chez l’agent',
      cardReady: 'Le livreur vient le prendre',
      cardCollected: 'En route',
      cardCancelled: 'Annulé',
      creditTitle: 'Mon crédit',
      creditSubtitle: 'Le crédit sert à payer la livraison. Il n’est pas remboursable.',
      creditBalance: 'Solde du crédit',
      creditAvailable: 'Crédit disponible',
      creditExposed: 'Crédit réservé',
      creditThreshold: 'Seuil d’alerte',
      creditFeePerDelivery: '{amount} {currency} par livraison',
      topupTitle: 'Recharger mon crédit',
      topupAmount: 'Montant voulu',
      topupAmountPlaceholder: 'Montant en MAD',
      topupNote: 'Raison de la demande',
      topupNotePlaceholder: 'Ex. : plusieurs colis cette semaine',
      topupSubmit: 'Demander une recharge',
      topupHistory: 'Historique des recharges',
      topupRequests: 'Mes demandes de recharge',
      topupPending: 'En attente',
      topupApproved: 'Acceptée',
      topupRejected: 'Refusée',
      downloadCsv: 'Télécharger le fichier CSV',
      cancelTitle: 'Annuler ma demande',
      cancelHint: 'Annulez cette demande avant que l’agent confirme le dépôt.',
      cancelReason: 'Pourquoi annuler ?',
      cancelReasonPlaceholder: 'Dites-nous pourquoi',
      cancelSubmit: 'Confirmer l’annulation',
      cancelConfirmTitle: 'Confirmer l’annulation',
      cancelConfirmBody: 'Votre demande sera annulée. Vous ne pourrez pas revenir en arrière.',
      cancelSuccess: 'Demande annulée',
      insufficientCredit: 'Votre crédit ne suffit pas pour cette livraison.',
      typeOffNotice: 'Ce service n’est pas disponible pour ce type d’envoi.',
    },
  },
  en: {
    common: {
      back: 'Back',
      copied: 'Copied.',
      steps: 'Steps',
      completed: 'completed',
      language: 'Language',
      french: 'French',
      english: 'English',
      arabic: 'Arabic',
      moroccan: 'Moroccan Arabic',
      profile: 'Profile',
      logout: 'Log out',
      accountActions: 'My account',
      healthySync: 'Everything is sent',
      admin: 'Admin',
      agent: 'Agent',
      courier: 'Courier',
      partner: 'Partner',
      partners: 'Partners',
      agents: 'Agents',
      relay: 'Point',
      platform: 'Platform',
      account: 'Account',
      fieldManager: 'Field manager',
      workflow: 'Workflow',
      startPilot: 'Start a pilot',
      installApp: 'Install the app',
      installFromBrowser: 'Install with Chrome',
      phoneNumber: 'Phone number',
      verificationCode: 'Code received',
      resend: 'Send again',
      resendIn: 'Send again in {seconds} s',
      codeSentTo: 'Code sent to {phone}',
      pleaseWait: 'One moment…',
      date: 'Date',
      retry: 'Try again',
      filtering: 'Filtered by',
      searchPackages: 'Reference, recipient, point…',
      verifyAndContinue: 'Confirm and continue',
      sendVerificationCode: 'Get a code',
      continue: 'Continue',
      previous: 'Previous',
      next: 'Next',
      loadMore: 'See more',
      loadingMore: 'Loading…',
      pageOf: 'Page {current} / {last}',
      pageOfTotal: 'Page {current} / {last} · {total} packages',
      filter: 'Filter',
      reset: 'Clear all',
      all: 'All',
      allStates: 'All steps',
      today: 'Today',
      thisWeek: 'This week',
      thisMonth: 'This month',
      city: 'City',
      notProvided: 'Not given',
      showFullText: 'Show full address',
      showLess: 'Show less',
      required: 'Required',
      selectedFile: 'Chosen file',
      selectedPdf: 'Chosen PDF document',
      addFile: 'Add a file',
      replace: 'Replace',
      choose: 'Choose',
      chooseFile: 'Choose a file',
      edit: 'Change',
    save: 'Save',
    saved: 'Saved',
    saving: 'Saving…',
      refresh: 'Refresh',
      confirm: 'Confirm',
      confirmAction: 'Confirm',
      cancel: 'Cancel',
      close: 'Close',
      suspend: 'Suspend',
      reactivate: 'Reactivate',
      approve: 'Accept',
      reject: 'Refuse',
      action: 'Action',
      actions: 'Actions',
      type: 'Type',
      amount: 'Amount',
      reason: 'Reason',
      status: 'Status',
      viewDetail: 'View detail',
      loadingImpossible: 'Could not load',
      openMenu: 'Open menu',
      workspaceShell: 'Workspace shell',
      search: 'Search...',
      user: 'User',
      identifier: 'Identifier',
      email: 'Email',
      loading: 'Loading',
      logisticsControl: 'Logistics control',
      navigation: 'Navigation',
      offlineMode: 'Offline mode: field actions will be queued.',
      rowsRange: '{first}-{last} of {total}',
      rowsReceived: '{count} received',
      copiedWithLabel: '{label} copied.',
      copy: 'Copy',
      reasonCodes: {
        policyViolation: 'Policy violation',
        fraudSuspected: 'Fraud suspected',
        inactivity: 'Inactivity',
        escrowInsufficient: 'Escrow insufficient',
        other: 'Other'
      },
      cod: 'COD',
      kyc: 'KYC',
      ok: 'OK',
      mad: 'MAD',
      platformName: '3asass',
      agentPrefix: 'Agent:',
      partnerPrefix: 'Partner:',
      packageId: 'Parcel ID',
      deliveryId: 'Delivery ID',
      residenceIdPrefix: 'residence:'
    },
    packageType: {
      normal: 'Standard',
      untracked: 'No tracking',
      pickup: 'Customer drop-off'
    },
    sampleDashboard: {
      title: 'Dashboard',
      description: 'Generic application shell with reusable loading states.',
      foundation: 'Foundation',
      skeletons: 'Skeletons',
      emptyState: 'Empty state',
      placeholderTitle: 'Placeholder content',
      placeholderDescription: 'This page intentionally avoids business-specific modules.'
    },
    sampleSettings: {
      title: 'Settings',
      description: 'Generic controls used to verify shared UI components.',
      interface: 'Interface',
      interfaceDescription: 'Neutral placeholder inputs for component verification.',
      textInput: 'Text input',
      textarea: 'Textarea',
      selectOption: 'Select option',
      default: 'Default',
      compact: 'Compact',
      enableOption: 'Enable generic option',
      application: 'Application',
      applicationDescription: 'PWA and notification examples.',
      notificationExample: 'Notification example',
      showToast: 'Show toast',
      offlinePage: 'Offline page'
    },
    contact: {
      backHome: 'Back home',
      label: 'Launch a pilot',
      title: 'Frame a 3asass pilot on a real zone.',
      description: 'The pilot should show one simple thing: fewer doors to visit, fewer failures, more proof, and payments on delivery that are easier to check.',
      cityZone: 'Pilot city or zone',
      cityZoneValue: 'Marrakech, Casablanca, Rabat...',
      packageVolume: 'Estimated package volume',
      packageVolumeValue: 'Packages per day or per week',
      residenceNetwork: 'Network of points',
      residenceNetworkValue: 'Number of buildings or guardians',
      currentOperation: 'Current operation',
      currentOperationValue: 'Failures, payments on delivery, returns, proofs',
      formTitle: 'Pilot request',
      formDescription: 'This form is not connected yet. Sending is switched off for now.',
      company: 'Company',
      companyPlaceholder: 'Company name',
      contact: 'Contact',
      contactPlaceholder: 'Name, phone, or email',
      pilotZone: 'Pilot zone',
      pilotZonePlaceholder: 'City, area, number of points',
      volumeContext: 'Volume and context',
      volumeContextPlaceholder: 'Example: 300 parcels a week, a lot of cash to collect, many failures…',
      submitSoon: 'Send request soon',
      disabledNote: 'No message is sent for now.'
    },
    auth: {
      phoneInvalid: 'Enter a number with the country code, for example +212600000000.',
      fieldTitle: 'Log in',
      fieldDescription: 'Enter your phone number.',
      agentTitle: 'Agent login',
      agentDescription: 'Enter the number registered for your point.',
      agentTestPhone: 'Local test agent: +212600000010',
      courierTitle: 'Courier login',
      courierDescription: 'Enter your phone number. If you have no account, one will be created.',
      courierTestPhone: 'Local test courier: +212600000020',
      adminTitle: 'Admin login',
      adminDescription: 'Operations access requires password and authenticator verification.',
      workEmail: 'Work email',
      password: 'Password',
      adminTest: 'Local test admin: admin{\'@\'}example.com / password',
      setupAuthenticator: 'Set up Authenticator',
      setupAuthenticatorDescription: 'Open Google Authenticator or Authy, add a new account, then scan this QR code.',
      authenticatorQrAlt: 'Authenticator setup QR code',
      openSetupLink: 'Open setup link',
      secretKey: 'Secret key',
      copy: 'Copy',
      authenticatorCode: 'Authenticator code',
      activate2fa: 'Activate 2FA and enter',
      verify2fa: 'Verify 2FA code'
    },
    maps: {
      position: 'Location',
      currentLocation: 'Your location',
      currentLocationUnavailable: 'Cannot find your location.',
      addressNotFound: 'Address not found.',
      routeCalculating: 'Finding the route…',
      routeUnavailable: 'Route not available.',
      basemapLabel: 'Map type',
      basemap_streets: 'Streets',
      basemap_light: 'Light',
      basemap_dark: 'Dark',
      basemap_satellite: 'Satellite',
      basemapFallback: 'The detailed map is not available. A simple map is shown.',
      openGoogleMaps: 'Open in Google Maps',
      regionLabel: 'Map',
      routeRegionLabel: 'Map of the route to {place}',
      basemapHint: 'Choose the map that is easiest to read.',
      locateMe: 'Where am I?',
      expand: 'Make the map bigger',
      collapse: 'Make the map smaller',
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      credits: 'Map sources',
      destination: 'Destination',
      departure: 'Start',
      navigate: 'Go there',
      arrivalLabel: 'arrival around',
      kind: { agent: 'Agent', residence: 'Point', parcel: 'Parcel', collection: 'Pickup point', place: 'Place', return: 'Return point', pickupPoint: 'Pickup point', deliveryPoint: 'Delivery point' },
      stopNumber: 'Stop {number}',
      previousStop: 'Previous stop',
      nextStop: 'Next stop',
      pointsCount: '{count} points on the map',
      pointsListLabel: 'Points',
      selectOnMap: 'Tap a marker to see the details.',
      previousPoint: 'Previous point',
      nextPoint: 'Next point'
    },
    geolocation: {
      label: 'My location',
      title: 'Where you are',
      notCaptured: 'Location not taken',
      unavailable: 'Cannot find your location',
 insecureConnection: 'Location only works on a secure connection (https). Open the app over https.',

 permissionRequired: 'Allow location in the browser, then tap “Get my location”.',
      capture: 'Get my location',
      capturing: 'Looking…'
    },
    category: {
      badge: 'Welcome to 3asass',
      title: 'What are you looking for?',
      description: 'Choose the service you need.',
      enter: 'Enter',
      comingSoon: 'Coming soon',
      footer: '3asass — Simple delivery, close to you.',
      cards: {
        logistics: {
          title: 'Logistics',
          description: 'Delivery close to you: agents, couriers and live tracking.'
        },
        services: {
          title: 'Services',
          description: 'Services for buildings and their residents.'
        },
        marketplace: {
          title: 'Marketplace',
          description: 'A place to buy and sell between residents and shops.'
        }
      }
    },
    home: {
      hero: {
        badge: 'Innovative logistics solution',
        titleBefore: 'Reduce delivery',
        titleHighlight: 'failures',
        titleAfter: '.',
        description: 'We turn building guardians into delivery points. The courier leaves the parcel with a trusted guardian, the recipient is told on WhatsApp, proof is taken, and the money to collect stays tracked.'
      },
      tracking: {
        placeholder: 'Parcel code',
        aria: 'Parcel code',
        submit: 'Track my parcel'
      },
      returnRequest: {
        title: 'Ask for a return',
        description: 'Got a parcel and want to send it back? Send us a request.'
      },
      dashboard: {
        title: 'Admin pulse',
        live: 'Live',
        delivered24h: 'Delivered (24h)',
        deliveredTrend: '+12.5% vs yesterday',
        codSecured: 'Secured COD',
        reconcileToday: 'To reconcile today',
        packageRef: 'Package #3AS-2041',
        inTransit: 'In transit',
        receivedGuardian: 'Guardian received',
        notified: 'Notified',
        exceptionAlert: '1 exception detected in the Anfa zone.',
        view: 'View'
      },
      problem: {
        titleBefore: 'The last mile is',
        titleHighlight: 'broken',
        description: 'Couriers do not need more phone calls. They need a reliable relay point. 3asass turns an already available presence into a traceable control point.',
        cards: {
          failures: {
            title: 'Recurring delivery failures',
            desc: 'Couriers waiting in front of closed doors.'
          },
          transparency: {
            title: 'Lack of transparency',
            desc: 'Packages marked failed without reliable context.'
          },
          cash: {
            title: 'Cash management (COD)',
            desc: 'Collected cash is difficult to control and reconcile.'
          },
          time: {
            title: 'Courier time lost',
            desc: 'Returns and disputes scattered across calls and WhatsApp.'
          }
        }
      },
      lifecycle: {
        badge: '3asass lifecycle',
        titleLine1: 'The package at the center',
        titleLine2: 'of operations.',
        description: 'At every step, 3asass knows who has the package, which residence it is in, what proof exists, what cash was collected, and which commission is due.',
        cta: 'Explore the technical docs',
        items: {
          created: {
            state: 'CREATED',
            label: 'Imported from the merchant'
          },
          dropped: {
            state: 'DROPPED',
            label: 'Scanned by the courier at the relay'
          },
          received: {
            state: 'RECEIVED',
            label: 'Confirmed by the guardian'
          },
          out: {
            state: 'IN PROGRESS',
            label: 'Resident notified'
          },
          delivered: {
            state: 'DELIVERED',
            label: 'POD and commission validated'
          }
        }
      },
      surfaces: {
        titleLine1: 'Three surfaces,',
        titleLine2: 'one source of truth.',
        description: 'Each actor gets a tool optimized for their workflow, synchronized in real time.',
        agent: {
          title: 'Agent PWA',
          subtitle: 'For the guardian',
          metric: '42 packages',
          items: {
            scan: 'Scan QR code',
            notify: 'Notify the resident',
            proof: 'Capture signature + photo',
            wallet: 'Request wallet withdrawal'
          }
        },
        courier: {
          title: 'Courier PWA',
          subtitle: 'For the courier',
          metric: '8 drops',
          items: {
            route: 'See relays to visit',
            scan: 'Scan the lot',
            photos: 'Photograph packages',
            close: 'Close the route'
          }
        },
        admin: {
          title: 'Admin portal',
          subtitle: 'For operations',
          metric: '3 disputes',
          items: {
            track: 'Track every package',
            proofs: 'Review proofs',
            wallets: 'Settle wallets',
            audit: 'Audit exceptions'
          }
        }
      },
      proof: {
        titleLine1: 'Proof at the heart',
        titleLine2: 'of trust.',
        description: 'Proof of delivery is not a detail: it protects the operator, merchant, resident, and guardian. Even without network, actions stay recorded locally and sync later.',
        guarantee: '100% traceability guaranteed',
        items: {
          signature: 'Resident signature',
          photo: 'Package photo',
          gps: 'GPS position',
          cod: 'COD amount',
          offline: 'Offline sync',
          whatsapp: 'WhatsApp message'
        }
      },
      portalCards: {
        title: 'Choose your area',
        description: 'Choose who you are to continue.',
        agent: {
          title: 'Agent',
          description: 'Receive parcels, hand them over and follow your money.',
          cta: 'Install the app'
        },
        courier: {
          title: 'Courier',
          description: 'Drop off parcels, pick up returns and follow your rounds.',
          cta: 'Install the app'
        },
        admin: {
          title: 'Admin',
          description: 'Follow activity, agents and the platform.',
          cta: 'Admin area'
        },
        partner: {
          title: 'Partner',
          description: 'Follow your parcels, invoices and account.',
          cta: 'Partner area'
        },
        user: {
          title: 'Customer',
          description: 'Send a parcel and follow it.',
          cta: 'Customer area'
        }
      }
    },
    download: {
      badge: 'Phone app',
      agentTitle: 'Install the agent app',
      courierTitle: 'Install the courier app',
      agentDescription: 'Install 3asass on your phone, then log in with your number.',
      courierDescription: 'Install 3asass on your phone to scan parcels, confirm drop-offs and follow returns.',
      login: 'Continue to log in',
      loginTitle: 'Log in',
      loginDescription: 'Go to your area with your phone number.',
      installTitle: 'Install',
      installDescription: 'Put the app on your phone.',
      installFallback: 'With Chrome, installing is direct. With Firefox or Safari, use the browser menu to add the app to the home screen.',
      installHelp: {
        button: 'Install from this browser',
        title: 'Install 3asass',
        description: 'If the installation does not start by itself, use the browser menu.',
        steps: {
          chromiumMenu: 'Open the browser menu (the three dots, at the top or bottom).',
          chromiumInstall: 'Tap “Install app” or “Add to home screen”.',
          firefoxMenu: 'Open the Firefox menu.',
          firefoxAdd: 'Tap “Install” or “Add to home screen”.',
          safariShare: 'On iPhone, tap the Share button in Safari.',
          safariAdd: 'Choose “Add to Home Screen”, then confirm.'
        }
      },
      panelTitle: 'Quick install',
      panelDescription: 'The app installs from Chrome, without an app store.',
      menuDescription: 'Quick access to 3asass interfaces.',
      workflowMenuDescription: 'See how the package lifecycle works.',
      agentMenuDescription: 'Install and open the agent area.',
      courierMenuDescription: 'Install and open the courier area.',
      partnerMenuDescription: 'Sign in to the sender portal.',
      contactMenuDescription: 'Contact the team to launch a pilot.',
      adminMenuDescription: 'Operations-only access.',
      steps: {
        open: 'Open this page in Chrome on your phone.',
        install: 'Tap “Install app” or “Add to home screen”.',
        login: 'Open the 3asass icon and log in with your number.'
      },
      cards: {
        installTitle: 'An icon on your phone',
        installText: '3asass opens like a real app.',
        offlineTitle: 'Without internet',
        offlineText: 'Without network, your actions are kept and sent when the connection is back.',
        secureTitle: 'Safe login',
        secureText: 'You log in with a code sent to your phone. Your data is protected.'
      }
    },
    state: {
      created: 'Created',
      en_route: 'On the way',
      dropped: 'Dropped off',
      received: 'Received',
      out_for_delivery: 'Out for delivery',
      delivered: 'Delivered',
      returned: 'Given back to sender',
      returnedHint: 'The parcel was given back to the sender.',
      failed: 'Failed',
      return_requested: 'Return requested',
      return_deposited: 'Return dropped off',
      return_collected: 'Return picked up',
      disputed: 'In dispute',
      cancelled: 'Cancelled',
      awaiting_pickup: 'To drop off',
      pickup_ready: 'Ready to collect'
    },
    dashboard: {
      agentLabel: 'Agent',
      agentTitle: 'Parcels to deal with',
      agentDescription: 'Reception, delivery, problems and money from your point.',
      courierLabel: 'Courier',
      courierTitle: 'My round today',
      courierDescription: 'Scan the parcels at the agent’s, take a photo, then finish the drop-off.',
      startDrop: 'Start a drop-off',
      packageSearchPlaceholder: 'Code, recipient, phone, address…',
      loadingPackages: 'Loading…',
      loadingRoute: 'Loading…',
      noPackagesWithFilters: 'No parcel matches these filters.',
      loadAgentPackagesFailed: 'Could not load your parcels.',
      loadAgentWalletFailed: 'Could not load your wallet.',
      loadRouteFailed: 'Could not load the round.',
      backendActionPending: 'This action is not available yet.',
      actionQueued: 'Action kept on the phone. It will be sent when you are online.',
      actionSynced: 'Action sent.',
      actionRejected: 'The action was not accepted.',
      returnRequestedByResident: 'The return must first be requested from the tracking page or by the team. Then you can drop it off.',
      enRouteStarted: 'You are on your way to the point.',
      bulkStartDelivery: 'Go and deliver ({count})',
      bulkMarkEnRoute: 'On the way ({count})',
      loadTodayDeliveriesFailed: 'Could not load today’s deliveries.'
    },
    adminDashboard: {
      label: 'Dashboard',
      title: 'Live activity',
      description: 'Spot what is stuck, follow active agents, open urgent parcels and go to settlements or the history.',
      backendUnavailable: 'Service unavailable',
      loadFailed: 'Could not load the dashboard.',
      loadQueueFailed: 'Could not load the parcel list.',
      notAvailable: '—',
      refreshHint: 'Updates every 30 s',
      importCsv: 'Import a CSV file',
      createPackage: 'Create a parcel',
      loadingQueue: 'Loading…',
      emptyQueue: 'No parcel for this filter.',
      kpis: {
        handoverTime: 'Hand-over time',
        handoverHelp: 'Coming: from drop-off to reception.',
        firstAttempt: 'Delivered at first try',
        firstAttemptHelp: 'Delivered today compared with open problems.',
        podCompletion: 'Complete proofs',
        podHelp: '{count} proofs received',
        activeAgents: 'Active agents',
        activeAgentsHelp: 'Agent accounts active right now.',
        exceptionRate: 'Share of problems',
        exceptionHelp: '{count} parcels to deal with'
      },
      search: {
        label: 'Search a parcel',
        title: 'Find and open quickly',
        placeholder: 'Reference, recipient, phone, agent, point…',
        submit: 'Search'
      },
      filters: {
        active: 'In progress',
        dropped: 'Dropped off',
        received: 'Received',
        out: 'Out for delivery',
        returns: 'Returns',
        exceptions: 'Problems'
      },
      decisions: {
        title: 'Waiting for a decision',
        cancellations: 'Cancellation requests',
        cancellationsHint: 'A customer wants their parcel brought back',
        reports: 'Reported problems',
        reportsHint: 'Problems customers reported after delivery, and returns asked for without an account',
        incidents: 'Stuck returns',
        incidentsHint: 'A return on its way back hit a problem',
        none: 'Nothing is waiting for your decision.',
        returnsInProgress: '{count} return on its way | {count} returns on their way'
      },
      exceptions: {
        label: 'Urgent',
        title: 'Problems to deal with',
        empty: 'No open problem.',
        open: 'See all problems'
      },
      cod: {
        label: 'Cash to collect',
        description: 'Total to collect for the parcels shown.'
      },
      agents: {
        label: 'Agents map',
        title: 'Areas covered',
        cityLine: '{agents} agent(s) · {deliveries} delivery(ies) in progress',
        activeDeliveries: '{count} in progress'
      },
      settlement: {
        label: 'Settlement',
        title: 'Prepare the settlement',
        description: 'Look at the preview, check the amounts and start the settlement if the gap is acceptable.',
        open: 'Open settlements'
      },
      audit: {
        label: 'History',
        title: 'Who did what',
        description: 'See the team’s actions, step changes, reasons and sensitive events.',
        open: 'Open the history'
      },
      snapshot: {
        active: 'In progress',
        delivered: 'Delivered today',
        proofs: 'Proofs'
      }
    },
    platformConfig: {
      courierWaitInput: 'Max courier wait (minutes)',
      courierWaitHelp: 'After this, a parcel ready at its pickup point shows in exceptions. Between 15 and 1440 minutes (120 = 2 h).',
      requestAcceptInput: 'Time the agent has to answer (minutes)',
      requestAcceptHelp: 'After this, the request is declined for them and the customer picks another point. Between 5 and 1440 minutes (30 = 30 min, 720 = 12 h).',
      label: 'Admin finance',
      title: 'Financial configuration',
      description: 'Set the partner’s fee, the agent’s commission for each hand-over, the courier’s pay after reception at the point, and the customer’s fee noted at drop-off.',
      loadFailed: 'Could not load the configuration.',
      saveFailed: 'Could not save the configuration.',
      saved: 'Financial configuration saved.',
      actionImpossible: 'Not possible',
      partnerFee: 'Partner’s fee',
      partnerFeeDescription: 'Amount taken from the partner’s credit for each parcel delivered and settled.',
      agentCommission: 'Agent commission',
      agentCommissionDescription: 'Amount added for each hand-over an agent completes, at the customer’s drop-off or the final delivery.',
      platformRevenue: 'Platform revenue',
      platformRevenueDescription: 'Estimate for a partner parcel: the fee minus two agent commissions and the courier’s commission.',
      settlementSettings: 'Settlement settings',
      nextSettlements: 'Amounts applied to upcoming settlements',
      lastRead: 'Last read {time}',
      partnerFeeInput: 'Partner’s fee per delivery (MAD)',
      partnerFeeHelp: 'Example: 15 MAD will be stored as 1500 centimes.',
      agentCommissionInput: 'Agent commission per delivery (MAD)',
      agentCommissionHelp: 'Example: 10 MAD is credited after each eligible handover completed by an agent.',
      courierCommissionInput: 'Courier pay per received parcel (MAD)',
      courierCommissionHelp: 'Paid once after the destination keeper confirms receipt. The rate is frozen at parcel creation; return trips are unpaid.',
      negativeTitle: 'Unprofitable configuration',
      negativeDescription: 'The agent’s and courier’s commissions are more than the partner’s fee. The outward trip would lose {amount} per parcel.',
      exampleTitle: 'Example with these values',
      exampleDescription: 'Partner parcel: fee {partnerFee}, two agent commissions of {agentCommission}, courier commission {courierCommission}, estimated gain {platformRevenue}.',
      existingSettlementsNote: 'Already settled packages are not recalculated. These amounts apply to upcoming settlement runs.'
    },
    adminExceptions: {
      courierLateTitle: 'Parcels waiting for a courier ({count})',
      courierLateHint: 'Ready at the pickup point for more than {wait}. Send a courier or call the keeper.',
      courierLateWaiting: 'Waiting {time}',
      label: 'Exceptions queue',
      title: 'Incidents to process',
      description: 'Failures and disputes reported by agents, couriers or the team.',
      exception: 'Exception',
      exceptionCode: 'Exception code',
      open: 'Open',
      failedPage: 'Failed on page',
      disputesPage: 'Disputes on page',
      searchPlaceholder: 'Code, recipient, phone, address, agent...',
      emptyTitle: 'No exception',
      emptyDescription: 'Failed or disputed packages will appear here.',
      loadFailed: 'Could not load the exceptions queue.',
      resolved: 'Exception resolved.',
      resolutionRejected: 'The decision was not accepted.',
      resolutionDescription: 'Add an operational note. It will be recorded in the audit trail.',
      resolutionPlaceholder: 'Admin decision, customer call, justification...',
      resolutionHelp: 'Minimum 3 characters. Overrides without a note are rejected.'
    },
    settlements: {
      title: 'Settlements',
      description: 'Review finished parcels not yet settled, take the fees of delivered parcels, add the agents’ commissions, then close.',
      loadFailed: 'Could not load the settlements.',
      loadDetailFailed: 'Could not load this settlement.',
      runFailed: 'Could not start the settlement.',
      runStarted: 'Settlement started.',
      reviewWarning: 'Some parcels need checking.',
      running: 'Settling…',
      run: 'Start the settlement',
      backToSettlements: 'Back to settlements',
      detailTitle: 'Settlement details',
      toSettle: 'To settle',
      toSettleDescription: 'Finished parcels, not yet settled.',
      partnerDebitDescription: 'Fees to take from the partners’ credit.',
      agentCommissionDescription: 'Amount added to what the agent can withdraw.',
      operationalRule: 'How it works',
      ruleTitle: 'The settlement closes finished parcels',
      ruleDescription: 'A delivered parcel debits the partner, pays the agent and earns for the platform. A failed, cancelled or returned parcel is closed with no fee.',
      permanentAudit: 'Kept in the history',
      history: 'History',
      runsTitle: 'Settlements done',
      runColumn: 'Settlement',
      deliveries: 'Deliveries',
      partnerFees: 'Partners’ fees',
      agentCommissions: 'Agents’ commissions',
      completedAt: 'Finished on',
      failedCount: '{count} failed',
      emptyRuns: 'No settlement yet.',
      runCount: '{count} settlement(s)',
      settledDeliveries: 'Deliveries settled',
      partnerDebit: 'Taken from partners’ credit',
      partnerCreditConsumed: 'Partners’ credit used.',
      agentBalanceCredited: 'Amount added to what agents can withdraw.',
      completedOn: 'Finished on {date}',
      toReview: 'To check',
      unsettledLines: 'Lines not settled automatically',
      unknownDelivery: 'Unknown delivery',
      partnerNotProvided: 'Partner not given',
      errorNotProvided: 'Error not given',
      requiredFee: 'Fee to pay',
      currentCredit: 'Current credit',
      estimatedAvailable: 'Available (estimate)',
      fixAndRerun: 'Fix the problem, then start the settlement again.',
      includedDeliveries: 'Deliveries included',
      deliveredAt: 'Delivered at',
      noPartner: 'No partner',
      noAttachedPackages: 'No parcel in this settlement.',
      creditDebits: 'Taken from credit',
      creditedCommissions: 'Commissions added',
      recordedRevenue: 'Earnings recorded',
      noPartnerDebit: 'Nothing taken from partners.',
      noAgentCommission: 'No agent commission.',
      noPlatformRevenue: 'No earnings for the platform.',
      status: {
        completed: 'Finished',
        running: 'In progress',
        pendingReview: 'To check',
        failed: 'Failed'
      }
    },
    auditViewer: {
      outcomes: {
        success: 'Succeeded',
        warning: 'Needs review',
        error: 'Failed'
      },
      label: 'History',
      title: 'Calendar of actions',
      description: 'See the important actions day by day. Filter by role, action, subject or reason, then open the details.',
      loadFailed: 'Could not load the history.',
      clearDates: 'Clear dates',
      clearFilters: 'Clear filters',
      applyFilters: 'Apply',
      roles: {
        system: 'System'
      },
      views: {
        calendar: 'Calendar',
        table: 'Table'
      },
      columns: {
        time: 'Time',
        actor: 'Actor',
        role: 'Role',
        action: 'Action',
        subject: 'Subject',
        reason: 'Reason',
        status: 'Status'
      },
      filters: {
        role: 'Role',
        allRoles: 'All roles',
        action: 'Action',
        actionPlaceholder: 'Step change, login, update…',
        subject: 'Subject',
        subjectPlaceholder: 'Parcel, agent, wallet…',
        reason: 'Reason code',
        reasonPlaceholder: 'LOST, ADMIN_OVERRIDE...',
        period: 'Period',
        from: 'From',
        to: 'To'
      },
      stats: {
        visibleEvents: 'Visible events',
        issues: 'Needs attention',
        actors: 'Actors'
      },
      legend: {
        label: 'Colors',
        package: 'Parcel',
        exception: 'Problem',
        wallet: 'Wallet',
        agent: 'User',
        auth: 'Login',
        system: 'System'
      },
      calendar: {
        label: 'Audit calendar',
        title: 'Actions by date',
        range: 'Range',
        loading: 'Loading',
        synced: 'Synced',
        today: 'Today',
        month: 'Month',
        week: 'Week',
        list: 'List'
      },
      focus: {
        label: 'Selected event',
        empty: 'Tap an event in the calendar or a row in the table to see the details.'
      },
      quickSearch: {
        label: 'Quick search',
        placeholder: 'Actor, action, subject, reason...',
        help: 'Search applies to both the calendar and the table.'
      },
      table: {
        searchPlaceholder: 'Search actor, action, subject, reason...',
        emptyTitle: 'Nothing in the history',
        emptyDescription: 'Important actions will show here.'
      }
    },
    handovers: {
      searchPlaceholder: 'Reference, parcel, courier, agent…',
      agentLabel: 'Arrivals',
      agentTitle: 'Arrivals',
      agentDescription: 'Open an arrival to choose the parcels to accept, add photos and enter the courier’s code.',
      courierLabel: 'My drop-offs',
      courierTitle: 'Drop-off history',
      courierDescription: 'Find each drop-off at an agent, the parcels left there and the code to show if needed.',
      handover: 'Arrival',
      courierFallback: 'Courier',
      total: 'Total',
      received: 'Received',
      alreadyReceived: 'Already received',
      pendingToReceive: 'To receive',
      waiting: 'Waiting',
      codTotal: 'To collect',
      cod: 'To collect',
      pending: 'To receive',
      partial: 'Partly',
      dropped: 'Dropped off',
      loading: 'Loading…',
      loadingDetail: 'Loading…',
      noResults: 'Nothing matches your search.',
      emptyAgent: 'Nothing to receive for now. When a courier drops parcels for you, they will show here.',
      emptyCourier: 'You have not made any drop-off yet.',
      loadFailed: 'Could not load the list.',
      courierLoadFailed: 'Could not load your drop-offs.',
      newDrop: 'New drop-off',
      newCode: 'New code',
      codeRefreshed: 'New code ready.',
      codeRefreshFailed: 'Could not create a new code.',
      detailTitle: 'Arrival details',
      backToHandovers: 'Arrivals',
      keepCodeVisible: 'Keep this code on screen until the agent has received all the parcels.',
      confirmationTitle: 'Confirm the arrival',
      confirmationDescription: 'Receive the parcels you chose.',
      dropProgress: 'Sending. Keep this page open.',
      selectedSummary: '{packages} parcels · {photos} photo(s)',
      packageCounts: '{packages} parcels · {received} received · {pending} waiting',
      expiresAt: 'Valid until {time}',
      batchPackages: 'Parcels in this drop-off',
      parcelReturningHint: 'This parcel is on its way back. You will see it once the agent has deposited it.',
      batchAgent: 'Agent for this drop-off',
      batchAgentHelp: 'All parcels scanned here must have this agent.',
      packagesToAccept: 'Parcels to accept',
      packagesToAcceptDescription: 'Remove only the parcels you are not receiving now. They will stay for later.',
      noneSelected: 'No parcel chosen. Put back at least one parcel.',
      nonCod: 'Nothing to collect',
      removeFromReception: 'Do not receive this parcel',
      removedCount: '{count} parcel(s) removed',
      removeFromBatch: 'Remove',
      removedFromBatch: 'Parcel removed.',
      restore: 'Put back',
      alreadyReceivedCount: '{count} parcel(s) of this arrival were already received.',
      receptionPhotos: 'Photos of the received parcels',
      receptionPhotosHelp: 'Required. Take at least one photo of the parcels you received.',
      physicalCode: 'Courier’s code',
      physicalCodeHelp: 'Compare this code with the courier’s screen before receiving.',
      senderCode: 'Code for the sender',
      senderCodeHelp: 'The sender gives this code to the agent when dropping off the parcel.',
      resendSenderCode: 'Send the code again',
      resendOnlyWhileWaiting: 'Only possible while the parcel waits for the sender.',
      senderCodeResending: 'Sending…',
      senderCodeResent: 'The code was sent again to the sender.',
      senderCodeResendFailed: 'Could not send the code again.',
      confirmPackages: 'Confirm {count} parcels',
      notFound: 'Arrival not found.',
      photoRequired: 'Add at least one photo.',
      noDeliverySelected: 'No parcel chosen to receive.',
      receiveRejected: 'The reception was not accepted. Try again.',
      receiveSuccess: '{count} parcel(s) received.',
      invalidCourierDrop: 'This parcel cannot be dropped off from this screen.',
      duplicatePackage: 'This parcel is already in the list.',
      agentRequired: 'This parcel has no agent yet. Ask the 3asass team to choose one, then scan it again.',
      agentMismatch: 'This parcel is for {packageAgent}. This drop-off is for {batchAgent}.',
      readyToDrop: 'Ready to drop off.',
      addedToBatch: 'Parcel added.',
      dropPhotoRequired: 'Add at least one photo of the parcels.',
      scanAtLeastOne: 'Scan at least one parcel.',
      singleAgentRequired: 'One drop-off can only hold parcels for the same agent.',
      deliveryMissing: 'This parcel has no delivery.',
      deliveryMissingInBatch: 'One of the parcels has no delivery.',
      codeMessage: '{reference} · Code: {code}',
      dropRejected: 'The drop-off was not accepted. Try again.',
      failedCount: '{count} parcel(s) refused. Fix them and try again.',
      droppedCount: '{count} parcel(s) dropped off.',
      dropPhotos: 'Photos of the parcels dropped off',
      dropPhotosHelp: 'Take at least one photo of the parcels.',
      showCodeToAgent: 'Show this code to the agent. They must enter it on their screen to confirm reception.',
      doneHint: 'The agent received these parcels. Nothing left to do.',
      removedFromReception: 'Parcel removed.',
      readyToReceiveOne: 'Parcel ready to receive.',
      scanOneFirst: 'First scan a parcel that was dropped off.',
      singleReceiveLabel: 'Receive a parcel',
      singleReceiveTitle: 'Scan a parcel',
      singleReceiveDescription: 'Receive one parcel with the code given by the courier.',
      selectedPackage: 'Chosen parcel',
      linkedHandover: 'Linked arrival: {reference}',
      askCourierCode: 'Ask the courier for the code on their screen.',
      confirmOnePackage: 'Confirm this parcel',
      scanOneEmpty: 'Scan the QR code of a parcel that was dropped off, or type its code.',
      confirmDrop: 'Confirm the drop-off',
      stepScan: 'Scan',
      stepPackages: 'Parcels',
      stepPhoto: 'Photo',
      stepCode: 'Code',
      stepSignature: 'Signature',
      stepConfirm: 'Confirm',
      nextStep: 'Next: {step}',
      sessionMismatch: 'This parcel is in another arrival. Scan parcels from one arrival at a time.',
      scanMoreHelp: 'Scan another parcel or go to the next step.',
      scannedCount: '{count} parcels scanned',
      dropComplete: 'Drop-off done',
      dropQueued: 'Drop-off kept on the phone. It will be sent when the connection is back.',
      startNewDrop: 'New drop-off'
    },
    courierEarnings: {
      title: 'My courier earnings',
      balance: 'Confirmed earnings',
      completed: 'Parcels received this week',
      help: 'Your earnings for the outward trip are added when the destination agent confirms reception. Return trips are not paid.'
    },
    profile: {
      connectedAccount: 'Your account details.',
      operationalDescription: 'Change your work details.',
      actionFailed: 'It did not work',
      fullNameRequired: 'The name is required.',
      phoneInvalid: 'Enter a number with the country code, for example +212600000000.',
      residenceRequired: 'Choose your point.',
      saved: 'Profile saved.',
      saveFailed: 'Could not save the profile.',
      loadFailed: 'Could not load your profile.',
      chooseDocument: 'Choose at least one document to replace.',
      kycSaved: 'Documents saved. An administrator must check your identity again.',
      kycSaveFailed: 'Could not save the documents.',
      kycDocuments: 'Identity documents',
      editKycImages: 'Change the document photos',
      replaceNeededFiles: 'Replace only the files you need. Any change must be checked again.',
      displayName: 'Name shown',
      saveName: 'Save'
    },
    pod: {
      validationTitle: 'Confirming the delivery',
      validationDescription: 'Sending the proof, the money collected and your commission…',
      label: 'Hand-over to the recipient',
      captureProof: 'Take the proof',
      description: 'The signature, the photo, your location and the money collected are required before sending.',
      loadingPackage: 'Loading the parcel…',
      deliveryMissing: 'Delivery not found.',
      signatureRequired: 'The signature is required.',
      photoRequired: 'The photo is required.',
      geolocationRequired: 'Turn on location, then tap “Get my location”.',
      cashRequired: 'Enter the money collected.',
      cashInvalid: 'The amount is not valid.',
      cashExpected: 'The amount must be {amount}.',
      queued: 'Proof kept on the phone. It will be sent when the connection is back.',
      synced: 'Proof sent.',
      rejected: 'Proof refused. Check the fields, then try again.',
      dropPhoto: 'Photo of the hand-over',
      dropPhotoHelp: 'The photo is made smaller on the phone, then sent.',
      cod: 'To collect',
      cashCollection: 'Money collected',
      expectedAmount: 'Amount to collect: {amount}',
      noCod: 'Nothing to collect for this parcel.',
      cashPlaceholder: 'Money collected',
      noCashPlaceholder: 'Nothing to collect',
      cashMismatch: 'The amount must be exactly the one asked.',
      validateDelivery: 'Confirm the delivery',
      stepProof: 'Proof',
      stepSignature: 'Signature'
    },
    bulkPod: {
      podAction: 'Proofs ({count})',
      title: 'Hand over several parcels',
      label: 'One proof',
      description: 'One photo, one signature and your location for all the chosen parcels.',
      selectedSummary: '{count} parcel(s) chosen',
      proofOnce: 'The same proof will be used for each parcel.',
      remove: 'Remove',
      removed: 'Parcel removed.',
      submit: 'Confirm ({count})',
      confirmTitle: 'Sending',
      confirmDescription: 'Each parcel will be marked delivered with its proof.',
      resultTitle: 'Proofs saved',
      resultSummary: '{count} parcel(s) delivered',
      queued: 'No connection: the proofs will be sent as soon as possible.',
      backToPackages: 'Back to the parcels',
      reasonNotAvailable: 'This parcel is not in your list.',
      missingTargets: 'No parcel chosen.'
    },
    packages: {
      title: 'All packages',
      description: 'Search, filter and follow parcels.',
      importCsv: 'Import CSV',
      create: 'Create package',
      currentPage: 'Current page',
      created: 'Created',
      active: 'Active',
      issues: 'Issues',
      codPage: 'Amount due',
      searchPlaceholder: 'Reference, recipient, phone…',
      emptyTitle: 'No parcel',
      emptyDescription: 'Parcels you create will show here.',
      packages: 'Packages',
      package: 'Package',
      open: 'Open',
      recipient: 'Recipient',
      unknownRecipient: 'Unknown recipient',
      relay: 'Point',
      assignedAgent: 'Assigned agent',
      state: 'State',
      type: 'Type',
      residence: 'Point',
      createdAt: 'Created at',
      createdFrom: 'Created from',
      createdTo: 'Created to',
      unassigned: 'Unassigned',
      csvTitle: 'Import CSV manifest',
      csvDescription: 'Creates packages in bulk. Valid rows also create their delivery in created state.',
      expectedColumns: 'Expected columns',
      expectedColumnsDescription: 'residence_id, cod_amount_mad, recipient_name, recipient_phone, recipient_address. operator_tracking_ref, internal_ref, partner_id, and agent_id are optional.',
      codMadHelp: 'Write the amount in dirhams, for example 125 for 125 MAD. It is converted automatically.',
      template: 'Template',
      csvFile: 'CSV file',
      skipped: 'Skipped',
      errors: 'Errors',
      line: 'Line',
      status: 'Status',
      reference: 'Reference',
      detail: 'Detail',
      close: 'Close',
      importing: 'Importing...',
      agentLabel: 'Agent:'
    },
    parcelMap: {
      subtitle: 'Your parcels and collections on one map.',
      agentSubtitle: 'Your parcels on one map.',
      listLabel: 'Parcels and collections',
      parcelPoint: 'Where the parcel goes',
      collectionPoint: 'Where to collect it',
      open: 'Open',
      searchPlaceholder: 'Reference, recipient or address…',
      widenHint: 'Move the map or search to see further.',
      showAll: 'Show all',
      selectHint: 'Tap a parcel on the map to see it here.',
      empty: 'No parcel on the map',
      emptyHint: 'Parcels will show here once their address is found.'
    },
    courierPickups: {
      title: 'Collections',
      subtitle: 'Pick up parcels from agents or from senders',
      tabPending: 'To collect',
      tabCollected: 'Collected',
      pendingEmpty: 'No collection waiting',
      pendingEmptyHint: 'New collections will show here.',
      collectedEmpty: 'No collection done yet',
      pointLabel: 'Drop-off point',
      parcelCount: '{count} parcel(s)',
      distanceKm: '{distance} km',
      collectTitle: 'Pick up the parcel',
      collectStepScan: 'Scan',
      collectStepCode: 'Code',
      collectStepConfirm: 'Confirm',
      codeLabel: 'Hand-over code',
      codePrompt: 'Enter the code the agent shows you',
      codeWrong: 'Wrong code',
      codeExpired: 'Code expired',
      codeExpiredHint: 'Ask the agent for a new code, then refresh.',
      codeMissing: 'No code to enter',
      collectPhotos: 'Photos of the collection',
      collectPhotosHelp: 'Photograph the parcels the agent gives you.',
      collectPhotoRequired: 'Add a photo of the parcels handed over.',
      collectConfirm: 'Pick up {count} parcels',
      collectSuccess: 'Parcel picked up. Head to the destination.',
      sessionTitle: 'Collection',
      sessionReference: 'Reference {ref}',
      sessionEmpty: 'No parcel in this collection.',
      refreshCode: 'Refresh the code',
      goToPoint: 'Open the route',
      senderLocationCapturedAtCollection: 'Your location is taken automatically at the photo step.',
      senderProofSummary: 'A photo and your location will confirm the pickup at this address.',
      releasePickup: 'Cancel my reservation',
      releaseSuccess: 'Reservation cancelled. Another courier can take it.',
    },
    packageDetail: {
      recipientPayment: 'Payment by the recipient',
      paidFee: 'You paid',
      notFound: 'Parcel not found',
      loadFailed: 'Could not load the parcel.',
      loadDetailFailed: 'Could not load the parcel details.',
      detail: 'Parcel details',
      returnCourier: 'Courier for the return',
      tabTimeline: 'Tracking',
      tabProofs: 'Proofs',
      tabMap: 'Map',
      tabReferences: 'References',
      createdOn: 'Created on {date}',
      backToList: 'Parcel list',
      copied: 'Copied.',
      copyReference: 'Copy the reference',
      copyPhone: 'Copy the number',
      publicTracking: 'Public tracking page',
      myPackages: 'My parcels',
      route: 'Round',
      deliveryState: 'Delivery step',
      assignedAgent: 'Chosen agent',
      selectAgent: 'Choose an agent',
      reassignNote: 'Note to explain the change',
      reassignAgent: 'Change the agent',
      returnPoint: 'Return point', returnPointTitle: 'Choose where the customer will take the parcel back', returnPointHint: 'The original point stays {original}. Choose an active point and explain why.', returnPointReason: 'Why change the return point?', assignReturnPoint: 'Choose this return point', returnPointAssigned: 'Return point chosen.', returnPointAssignFailed: 'Could not choose this return point.',
      exception: 'Problem',
      none: 'None',
      recipient: 'Recipient',
      phone: 'Phone',
      deliveryAddress: 'Delivery address',
      references: 'References',
      packageIdentifiers: 'Parcel references',
      courierQrScan: 'QR code for the courier to scan',
      downloadQr: 'Download the QR code',
      qrUnavailable: 'QR code not available.',
      internalQrReference: 'Internal reference / QR',
      internalReference: 'Internal reference:',
      operatorReference: 'Tracking reference:',
      technicalIds: 'Technical IDs',
      show: 'Show',
      hide: 'Hide',
      delivery: 'Delivery',
      milestones: 'Parcel steps',
      dropped: 'Dropped off',
      relayDropped: 'Dropped at the point',
      received: 'Received',
      agentReceived: 'Received by the agent',
      outForDelivery: 'Out for delivery',
      delivered: 'Delivered',
      noMilestones: 'No step recorded yet.',
      backendActions: 'Possible actions',
      availableActions: 'Possible actions',
      runnable: 'possible',
      noActions: 'No action possible at this step.',
      timeline: 'Tracking',
      operationalHistory: 'Parcel history',
      adminNotePrompt: 'A note is required for this action',
      adminNoteRequired: 'The note is required.',
      selectActiveAgent: 'Choose an active agent.',
      deliveryActionSynced: 'Action saved.',
      backendRejected: 'The action was not accepted.',
      agentUpdated: 'The agent was changed.',
      reassignmentRejected: 'The agent change was not accepted.',
      agentDescription: 'The agent’s tracking, from reception to delivery or problem.',
      courierDescription: 'The courier’s tracking, from creation to drop-off at the point.',
      enRoute: 'On the way',
      enRouteDescription: 'The courier has left and is heading to the point.',
      progression: 'Progress',
      relayAddress: 'Point and address',
      relayMap: 'Map of the point',
      routeToDrop: 'Route to the delivery point',
      routeToPickup: 'Route to the pickup',
      routeToReturnPoint: 'Route to the return point',
      takePickupPhoto: 'Photograph the parcel at the sender’s',
      confirmPickup: 'Confirm the pickup',
      senderReturnSaved: 'Parcel given back to the sender',
      senderReturnComplete: 'The return is done.',
      senderReturnHelp: 'Hand the parcel to the sender in person, then save a photo and your location.',
      takeSenderReturnPhoto: 'Take the hand-back photo',
      senderReturnTo: 'Give back to the sender',
      senderReturnStepSender: 'Sender',
      senderReturnPhoto: 'Hand-back photo',
      senderReturnPhotoHelp: 'Take a photo of the parcel, with the person if you can.',
      senderReturnPhotoFirst: 'Add the photo first',
      senderReturnUnavailable: 'This parcel is not waiting to go back to the sender.',
      backToParcel: 'Back to the parcel',
      senderReturnFailed: 'The hand-back was not saved. Check your location and connection, then try again.',
      pickupLocationRequired: 'Allow location to confirm the pickup.',
      pickupProofSaved: 'Pickup confirmed. Proof saved.',
      pickupProofFailed: 'The pickup could not be confirmed. Check the photo and location, then try again.',
      dropProofs: 'Drop-off proofs',
      uploadedPhotos: 'Photos sent',
      noDropProof: 'No drop-off proof for this parcel.',
      returnDepositPhotos: 'Photos of the return drop-off',
      returnCollectionPhotos: 'Photos of the return pick-up',
      returnRequests: 'Return requests',
      returnIncidents: 'Return problems',
      returnRequestsForPackage: 'Requests for this parcel',
      noReturnRequests: 'No return request for this parcel.',
      approveReturnRequest: 'Accept and start the return',
      rejectReturnRequest: 'Refuse',
      returnApprovePrompt: 'Note for accepting this return',
      returnRejectPrompt: 'Note for refusing this return',
      returnApproved: 'Return request accepted.',
      returnRejected: 'Return request refused.',
      reviewedAt: 'Answered on',
      adminNote: 'Note',
      returnStatuses: {
        pending: 'Waiting',
        approved: 'Accepted',
        rejected: 'Refused'
      },
      packageCreated: 'Parcel created',
      packageCreatedDescription: 'The parcel is registered for delivery.',
      dropConfirmed: 'Drop-off confirmed',
      dropConfirmedDescription: 'The courier scanned the parcel at the point and finished the drop-off.',
      system: 'System',
      courier: 'Courier',
      actions: {
        en_route: 'On the way',
        mark_en_route: 'On the way',
        drop: 'Drop-off by the courier',
        cancel: 'Cancel',
        receive: 'Reception by the agent',
        notify_resident: 'Tell the recipient',
        start_delivery: 'Go and deliver',
        report_exception: 'Report a problem',
        capture_pod: 'Give to recipient',
        request_return: 'Ask for the return',
        open_dispute: 'Open a dispute',
        retry_by_admin: 'Try again',
        return_to_sender: 'Give back to the sender',
        deposit_return: 'Return dropped off',
        collect_return: 'Return picked up',
        resolve_as_delivered: 'Settle: delivered',
        resolve_as_failed: 'Settle: failed',
        confirm_failed: 'Confirm the failure',
        accept_damaged: 'Accept with a note',
        clear_agent: 'Clear the agent',
        confirm_loss_agent_fault: 'Loss caused by the agent',
        declare_cod_loss: 'Declare the loss'
      },
      collectionTitle: 'Collection',
      collectionOpen: 'See the collection and its code',
      arrivalTitle: 'Arrival',
      arrivalOpen: 'See the arrival and the courier’s code'
    },
    returnRequests: {
      label: 'Reports and returns',
      title: 'Reported problems and returns',
      description: '{count} request(s) in the current queue: problems customers reported after delivery, and returns asked for without an account.',
      loadFailed: 'Could not load return requests.',
      empty: 'No reports or returns for this filter.',
      packageCode: 'Package code',
      requester: 'Requester',
      requestedAt: 'Requested at',
      reviewedFrom: 'Reviewed from',
      reviewedTo: 'Reviewed to',
      searchPlaceholder: 'Package code, name, phone, address, note...',
      reviewTitle: 'Review request',
      approveTitle: 'Accept and start the return',
      rejectTitle: 'Refuse: the parcel stays delivered',
      reviewDescription: 'Add an internal note before confirming this decision.',
      reviewNotePlaceholder: 'Admin note for this request'
    },
    returnIncidents: {
      title: 'Return incidents', description: 'Packages stay with their current custodian until an admin resumes or closes the return.',
      loadFailed: 'Could not load return incidents.', empty: 'No return incidents.', reportedBy: 'Reported by', custodian: 'Current custodian',
      custodyAtReport: 'State when reported', resolution: 'Decision', viewEvidence: 'View photo evidence', reasonPlaceholder: 'Admin decision reason (at least 8 characters)',
      chooseCourier: 'Choose an active courier', resume: 'Resume return', reassign: 'Change courier after the hand-over', closeLost: 'Close as lost',
      actionFailed: 'The decision failed.', resumeSuccess: 'Return resumed.', reassignSuccess: 'Return reassigned to the new courier.', 'close-lostSuccess': 'Return closed as lost.',
      statuses: { open: 'Needs review', resumed: 'Resumed', reassigned: 'Courier changed', closed_lost: 'Lost' }
    },
    cancellationRequests: {
      title: 'Cancellation requests', description: 'A parcel already in the network is only cancelled after it is physically back with the sender.',
      loadFailed: 'Could not load cancellation requests.', empty: 'No cancellation requests.', askedAt: 'Asked', stateWhenAsked: 'State when asked',
      parcelNow: 'Parcel now', decisionNote: 'Decision', notePlaceholder: 'Decision reason (at least 8 characters)',
      approve: 'Approve and send back', reject: 'Refuse', approveSuccess: 'Cancellation approved; the parcel is on its way back to the sender.', rejectSuccess: 'Request refused.',
      actionFailed: 'The decision failed.', pendingCount: '{count} request(s) waiting.',
      waitForRelay: 'The parcel is on the road. Wait until it reaches a relay before approving.',
      awaitingPhysicalReturn: 'Approved. Waiting for the parcel to reach the sender.', returnedAt: 'Handed back to the sender on {at}.',
      statuses: { pending: 'To review', approved: 'Coming back', rejected: 'Refused', completed: 'Cancelled' }
    },
    packageCreate: {
      intake: 'Add parcels',
      title: 'Create package',
      description: 'Creates the operator package and its initial delivery in created state.',
      actionDenied: 'Action denied',
      referenceDestination: 'Reference and destination',
      operatorReference: 'Operator reference',
      operatorReferenceHelp: 'Optional. Generated automatically when left empty.',
      internalReference: 'Internal reference',
      generatedIfEmpty: 'Generated if empty',
      internalReferenceHelp: 'Optional. Used by 3asass for QR, scans, and support.',
      assignment: 'Assignment',
      relayAgentPayment: 'Relay, agent, and payment',
      relayResidence: 'Relay residence',
      collectionMode: 'Collect from',
      relayOrigin: 'Collection relay point',
      senderAddressOrigin: 'Sender address',
      pickupPoint: 'Relay pickup point',
      senderName: 'Sender name',
      senderPhone: 'Sender phone',
      senderAddress: 'Collection address',
      originCsvHelp: 'Use sender_address with name, phone, and address, or relay with sender name, phone, and pickup_agent_id.',
      senderPinNotice: 'The parcel drop-off code will be sent to the sender’s phone through WhatsApp.',
      assignedAgent: 'Assigned agent',
      backendAutoAssign: 'Automatic choice',
      assignedAgentHelp: 'Optional. If empty, the least busy active agent at this point is chosen.',
      noActiveAgent: 'No active agent available for this residence.',
      noPartner: 'No partner',
      partnerHelp: 'Optional. Used to track partner credit and delivery fees.',
      codAmountMad: 'COD amount in MAD',
      recipient: 'Recipient',
      deliveryContact: 'Delivery contact details',
      recipientName: 'Recipient name',
      recipientPhone: 'E.164 phone',
      recipientAddress: 'Recipient address',
      creating: 'Creating...',
      create: 'Create package',
      afterCreation: 'After creation',
      backendDoes: 'What happens next',
      backendCreatesDelivery: 'A delivery is created by itself, at the “created” step.',
      backendAssignsAgent: 'We try to choose an active agent at the same point, the least busy.',
      backendIdempotency: 'If you send twice by mistake, only one parcel is created.',
      referenceExplanation: 'Operator reference = the seller external reference, generated if missing. Internal reference = our short reference for QR, scan, and support.',
      validationResidence: 'Select a relay residence.',
      validationRecipientName: 'Recipient name is required.',
      validationRecipientPhone: 'Recipient phone is required.',
      validationRecipientAddress: 'Recipient address is required.',
      validationCod: 'COD amount must be a positive number or 0.',
      creationFailed: 'Creation failed.',
      normalMode: 'Normal',
      excelMode: 'Excel / CSV',
      addPartnerCreditWarning: 'Add partner credit before creating more paid-fee packages.'
    },
    agentCreatePackage: {
      title: 'New parcel',
      subtitle: 'Scan or type the parcel code, then fill in the details.',
      backToDashboard: 'Home',
      back: 'Back',
      qrMode: 'Scan the QR code',
      qrModeHint: 'With the phone camera',
      textMode: 'Type the code',
      textModeHint: 'Type or paste the code',
      enterTextLabel: 'Parcel code',
      textModePlaceholder: 'Type or paste the code here…',
      processText: 'Read the code',
      scannedCode: 'Code read',
      copyCode: 'Copy the code',
      autoExtract: 'Fill in automatically',
      trackingCode: 'Tracking reference',
      trackingCodePlaceholder: 'Reference read',
      recipientName: 'Recipient’s name',
      recipientNamePlaceholder: 'Full name',
      recipientPhone: 'Phone',
      recipientPhonePlaceholder: '+212600000000',
      recipientAddress: 'Address',
      recipientAddressPlaceholder: 'Full address',
      createPackage: 'Create the parcel',
      creating: 'Creating…',
      success: 'Parcel created.',
      failed: 'The parcel could not be created.',
      copied: 'Copied.',
      copyFailed: 'Could not copy.',
      enterCode: 'Enter a code.',
      extracted: 'The fields were filled in.',
      extractFailed: 'Could not fill in the fields. Write the name, phone and address, one per line.',
      validationRecipientName: 'The recipient’s name is required.',
      validationRecipientPhone: 'The recipient’s phone is required.',
      validationRecipientAddress: 'The recipient’s address is required.',
      photoProof: 'Photo of the parcel',
      validationPhoto: 'The photo of the parcel is required.',
      ocrCamera: 'Camera',
      ocrUpload: 'Photo',
      ocrManual: 'Type',
      ocrCapture: 'Read the text',
      ocrProcessing: 'Reading…',
      ocrRetake: 'Take again',
      ocrUseText: 'Use this text',
      ocrSelectImage: 'Choose a photo',
      ocrSelectImageHint: 'Photo of the parcel to read the text',
      ocrReupload: 'Another photo',
      ocrManualPlaceholder: 'Type or paste the text here…',
      ocrCameraInit: 'Opening the camera…',
      ocrRetry: 'Try again',
      ocrConfirmUse: 'Use this information',
      ocrTakePhoto: 'Take a photo'
    },
    agentCreate: {
      onboarding: 'Agent sign-up',
      title: 'Create agent',
      description: 'Create the pending account, attach the residence, then collect KYC documents.',
      agentList: 'Agent list',
      actionDenied: 'Action denied',
      information: 'Information',
      operationalProfile: 'Operational profile',
      fullName: 'Full name',
      e164Phone: 'E.164 phone',
      language: 'Language',
      residence: 'Residence',
      kyc: 'KYC',
      fieldDocuments: 'Field-collected documents',
      identityDocument: 'Identity document',
      identityDocumentHelp: 'JPG, PNG, or PDF. Maximum 5 MB.',
      residenceProof: 'Proof of residence',
      residenceProofHelp: 'JPG, PNG, or PDF. Can be added later.',
      facePhoto: 'Face photo',
      facePhotoHelp: 'JPG or PNG. Maximum 2 MB.',
      creating: 'Creating...',
      create: 'Create agent',
      missingKyc: 'KYC documents are required.',
      creationFailed: 'Creation failed.'
    },
    agentOnboarding: {
      label: 'Agent sign-up',
      title: 'Complete your profile',
      description: 'Your account is waiting. You will be able to receive parcels, scan and see your money after the team approves it.',
      actionFailed: 'It did not work',
      identitySection: 'Your details',
      fullName: 'Full name',
      phone: 'Phone',
      preferredLanguage: 'Language',
      residenceZone: 'Your point',
      documentsSection: 'Identity documents',
      documentsDescription: 'Add or replace the documents asked for. Any change must be checked again by the team.',
      identityDocument: 'ID card',
      proofOfResidence: 'Proof of address',
      facePhoto: 'Photo of your face',
      currentDocument: 'Current document',
      currentPhoto: 'Current photo',
      openCurrentDocument: 'See the current document',
      openCurrentPhoto: 'See the current photo',
      noCurrentDocument: 'No document',
      noCurrentPhoto: 'No photo',
      saveDocuments: 'Save the documents',
      documentsSaved: 'Documents saved. The team must check them again.',
      chooseDocument: 'Choose at least one document to replace.',
      validationState: 'Where your file stands',
      profileCompleted: 'Profile complete',
      identityDocReceived: 'ID card received',
      residenceProofReceived: 'Proof of address received',
      photoReceived: 'Photo received',
      kycValidated: 'Identity checked by the team',
      escrowRecorded: 'Deposit recorded',
      saveProfile: 'Save my profile',
      saving: 'Saving…',
      chooseResidence: 'Choose your point.',
      chooseName: 'Enter your full name.',
      choosePhone: 'Enter your phone number.',
      saveFailed: 'Could not save the profile.',
      kycSaveFailed: 'Could not save the documents.',
      loadFailed: 'Could not load your details.'
    },
    scanner: {
      title: 'Scan a parcel',
      hint: 'Point the camera at the parcel’s QR code, or type its code.',
      looking: 'Looking for the parcel…',
      notFound: 'No parcel with this code for you.',
      failed: 'Could not check the code. Try again.',
      again: 'Scan another parcel',
      details: 'See the parcel',
      reportProblem: 'Report a problem',
      steps: {
        customer_handover: 'Take the parcel from the customer',
        show_collection_code: 'Show the code to the courier',
        receive_arrival: 'Receive the parcel',
        start_delivery: 'Go and deliver',
        deliver: 'Give to recipient',
        deposit_return: 'Drop off the return',
        return_arrived: 'The parcel is with me',
        hand_back_to_customer: 'Give back to the customer',
        drop_off: 'Drop off at the agent',
        collect_session: 'Open the collection',
        accept_return: 'Accept this return',
        collect_return: 'Pick up the return',
        confirm_sender_return: 'Hand to sender'
      },
      waiting: {
        waiting_courier: 'This parcel is waiting for the courier.',
        coming_courier: 'The courier is bringing this parcel.',
        delivered: 'This parcel was delivered. Nothing to do.',
        cancelled: 'This parcel was cancelled.',
        with_team: 'The team is handling a problem with this parcel.',
        return_in_progress: 'This parcel is on its way back. Nothing for you to do now.',
        nothing: 'Nothing to do with this parcel right now.'
      }
    },
    senderReturns: {
      title: 'Parcels coming back ({count})',
      comingBack: 'The courier is bringing this parcel back. Tap when it is with you.',
      arrived: 'The parcel is with me',
      arrivedDone: 'The customer has been told. They can come for it.',
      askCode: 'Ask the customer for their 4-digit code.',
      stepCustomer: 'Customer',
      stepProof: 'Code and photo',
      codeFirst: 'Enter the customer’s code',
      photo: 'Hand-back photo',
      photoHelp: 'Take a photo of the parcel, with the customer if you can.',
      unavailable: 'This parcel is not ready to go back to the customer.',
      backToReturns: 'Back to returning parcels',
      handBack: 'Give back to the customer',
      handedBack: 'Parcel given back to the customer.',
      retry: 'Try again',
      failed: 'Not saved. Try again.'
    },
    simpleStatus: {
      requested: 'Requested',
      dropped_off: 'Dropped off',
      on_the_way: 'On the way',
      delivered: 'Delivered',
      returned: 'Given back to sender',
      returnedHint: 'The parcel was given back to the sender.',
      problem: 'There is a problem, we are on it',
      problemHint: 'Our team is on it. We will keep you posted.',
      cancelled: 'Cancelled',
      journey: 'Parcel steps',
      returnJourney: 'Return steps',
      returnRequested: 'Return requested',
      returnAtDestination: 'With the agent',
      returnOnWay: 'Coming back',
      returnReady: 'Ready to collect',
      returnReceived: 'Back with you'
    },
    pageTitles: {
      pickupsShort: 'Drop-offs',
      home: 'Home',
      packages: 'Parcels',
      packageDetail: 'Parcel',
      scan: 'Receive a parcel',
      createPackage: 'New parcel',
      handovers: 'Arrivals',
      handoverDetail: 'Arrival',
      pickups: 'Drop-offs',
      pickupScan: 'Receive from customer',
      pickupHandover: 'Give to courier',
      pickupSession: 'Parcels for the courier',
      returns: 'Returns',
      pod: 'Give to recipient',
      bulkPod: 'Give several parcels',
      returnDeposit: 'Receive a return',
      exception: 'Report a problem',
      sync: 'Data sending',
      wallet: 'My earnings',
      profile: 'My profile',
      dropSessions: 'My drop-offs',
      dropSessionsShort: 'Drops',
      dropSessionDetail: 'Drop-off',
      drop: 'Drop off at an agent',
      collections: 'Collections',
      collectionDetail: 'Collection',
      returnCollect: 'Pick up a return',
      scanner: 'Scan',
      senderReturn: 'Hand back to sender',
      requests: 'Requests',
      requestNew: 'Send a parcel',
      requestDetail: 'Request',
      dropOffs: 'My drop-offs',
      payments: 'Payments',
      courierMap: 'Parcel map',
      agentMap: 'Parcel map',
      back: 'Back',
      menu: 'Menu'
    },
    pickupRequests: {
      loadFailed: 'Could not load the requests. Try again.',
      title: 'New requests ({count})',
      customer: 'Customer',
      goingTo: 'For',
      call: 'Call the customer',
      answerBy: 'Answer before {time}',
      accept: 'Accept',
      decline: 'Refuse',
      declineConfirm: 'Refuse this request? The customer will have to choose another point.',
      keep: 'Keep',
      declineYes: 'Yes, refuse',
      accepted: 'Request accepted. The customer will bring you the parcel.',
      declined: 'Request refused.',
      answerFailed: 'Your answer was not sent. Try again.'
    },
    agentPickups: {
      title: 'Customer drop-offs',
      subtitle: 'Parcels customers hand to you in person',
      /** Badge on a parcel card that names the customer handing the parcel over. */
      clientLabel: 'Customer',
      /** Second line of a pickup card: where the parcel goes once it leaves the point. */
      deliverTo: 'Going to',
      tabIncoming: 'To receive',
      tabReady: 'To hand over',
      tabSessions: 'Collections',
      incomingEmpty: 'No parcel to receive',
      incomingEmptyHint: 'Customers will show here as soon as they choose your point to drop a parcel.',
      readyEmpty: 'No parcel to hand over',
      readyEmptyHint: 'Confirm a customer’s drop-off to offer the parcel to a courier.',
      sessionsEmpty: 'No collection',
      sessionsEmptyHint: 'Collections show up when a customer hands you a parcel.',
      scanTitle: 'Scan the parcels',
      scanStepPackages: 'Parcels',
      scanStepPhoto: 'Photo',
      scanStepConfirm: 'Confirm',
      scanHint: 'Scan the parcels one by one, then take a photo before you confirm.',
      scanSelected: '{count} parcel(s) chosen',
      scanRemove: 'Remove this parcel',
      scanClearAll: 'Remove all',
      confirmHandover: 'Confirm the drop-off',
      customerPresent: 'The customer is here and gave me this parcel',
      signatureRequired: 'The customer’s signature is required.',
      geolocationMissing: 'Your location was not found. Turn on location.',
      photoRequired: 'A photo is required.',
      photoBatchHint: 'One photo is enough for all the parcels.',
      parcelNotYours: 'This parcel is not in your list.',
      reasonNotPickupPackage: 'This parcel was not dropped off by a customer.',
      reasonAgentMismatch: 'This parcel is linked to another point.',
      reasonAlreadyPickupReady: 'This parcel is already ready for the courier.',
      reasonInvalidState: 'This confirmation is not possible at this step of the parcel.',
      reasonPodRejected: 'The proof was refused for this parcel.',
      reasonCodeInvalid: 'Wrong code. Ask the customer again.',
      reasonCodeLocked: 'Too many wrong codes. Try again in 15 minutes.',
      customerCodeTitle: 'Customer’s code',
      customerCodeHint: 'Ask the customer for the 4-digit code in their app.',
      customerCodeMissing: 'Enter the 4-digit code for each parcel.',
      notReadyForCollection: 'This parcel is not ready for the courier yet.',
      queuedOffline: 'No connection: the confirmation will be sent later.',
      sessionTitle: 'Collection',
      sessionReference: 'Reference {ref}',
      sessionParcelCount: '{count} parcel(s)',
      sessionEmpty: 'No parcel in this collection.',
      createSession: 'Prepare the collection',
      sessionCreated: 'Collection ready. Show the code to the courier.',
      code: 'Hand-over code',
      codeHint: 'Give this code to the courier. It is valid for 15 minutes.',
      doneHint: 'The courier collected these parcels. Nothing left to do.',
      codeCopied: 'Code copied',
      codeRefreshed: 'New code ready',
      codeRefreshQueued: 'New code saved. It will work once the connection is back.',
      codeExpiresAt: 'Valid for 15 minutes',
      codeExpired: 'The code expired. Create a new one.',
      codeMissing: 'No valid code',
      codeInvalid: 'Wrong code',
      codeSixDigits: 'The code has 6 digits.',
      waitForCourier: 'Waiting for the courier',
      showCodeToCourier: 'Show this code to the courier',
      assignedLivreur: 'Chosen courier',
      livreurRequired: 'Choose the courier who will come for these parcels.',
      noActiveLivreur: 'No courier available',
      reassignLivreur: 'Change the courier',
      reassignDone: 'The courier was changed.',
      excludeParcel: 'Remove this parcel',
      includedParcels: '{count} parcel(s) inside',
      handoverTitle: 'Customer drop-off',
      handoverHint: 'Check the parcel and the customer before you confirm.',
      typeBadgePickup: 'Customer drop-off',
      fromCustomer: 'Dropped off by the customer',
      tabCollected: 'Collected',
      statusWaiting: 'Waiting for the courier',
      statusCollected: 'Collected by the courier',
      collectedEmpty: 'No finished collection',
      collectedEmptyHint: 'Collections the courier has finished will show here.',
      parcelsNoSession: 'Ready parcels without a collection',
      openSessionHint: 'Open to see the code',
    },
    wallet: {
      label: 'My wallet',
      title: 'My money',
      description: 'Your balance, your commissions and your money movements.',
      backendUnavailable: 'Service unavailable',
      noBackendAgent: 'No agent found',
      noBackendAgentDescription: 'The wallet will show as soon as an agent exists.',
      profit: 'My earnings',
      totalCommissionDescription: 'Total commissions earned on delivered parcels.',
      packagesCount: '{count} parcels',
      noDeliveredProfit: 'No earnings yet',
      noDeliveredProfitDescription: 'The commission of each delivered parcel will be added here.',
      history: 'History',
      movements: 'Movements',
      filters: {
        profit: 'Earnings',
        cod: 'Money collected',
        withdrawal: 'Withdrawals',
        all: 'All'
      },
      searchPlaceholder: 'Search a parcel, a type…',
      loadingHistory: 'Loading…',
      noEntries: 'No movement',
      noEntriesDescription: 'No movement matches this filter.',
      wallet: 'Wallet',
      summary: 'Summary',
      availableToSettle: 'Available now',
      pendingPayout: 'Waiting to be paid',
      completedThisWeek: 'Done this week',
      availableFromApi: 'Available balance',
      reservedCod: 'Cash to collect',
      withdrawableBalance: 'Balance you can withdraw',
      deliveredWeek: 'Delivered this week',
      statuses: {
        credited: 'Added',
        pending: 'Waiting',
        withdrawn: 'Withdrawn'
      },
      movementsCount: '{count} movements',
      loadFailed: 'Could not load the wallet.',
      courierFinance: 'My money',
      collections: 'Money collected',
      courierDescription: 'Your commissions and payments linked to your rounds.',
      courierUnavailable: 'Wallet coming soon',
      courierUnavailableDescription: 'The courier wallet is not available yet.',
      requestWithdrawal: 'Ask for a withdrawal',
      withdrawalAmount: 'Amount in MAD',
      withdrawalMethod: 'How to be paid',
      withdrawalNote: 'Note (optional)',
      mobileWallet: 'Mobile wallet',
      bankTransfer: 'Bank transfer',
      withdrawalHelp: 'The amount is set aside right away. The 3asass team confirms the payment or refuses the request.',
      withdrawalSubmitted: 'Request sent. The amount stays set aside until the team decides.',
      withdrawalFailed: 'Could not send the withdrawal request.',
      withdrawalAmountInvalid: 'Enter an amount above zero.',
      withdrawalQueue: 'Withdrawal requests',
      withdrawalQueueHelp: 'Check the amount and who is to be paid. To pay, enter the transfer reference. To refuse, enter the reason.',
      withdrawalQueueEmpty: 'No withdrawal requests.',
      withdrawalDecisionInput: 'Payment reference or reason for refusing',
      withdrawalDecisionHint: 'This field is the reference if you pay, and the reason if you refuse.',
      markPaid: 'Mark as paid',
      rejectWithdrawal: 'Refuse the request',
      withdrawalPaid: 'Payment recorded.',
      withdrawalRejected: 'Request refused. The money is back in the balance.',
      withdrawalStatuses: { pending: 'Waiting', paid: 'Paid', rejected: 'Refused' }
    },
    adminAgentDetail: {
      sheet: 'Agent file',
      backendUnavailable: 'Service unavailable',
      actionDenied: 'Action refused',
      loadFailed: 'Could not load the agent.',
      actionFailed: 'It did not work.',
      mediaLoadFailed: 'Could not load the identity documents.',
      copyAgentId: 'Copy the agent’s ID',
      copyResidenceId: 'Copy the point’s ID',
      activation: 'Activation',
      ready: 'Ready',
      pending: 'Pending',
      status: 'Status: {status}',
      wallet: 'Wallet',
      guaranteeAvailable: 'Deposit available',
      reserved: 'Reserved',
      withdrawableAmount: 'Withdrawable',
      relay: 'Point',
      performance: 'Performance',
      deliveriesLabel: 'Deliveries',
      successRateLabel: 'Success rate',
      deliveries: 'Deliveries: {count}',
      success: 'Success: {rate}%',
      exceptions: 'Problems: {rate}%',
      checklist: 'To check',
      preactivation: 'Before activation',
      missing: 'Missing',
      activate: 'Activate',
      kyc: 'Identity',
      agentDocuments: 'Agent’s documents',
      identityDocument: 'Identity document',
      identityDocumentHelp: 'National document or equivalent.',
      residenceProof: 'Proof of residence',
      residenceProofHelp: 'Bill, certificate or proof on site.',
      facePhoto: 'Face photo',
      facePhotoHelp: 'Clear photo of the agent.',
      validateKyc: 'Confirm the identity',
      agentInfo: 'Agent’s details',
      profileDetails: 'Profile details',
      agentInfoHelp: 'Change the profile without creating the account again.',
      saveInfo: 'Save',
      escrow: 'Deposit',
      cashManagement: 'Cash handed in',
      escrowHelp: 'Record the cash the agent handed to the field manager.',
      amountMad: 'Amount (MAD)',
      escrowNote: 'Required note, e.g. starting deposit received in cash',
      record: 'Record',
      escrowRule: 'Amount above 0 MAD and a note of at least 10 characters',
      escrowHistory: 'Deposit history',
      escrowHistoryHelp: 'Deposit top-ups recorded in the wallet.',
      noEscrow: 'No deposit recorded for this agent.',
      statusActions: 'Change the status',
      statusActionsHelp: 'Temporary suspension or permanent stop.',
      reactivate: 'Reactivate',
      suspensionReason: 'Reason for the suspension',
      requiredReason: 'The reason is required',
      suspend: 'Suspend',
      confirmationName: 'Full name, to disable',
      disable: 'Disable',
      suspensionRule: 'Suspension: a reason of at least 10 characters. Disabling: the same reason and the exact full name.',
      reassignResidence: 'Change the point',
      reassign: 'Change',
      returnsCap: 'Return limit',
      adjust: 'Adjust',
      unavailableDate: 'Date not known',
      profileCompleted: 'Profile complete',
      identityDoc: 'ID card',
      residenceProofShort: 'Proof of address',
      facePhotoShort: 'Face photo',
      kycValidated: 'Identity confirmed',
      escrowRecorded: 'Deposit recorded'
    },
    adminCourierDetail: {
      sheet: 'Courier file',
      backendUnavailable: 'Service unavailable',
      actionDenied: 'Action refused',
      loadFailed: 'Could not load the courier.',
      suspendFailed: 'Could not suspend courier.',
      reactivateFailed: 'Could not reactivate courier.',
      dropsToday: 'Drops today',
      dropsTodayHelp: 'Drops recorded today.',
      lastActivity: 'Last activity',
      account: 'Account',
      noActivity: 'No activity',
      dateUnavailable: 'Date unavailable',
      dropHistory: 'Drop history',
      dropHistoryHelp: 'The latest drop-offs of the day will show here.',
      noDetailedDrops: 'No detailed drop-off for this courier.',
      suspension: 'Suspension',
      suspensionHelp: 'Cuts the courier’s access right away.',
      reasonPlaceholder: 'Required reason, minimum 10 characters',
      suspend: 'Suspend the courier',
      suspensionRule: 'Suspension requires a reason of at least 10 characters.',
      reactivation: 'Reactivation',
      reactivationHelp: 'Only possible if the courier is suspended.',
      reactivate: 'Reactivate the courier'
    },
    adminLists: {
      relayAgents: 'Agents of the points',
      agentManagement: 'Agent management',
      agentDescription: 'Operational monitoring for guardians, KYC, active load, and wallet balances.',
      createAgent: 'Create agent',
      active: 'Active',
      pending: 'Pending',
      suspended: 'Suspended',
      withdrawable: 'Withdrawable',
      status: 'Status',
      load: 'Load',
      relay: 'Point',
      loadAgentsFailed: 'Could not load the agents.',
      agentSearch: 'Name, phone, point…',
      noAgents: 'No agent',
      agentsEmpty: 'Agents you create will show here.',
      copyAgentId: 'Copy agent ID',
      copyResidenceId: 'Copy residence ID',
      validated: 'Validated',
      toValidate: 'To validate',
      activeCount: '{count} active',
      couriersTitle: 'Couriers',
      couriersDescription: 'Follow courier accounts, suspensions and drop-offs.',
      dropsToday: 'Drops today',
      lastActivity: 'Last activity',
      dropsDay: 'Daily drops',
      accounts: 'Accounts',
      courierSearch: 'Name or phone...',
      noCouriers: 'No couriers',
      couriersEmpty: 'Couriers created by OTP will appear here.',
      loadCouriersFailed: 'Could not load couriers.',
      noActivity: 'No activity',
      statuses: {
        pending: 'Pending',
        active: 'Active',
        suspended: 'Suspended',
        disabled: 'Disabled'
      }
    },
    residences: {
      relay: 'Relay',
      title: 'Residences',
      description: 'Manage the points available for choosing agents and receiving parcels.',
      add: 'Add residence',
      total: 'Total',
      active: 'Active',
      inactiveCount: '{count} inactive',
      linkedAgents: 'Linked agents',
      linkedPackages: 'Linked packages',
      tableView: 'Table',
      mapView: 'Map',
      mapTitle: 'Residences map',
      mapSubtitle: 'All available relays',
      mapDescription: 'See the points on the map, choose one and open its file.',
      coverage: 'Coverage',
      mappableCount: '{count} residences have GPS coordinates.',
      selectedRelay: 'Selected relay',
      address: 'Address',
      gps: 'GPS',
      actions: 'Actions',
      inactive: 'Inactive',
      searchPlaceholder: 'Name, address, city...',
      emptyTitle: 'No residence',
      emptyDescription: 'Add a residence to start package assignment.',
      edit: 'Edit',
      deactivate: 'Deactivate',
      editTitle: 'Edit residence',
      addTitle: 'Add residence',
      residenceId: 'Residence ID',
      osmSearch: 'OpenStreetMap search',
      osmPlaceholder: 'Residence, street, district, city...',
      searchRequired: 'Enter an address or residence name.',
      noMoroccoResult: 'No result found in Morocco.',
      geolocationUnavailable: 'Browser geolocation is not available.',
      geolocationFailed: 'Could not get browser position.',
      morocco: 'Morocco',
      name: 'Name',
      latitude: 'Latitude',
      longitude: 'Longitude',
      activeCheckbox: 'Active',
      mapHelp: 'Click the map to place the marker. You can also zoom and pan the map.',
      openOsm: 'Open in OpenStreetMap',
      osmDisclaimer: 'Address data comes from OpenStreetMap. Always verify the address before saving.',
      create: 'Create',
      validationRequired: 'Name, address, and city are required.',
      invalidLatitude: 'Invalid latitude.',
      invalidLongitude: 'Invalid longitude.',
      actionFailed: 'Action failed.'
    },
    publicTracking: {
      unavailable: 'Tracking not available',
      unavailableMessage: 'This code was not found, or tracking is not available right now.',
      label: 'Parcel tracking',
      backHome: 'Back to home',
      package: 'Parcel',
      recipient: 'Recipient:',
      hiddenRecipient: 'Hidden until it arrives at the point',
      operatorReference: 'Tracking reference:',
      relay: 'Delivery point',
      relayPending: 'The point will show once the agent has received the parcel.',
      agent: 'Agent',
      agentPending: 'Shown when the parcel reaches the point',
      dates: 'Dates',
      dropped: 'Dropped off:',
      received: 'Received:',
      out: 'Out for delivery:',
      delivered: 'Delivered:',
      map: 'Map',
      relayPosition: 'Where the point is',
      trackingTimeline: 'Parcel progress',
      createdTitle: 'Parcel created',
      createdDescription: 'The parcel is registered.',
      en_route: 'On the way:',
      enRouteTitle: 'On the way to the point',
      enRouteDescription: 'The courier has the parcel and is heading to the point.',
      droppedTitle: 'Dropped at the point',
      droppedDescription: 'The courier dropped the parcel at the point.',
      receivedTitle: 'Received by the agent',
      receivedDescription: 'The agent confirmed that they received the parcel.',
      outTitle: 'Out for delivery',
      outDescription: 'The parcel is on its way to the recipient.',
      deliveredTitle: 'Delivered',
      deliveredDescription: 'The parcel was handed over, with a proof of delivery.',
      failedTitle: 'Delivery did not work',
      failedDescription: 'The delivery did not work.',
      noMapBeforeReceived: 'The map shows once the agent has received the parcel.',
      returnRequest: 'Return request',
      returnRequestTitle: 'Ask for a return',
      returnPageDescription: 'Enter your details and the parcel code. The team checks your request before starting the return.',
      returnName: 'Your full name',
      returnPhone: 'Your phone',
      returnAddress: 'Your address',
      returnPackageCode: 'Parcel code',
      returnNote: 'Message for the team',
      returnSubmit: 'Send my request',
      returnFormRequired: 'The name, phone, address and parcel code are required.',
      returnSubmitted: 'Request sent.',
      returnSubmittedDetail: 'We received your request. The 3asass team checks it before starting the return.',
      returnFailed: 'Could not send the request.'
    },
    documents: {
      view: 'View document',
      unavailable: 'Document unavailable'
    },
    exception: {
      title: 'Report a problem',
      reason: 'Reason',
      operationalNote: 'Details (optional)',
      submit: 'Send',
      queued: 'Problem kept on the phone. It will be sent when you are online.',
      synced: 'Problem sent.',
      rejected: 'The problem was not accepted. Try again.',
      notAllowedForState: 'You cannot report any problem at this step.',
      recipientAbsent: 'Recipient not there',
      refused: 'Recipient refused',
      damagedAtReceipt: 'Damaged on arrival',
      damagedAtDelivery: 'Damaged on the way',
      lost: 'Parcel lost',
      wrongContent: 'Wrong or suspicious content',
      unreachable: 'Recipient cannot be reached',
      adminOverride: 'Changed by the administration',
      returnApproved: 'Return accepted',
      returnRejected: 'Return declined',
      photoLabel: 'Photo of the problem',
      photoHelp: 'Optional, but recommended. Take a photo that shows the problem.',
      agentLabel: 'Problem with a parcel',
      agentTitle: 'Report a problem',
      agentEligibleStates: 'Possible when the parcel is received, out for delivery, failed or in dispute.',
      noPackageSelected: 'No parcel chosen. Go back to the parcel page and choose “Report a problem”.',
      courierLabel: 'Problem at drop-off',
      courierTitle: 'Report a problem',
      courierDescription: 'Use this if a parcel dropped at the agent has a problem before it is received.'
    },
    podMedia: {
      signedPod: 'Signed proof',
      operationalProofs: 'Delivery proofs',
      courierDropPhoto: 'Photo of the drop-off by the courier',
      courierDropPhotoAlt: 'Drop-off photo {index}',
      noDropPhoto: 'No drop-off photo',
      courierPickupPhoto: 'Photos of the collection',
      courierPickupPhotoAlt: 'Collection photo {index}',
      noCourierPickupPhoto: 'No collection photo',
      receptionPhotos: 'Photos of the reception',
      receptionPhotoAlt: 'Reception photo {index}',
      noReceptionPhoto: 'No reception photo',
      deliveryPhoto: 'Photo of the delivery',
      noPhoto: 'No photo',
      signature: 'Recipient’s signature',
      noSignature: 'No signature',
      customerHandoverPhotos: 'Photos of the drop-off by the customer',
      customerHandoverPhotoAlt: 'Customer drop-off photo {index}',
      customerHandoverSignature: 'Customer’s signature (drop-off at the agent)',
      noCustomerHandoverSignature: 'No customer signature.',
      noCustomerHandoverPhoto: 'No photo of the customer’s drop-off',
      exceptionsAndReturns: 'Problems and returns',
      incidentProofs: 'Proofs of the problem',
      exceptionPhotos: 'Photos of the problem',
      exceptionPhotoAlt: 'Photo of the problem {index}',
      noExceptionPhoto: 'No photo of the problem',
      returnAgentPhotos: 'Photos of the return at the agent',
      returnAgentPhotoAlt: 'Return at agent photo {index}',
      noReturnAgentPhoto: 'No photo of the return at the agent',
      returnCourierPhotos: 'Photos of the return picked up by the courier',
      returnCourierPhotoAlt: 'Photo of the return picked up {index}',
      senderReturnPhotos: 'Photos of the parcel given back to the sender',
      senderReturnPhotoAlt: 'Photo of the parcel given back {index}',
      noReturnCourierPhoto: 'No photo of the return picked up'
    },
    timeline: {
      history: 'Parcel history',
      lifecycle: 'Steps',
      empty: 'No event for this parcel.',
      gpsPosition: 'Position on the map',
      viewGps: 'See the position',
      transitions: {
        awaitingPickupToPickupReady: 'Customer’s drop-off at the agent confirmed',
        pickupReadyToEnRoute: 'Parcel taken by the courier at the agent',
        pickupToCancelled: 'Drop-off cancelled',
        pickupReadyToReceived: 'Parcel received from the customer at the relay',
        enRouteToDropped: 'Parcel dropped at the relay by the courier',
        droppedToReceived: 'Parcel received at the relay',
        receivedToOut: 'Out for delivery',
        receivedToOutHold: 'The recipient is here: hand-over started',
        outToDelivered: 'Handed to the recipient',
        outToDeliveredHold: 'Collected by the recipient',
        toFailed: 'Delivery failed',
        toReturnRequested: 'Return started',
        returnRequestedToDeposited: 'Returned parcel deposited at the relay',
        depositedToCollected: 'Returned parcel taken by the courier',
        toDisputed: 'Dispute opened',
        disputedToDelivered: 'Dispute settled: delivered',
        disputedToFailed: 'Dispute settled: failed',
        failedToReceived: 'New delivery attempt',
        toCancelled: 'Parcel cancelled',
        createdToEnRoute: 'Parcel taken from the sender'
      },
      actions: {
        transition: 'Step changed',
        en_route: 'On the way to the point',
        partner_return: 'Return to the partner',
        state_changed: 'Step changed'
      },
      descriptions: {
        partnerReturn: 'The partner confirmed that they received the returned parcel.',
        auditEvent: 'Action recorded in the history.',
        system: 'System'
      },
      showAll: '+{count} steps',
      showLess: 'Show fewer'
    },
    podUpload: {
      title: 'Delivery proofs',
      assets: 'Proof files',
      addPhoto: 'Add a photo',
      ready: 'Ready',
      missing: 'Missing',
      uploaded: 'Sent'
    },
    logisticsUi: {
      photo: 'Photo',
      takePhoto: 'Take a photo',
      upload: 'Choose a file',
      removePhoto: 'Remove the photo',
      compression: 'One moment…',
      noFileSelected: 'No file chosen',
      compressionUnavailable: 'The photo could not be made smaller. The original photo is used.',
      photosSelected: '{count} photo(s) chosen',
      photoLimitReached: 'You have reached the limit of {max} photos.',
      removeAllPhotos: 'Remove all photos',
      proofPhoto: 'Photo {index}',
      qrScanner: {
        label: 'QR code scanner',
        httpsRequired: 'The camera only works on a secure connection (HTTPS). Type the code below.',
        cameraUnavailable: 'The camera is not available on this device.',
        cameraDenied: 'Camera access was refused, or the camera did not start.'
      },
      packageVerification: 'Check the parcel',
      start: 'Start',
      stop: 'Stop',
      qrHelp: 'Point the camera at the parcel’s QR code.',
      manualPackageCode: 'Or type the parcel code',
      confirm: 'Confirm',
      signaturePad: 'Space to sign',
      proofOfDelivery: 'Proof of delivery',
      clear: 'Clear',
      signatureReady: 'Signature taken.',
      signatureTooSmall: 'The signature is too small. Sign bigger inside the box.',
      signatureRequired: 'The customer’s signature is required.'
    },
    sync: {
      synced: 'Sent',
      pending: 'Waiting',
      syncing: 'Sending',
      failed: 'Sending failed',
      conflict: 'Problem to check',
      conflictProofRetained: 'The proof stays on this phone. Ask for a check before sending it again.',
      inProgressRetry: 'The server is still working. Try again in a few seconds. Your proof is kept.',
      offline: 'No connection',
      title: 'Data sending',
      description: 'When there is no network, your actions are kept on the phone and sent as soon as the connection is back.',
      emptyQueue: 'Nothing to send',
      syncNow: 'Send now'
    },
    nav: {
      groups: { operations: 'Activity', network: 'Network', finance: 'Money', system: 'System' },
      overview: 'Overview',
      settings: 'Settings',
      packages: 'Parcels',
      createPackage: 'Create',
      returnRequests: 'Reports and returns',
      returnIncidents: 'Stuck returns',
      cancellationRequests: 'Cancellation requests',
      orderRequests: 'Platform requests',
      partners: 'Partners',
      customers: 'Customers',
      exceptions: 'Problems',
      agents: 'Agents',
      residences: 'Points',
      couriers: 'Couriers',
      settlements: 'Settlements',
      withdrawals: 'Withdrawals',
      platformConfig: 'Configuration',
      audit: 'History',
      route: 'Round',
      drop: 'Drop-off',
      sessions: 'Hand-overs',
      handovers: 'Arrivals',
      returns: 'Returns',
      scan: 'Scan',
      sync: 'Sending',
      balance: 'Balance',
      home: 'Home',
      money: 'Money',
      pickups: 'Drop-offs'
    },
    pwa: {
      home: 'Home',
      roles: {
        agent: 'Agent',
        courier: 'Courier',
        customer: 'Customer',
      },
      greeting: 'Hello {name}',
      greetingFallback: 'Hello',
      buckets: {
        action: 'To do',
        problems: 'Problems',
        done: 'Done',
        incoming: 'Coming',
        ready: 'Ready to hand over',
        pickup: 'To pick up',
      },
      scan: 'Scan',
      packagesNav: 'Parcels',
      pickups: 'Drop-offs',
      lifecycle: { all: 'All steps' },
      filters: { title: 'Filter', stageHint: 'Show only the parcels at one step.' },
      returns: 'Returns',
      money: 'Money',
      profile: 'My profile',
      logout: 'Log out',
      online: 'Online',
      offline: 'No connection',
      wallet: {
        available: 'Available balance',
        reservedCod: 'Cash to collect',
        weeklyDelivered: 'Delivered this week',
        earnings: 'My earnings',
        perParcel: 'Per parcel',
        seeEarnings: 'See my earnings',
        viewDetails: 'See details',
      },
      actions: {
        scan: 'Scan',
        scanDesc: 'With the QR code',
        more: 'More actions ({count})',
        create: 'Create',
        createDesc: 'New parcel',
        handovers: 'Arrivals',
        handoversDesc: 'Parcels received',
        returns: 'Returns',
        returnsDesc: 'Parcels sent back',
      },
      todayDeliveries: {
        title: 'To deliver today',
        empty: 'No parcels to deliver today.',
        cod: 'To collect',
        phone: 'Phone',
        address: 'Address',
      },
      packages: {
        title: 'My parcels',
        searchPlaceholder: 'Search for a parcel…',
        filterAll: 'All',
        filterPending: 'Waiting',
        filterInProgress: 'On the way',
        filterDelivered: 'Delivered',
        empty: 'No parcels found.',
        loadFailed: 'Could not load the parcels.',
        bulk: {
          title: 'Choose several parcels',
          hint: 'Tick several parcels, then do the action once.',
          enter: 'Choose parcels',
          exit: 'Done',
          selectLoaded: 'Choose all ({count})',
          selectedCount: '{count} parcels chosen',
          noEligible: 'None of these parcels can do this action.',
          clear: 'Untick all',
          remove: 'Remove',
          reviewTitle: 'Chosen parcels',
          reviewEmpty: 'You have not chosen anything yet.'
        },
      },
    },
    partners: {
      title: 'Partners',
      description: 'Sender accounts, credit, status and delivery fees.',
      partner: 'Partner',
      create: 'New partner',
      createPartner: 'Create a partner',
      editPartner: 'Edit partner',
      companyName: 'Company',
      contactName: 'Contact name',
      contactPhone: 'Contact’s phone',
      contactEmail: 'Contact’s email',
      contact: 'Contact',
      agent: 'Agent',
      credit: 'Credit',
      creditBalance: 'Credit balance',
      lowCreditThresholdMad: 'Minimum credit before alert (MAD)',
      threshold: 'Minimum',
      activePartners: 'Active partners',
      lowCredit: 'Low credit',
      creditBlocked: 'Credit used up',
      availableCredit: 'Credit available',
      reservedFees: 'Fees set aside',
      balanceLabel: 'Balance',
      totalCredit: 'Total credit',
      backToList: 'Partner list',
      addCredit: 'Add credit',
      recordTopup: 'Record the top-up',
      amount: 'Amount',
      amountMad: 'Amount (MAD)',
      note: 'Note',
      postedAt: 'Date',
      postedFrom: 'From',
      postedTo: 'To',
      entryType: 'Type',
      searchPlaceholder: 'Company, contact, email, phone…',
      creditSearchPlaceholder: 'Reference, note, recipient…',
      emptyTitle: 'No partners',
      emptyDescription: 'The partners you create will show here.',
      noCreditEntries: 'No credit movement',
      noCreditEntriesDescription: 'Top-ups and delivery fees will show here.',
      noPartner: 'No partner',
      portalPassword: 'Partner area password',
      portalPasswordUpdate: 'New password',
      portalPasswordHelp: 'Optional. At least 12 characters. If empty, access is not created or changed.',
      portalPasswordInvalid: 'The password must have at least 12 characters.',
      portalEnabled: 'Access on',
      portalDisabled: 'Access off',
      actionFailed: 'It did not work.',
      companyRequired: 'The company name is required.',
      contactRequired: 'The contact name is required.',
      phoneRequired: 'The phone is required.',
      emailRequired: 'The email is required.',
      thresholdInvalid: 'The minimum must be a positive amount.',
      amountInvalid: 'The amount must be above zero.',
      noteRequired: 'Add a clear note.',
      requested: 'Requested',
      copyPartnerId: 'Copy the partner’s ID',
      unsettledExposure: 'Parcels not yet settled',
      balanceAfterExposure: 'Balance after these parcels',
      needsCreditAttention: 'Credit to watch',
      creditOperational: 'Enough credit',
      submittedByPartner: 'Sent by this partner',
      creditActivity: 'Credit movements',
      topupsAndFees: 'Top-ups and delivery fees',
      financeViewHelp: 'Quick overview before opening the details.',
      credited: 'Added',
      feesDebited: 'Fees taken',
      pendingTopup: 'Top-up waiting',
      latestMovement: 'Latest movement',
      noCreditMovement: 'No movement yet.',
      topupRequests: 'Top-up requests',
      reviewQueue: 'To review',
      partnerAccess: 'Partner’s access',
      statusActions: 'Change the status',
      statusActionsHelp: 'Decide whether this partner can log in and create parcels.',
      portalActive: 'The partner’s access is on.',
      portalSuspended: 'The partner’s access is suspended for now.',
      portalClosed: 'The partner’s account is closed.',
      statusImpact: 'A suspended or closed partner can no longer create parcels. Their history stays visible to the team.',
      searchTopupRequests: 'Search a top-up request…',
      noTopupRequests: 'No top-up request',
      noTopupRequestsDescription: 'Partners’ top-up requests will show here.',
      bankTransferReceived: 'Bank transfer received.',
      approveTopupRequest: 'Accept the top-up request',
      rejectTopupRequest: 'Refuse the top-up request',
      request: 'Request',
      noPartnerNote: 'No note from the partner.',
      rejectRequestPlaceholder: 'Explain why you refuse…',
      approveRequest: 'Accept the request',
      rejectRequest: 'Refuse the request',
      suspendPartner: 'Suspend the partner',
      closePartner: 'Close the account',
      reactivatePartner: 'Reactivate the partner',
      suspendPartnerHelp: 'Blocks the partner’s access and parcel creation for a while.',
      closePartnerHelp: 'Closes the account and blocks everything. Use only if the work together is over.',
      reactivatePartnerHelp: 'Gives the partner access back. They can create parcels if their credit is enough.',
      statusReasonRequired: 'Write a clear reason of at least 10 characters.',
      statusReasonPlaceholder: 'Explain why you are doing this…',
      active: 'Active',
      suspended: 'Suspended',
      closed: 'Closed',
      status: {
        active: 'Active',
        suspended: 'Suspended',
        closed: 'Closed'
      },
      entry: {
        credit_topup: 'Top-up',
        partner_fee_debit: 'Delivery fee',
        credit_adjustment: 'Credit correction'
      }
    },
    adminCustomers: {
      title: 'Customers',
      subtitle: 'Customer accounts and delivery credit',
      searchPlaceholder: 'Search a customer…',
      empty: 'No customer found.',
      balance: 'Balance',
      available: 'Available',
      exposed: 'Set aside',
      threshold: 'Alert level',
      totalPackages: 'Total parcels',
      deliveredPackages: 'Parcels delivered',
      lastSync: 'Last update',
      lastActivity: 'Last activity',
      detailTitle: 'Customer file',
      detailSubtitle: 'Credit, deliveries and top-up requests',
      contact: 'Contact',
      customerSince: 'Customer since',
      packagesSection: 'Customer’s parcels',
      orderRequestsSection: 'Sending requests',
      returnsSection: 'Return requests',
      creditLedger: 'Credit movements',
      creditLedgerEmpty: 'No credit movement.',
      creditRequests: 'Top-up requests',
      creditRequestsEmpty: 'No top-up request.',
      topupTitle: 'Top-up request',
      topupAmount: 'Amount',
      topupNote: 'Reason',
      topupSubmit: 'Send to the customer',
      approveRequest: 'Accept',
      rejectRequest: 'Refuse',
      adminNote: 'Team note',
      adminNotePlaceholder: 'Seen only by the team',
      entryTypeCreditTopup: 'Top-up',
      entryTypeDeliveryFeeDebit: 'Delivery fee',
      entryTypeCreditAdjustment: 'Credit correction',
      requestStatusPending: 'Waiting',
      requestStatusApproved: 'Accepted',
      requestStatusRejected: 'Refused',
      pickupEnabled: 'Customer drop-offs',
      pickupEnabledHint: 'Customers will be able to choose this agent as a drop-off point.',
      pickupEnabledOn: 'On',
      pickupEnabledOff: 'Off',
      configPickupTypeEnabled: 'Customer drop-offs (general)',
      configPickupTypeEnabledHint: 'Main switch. Off: no drop-off point is offered and no customer parcel is created.',
      configCustomerFee: 'Price of one delivery for the customer',
      configCustomerFeeHint: 'This price is noted when an agent accepts a customer’s parcel. It is not proof of payment.',
      configSaved: 'Setting saved',
      orderRequestPickupPoint: 'Drop-off point',
      orderRequestPickupHint: 'The customer already chose a drop-off point. Keep it or choose another.',
      orderRequestSelectPickupPoint: 'Drop-off point',
      orderRequestNoPoints: 'No agent can take this parcel.',
      orderRequestPickupNone: 'Direct delivery to the address',
      packagePickupPoint: 'Drop-off point',
      packagePickupAgent: 'Agent',
      packageHandoverAt: 'Given to the agent on',
      packageCollectedAt: 'Taken by the courier on',
      customerCreditExhausted: 'Credit used up: the customer must top up.',
    },
    partnerPortal: {
      portal: 'Partner area',
      dashboard: 'Home',
      dashboardDescription: 'Follow your credit, the parcels you sent and deliveries in progress.',
      loginTitle: 'Partner login',
      loginDescription: 'Access for partners created by the 3asass team.',
      login: 'Log in',
      submitPackage: 'Add a parcel',
      submitDescription: 'Create a parcel for your customer. Your partner account is added automatically.',
      myPackages: 'My parcels',
      myPackagesDescription: 'Your parcels with their step, delivery point and amount to collect.',
      packageDetail: 'Parcel details',
      timeline: 'Tracking',
      packageProgress: 'Where the parcel is',
      timelineCreatedTitle: 'Parcel created',
      timelineCreatedDescription: 'The parcel is registered in 3asass and waiting to be taken in charge.',
      timelineDroppedTitle: 'Dropped at the point',
      timelineDroppedDescription: 'The courier dropped the parcel at the planned point.',
      timelineReceivedTitle: 'Received by the agent',
      timelineReceivedDescription: 'The agent confirmed that they received the parcel.',
      timelineOutTitle: 'Out for delivery',
      timelineOutDescription: 'The parcel is on its way to the recipient.',
      timelineDeliveredTitle: 'Delivered',
      timelineDeliveredDescription: 'The parcel is delivered, with the proof of delivery.',
      timelineReturnRequestedTitle: 'Return requested',
      timelineReturnRequestedDescription: 'A return request was accepted by the team.',
      timelineReturnDepositedTitle: 'Return dropped off',
      timelineReturnDepositedDescription: 'The agent dropped off the returned parcel, ready to be picked up.',
      timelineReturnCollectedTitle: 'Return picked up',
      timelineReturnCollectedDescription: 'The return was picked up. It waits for your confirmation.',
      partnerConfirmed: 'Confirmed by the partner',
      returnReception: 'Return reception',
      waitingReturnPackages: 'Returns to confirm',
      waitingReturnPackagesDescription: 'Parcels that came back to you, waiting for your confirmation.',
      confirmReturnReceived: 'Confirm the return was received',
      confirmReturnReceivedDescription: 'Confirm only after you have the parcel in your hands.',
      returnAlreadyConfirmed: 'Return already confirmed',
      returnConfirmedAt: 'Confirmed on {date}',
      returnReceiptConfirmed: 'Return reception confirmed.',
      returnReceiptFailed: 'Could not confirm the reception.',
      noWaitingReturns: 'No return to confirm.',
      timelinePartnerReturnReceivedTitle: 'Return received by the partner',
      timelinePartnerReturnReceivedDescription: 'The partner confirmed that they took the parcel back.',
      podVisibilityTitle: 'Proofs of delivery',
      podReadyTitle: 'Proof available',
      podHiddenTitle: 'Proof not available yet',
      podVisibilityDescription: 'This parcel’s proofs are below. Tap one to enlarge it.',
      podPendingDescription: 'Proofs will show here as the parcel moves along.',
      podDeliveredEmpty: 'The parcel is delivered, but no proof is available yet.',
      podPendingEmpty: 'No proof yet.',
      deliveryPhoto: 'Delivery photo',
      signature: 'Signature',
      dropPhoto: 'Drop-off photo',
      receptionPhoto: 'Reception photo',
      exceptionPhoto: 'Photo of the problem',
      creditAccount: 'My credit',
      creditDescription: 'Top-ups, fees and corrections on your partner account.',
      reports: 'Reports',
      reportsDescription: 'Summary of the month: parcels, success, times and fees.',
      profileTitle: 'Partner profile',
      profileDescription: 'Change the company details, contacts and password.',
      companyInfo: 'Company details',
      contactCard: 'Contact',
      portalEnabled: 'Access on',
      portalDisabled: 'Access off',
      security: 'Security',
      changePassword: 'Change the password',
      passwordDescription: 'The password must have at least 12 characters.',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmPassword: 'Confirm the password',
      passwordsDoNotMatch: 'The two passwords are not the same.',
      saveProfile: 'Save',
      savePassword: 'Change the password',
      profileSaved: 'Profile saved.',
      passwordSaved: 'Password changed.',
      profileSaveFailed: 'Could not save the profile.',
      passwordSaveFailed: 'Could not change the password.',
      actionFailed: 'It did not work',
      lowCreditWarning: 'Your credit is below the minimum of {amount}. Contact the 3asass team to top it up.',
      submittedToday: 'Sent today',
      reservedFees: 'Fees set aside',
      reservedFeesDescription: 'Fees for parcels not yet settled',
      available: 'Available',
      availableAfterFees: 'After the fees set aside',
      successToday: 'Successful today',
      deliveredToday: '{count} delivered today',
      recentPackages: 'Latest parcels',
      viewAll: 'See all',
      noPackagesSubmitted: 'No parcel yet.',
      quickTracking: 'Quick tracking',
      packageReference: 'Parcel reference',
      track: 'Track',
      residences: 'Points',
      chooseFromMap: 'Choose on the map',
      openRelayMapDescription: 'Open the map of points before you create your next parcel.',
      openMap: 'Open the map',
      inProgress: 'In progress',
      failed: 'Failed',
      creditBalance: 'Credit balance',
      threshold: 'Minimum',
      reservedFeesShort: 'Fees set aside',
      availableCredit: 'Credit available',
      usableForNewPackages: 'Can be used for new parcels',
      topupRequest: 'Top-up request',
      requestMoreCredit: 'Ask for more credit',
      topupDescription: 'Enter the amount you want, then make the bank transfer. The team adds the credit once the payment is confirmed.',
      amountInMad: 'Amount in MAD',
      note: 'Note',
      notePlaceholder: 'Transfer reference, expected date…',
      sendRequest: 'Send the request',
      topupSent: 'Request sent. Make the transfer with the reference below.',
      bankTransferInstructions: 'How to make the transfer',
      beneficiary: 'Beneficiary',
      reference: 'Reference',
      validation: 'Confirmation',
      adminConfirmsPayment: 'The team confirms when the payment is received.',
      searchRequests: 'Search a request…',
      noTopupRequests: 'No top-up requests',
      noTopupRequestsDescription: 'Your top-up requests will show here.',
      requested: 'Requested on',
      status: 'Status',
      adminNote: 'Team’s note',
      creditHistory: 'Credit history',
      transactions: 'Movements',
      creditHistoryDescription: 'Top-ups, delivery fees and the balance after each movement.',
      exportCsv: 'Download as CSV',
      balance: 'Balance',
      monthlyReports: 'Monthly reports',
      noPackageActivity: 'No parcel activity',
      availableForNewPackages: 'Available for new parcels',
      addCreditBeforePackages: 'Add credit before creating more parcels with fees.',
      creationMode: 'How to create',
      onePackage: 'One parcel',
      excelCsvImport: 'From an Excel / CSV file',
      normal: 'One by one',
      normalCreateHelp: 'To create a single parcel by hand.',
      excelCreateHelp: 'To create many parcels from a ready file.',
      selectedResidence: 'Chosen point',
      selectResidenceOnMap: 'Choose a point on the map',
      selectResidenceOnMapDescription: 'Tap a marker to use that point for this parcel.',
      residencesMap: 'Map of the points',
      availableRelayPoints: 'Available points',
      residencesMapDescription: 'See the active points on the map before choosing where to send parcels.',
      coverage: 'Areas covered',
      gpsResidences: '{count} point(s) have a GPS position.',
      selectedRelay: 'Chosen point',
      useForPackage: 'Use for a parcel',
      submitted: 'Sent',
      packagesCreatedThisMonth: 'Parcels created this month',
      delivered: 'Delivered',
      successRate: '{rate}% success',
      packagesClosedAsFailed: 'Parcels closed as failed',
      averageTime: 'Average time',
      createdToDelivered: 'From creation to delivery',
      feesCharged: 'Fees charged',
      partnerFeesSettledThisMonth: 'Fees settled this month',
      loadReportFailed: 'Could not load the report.',
      downloadReportFailed: 'Could not download the CSV file.',
      packagesThisMonthAppearHere: 'Parcels created this month will show here.',
      state: 'Step',
      created: 'Created on',
      deliveredAt: 'Delivered on',
      hours: 'Hours',
      cod: 'To collect',
      loadFailed: 'Could not load your area.'
    },
    returns: {
      title: 'Returns',
      agentLabel: 'Agent',
      courierLabel: 'Courier',
      agentDescription: 'Parcels to receive from the recipient, or already dropped at your point.',
      courierDescription: 'Returns to pick up from the agent, and returns already picked up.',
      loading: 'Loading…',
      empty: 'No returned parcel for now.',
      loadFailed: 'Could not load the list.',
      startDeposit: 'Scan a return to drop off',
      startCollection: 'Scan a return to pick up',
      agentDepositTitle: 'Drop off a return',
      agentDepositProgress: 'Sending the photos…',
      agentDepositPageLabel: 'Return at the agent',
      agentDepositHeading: 'Drop off a return',
      agentDepositDescription: 'Scan the parcel, take a photo of its condition, then confirm.',
      courierCollectTitle: 'Pick up a return',
      courierCollectProgress: 'Sending the photos…',
      courierCollectPageLabel: 'Courier’s return',
      courierCollectHeading: 'Pick up a return',
      courierCollectDescription: 'Scan the returns at the agent’s, take a photo, then confirm.',
      returnPhotos: 'Photos of the return',
      returnPhotosHelp: 'Required. Take at least one photo of the parcel’s condition.',
      returnCollectionPhotos: 'Photos of the return picked up',
      returnCollectionPhotosHelp: 'Required. Take at least one photo of the return.',
      removeFromBatch: 'Remove',
      removedFromBatch: 'Return removed.',
      invalidAgentReturn: 'This parcel cannot be dropped off as a return from this screen.',
      invalidCourierReturn: 'This return cannot be picked up from this screen.',
      duplicateReturn: 'This return is already in the list.',
      readyToDeposit: 'Ready to drop off.',
      readyToCollect: 'Ready to pick up.',
      added: 'Return added.',
      notFound: 'No parcel found with this code.',
      photoRequired: 'Add at least one photo of the return.',
      collectionPhotoRequired: 'Add at least one photo of the return you picked up.',
      scanAtLeastOne: 'Scan at least one return.',
      deliveryMissing: 'This parcel has no delivery.',
      depositing: 'Dropping off…',
      collecting: 'Picking up…',
      queuedDeposit: 'Return kept on the phone. It will be sent when you are online.',
      queuedCollection: 'Pick-up kept on the phone. It will be sent when you are online.',
      deposited: 'Return dropped off.',
      collected: 'Return picked up.',
      depositRejected: 'The drop-off was not accepted. Try again.',
      collectionRejected: 'The pick-up was not accepted. Try again.',
      rejectedCount: '{count} return(s) refused.',
      depositedCount: '{count} return(s) dropped off.',
      collectedCount: '{count} return(s) picked up.',
      depositComplete: 'Return dropped off',
      collectionComplete: 'Return picked up',
      startNewDeposit: 'Drop off another return',
      startNewCollection: 'Pick up another return',
      confirmDeposit: 'Confirm the drop-off',
      confirmCollection: 'Confirm the pick-up',
      statusSync: 'Sending',
      statusDeposited: 'Dropped off',
      statusCollected: 'Picked up',
      statusQueued: 'No connection',
      statusFailed: 'Error',
      statusPending: 'Waiting',
      confirmationSummary: '{returns} return(s) · {photos} photo(s)',
      viewDetails: 'See details'
    },
    layout: {
      adminControl: 'Admin area',
      operationsPortal: 'Work area',
      secureAccess: 'Secure sign-in',
      roleEntry: 'One account for all your apps.',
      authDescription: 'Sign in once: your account opens the app for your work.',
      fieldOtp: 'Sign in with a code',
      fieldOtpDescription: 'Agents and couriers sign in with a code sent to their phone.',
      admin2fa: 'Double check',
      admin2faDescription: 'Admin sign-in needs a password and a verification code.',
      operationsConsole: '3asass.ma console',
      backToRoles: 'Back to choosing your area'
    },
    errors: {
      requestFailed: 'It did not work',
      loadingFailed: 'Could not load',
      unauthenticated: 'Your session ended. Please log in again.',
      notFoundTitle: 'Page not found',
      notFoundDescription: 'This page does not exist.',
      goHome: 'Back to home',
      noData: 'Nothing to show',
      resultsWillAppear: 'Results will show here.',
      search: 'Search…'
    },
    actions: {
      scan_reception: 'Scan the received parcel',
      confirm_reception: 'Confirm reception',
      start_delivery: 'Go and deliver',
      capture_pod: 'Give to recipient',
      report_exception: 'Report a problem',
      request_return: 'Ask for the return',
      deposit_return: 'Drop off the return',
      mark_en_route: 'On the way',
      scan_drop: 'Scan the drop-off',
      capture_lot_photo: 'Photo of the parcels',
      confirm_handover: 'Agent’s code',
      close_drop: 'Finish the drop-off',
      collect_return: 'Pick up the return',
      confirm_sender_return: 'Hand to sender',
      view_pod: 'See the proof',
      open_litigation: 'Open a dispute',
      retry_by_admin: 'Try the delivery again',
      return_to_sender: 'Give back to the sender',
      resolve_as_delivered: 'Settle: delivered',
      resolve_as_failed: 'Settle: failed',
      confirm_failed: 'Confirm the failure',
      accept_damaged: 'Accept with a note',
      clear_agent: 'Clear the agent',
      confirm_loss_agent_fault: 'Loss caused by the agent',
      declare_cod_loss: 'Declare the loss',
      cancel: 'Cancel',
      run_settlement: 'Start the settlement',
      confirm_customer_handover: 'Confirm the hand-over',
      create_pickup_handover: 'Prepare the hand-over',
      collect_pickup: 'Pick up'
    },
    walletEntryTypes: {
      commission_earned: 'Commission earned',
      cod_reserve: 'Cash to collect',
      cod_release: 'Collected cash released',
      cod_loss: 'Money lost',
      float_topup: 'Top-up',
      platform_fee: '3asass fee',
      withdrawal_request: 'Withdrawal request',
      withdrawal_paid: 'Withdrawal paid',
      withdrawal_reversal: 'Withdrawal cancelled'
    },
    user: {
      login: {
        title: 'Customer area',
        help: 'Log in with your 3asass account.',
        submit: 'Log in',
        no_account: 'No account yet?',
        signup: 'Create an account'
      },
      dashboard: {
        welcome: 'Hello {name}',
        user: 'Customer',
        cards: {
          packages: {
            title: 'My parcels',
            desc: 'Follow your parcels easily.'
          },
          tracking: {
            title: 'Live tracking',
            desc: 'See where your parcel is.'
          },
          placeholder: {
            title: 'Coming soon',
            desc: 'More features are coming soon.'
          }
        },
        coming_soon: {
          title: 'Coming soon',
          desc: 'More features are coming soon.'
        }
      },
      nav: {
        dashboard: 'Home',
        profile: 'My profile'
      },
      logout: 'Log out'
    },
    platform: {
      dashboard: {
        title: 'Platform space',
        welcome: 'Hello {name}',
        user: 'User',
        cards: {
          landing: {
            title: '3asass Platform',
            desc: 'Access the central 3asass platform.'
          },
          placeholder: {
            title: 'Coming soon',
            desc: 'More features are coming soon.'
          }
        },
        coming_soon: {
          title: 'Coming soon',
          desc: 'More features are coming soon.'
        }
      },
      nav: {
        dashboard: 'Home',
        requests: 'My requests',
        returnRequests: 'Reported problems',
        packages: 'Parcels',
      },
      logout: 'Log out',
      requests: {
        title: 'My requests',
        submitter: 'Sent by',
        description: '{count} request(s)',
        newTitle: 'New request',
        newDescription: 'Send a request so that an agent takes your parcel.',
        newRequest: 'New request',
        backToList: 'Back to the list',
        whatNext: 'What happens next?',
        nextPending: 'We are checking your request. You will be told as soon as it is accepted.',
        nextRejected: 'This request was refused.',
        nextConverted: 'Your parcel is created. Follow it below.',
        nextCancelled: 'You cancelled this request.',
        keyFacts: 'The essentials',
        changeDestination: 'Change the destination',
        cancelRequest: 'Cancel the request',
        deleteRequest: 'Delete the request',
        cancelParcel: 'Cancel the parcel',
        cancelParcelBlocked: 'The parcel was already handed in. It can no longer be cancelled.',
        cancelRequestConfirmTitle: 'Cancel this request?',
        cancelRequestConfirmBody: 'The request will be cancelled. No parcel will be created.',
        deleteRequestConfirmTitle: 'Delete this request?',
        deleteRequestConfirmBody: 'The request will be deleted for good.',
        cancelParcelConfirmTitle: 'Cancel this parcel?',
        cancelParcelConfirmBody: 'The parcel has not been dropped off yet. It will be cancelled.',
        confirmCancelAction: 'Yes, cancel',
        confirmDeleteAction: 'Yes, delete',
        confirmChangeAction: 'Confirm',
        outcomeCancelled: 'Request cancelled',
        outcomeDeleted: 'Request deleted',
        outcomeParcelCancelled: 'Parcel cancelled. It had not been dropped off yet.',
        outcomeDestinationChanged: 'Destination changed',
        changeDestinationTitle: 'New destination',
        changeDestinationHint: 'Choose the point that will receive the parcel.',
        editDetails: 'Edit the details',
        changePickup: 'Change the drop-off point',
        changePickupTitle: 'New drop-off point',
        changePickupHint: 'Choose the agent you will leave the parcel with.',
        noAlternativePickupHint: 'No other drop-off point is available right now. Try again later or contact us.',
        confirmPickupAction: 'Confirm this point',
        outcomePickupChanged: 'Drop-off point changed',
        currentlyLabel: 'Currently',
        moreDetails: 'More details',
        requestFacts: 'Request details',
        reference: 'Reference',
        submittedOn: 'Sent on',
        cashOnDelivery: 'To pay on delivery',
        relay: 'Delivery point',
        zone: 'Area',
        amountDue: 'Amount to pay',
        followPackage: 'Follow the parcel',
        deliveryPoint: 'Delivery point',
        deliveryPointHint: 'Choose the point where you want to receive your parcel. Our team will confirm your choice.',
        noResidencesHint: 'No point is available right now. You can still send the request.',
        detailTitle: 'Request details',
        stepHandOverTitle: 'Where you drop off the parcel',
        stepRecipientTitle: 'Who receives the parcel',
        stepRecipientHint: 'The courier calls this number before coming. Give a full address.',
        pickupAddress: 'Your address',
        pickupSearchAddress: 'Address to search',
        pickupAddressHint: 'Optional. Used to find the points closest to you. You drop the parcel at the point you choose.',
        recipient: 'Recipient',
        recipientName: 'Recipient’s name',
        recipientPhone: 'Phone',
        createdAt: 'Created on',
        recipientAddress: 'Delivery address',
        recipientAddressHint: 'The courier will go to this address.',
        notes: 'Notes',
        notesPlaceholder: 'Other information…',
        notesHint: 'Optional: floor, building code, preferred time…',
        submit: 'Send the request',
        summarySelected: 'Drop-off point chosen: {point}',
        summaryUnselected: 'No point chosen. One will be given when the request is accepted.',
        created: 'Request sent',
        createFailed: 'The request was not sent',
        loadFailed: 'Could not load',
        rejectionReason: 'Reason for refusal',
        convertedPackage: 'Parcel created',
        viewPackage: 'See the parcel',
        approve: 'Accept',
        reject: 'Refuse',
        approved: 'Request accepted',
        rejected: 'Request refused',
        actionFailed: 'It did not work',
        approveTitle: 'Accept the request',
        approveDescription: 'Choose the point.',
        rejectTitle: 'Refuse the request',
        rejectDescription: 'Give the reason for refusing.',
        residence: 'Point (ID)',
        residencePlaceholder: 'Point ID',
        selectResidence: 'Choose a point on the map',
        residencesLoadFailed: 'Could not load the points',
        selectedResidenceInfo: 'The point chosen on the map will be linked to this request.',
        destinationRequired: 'Choose the destination point. Without it, the request cannot be accepted.',
        customerCredit: 'Customer’s credit',
        codAmount: 'Amount to collect (centimes)',
        codPlaceholder: '0',
        adminLabel: 'Requests',
        adminTitle: 'Customer requests',
        searchPlaceholder: 'Search…',
        empty: 'No requests yet',
        statuses: {
          pending: 'Waiting',
          approved: 'Accepted',
          rejected: 'Refused',
          converted: 'Parcel created',
          cancelled: 'Cancelled',
          declined: 'Choose another point',
        },
      },
      packages: {
        label: 'My parcels',
        title: 'My parcels',
        description: '{count} parcel(s)',
        empty: 'No parcels yet',
        loadFailed: 'Could not load the parcels',
        createdAt: 'Created on',
        trackingCode: 'Tracking code',
        relay: 'Delivery point',
        track: 'Follow',
        requestReturn: 'Ask for a return',
        requestCancellation: 'Ask to cancel',
        cancelRequestTitle: 'Cancel the parcel',
        cancelRequestExplainer: 'The parcel is no longer with you. We ask the team to agree, then the parcel is given back to you before it is cancelled.',
        cancelRequestReason: 'Reason (optional)',
        cancelRequestSubmit: 'Send the request',
        cancelRequestSubmitted: 'Cancellation request sent.',
        cancelRequestFailed: 'Could not send the request.',
        cancelRequestPending: 'We are looking at your request. The parcel keeps going until we answer.',
        cancelRequestApproved: 'Cancellation accepted. The parcel is coming back to you. Open the return instructions to see the point and your code when the parcel arrives.',
        cancelRequestRejected: 'Cancellation refused. Check the tracking to see where the parcel is.',
        cancelRequestCompleted: 'Parcel cancelled and taken back.',
        packageInfo: 'Parcel details',
        recipient: 'Recipient',
        relayName: 'Name of the point',
        city: 'City',
        relayAddress: 'Address of the point',
        timeline: 'Tracking',
        noTimeline: 'No tracking yet',
        assignedAgent: 'Agent',
      },
      returnRequests: {
        title: 'My reports',
        description: '{count} report(s)',
        loadFailed: 'Could not load the reports',
        empty: 'No reports yet',
        searchPlaceholder: 'Search by code, name, phone or address…',
        packageCode: 'Parcel',
        packageStatus: 'Parcel step',
        status: 'Answer to the report',
        requestedAt: 'Asked on',
        reviewedAt: 'Answered on',
        openPackage: 'See the parcel',
      },
    },
    platformPickup: {
      pendingTitle: 'My drop-offs',
      pendingHint: 'Follow the parcels you have to drop off, and cancel those still waiting for your confirmation.',
      chosenPoint: 'Chosen point',
      awaitingApproval: 'Waiting for an answer',
      filterAll: 'All',
      filterCancellable: 'Can be cancelled',
      listSummary: '{total} drop-off(s) · {cancellable} can be cancelled',
      cancellableBadge: 'Can be cancelled',
      agentLabel: 'Agent',
      noPickupsTitle: 'No drop-off in progress',
      noPickupsDescription: 'Your parcels to drop off will show here as soon as you create one.',
      noneCancellableTitle: 'Nothing to cancel',
      cancelBlockedHint: 'You can no longer cancel: the agent has already taken the parcel.',
      backToPackages: 'See my parcels',
      stepTitle: 'Choose where to drop off your parcel',
      stepHint: 'You leave the parcel with an agent. Then a courier takes it and brings it to its destination.',
      stepLabel: 'Drop-off point',
      pickPoint: 'Choose a drop-off point',
      changePoint: 'Change the point',
      noPoints: 'No drop-off point available',
      noPointsHint: 'No agent near this address takes parcels yet.',
      noPointsDisabled: 'Drop-off is not available yet.',
      searchArea: 'Search in this area',
      useMyLocation: 'Use my location',
      locating: 'Finding your location…',
      locationLocated: 'Location found. The points are sorted around you.',
      locationUnsupported: 'Your browser cannot find your location.', locationInsecure: 'Location only works on a secure connection (https).',
      locationDenied: 'Location access refused. Allow it, or type your address.',
      locationTimeout: 'Finding your location took too long. Try again, or type your address.',
      mapInstruction: 'Tap the map or move the marker to change the search area.',
      radiusKm: '{distance} km around you',
      pointDistance: '{distance} km away',
      pointSelected: 'Chosen point',
      nearest: 'Closest',
      residenceOnly: 'Only in my building',
      cardTitle: 'Drop-off point',
      cardWaiting: 'Waiting at the agent’s',
      cardReady: 'The courier is coming for it',
      cardCollected: 'On the way',
      cardCancelled: 'Cancelled',
      creditTitle: 'My credit',
      creditSubtitle: 'Credit pays for deliveries. It cannot be refunded.',
      creditBalance: 'Credit balance',
      creditAvailable: 'Credit available',
      creditExposed: 'Credit set aside',
      creditThreshold: 'Alert level',
      creditFeePerDelivery: '{amount} {currency} per delivery',
      topupTitle: 'Add to my credit',
      topupAmount: 'Amount wanted',
      topupAmountPlaceholder: 'Amount in MAD',
      topupNote: 'Reason for the request',
      topupNotePlaceholder: 'e.g. several parcels this week',
      topupSubmit: 'Ask for a top-up',
      topupHistory: 'Top-up history',
      topupRequests: 'My top-up requests',
      topupPending: 'Waiting',
      topupApproved: 'Accepted',
      topupRejected: 'Refused',
      downloadCsv: 'Download the CSV file',
      cancelTitle: 'Cancel my request',
      cancelHint: 'Cancel this request before the agent confirms the drop-off.',
      cancelReason: 'Why cancel?',
      cancelReasonPlaceholder: 'Tell us why',
      cancelSubmit: 'Confirm the cancellation',
      cancelConfirmTitle: 'Confirm the cancellation',
      cancelConfirmBody: 'Your request will be cancelled. You cannot undo this.',
      cancelSuccess: 'Request cancelled',
      insufficientCredit: 'Your credit is not enough for this delivery.',
      typeOffNotice: 'This service is not available for this kind of shipment.',
    },
  }
} as const

type MessageValue = string | MessageTree
type MessageTree = { readonly [key: string]: MessageValue }

function isMessageTree(value: unknown): value is MessageTree {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

function mergeMessages<T extends MessageTree>(base: T, overrides: MessageTree): T {
  const result: Record<string, MessageValue> = { ...base }

  Object.entries(overrides).forEach(([key, value]) => {
    const baseValue = result[key]
    result[key] = isMessageTree(baseValue) && isMessageTree(value)
      ? mergeMessages(baseValue, value)
      : value
  })

  return result as T
}

const arOverrides = {
  common: {
    back: 'رجوع',
    copied: 'تم النسخ.',
    steps: 'المراحل',
    completed: 'مكتمل',
    installFromBrowser: 'التثبيت متاح عبر Chrome',
    language: 'اللغة',
    french: 'الفرنسية',
    english: 'الإنجليزية',
    arabic: 'العربية',
    moroccan: 'الدارجة المغربية',
    profile: 'الملف الشخصي',
    logout: 'تسجيل الخروج',
    accountActions: 'حسابي',
    healthySync: 'تم إرسال كل شيء',
    admin: 'المدير',
    agent: 'الوكيل',
    courier: 'الموزّع',
    partner: 'الشريك',
    partners: 'الشركاء',
    agents: 'الوكلاء',
    relay: 'النقطة',
    platform: 'المنصة',
    account: 'الحساب',
    fieldManager: 'مدير ميداني',
    workflow: 'مسار العمل',
    startPilot: 'إطلاق تجربة',
    installApp: 'تثبيت التطبيق',
    phoneNumber: 'رقم الهاتف',
    verificationCode: 'الرمز المستلم',
    resend: 'إعادة الإرسال',
    resendIn: 'إعادة الإرسال بعد {seconds} ثانية',
    codeSentTo: 'تم إرسال الرمز إلى {phone}',
    pleaseWait: 'لحظة من فضلك…',
    date: 'التاريخ',
    retry: 'حاول مرة أخرى',
    filtering: 'تصفية حسب',
    searchPackages: 'المرجع أو المستلم أو النقطة…',
    verifyAndContinue: 'تأكيد والمتابعة',
    sendVerificationCode: 'استلام رمز',
    continue: 'متابعة',
    previous: 'السابق',
    next: 'التالي',
    loadMore: 'عرض المزيد',
    loadingMore: 'جارٍ التحميل…',
    pageOf: 'الصفحة {current} / {last}',
    pageOfTotal: 'الصفحة {current} / {last} · {total} طرد',
    filter: 'تصفية',
    reset: 'مسح الكل',
    all: 'الكل',
    allStates: 'كل المراحل',
    today: 'اليوم',
    thisWeek: 'هذا الأسبوع',
    thisMonth: 'هذا الشهر',
    city: 'المدينة',
    notProvided: 'غير مذكور',
    showFullText: 'عرض العنوان كاملاً',
    showLess: 'عرض أقل',
    required: 'مطلوب',
    selectedFile: 'الملف المختار',
    selectedPdf: 'ملف PDF المختار',
    addFile: 'إضافة ملف',
    replace: 'استبدال',
    choose: 'اختيار',
    chooseFile: 'اختيار ملف',
    edit: 'تعديل',
    save: 'حفظ',
    saved: 'تم الحفظ',
    saving: 'جارٍ الحفظ…',
    refresh: 'تحديث',
    confirm: 'تأكيد',
    confirmAction: 'تأكيد',
    cancel: 'إلغاء',
    close: 'إغلاق',
    suspend: 'إيقاف مؤقت',
    reactivate: 'إعادة التفعيل',
    approve: 'قبول',
    reject: 'رفض',
    action: 'إجراء',
    actions: 'الإجراءات',
    type: 'النوع',
    amount: 'المبلغ',
    reason: 'السبب',
    status: 'الحالة',
    viewDetail: 'عرض التفاصيل',
    loadingImpossible: 'تعذر التحميل',
    openMenu: 'فتح القائمة',
    workspaceShell: 'مساحة العمل',
    search: 'بحث...',
    user: 'المستخدم',
    identifier: 'المعرف',
    email: 'البريد الإلكتروني',
    loading: 'جاري التحميل',
    logisticsControl: 'التحكم اللوجستي',
    navigation: 'التنقل',
    offlineMode: 'وضع دون اتصال: سيتم تعليق الإجراءات الميدانية.',
    rowsRange: '{first}-{last} من {total}',
    rowsReceived: 'تم استلام {count}',
    copiedWithLabel: 'تم نسخ {label}.',
    copy: 'نسخ',
    reasonCodes: {
      policyViolation: 'مخالفة السياسة',
      fraudSuspected: 'اشتباه احتيال',
      inactivity: 'عدم نشاط',
      escrowInsufficient: 'ضمان غير كاف',
      other: 'أخرى'
    },
    cod: 'الدفع عند الاستلام',
    kyc: 'التحقق من الهوية',
    ok: 'موافق',
    mad: 'درهم',
    platformName: 'ثلاثاس',
    agentPrefix: 'الوكيل:',
    partnerPrefix: 'الشريك:',
    residenceIdPrefix: 'الإقامة:',
    packageId: 'معرّف الطرد',
    deliveryId: 'معرّف التوصيل'
  },
  packageType: {
    normal: 'عادي',
    untracked: 'بدون تتبع',
    pickup: 'إيداع زبون'
  },
  sampleDashboard: {
    title: 'لوحة التحكم',
    description: 'هيكل تطبيق عام مع حالات تحميل قابلة لإعادة الاستعمال.',
    foundation: 'الأساس',
    skeletons: 'هياكل التحميل',
    emptyState: 'حالة فارغة',
    placeholderTitle: 'محتوى مؤقت',
    placeholderDescription: 'هذه الصفحة تتجنب عمداً الوحدات الخاصة بالعمل.'
  },
  sampleSettings: {
    title: 'الإعدادات',
    description: 'عناصر تحكم عامة للتحقق من المكونات المشتركة.',
    interface: 'الواجهة',
    interfaceDescription: 'حقول محايدة للتحقق من المكونات.',
    textInput: 'حقل نص',
    textarea: 'منطقة نص',
    selectOption: 'اختيار خيار',
    default: 'افتراضي',
    compact: 'مضغوط',
    enableOption: 'تفعيل الخيار العام',
    application: 'التطبيق',
    applicationDescription: 'أمثلة PWA والإشعارات.',
    notificationExample: 'مثال إشعار',
    showToast: 'إظهار الإشعار',
    offlinePage: 'صفحة دون اتصال'
  },
  contact: {
    backHome: 'العودة إلى الرئيسية',
    label: 'إطلاق تجربة',
    title: 'حدد تجربة 3asass على منطقة حقيقية.',
    description: 'يجب أن تُظهر التجربة أمرا بسيطا: أبواب أقل للزيارة، فشل أقل، إثباتات أكثر، ومبالغ توصيل أسهل في المراجعة.',
    cityZone: 'مدينة أو منطقة التجربة',
    cityZoneValue: 'مراكش، الدار البيضاء، الرباط...',
    packageVolume: 'حجم الطرود المتوقع',
    packageVolumeValue: 'طرود يومياً أو أسبوعياً',
    residenceNetwork: 'شبكة النقاط',
    residenceNetworkValue: 'عدد المباني أو الحراس',
    currentOperation: 'العملية الحالية',
    currentOperationValue: 'الفشل، مبالغ التوصيل، الإرجاعات، الإثباتات',
    formTitle: 'طلب تجربة',
    formDescription: 'هذا النموذج غير مربوط بعد. الإرسال متوقف حاليا.',
    company: 'الشركة',
    companyPlaceholder: 'اسم الشركة',
    contact: 'جهة الاتصال',
    contactPlaceholder: 'الاسم، الهاتف أو البريد الإلكتروني',
    pilotZone: 'منطقة التجربة',
    pilotZonePlaceholder: 'المدينة، الحي، عدد النقاط',
    volumeContext: 'الحجم والسياق',
    volumeContextPlaceholder: 'مثال: 300 طرد في الأسبوع، مبالغ كثيرة للتحصيل، فشل كثير…',
    submitSoon: 'إرسال الطلب قريباً',
    disabledNote: 'لا تُرسل أي رسالة حاليا.'
  },
  auth: {
    phoneInvalid: 'أدخل رقما مع رمز البلد، مثل +212600000000.',
    fieldTitle: 'تسجيل الدخول',
    fieldDescription: 'أدخل رقم هاتفك.',
    agentTitle: 'دخول الوكيل',
    agentDescription: 'أدخل الرقم المسجل لنقطتك.',
    agentTestPhone: 'وكيل تجريبي محلي: +212600000010',
    courierTitle: 'دخول الموزّع',
    courierDescription: 'أدخل رقم هاتفك. إن لم يكن لديك حساب فسيتم إنشاؤه.',
    courierTestPhone: 'موزع تجريبي محلي: +212600000020',
    adminTitle: 'تسجيل دخول المدير',
    adminDescription: 'الوصول للعمليات يتطلب كلمة مرور وتحقق Authenticator.',
    workEmail: 'البريد المهني',
    password: 'كلمة المرور',
    adminTest: 'مدير تجريبي محلي: admin{\'@\'}example.com / password',
    setupAuthenticator: 'إعداد Authenticator',
    setupAuthenticatorDescription: 'افتحوا Google Authenticator أو Authy، أضيفوا حساباً، ثم امسحوا رمز QR هذا.',
    authenticatorQrAlt: 'رمز QR لإعداد Authenticator',
    openSetupLink: 'فتح رابط الإعداد',
    secretKey: 'المفتاح السري',
    authenticatorCode: 'رمز Authenticator',
    activate2fa: 'تفعيل 2FA والدخول',
    copy: 'نسخ',
    verify2fa: 'تحقق من رمز 2FA'
  },
  maps: {
    position: 'الموقع',
    currentLocation: 'موقعك الحالي',
    currentLocationUnavailable: 'تعذر تحديد موقعك.',
    addressNotFound: 'العنوان غير موجود.',
    routeCalculating: 'جارٍ البحث عن الطريق…',
    routeUnavailable: 'الطريق غير متوفر.',
    basemapLabel: 'نوع الخريطة',
    basemap_streets: 'الشوارع',
    basemap_light: 'فاتحة',
    basemap_dark: 'غامقة',
    basemap_satellite: 'صورة الأقمار الصناعية',
    basemapFallback: 'الخريطة المفصلة غير متوفرة. تم عرض خريطة بسيطة.',
    openGoogleMaps: 'فتح في Google Maps',
    regionLabel: 'الخريطة',
    routeRegionLabel: 'خريطة الطريق إلى {place}',
    basemapHint: 'اختر الخريطة الأوضح.',
    locateMe: 'أين أنا؟',
    expand: 'تكبير الخريطة',
    collapse: 'تصغير الخريطة',
    zoomIn: 'تكبير',
    zoomOut: 'تصغير',
    credits: 'مصادر الخريطة',
    destination: 'الوجهة',
    departure: 'نقطة البداية',
    navigate: 'اذهب',
    arrivalLabel: 'الوصول تقريبا',
    kind: { agent: 'الوكيل', residence: 'النقطة', parcel: 'الطرد', collection: 'نقطة الاستلام', place: 'المكان', return: 'نقطة الإرجاع', pickupPoint: 'نقطة الاستلام', deliveryPoint: 'نقطة التسليم' },
    stopNumber: 'المحطة {number}',
    previousStop: 'المحطة السابقة',
    nextStop: 'المحطة التالية',
    pointsCount: '{count} نقاط على الخريطة',
    pointsListLabel: 'النقاط',
    selectOnMap: 'اضغط على علامة لرؤية التفاصيل.',
    previousPoint: 'النقطة السابقة',
    nextPoint: 'النقطة التالية'
  },
  geolocation: {
    label: 'موقعي',
    title: 'مكانك الحالي',
    notCaptured: 'لم يتم تحديد الموقع',
    unavailable: 'تعذر تحديد موقعك',
 insecureConnection: 'لا يعمل تحديد الموقع إلا باتصال آمن (https). افتح التطبيق عبر https.',

 permissionRequired: 'اسمح بالموقع في المتصفح، ثم اضغط «تحديد موقعي».',
    capture: 'تحديد موقعي',
    capturing: 'جارٍ التحديد…'
  },
  state: {
      created: 'تم إنشاؤه',
      en_route: 'في الطريق',
      dropped: 'تم تسليمه في النقطة',
    received: 'تم استلامه',
    out_for_delivery: 'خرج للتوصيل',
    delivered: 'تم تسليمه',
    returned: 'أعيد إلى المرسل',
    returnedHint: 'تم تسليم الطرد إلى المرسل.',
    failed: 'فشل',
    return_requested: 'تم طلب الإرجاع',
    return_deposited: 'تم تسليم المرتجع',
    return_collected: 'تم أخذ المرتجع',
    disputed: 'محل نزاع',
    cancelled: 'ملغى',
    awaiting_pickup: 'بانتظار التسليم',
    pickup_ready: 'جاهز للأخذ'
  },
  nav: {
    groups: { operations: 'النشاط', network: 'الشبكة', finance: 'المال', system: 'النظام' },
    overview: 'نظرة عامة',
    settings: 'الإعدادات',
    packages: 'الطرود',
    createPackage: 'إنشاء',
    returnRequests: 'البلاغات والإرجاعات',
    returnIncidents: 'إرجاعات متعثرة',
    cancellationRequests: 'طلبات الإلغاء',
    orderRequests: 'طلبات المنصة',
    partners: 'الشركاء',
    customers: 'الزبائن',
    exceptions: 'المشاكل',
    agents: 'الوكلاء',
    residences: 'النقاط',
    couriers: 'الموزّعون',
    settlements: 'التسويات',
    withdrawals: 'السحوبات',
    configuration: 'الإعدادات',
    platformConfig: 'الإعدادات',
    audit: 'السجل',
    dashboard: 'لوحة التحكم',
    route: 'الجولة',
    drop: 'التسليم',
    sessions: 'التسليمات',
    handovers: 'الوصولات',
    returns: 'المرتجعات',
    scan: 'مسح',
    sync: 'الإرسال',
    balance: 'الرصيد',
    submitPackage: 'إضافة طرد',
    creditAccount: 'حساب الرصيد',
    reports: 'التقارير',
    profile: 'الملف الشخصي',
    logOut: 'تسجيل الخروج',
    home: 'الرئيسية',
    money: 'المال',
    pickups: 'الإيداعات'
  },
  pwa: {
    home: 'الرئيسية',
    roles: {
      agent: 'الوكيل',
      courier: 'الموزّع',
      customer: 'الزبون',
    },
    greeting: 'مرحبا {name}',
    greetingFallback: 'مرحبا',
    buckets: {
      action: 'المطلوب',
      problems: 'المشاكل',
      done: 'المكتملة',
      incoming: 'القادمة',
      ready: 'جاهزة للتسليم',
      pickup: 'للجمع',
    },
    scan: 'مسح',
    packagesNav: 'الطرود',
    pickups: 'الإيداعات',
    lifecycle: { all: 'كل المراحل' },
    filters: { title: 'تصفية', stageHint: 'اعرض الطرود حسب المرحلة.' },
    returns: 'المرتجعات',
    money: 'المال',
    profile: 'ملفي الشخصي',
    logout: 'تسجيل الخروج',
    online: 'متصل',
    offline: 'لا يوجد اتصال',
    wallet: {
      available: 'الرصيد المتاح',
      reservedCod: 'مبالغ للتحصيل',
      weeklyDelivered: 'تم تسليمها هذا الأسبوع',
      earnings: 'أرباحي',
      perParcel: 'لكل طرد',
      seeEarnings: 'عرض أرباحي',
      viewDetails: 'عرض التفاصيل',
    },
    actions: {
      scan: 'مسح',
      scanDesc: 'برمز QR',
      more: 'إجراءات أخرى ({count})',
      create: 'إنشاء',
      createDesc: 'طرد جديد',
      handovers: 'الوصولات',
      handoversDesc: 'الطرود المستلمة',
      returns: 'المرتجعات',
      returnsDesc: 'الطرود المرتجعة',
    },
    todayDeliveries: {
      title: 'للتسليم اليوم',
      empty: 'لا توجد طرود للتسليم اليوم.',
      cod: 'المبلغ المطلوب',
      phone: 'الهاتف',
      address: 'العنوان',
    },
    packages: {
      title: 'طرودي',
      searchPlaceholder: 'ابحث عن طرد…',
      filterAll: 'الكل',
      filterPending: 'في الانتظار',
      filterInProgress: 'قيد التوصيل',
      filterDelivered: 'تم تسليمها',
      empty: 'لا توجد طرود.',
      loadFailed: 'تعذر تحميل الطرود.',
      bulk: {
        title: 'اختيار عدة طرود',
        hint: 'حدد عدة طرود ثم نفّذ الإجراء مرة واحدة.',
        enter: 'اختيار الطرود',
        exit: 'تم',
        selectLoaded: 'اختيار الكل ({count})',
        selectedCount: 'تم اختيار {count} طرود',
        noEligible: 'لا يمكن تنفيذ هذا الإجراء على أي من هذه الطرود.',
        clear: 'إلغاء التحديد',
        remove: 'إزالة',
        reviewTitle: 'الطرود المختارة',
        reviewEmpty: 'لم تختر شيئا بعد.'
      },
    },
  },
  category: {
    badge: 'مرحبا بك في 3asass',
    title: 'ماذا تريد؟',
    description: 'اختر الخدمة التي تحتاجها.',
    enter: 'دخول',
    comingSoon: 'قريبا',
    footer: '3asass — توصيل بسيط وقريب منك.',
    cards: {
      logistics: {
        title: 'اللوجستيك',
        description: 'توصيل قريب منك: وكلاء وموزّعون وتتبع مباشر.'
      },
      services: {
        title: 'الخدمات',
        description: 'خدمات للعمارات وسكانها.'
      },
      marketplace: {
        title: 'السوق',
        description: 'مكان للبيع والشراء بين السكان والتجار.'
      }
    }
  },
  home: {
    hero: {
      badge: 'حل لوجستي مبتكر',
      titleBefore: 'قلّلوا',
      titleHighlight: 'فشل',
      titleAfter: ' عمليات التسليم.',
      description: 'نحوّل حراس العمارات إلى نقاط تسليم. يترك الموزّع الطرد عند حارس موثوق ويصل المستلم إشعار واتساب ويؤخذ الإثبات وتبقى المبالغ مضبوطة.'
    },
    tracking: {
      placeholder: 'رمز الطرد',
      aria: 'رمز الطرد',
      submit: 'تتبع طردي'
    },
    returnRequest: {
      title: 'طلب إرجاع',
      description: 'استلمت طردا وتريد إرجاعه؟ أرسل لنا طلبا.'
    },
    dashboard: {
      title: 'نبض الإدارة',
      live: 'مباشر',
      delivered24h: 'تم التسليم (24 ساعة)',
      deliveredTrend: '+12.5% مقارنة بالأمس',
      codSecured: 'COD مؤمن',
      reconcileToday: 'للمطابقة اليوم',
      packageRef: 'الطرد #3AS-2041',
      inTransit: 'في الطريق',
      receivedGuardian: 'استلمه الحارس',
      notified: 'تم الإشعار',
      exceptionAlert: 'تم اكتشاف استثناء واحد في منطقة أنفا.',
      view: 'عرض'
    },
    problem: {
      titleBefore: 'الميل الأخير',
      titleHighlight: 'معطّل',
      description: 'الموزعون لا يحتاجون إلى مزيد من المكالمات. يحتاجون إلى نقطة استلام موثوقة. 3asass يحول وجوداً متاحاً أصلاً إلى نقطة مراقبة قابلة للتتبع.',
      cards: {
        failures: {
          title: 'فشل متكرر في التسليم',
          desc: 'موزعون ينتظرون أمام أبواب مغلقة.'
        },
        transparency: {
          title: 'نقص في الشفافية',
          desc: 'طرود يتم تسجيلها كفاشلة دون سياق موثوق.'
        },
        cash: {
          title: 'تدبير الدفع عند التسليم (COD)',
          desc: 'النقد المحصل يصعب التحكم فيه ومطابقته.'
        },
        time: {
          title: 'وقت الموزع المهدور',
          desc: 'الإرجاعات والنزاعات متفرقة بين المكالمات وواتساب.'
        }
      }
    },
    lifecycle: {
      badge: 'دورة حياة 3asass',
      titleLine1: 'الطرد في مركز',
      titleLine2: 'العملية.',
      description: 'في كل مرحلة، يعرف 3asass من يحمل الطرد، وفي أي إقامة يوجد، وما الإثبات المتوفر، وما النقد المحصل، وما العمولة المستحقة.',
      cta: 'استكشاف الوثائق التقنية',
      items: {
        created: {
          state: 'تم الإنشاء',
          label: 'تم استيراده من التاجر'
        },
        dropped: {
          state: 'تم الإيداع',
          label: 'مسحه الموزع في نقطة الاستلام'
        },
        received: {
          state: 'تم الاستلام',
          label: 'أكده الحارس'
        },
        out: {
          state: 'قيد المعالجة',
          label: 'تم إشعار الساكن'
        },
        delivered: {
          state: 'تم التسليم',
          label: 'تم تأكيد إثبات التسليم والعمولة'
        }
      }
    },
    surfaces: {
      titleLine1: 'ثلاث واجهات،',
      titleLine2: 'مصدر حقيقة واحد.',
      description: 'كل طرف يحصل على أداة مناسبة لسير عمله، ومتزامنة في الوقت الحقيقي.',
      agent: {
        title: 'تطبيق الوكيل PWA',
        subtitle: 'للحارس',
        metric: '42 طرداً',
        items: {
          scan: 'مسح رمز QR',
          notify: 'إشعار الساكن',
          proof: 'التقاط التوقيع والصورة',
          wallet: 'طلب سحب المحفظة'
        }
      },
      courier: {
        title: 'تطبيق الموزع PWA',
        subtitle: 'للموزع',
        metric: '8 إيداعات',
        items: {
          route: 'عرض نقاط الاستلام للزيارة',
          scan: 'مسح الدفعة',
          photos: 'تصوير الطرود',
          close: 'إغلاق الجولة'
        }
      },
      admin: {
        title: 'بوابة الإدارة',
        subtitle: 'للعمليات',
        metric: '3 نزاعات',
        items: {
          track: 'تتبع كل الطرود',
          proofs: 'مراجعة الإثباتات',
          wallets: 'تسوية المحافظ',
          audit: 'تدقيق الاستثناءات'
        }
      }
    },
    proof: {
      titleLine1: 'الإثبات في قلب',
      titleLine2: 'الثقة.',
      description: 'إثبات التسليم ليس تفصيلاً: إنه يحمي المشغل والتاجر والساكن والحارس. حتى بدون شبكة، تبقى الإجراءات مسجلة محلياً وتتم مزامنتها لاحقاً.',
      guarantee: 'تتبع مضمون 100%',
      items: {
        signature: 'توقيع الساكن',
        photo: 'صورة الطرد',
        gps: 'موقع GPS',
        cod: 'مبلغ COD',
        offline: 'مزامنة دون اتصال',
        whatsapp: 'رسالة واتساب'
      }
    },
    portalCards: {
      title: 'اختر مساحتك',
      description: 'اختر صفتك للمتابعة.',
      agent: {
        title: 'الوكيل',
        description: 'استلم الطرود وسلّمها وتابع أموالك.',
        cta: 'تثبيت التطبيق'
      },
      courier: {
        title: 'الموزّع',
        description: 'سلّم الطرود وخذ المرتجعات وتابع جولاتك.',
        cta: 'تثبيت التطبيق'
      },
      admin: {
        title: 'الإدارة',
        description: 'تابع النشاط والوكلاء والمنصة.',
        cta: 'مساحة الإدارة'
      },
      partner: {
        title: 'الشريك',
        description: 'تابع طرودك وفواتيرك وحسابك.',
        cta: 'مساحة الشريك'
      },
      user: {
        title: 'الزبون',
        description: 'أرسل طردا وتابعه.',
        cta: 'مساحة الزبون'
      }
    }
  },
  download: {
    badge: 'تطبيق للهاتف',
    agentTitle: 'تثبيت تطبيق الوكيل',
    courierTitle: 'تثبيت تطبيق الموزّع',
    agentDescription: 'ثبّت 3asass على هاتفك ثم سجّل الدخول برقمك.',
    courierDescription: 'ثبّت 3asass على هاتفك لمسح الطرود وتأكيد التسليم ومتابعة الإرجاعات.',
    login: 'المتابعة إلى الدخول',
    loginTitle: 'تسجيل الدخول',
    loginDescription: 'ادخل إلى مساحتك برقم هاتفك.',
    installTitle: 'تثبيت',
    installDescription: 'ضع التطبيق على هاتفك.',
    installFallback: 'مع Chrome التثبيت مباشر. مع Firefox أو Safari استعمل قائمة المتصفح لإضافة التطبيق إلى الشاشة الرئيسية.',
    installHelp: {
      button: 'التثبيت من هذا المتصفح',
      title: 'تثبيت 3asass',
      description: 'إذا لم يبدأ التثبيت تلقائيا فاستعمل قائمة المتصفح.',
      steps: {
        chromiumMenu: 'افتح قائمة المتصفح (النقاط الثلاث في الأعلى أو الأسفل).',
        chromiumInstall: 'اضغط «تثبيت التطبيق» أو «إضافة إلى الشاشة الرئيسية».',
        firefoxMenu: 'افتح قائمة Firefox.',
        firefoxAdd: 'اضغط «تثبيت» أو «إضافة إلى الشاشة الرئيسية».',
        safariShare: 'على iPhone اضغط زر المشاركة في Safari.',
        safariAdd: 'اختر «إضافة إلى الشاشة الرئيسية» ثم أكد.'
      }
    },
    panelTitle: 'تثبيت سريع',
    panelDescription: 'يُثبَّت التطبيق من Chrome دون متجر تطبيقات.',
    menuDescription: 'وصول سريع إلى واجهات 3asass.',
    workflowMenuDescription: 'مشاهدة طريقة عمل دورة حياة الطرد.',
    agentMenuDescription: 'تثبيت وفتح مساحة الوكيل.',
    courierMenuDescription: 'تثبيت وفتح مساحة الموزّع.',
    partnerMenuDescription: 'تسجيل الدخول إلى بوابة المرسل.',
    contactMenuDescription: 'التواصل مع الفريق لإطلاق تجربة.',
    adminMenuDescription: 'وصول مخصص للعمليات فقط.',
    steps: {
      open: 'افتح هذه الصفحة في Chrome على هاتفك.',
      install: 'اضغط «تثبيت التطبيق» أو «إضافة إلى الشاشة الرئيسية».',
      login: 'افتح أيقونة 3asass وسجّل الدخول برقمك.'
    },
    cards: {
      installTitle: 'أيقونة على هاتفك',
      installText: 'يفتح 3asass مثل تطبيق حقيقي.',
      offlineTitle: 'بدون اتصال',
      offlineText: 'عند انقطاع الشبكة تُحفظ إجراءاتك وتُرسل عند عودة الاتصال.',
      secureTitle: 'دخول آمن',
      secureText: 'تدخل برمز يصل إلى هاتفك وبياناتك محمية.'
    }
  },
  dashboard: {
    loadAgentWalletFailed: 'تعذر تحميل محفظتك.',
    agentLabel: 'الوكيل',
    agentTitle: 'طرود للمعالجة',
    agentDescription: 'الاستلام والتسليم والمشاكل والأموال من نقطتك.',
    courierLabel: 'الموزّع',
    courierTitle: 'جولتي اليوم',
    courierDescription: 'امسح الطرود عند الوكيل والتقط صورة ثم أنهِ التسليم.',
    startDrop: 'بدء تسليم',
    packageSearchPlaceholder: 'الرمز أو المستلم أو الهاتف أو العنوان…',
    loadingPackages: 'جارٍ التحميل…',
    noPackagesWithFilters: 'لا توجد طرود تطابق هذه الفلاتر.',
    loadAgentPackagesFailed: 'تعذر تحميل طرودك.',
    actionSynced: 'تم إرسال الإجراء.',
    actionRejected: 'لم يتم قبول الإجراء.',
    actionQueued: 'تم حفظ الإجراء في الهاتف وسيُرسل عند عودة الاتصال.',
    backendActionPending: 'هذا الإجراء غير متاح بعد.',
    returnRequestedByResident: 'يجب طلب الإرجاع أولا من صفحة التتبع أو من الفريق. بعدها يمكنك تسليمه.',
    enRouteStarted: 'أنت في الطريق إلى النقطة.',
    bulkStartDelivery: 'بدء التوصيل ({count})',
    bulkMarkEnRoute: 'في الطريق ({count})',
    loadingRoute: 'جارٍ التحميل…',
    loadRouteFailed: 'تعذر تحميل الجولة.',
    loadTodayDeliveriesFailed: 'تعذر تحميل توصيلات اليوم.'
  },
  auditViewer: {
    outcomes: {
      success: 'ناجح',
      warning: 'يحتاج مراجعة',
      error: 'فشل'
    },
    label: 'السجل',
    title: 'تقويم الإجراءات',
    description: 'اطلع على الإجراءات المهمة يوما بيوم. صفّ حسب الدور أو الإجراء أو الموضوع أو السبب ثم افتح التفاصيل.',
    loadFailed: 'تعذر تحميل السجل.',
    clearDates: 'مسح التواريخ',
    clearFilters: 'مسح الفلاتر',
    applyFilters: 'تطبيق',
    roles: {
      system: 'النظام'
    },
    views: {
      calendar: 'التقويم',
      table: 'الجدول'
    },
    columns: {
      time: 'الوقت',
      actor: 'الفاعل',
      role: 'الدور',
      action: 'الإجراء',
      subject: 'الموضوع',
      reason: 'السبب',
      status: 'الحالة'
    },
    filters: {
      role: 'الدور',
      allRoles: 'كل الأدوار',
      action: 'الإجراء',
      actionPlaceholder: 'تغيير مرحلة، دخول، تعديل…',
      subject: 'الموضوع',
      subjectPlaceholder: 'طرد، وكيل، محفظة…',
      reason: 'رمز السبب',
      reasonPlaceholder: 'LOST, ADMIN_OVERRIDE...',
      period: 'الفترة',
      from: 'من',
      to: 'إلى'
    },
    stats: {
      visibleEvents: 'الأحداث الظاهرة',
      issues: 'تحتاج انتباهاً',
      actors: 'الفاعلون'
    },
    legend: {
      label: 'الألوان',
      package: 'طرد',
      exception: 'مشكل',
      wallet: 'المحفظة',
      agent: 'مستخدم',
      auth: 'دخول',
      system: 'النظام'
    },
    calendar: {
      label: 'تقويم التدقيق',
      title: 'الإجراءات حسب التاريخ',
      range: 'الفترة',
      loading: 'جاري التحميل',
      synced: 'متزامن',
      today: 'اليوم',
      month: 'شهر',
      week: 'أسبوع',
      list: 'قائمة'
    },
    focus: {
      label: 'الحدث المحدد',
      empty: 'المس حدثا في التقويم أو صفا في الجدول لرؤية التفاصيل.'
    },
    quickSearch: {
      label: 'بحث سريع',
      placeholder: 'فاعل، إجراء، موضوع، سبب...',
      help: 'ينطبق البحث على التقويم والجدول.'
    },
    table: {
      searchPlaceholder: 'ابحثوا عن فاعل، إجراء، موضوع، سبب...',
      emptyTitle: 'لا شيء في السجل',
      emptyDescription: 'ستظهر الإجراءات المهمة هنا.'
    }
  },
  handovers: {
    deliveryMissing: 'ليس لهذا الطرد توصيل.',
    searchPlaceholder: 'المرجع أو الطرد أو الموزّع أو الوكيل…',
    agentLabel: 'الوصولات',
    agentTitle: 'الوصولات',
    agentDescription: 'افتح الوصول لاختيار الطرود التي ستقبلها وإضافة الصور وإدخال رمز الموزّع.',
    courierLabel: 'إيداعاتي',
    courierTitle: 'سجل الإيداعات',
    courierDescription: 'تجد هنا كل إيداع عند وكيل، والطرود التي سلمتها، والرمز عند الحاجة.',
    handover: 'وصول',
    courierFallback: 'الموزّع',
    total: 'المجموع',
    received: 'المستلمة',
    alreadyReceived: 'استُلمت من قبل',
    pendingToReceive: 'للاستلام',
    waiting: 'في الانتظار',
    codTotal: 'المبلغ المطلوب تحصيله',
    cod: 'يُدفع عند التسليم',
    pending: 'للاستلام',
    partial: 'جزئيا',
    dropped: 'تم تسليمه',
    loading: 'جارٍ التحميل…',
    loadingDetail: 'جارٍ التحميل…',
    noResults: 'لا شيء يطابق بحثك.',
    emptyAgent: 'لا شيء للاستلام الآن. عندما يسلّمك موزّع طرودا ستظهر هنا.',
    emptyCourier: 'لم تقم بأي إيداع بعد.',
    loadFailed: 'تعذر تحميل القائمة.',
    courierLoadFailed: 'تعذر تحميل إيداعاتك.',
    newDrop: 'إيداع جديد',
    newCode: 'رمز جديد',
    codeRefreshed: 'الرمز الجديد جاهز.',
    codeRefreshFailed: 'تعذر إنشاء رمز جديد.',
    detailTitle: 'تفاصيل الوصول',
    backToHandovers: 'الوصولات',
    keepCodeVisible: 'أبق هذا الرمز ظاهرا حتى يستلم الوكيل كل الطرود.',
    confirmationTitle: 'تأكيد الوصول',
    confirmationDescription: 'استلم الطرود التي اخترتها.',
    dropProgress: 'جارٍ الإرسال. أبق هذه الصفحة مفتوحة.',
    selectedSummary: '{packages} طرد · {photos} صورة',
    packageCounts: '{packages} طرد · {received} مستلم · {pending} في الانتظار',
    expiresAt: 'صالح حتى {time}',
    batchPackages: 'طرود هذا الإيداع',
    parcelReturningHint: 'هذا الطرد في طريق العودة. سيظهر لك بعد أن يودعه الوكيل.',
    batchAgent: 'وكيل هذا الإيداع',
    batchAgentHelp: 'يجب أن يكون لكل الطرود الممسوحة هنا هذا الوكيل.',
    packagesToAccept: 'الطرود التي ستقبلها',
    packagesToAcceptDescription: 'احذف فقط الطرود التي لن تستلمها الآن. ستبقى لوقت لاحق.',
    noneSelected: 'لم تختر أي طرد. أعد طردا واحدا على الأقل.',
    nonCod: 'لا مبلغ للتحصيل',
    removeFromReception: 'عدم استلام هذا الطرد',
    removedCount: 'تم حذف {count} طرد',
    removeFromBatch: 'حذف',
    removedFromBatch: 'تم حذف الطرد.',
    restore: 'إعادة',
    alreadyReceivedCount: 'تم استلام {count} طرد من هذا الوصول من قبل.',
    receptionPhotos: 'صور الطرود المستلمة',
    receptionPhotosHelp: 'إلزامي. التقط صورة واحدة على الأقل للطرود المستلمة.',
    physicalCode: 'رمز الموزّع',
    physicalCodeHelp: 'قارن هذا الرمز بشاشة الموزّع قبل الاستلام.',
    senderCode: 'رمز المرسل',
    senderCodeHelp: 'يعطي المرسل هذا الرمز للوكيل عند تسليم الطرد.',
    resendSenderCode: 'إعادة إرسال الرمز',
    resendOnlyWhileWaiting: 'ممكن فقط أثناء انتظار الطرد للمرسل.',
    senderCodeResending: 'جارٍ الإرسال…',
    senderCodeResent: 'تم إرسال الرمز إلى المرسل مرة أخرى.',
    senderCodeResendFailed: 'تعذر إعادة إرسال الرمز.',
    confirmPackages: 'تأكيد {count} طرد',
    notFound: 'الوصول غير موجود.',
    photoRequired: 'أضف صورة واحدة على الأقل.',
    noDeliverySelected: 'لم تختر أي طرد للاستلام.',
    receiveRejected: 'لم يتم قبول الاستلام. حاول مرة أخرى.',
    receiveSuccess: 'تم استلام {count} طرد.',
    invalidCourierDrop: 'لا يمكن تسليم هذا الطرد من هذه الشاشة.',
    duplicatePackage: 'هذا الطرد موجود في القائمة.',
    agentRequired: 'ليس لهذا الطرد وكيل بعد. اطلب من فريق 3asass اختيار وكيل ثم امسحه من جديد.',
    agentMismatch: 'هذا الطرد لـ {packageAgent}. وهذا الإيداع لـ {batchAgent}.',
    readyToDrop: 'جاهز للتسليم.',
    addedToBatch: 'تمت إضافة الطرد.',
    dropPhotoRequired: 'أضف صورة واحدة على الأقل للطرود.',
    scanAtLeastOne: 'امسح طردا واحدا على الأقل.',
    singleAgentRequired: 'يمكن أن يضم الإيداع الواحد طرودا لوكيل واحد فقط.',
    deliveryMissingInBatch: 'أحد الطرود ليس له توصيل.',
    codeMessage: '{reference} · الرمز: {code}',
    dropRejected: 'لم يتم قبول الإيداع. حاول مرة أخرى.',
    failedCount: 'تم رفض {count} طرد. صحح ثم حاول مرة أخرى.',
    droppedCount: 'تم تسليم {count} طرد.',
    dropPhotos: 'صور الطرود المسلّمة',
    dropPhotosHelp: 'التقط صورة واحدة على الأقل للطرود.',
    showCodeToAgent: 'أظهر هذا الرمز للوكيل. عليه إدخاله في شاشته لتأكيد الاستلام.',
    doneHint: 'استلم الوكيل هذه الطرود. لا شيء متبقٍ للقيام به.',
    removedFromReception: 'تم حذف الطرد.',
    readyToReceiveOne: 'الطرد جاهز للاستلام.',
    scanOneFirst: 'امسح أولا طردا تم تسليمه.',
    singleReceiveLabel: 'استلام طرد',
    singleReceiveTitle: 'مسح طرد',
    singleReceiveDescription: 'استلم طردا واحدا بالرمز الذي أعطاك إياه الموزّع.',
    selectedPackage: 'الطرد المختار',
    linkedHandover: 'الوصول المرتبط: {reference}',
    askCourierCode: 'اطلب من الموزّع الرمز الظاهر على شاشته.',
    confirmOnePackage: 'تأكيد هذا الطرد',
    scanOneEmpty: 'امسح رمز QR لطرد تم تسليمه، أو اكتب رمزه.',
    confirmDrop: 'تأكيد الإيداع',
    stepScan: 'مسح',
    stepPackages: 'الطرود',
    stepPhoto: 'الصورة',
    stepCode: 'الرمز',
    stepSignature: 'التوقيع',
    stepConfirm: 'تأكيد',
    nextStep: 'التالي: {step}',
    sessionMismatch: 'هذا الطرد في وصول آخر. امسح طرود وصول واحد في كل مرة.',
    scanMoreHelp: 'امسح طردا آخر أو انتقل للخطوة التالية.',
    scannedCount: 'تم مسح {count} طرد',
    dropComplete: 'تم الإيداع',
    dropQueued: 'تم حفظ الإيداع في الهاتف وسيُرسل عند عودة الاتصال.',
    startNewDrop: 'إيداع جديد'
  },
  pod: {
    validationTitle: 'تأكيد التسليم',
    validationDescription: 'جارٍ إرسال الإثبات والمبلغ المحصّل وعمولتك…',
    label: 'التسليم للمستلم',
    captureProof: 'التقاط الإثبات',
    description: 'التوقيع والصورة وموقعك والمبلغ المحصّل مطلوبة قبل الإرسال.',
    loadingPackage: 'جارٍ تحميل الطرد…',
    deliveryMissing: 'التوصيل غير موجود.',
    signatureRequired: 'التوقيع مطلوب.',
    photoRequired: 'الصورة مطلوبة.',
    geolocationRequired: 'فعّل الموقع ثم اضغط «تحديد موقعي».',
    cashRequired: 'أدخل المبلغ الذي حصّلته.',
    cashInvalid: 'المبلغ غير صالح.',
    cashExpected: 'يجب أن يكون المبلغ {amount}.',
    queued: 'تم حفظ الإثبات في الهاتف وسيُرسل عند عودة الاتصال.',
    synced: 'تم إرسال الإثبات.',
    rejected: 'تم رفض الإثبات. تحقق من الحقول ثم حاول مرة أخرى.',
    dropPhoto: 'صورة التسليم',
    dropPhotoHelp: 'تُصغَّر الصورة في الهاتف ثم تُرسل.',
    cod: 'المبلغ المطلوب',
    cashCollection: 'المبلغ المحصّل',
    expectedAmount: 'المبلغ المطلوب: {amount}',
    noCod: 'لا مبلغ للتحصيل لهذا الطرد.',
    cashPlaceholder: 'المبلغ المحصّل',
    noCashPlaceholder: 'لا مبلغ للتحصيل',
    cashMismatch: 'يجب أن يطابق المبلغ المطلوب بالضبط.',
    validateDelivery: 'تأكيد التسليم',
    stepProof: 'الإثبات',
    stepSignature: 'التوقيع'
  },
  bulkPod: {
    podAction: 'الإثباتات ({count})',
    title: 'تسليم عدة طرود',
    label: 'إثبات واحد',
    description: 'صورة وتوقيع واحد وموقعك لكل الطرود المختارة.',
    selectedSummary: 'تم اختيار {count} طرد',
    proofOnce: 'سيُستعمل نفس الإثبات لكل طرد.',
    remove: 'حذف',
    removed: 'تم حذف الطرد.',
    submit: 'تأكيد ({count})',
    confirmTitle: 'جارٍ الإرسال',
    confirmDescription: 'سيُسجَّل كل طرد كمُسلَّم مع إثباته.',
    resultTitle: 'تم حفظ الإثباتات',
    resultSummary: 'تم تسليم {count} طرد',
    queued: 'لا يوجد اتصال: ستُرسل الإثباتات في أقرب وقت.',
    backToPackages: 'العودة إلى الطرود',
    reasonNotAvailable: 'هذا الطرد ليس في قائمتك.',
    missingTargets: 'لم تختر أي طرد.'
  },
  adminDashboard: {
    label: 'لوحة التحكم',
    title: 'النشاط المباشر',
    description: 'اكتشف ما يتعطل وتابع الوكلاء النشطين وافتح الطرود المستعجلة وانتقل إلى التسويات أو السجل.',
    backendUnavailable: 'الخدمة غير متاحة',
    loadFailed: 'تعذر تحميل لوحة التحكم.',
    loadQueueFailed: 'تعذر تحميل قائمة الطرود.',
    notAvailable: '—',
    refreshHint: 'يتحدث كل 30 ثانية',
    importCsv: 'استيراد ملف CSV',
    createPackage: 'إنشاء طرد',
    loadingQueue: 'جارٍ التحميل…',
    emptyQueue: 'لا توجد طرود لهذا الفلتر.',
    kpis: {
      handoverTime: 'زمن التسليم',
      handoverHelp: 'قريبا: من التسليم إلى الاستلام.',
      firstAttempt: 'نجاح من أول محاولة',
      firstAttemptHelp: 'المسلّمة اليوم مقارنة بالمشاكل المفتوحة.',
      podCompletion: 'الإثباتات المكتملة',
      podHelp: '{count} إثباتات مستلمة',
      activeAgents: 'الوكلاء النشطون',
      activeAgentsHelp: 'حسابات الوكلاء النشطة الآن.',
      exceptionRate: 'نسبة المشاكل',
      exceptionHelp: '{count} طرود للمعالجة'
    },
    search: {
      label: 'البحث عن طرد',
      title: 'ابحث وافتح بسرعة',
      placeholder: 'المرجع أو المستلم أو الهاتف أو الوكيل أو النقطة…',
      submit: 'بحث'
    },
    filters: {
      active: 'الجارية',
      dropped: 'المسلّمة في النقطة',
      received: 'المستلمة',
      out: 'في التوصيل',
      returns: 'المرتجعات',
      exceptions: 'المشاكل'
    },
    decisions: {
      title: 'بانتظار قرارك',
      cancellations: 'طلبات الإلغاء',
      cancellationsHint: 'زبون يريد إرجاع طرده',
      reports: 'المشاكل المبلَّغ عنها',
      reportsHint: 'بلاغات الزبائن بعد التسليم، وإرجاعات بلا حساب',
      incidents: 'إرجاعات متعثرة',
      incidentsHint: 'واجه إرجاع في طريقه مشكلة',
      none: 'لا شيء ينتظر قرارك.',
      returnsInProgress: 'إرجاع واحد في الطريق | {count} إرجاعات في الطريق'
    },
    exceptions: {
      label: 'مستعجل',
      title: 'مشاكل للمعالجة',
      empty: 'لا توجد مشاكل مفتوحة.',
      open: 'عرض كل المشاكل'
    },
    cod: {
      label: 'مبالغ للتحصيل',
      description: 'المجموع المطلوب تحصيله للطرود المعروضة.'
    },
    agents: {
      label: 'خريطة الوكلاء',
      title: 'المناطق المغطاة',
      cityLine: '{agents} وكيل · {deliveries} توصيل جارٍ',
      activeDeliveries: '{count} جارٍ'
    },
    settlement: {
      label: 'التسوية',
      title: 'تجهيز التسوية',
      description: 'اطلع على المعاينة وتحقق من المبالغ وابدأ التسوية إن كان الفرق مقبولا.',
      open: 'فتح التسويات'
    },
    audit: {
      label: 'السجل',
      title: 'من فعل ماذا',
      description: 'اطلع على إجراءات الفريق وتغييرات المراحل والأسباب والأحداث الحساسة.',
      open: 'فتح السجل'
    },
    snapshot: {
      active: 'الجارية',
      delivered: 'المسلّمة اليوم',
      proofs: 'الإثباتات'
    }
  },
  platformConfig: {
    courierWaitInput: 'أقصى مدة انتظار الموزع (بالدقائق)',
    courierWaitHelp: 'بعدها يظهر الطرد الجاهز عند الحارس في الاستثناءات. بين 15 و1440 دقيقة (120 = ساعتان).',
    requestAcceptInput: 'المدة المتاحة للحارس للرد (بالدقائق)',
    requestAcceptHelp: 'بعدها يُرفض الطلب نيابة عنه ويختار الزبون نقطة أخرى. بين 5 و1440 دقيقة (30 = 30 دقيقة، 720 = 12 ساعة).',
    label: 'مالية الإدارة',
    title: 'الإعدادات المالية',
    description: 'حدد رسوم الشريك وعمولة الوكيل عن كل تسليم وأجر الموزّع بعد الاستلام في النقطة ورسوم الزبون المسجلة عند الإيداع.',
    loadFailed: 'تعذر تحميل الإعدادات.',
    saveFailed: 'تعذر حفظ الإعدادات.',
    saved: 'تم حفظ الإعدادات المالية.',
    actionImpossible: 'غير ممكن',
    partnerFee: 'رسوم الشريك',
    partnerFeeDescription: 'مبلغ يُخصم من رصيد الشريك عن كل طرد مسلّم ومسوّى.',
    agentCommission: 'عمولة الوكيل',
    agentCommissionDescription: 'مبلغ يُضاف عن كل تسليم يُنجزه الوكيل، عند إيداع الزبون أو التسليم النهائي.',
    platformRevenue: 'إيراد المنصة',
    platformRevenueDescription: 'تقدير لطرد شريك: الرسوم ناقص عمولتي الوكيل وعمولة الموزّع.',
    settlementSettings: 'إعدادات التسوية',
    nextSettlements: 'المبالغ المطبقة على التسويات القادمة',
    lastRead: 'آخر قراءة {time}',
    partnerFeeInput: 'رسوم الشريك لكل توصيل (درهم)',
    partnerFeeHelp: 'مثال: 15 MAD ستخزن كـ 1500 سنتيم.',
    agentCommissionInput: 'عمولة الوكيل لكل تسليم (MAD)',
    agentCommissionHelp: 'مثال: 10 MAD ستضاف للوكيل بعد التسوية.',
    courierCommissionInput: 'أجرة الموزع لكل طرد مستلم (MAD)',
    courierCommissionHelp: 'تُدفع مرة واحدة بعد تأكيد وكيل الوجهة استلام الطرد. يُحفظ السعر عند الإنشاء ولا تُدفع أجرة الرجوع.',
    negativeTitle: 'إعدادات غير مربحة',
    negativeDescription: 'عمولتا الوكيل والموزّع أكبر من رسوم الشريك. ستخسر المنصة {amount} عن كل طرد.',
    exampleTitle: 'مثال بهذه القيم',
    exampleDescription: 'طرد شريك: الرسوم {partnerFee}، عمولتا وكيل بقيمة {agentCommission}، عمولة الموزّع {courierCommission}، الربح المقدر {platformRevenue}.',
    existingSettlementsNote: 'الطرود التي تمت تسويتها سابقاً لا يعاد حسابها. هذه المبالغ تطبق على التسويات القادمة.'
  },
  adminExceptions: {
    courierLateTitle: 'طرود في انتظار موزع ({count})',
    courierLateHint: 'جاهزة عند الحارس منذ أكثر من {wait}. أرسل موزعاً أو اتصل بالحارس.',
    courierLateWaiting: 'في الانتظار منذ {time}',
    label: 'قائمة الاستثناءات',
    title: 'الحوادث للمعالجة',
    description: 'حالات الفشل والنزاعات التي أبلغ عنها الوكلاء أو الموزّعون أو الفريق.',
    exception: 'استثناء',
    exceptionCode: 'رمز الاستثناء',
    open: 'مفتوحة',
    failedPage: 'فاشلة في الصفحة',
    disputesPage: 'نزاعات في الصفحة',
    searchPlaceholder: 'رمز، مستلم، هاتف، عنوان، وكيل...',
    emptyTitle: 'لا توجد استثناءات',
    emptyDescription: 'ستظهر الطرود الفاشلة أو المتنازع عليها هنا.',
    loadFailed: 'تعذر تحميل قائمة الاستثناءات.',
    resolved: 'تمت معالجة الاستثناء.',
    resolutionRejected: 'لم يتم قبول القرار.',
    resolutionDescription: 'أضيفوا ملاحظة تشغيلية. سيتم تسجيلها في سجل التدقيق.',
    resolutionPlaceholder: 'قرار إداري، اتصال بالعميل، تبرير...',
    resolutionHelp: '3 أحرف على الأقل. التعديلات دون ملاحظة مرفوضة.'
  },
  settlements: {
    title: 'التسويات',
    description: 'راجع الطرود المنتهية التي لم تُسوَّ بعد، واخصم رسوم الطرود المسلّمة، وأضف عمولات الوكلاء ثم أغلق التسوية.',
    loadFailed: 'تعذر تحميل التسويات.',
    loadDetailFailed: 'تعذر تحميل هذه التسوية.',
    runFailed: 'تعذر بدء التسوية.',
    runStarted: 'بدأت التسوية.',
    reviewWarning: 'بعض الطرود تحتاج إلى مراجعة.',
    running: 'جارٍ التسوية…',
    run: 'بدء التسوية',
    backToSettlements: 'العودة إلى التسويات',
    detailTitle: 'تفاصيل التسوية',
    toSettle: 'للتسوية',
    toSettleDescription: 'طرود منتهية لم تُسوَّ بعد.',
    partnerDebitDescription: 'رسوم ستُخصم من رصيد الشركاء.',
    agentCommissionDescription: 'مبلغ يُضاف إلى ما يستطيع الوكيل سحبه.',
    operationalRule: 'كيف يعمل',
    ruleTitle: 'التسوية تغلق الطرود المنتهية',
    ruleDescription: 'الطرد المسلّم يخصم من الشريك ويدفع للوكيل ويربح للمنصة. أما الفاشل أو الملغى أو المرتجع فيُغلق دون رسوم.',
    permanentAudit: 'يُحفظ في السجل',
    history: 'السجل',
    runsTitle: 'التسويات المنجزة',
    runColumn: 'التسوية',
    deliveries: 'التوصيلات',
    partnerFees: 'رسوم الشركاء',
    agentCommissions: 'عمولات الوكلاء',
    completedAt: 'انتهت في',
    failedCount: '{count} فاشلة',
    emptyRuns: 'لا توجد تسويات بعد.',
    runCount: '{count} تسوية',
    settledDeliveries: 'التوصيلات المسوّاة',
    partnerDebit: 'خصم من رصيد الشركاء',
    partnerCreditConsumed: 'استُعمل رصيد الشركاء.',
    agentBalanceCredited: 'أُضيف المبلغ إلى ما يستطيع الوكلاء سحبه.',
    completedOn: 'انتهت في {date}',
    toReview: 'للمراجعة',
    unsettledLines: 'سطور لم تُسوَّ تلقائيا',
    unknownDelivery: 'توصيل غير معروف',
    partnerNotProvided: 'الشريك غير مذكور',
    errorNotProvided: 'الخطأ غير مذكور',
    requiredFee: 'الرسوم المطلوبة',
    currentCredit: 'الرصيد الحالي',
    estimatedAvailable: 'المتاح (تقديريا)',
    fixAndRerun: 'أصلح المشكل ثم ابدأ التسوية من جديد.',
    includedDeliveries: 'التوصيلات المشمولة',
    deliveredAt: 'سلم في',
    noPartner: 'لا يوجد شريك',
    noAttachedPackages: 'لا توجد طرود في هذه التسوية.',
    creditDebits: 'خصومات من الرصيد',
    creditedCommissions: 'العمولات المضافة',
    recordedRevenue: 'الأرباح المسجلة',
    noPartnerDebit: 'لا خصم من الشركاء.',
    noAgentCommission: 'لا توجد عمولة للوكلاء.',
    noPlatformRevenue: 'لا أرباح للمنصة.',
    status: {
      completed: 'منتهية',
      running: 'جارية',
      pendingReview: 'للمراجعة',
      failed: 'فاشلة'
    }
  },
  adminCourierDetail: {
    sheet: 'ملف الموزّع',
    backendUnavailable: 'الخدمة غير متاحة',
    actionDenied: 'تم رفض الإجراء',
    loadFailed: 'تعذر تحميل الموزّع.',
    suspendFailed: 'تعذر تعليق الحساب.',
    reactivateFailed: 'تعذر إعادة التفعيل.',
    dropsToday: 'إيداعات اليوم',
    dropsTodayHelp: 'الإيداعات المسجلة خلال اليوم.',
    lastActivity: 'آخر نشاط',
    account: 'الحساب',
    noActivity: 'لا يوجد نشاط',
    dateUnavailable: 'التاريخ غير متوفر',
    dropHistory: 'سجل الإيداعات',
    dropHistoryHelp: 'ستظهر هنا آخر تسليمات اليوم.',
    noDetailedDrops: 'لا توجد تسليمات مفصلة لهذا الموزّع.',
    suspension: 'تعليق',
    suspensionHelp: 'يمنع الموزّع من الدخول فورا.',
    reasonPlaceholder: 'سبب إلزامي، 10 أحرف على الأقل',
    suspend: 'إيقاف الموزّع مؤقتا',
    suspensionRule: 'التعليق يتطلب سبباً من 10 أحرف على الأقل.',
    reactivation: 'إعادة التفعيل',
    reactivationHelp: 'ممكن فقط إذا كان الموزّع موقوفا.',
    reactivate: 'إعادة تفعيل الموزّع'
  },
  adminLists: {
    relayAgents: 'وكلاء النقاط',
    agentManagement: 'إدارة الوكلاء',
    agentDescription: 'متابعة تشغيلية للحراس، KYC، الحمل النشط وأرصدة المحافظ.',
    createAgent: 'إنشاء وكيل',
    active: 'نشطون',
    pending: 'في الانتظار',
    suspended: 'معلقون',
    withdrawable: 'قابل للسحب',
    status: 'الحالة',
    load: 'الحمل',
    relay: 'النقطة',
    loadAgentsFailed: 'تعذر تحميل الوكلاء.',
    agentSearch: 'الاسم أو الهاتف أو النقطة…',
    noAgents: 'لا يوجد وكلاء',
    agentsEmpty: 'سيظهر هنا الوكلاء الذين تنشئهم.',
    copyAgentId: 'نسخ معرف الوكيل',
    copyResidenceId: 'نسخ معرف الإقامة',
    validated: 'مصادق عليه',
    toValidate: 'للمصادقة',
    activeCount: '{count} نشط',
    couriersTitle: 'الموزّعون',
    couriersDescription: 'متابعة حسابات الموزّعين والإيقافات والتسليمات.',
    dropsToday: 'إيداعات اليوم',
    lastActivity: 'آخر نشاط',
    dropsDay: 'إيداعات اليوم',
    accounts: 'الحسابات',
    courierSearch: 'الاسم أو الهاتف...',
    noCouriers: 'لا يوجد موزعون',
    couriersEmpty: 'سيظهر الموزعون المنشؤون عبر OTP هنا.',
    loadCouriersFailed: 'تعذر تحميل الموزعين.',
    noActivity: 'لا يوجد نشاط',
    statuses: {
      pending: 'في الانتظار',
      active: 'نشط',
      suspended: 'معلق',
      disabled: 'معطل'
    }
  },
  adminAgentDetail: {
    sheet: 'ملف الوكيل',
    backendUnavailable: 'الخدمة غير متاحة',
    actionDenied: 'تم رفض الإجراء',
    loadFailed: 'تعذر تحميل الوكيل.',
    actionFailed: 'لم ينجح الأمر.',
    mediaLoadFailed: 'تعذر تحميل وثائق الهوية.',
    copyAgentId: 'نسخ معرّف الوكيل',
    copyResidenceId: 'نسخ معرّف النقطة',
    activation: 'التفعيل',
    ready: 'جاهز',
    pending: 'في الانتظار',
    status: 'الحالة: {status}',
    wallet: 'المحفظة',
    guaranteeAvailable: 'الضمان المتاح',
    reserved: 'محجوز',
    withdrawableAmount: 'قابل للسحب',
    relay: 'النقطة',
    performance: 'الأداء',
    deliveriesLabel: 'التسليمات',
    successRateLabel: 'نسبة النجاح',
    deliveries: 'التسليمات: {count}',
    success: 'النجاح: {rate}%',
    exceptions: 'المشاكل: {rate}%',
    checklist: 'قائمة المراجعة',
    preactivation: 'قبل التفعيل',
    missing: 'ناقص',
    activate: 'تفعيل',
    kyc: 'الهوية',
    agentDocuments: 'وثائق الوكيل',
    identityDocument: 'وثيقة الهوية',
    identityDocumentHelp: 'وثيقة وطنية أو ما يعادلها.',
    residenceProof: 'إثبات السكن',
    residenceProofHelp: 'فاتورة أو شهادة أو إثبات ميداني.',
    facePhoto: 'صورة الوجه',
    facePhotoHelp: 'صورة واضحة للوكيل.',
    validateKyc: 'تأكيد الهوية',
    agentInfo: 'معلومات الوكيل',
    profileDetails: 'تفاصيل الملف',
    agentInfoHelp: 'عدّل الملف دون إعادة إنشاء الحساب.',
    saveInfo: 'حفظ',
    escrow: 'الضمان',
    cashManagement: 'المبلغ المسلّم',
    escrowHelp: 'سجل المبلغ الذي سلمه الوكيل للمسؤول الميداني.',
    amountMad: 'المبلغ (درهم)',
    escrowNote: 'ملاحظة مطلوبة، مثل: ضمان البداية مستلم نقدا',
    record: 'تسجيل',
    escrowRule: 'مبلغ أكبر من 0 درهم وملاحظة من 10 أحرف على الأقل',
    escrowHistory: 'سجل الضمانات',
    escrowHistoryHelp: 'شحنات الضمان المسجلة في المحفظة.',
    noEscrow: 'لا يوجد ضمان مسجل لهذا الوكيل.',
    statusActions: 'تغيير الحالة',
    statusActionsHelp: 'إيقاف مؤقت أو توقف نهائي.',
    reactivate: 'إعادة التفعيل',
    suspensionReason: 'سبب الإيقاف',
    requiredReason: 'السبب مطلوب',
    suspend: 'إيقاف مؤقت',
    confirmationName: 'الاسم الكامل للتعطيل',
    disable: 'تعطيل',
    suspensionRule: 'الإيقاف المؤقت: سبب من 10 أحرف على الأقل. التعطيل: نفس السبب والاسم الكامل بالضبط.',
    reassignResidence: 'تغيير النقطة',
    reassign: 'تغيير',
    returnsCap: 'حد الإرجاعات',
    adjust: 'تعديل',
    unavailableDate: 'التاريخ غير معروف',
    profileCompleted: 'الملف مكتمل',
    identityDoc: 'بطاقة الهوية',
    residenceProofShort: 'إثبات السكن',
    facePhotoShort: 'صورة الوجه',
    kycValidated: 'الهوية مؤكدة',
    escrowRecorded: 'الضمان مسجل'
  },
  packages: {
    close: 'إغلاق',
    csvDescription: 'ينشئ طرودًا بالجملة. الأسطر الصحيحة تنشئ أيضًا توصيلها في حالة مُنشأ.',
    expectedColumnsDescription: 'residence_id, cod_amount_mad, recipient_name, recipient_phone, recipient_address. الحقول operator_tracking_ref و internal_ref و partner_id و agent_id اختيارية.',
    importing: 'جاري الاستيراد...',
    template: 'نموذج',
    codMadHelp: 'اكتب المبلغ بالدرهم، مثلا 125 يعني 125 درهما. يتحول تلقائيا.',
    title: 'كل الطرود',
    description: 'ابحث وصفّ وتابع الطرود.',
    importCsv: 'استيراد CSV',
    create: 'إنشاء طرد',
    currentPage: 'الصفحة الحالية',
    created: 'منشأة',
    active: 'نشطة',
    issues: 'مشاكل',
    searchPlaceholder: 'المرجع أو المستلم أو الهاتف…',
    emptyTitle: 'لا توجد طرود',
    emptyDescription: 'ستظهر هنا الطرود المنشأة.',
    packages: 'الطرود',
    package: 'الطرد',
    open: 'فتح',
    recipient: 'المستلم',
    unknownRecipient: 'مستلم غير معروف',
    relay: 'النقطة',
    assignedAgent: 'الوكيل المعين',
    state: 'الحالة',
    type: 'النوع',
    createdFrom: 'من تاريخ الإنشاء',
    createdTo: 'إلى تاريخ الإنشاء',
    residence: 'النقطة',
    unassigned: 'غير معين',
    csvTitle: 'استيراد ملف CSV',
    expectedColumns: 'الأعمدة المطلوبة',
    csvFile: 'ملف CSV',
    skipped: 'تم تجاهلها',
    errors: 'أخطاء',
    line: 'السطر',
    status: 'الحالة',
    reference: 'المرجع',
    detail: 'التفاصيل',
    agentLabel: 'الوكيل:',
    createdAt: 'تاريخ الإنشاء',
    codPage: 'المبلغ المستحق'
  },
  parcelMap: {
    subtitle: 'طرودك وعمليات الجمع على خريطة واحدة.',
    agentSubtitle: 'طرودك على خريطة واحدة.',
    listLabel: 'الطرود وعمليات الجمع',
    parcelPoint: 'وجهة الطرد',
    collectionPoint: 'مكان الجمع',
    open: 'فتح',
    searchPlaceholder: 'المرجع، المستلم أو العنوان…',
    widenHint: 'حرّك الخريطة أو ابحث لترى أبعد.',
    showAll: 'عرض الكل',
    selectHint: 'اضغط على طرد في الخريطة لتراه هنا.',
    empty: 'لا توجد طرود على الخريطة',
    emptyHint: 'ستظهر الطرود هنا عند تحديد عناوينها.'
  },
  courierPickups: {
    title: 'عمليات الجمع',
    subtitle: 'خذ الطرود من الوكلاء أو من المرسلين',
    tabPending: 'للجمع',
    tabCollected: 'تم جمعها',
    pendingEmpty: 'لا توجد عملية جمع منتظرة',
    pendingEmptyHint: 'ستظهر عمليات الجمع الجديدة هنا.',
    collectedEmpty: 'لم تنته أي عملية جمع بعد',
    pointLabel: 'نقطة الإيداع',
    parcelCount: '{count} طرد',
    distanceKm: '{distance} كم',
    collectTitle: 'أخذ الطرد',
    collectStepScan: 'مسح',
    collectStepCode: 'الرمز',
    collectStepConfirm: 'تأكيد',
    codeLabel: 'رمز التسليم',
    codePrompt: 'أدخل الرمز الذي يريك إياه الوكيل',
    codeWrong: 'رمز خاطئ',
    codeExpired: 'انتهى الرمز',
    codeExpiredHint: 'اطلب رمزا جديدا من الوكيل ثم حدّث الصفحة.',
    codeMissing: 'لا يوجد رمز لإدخاله',
    collectPhotos: 'صور الجمع',
    collectPhotosHelp: 'صوّر الطرود التي يسلمها لك الوكيل.',
    collectPhotoRequired: 'أضف صورة للطرود المسلّمة.',
    collectConfirm: 'أخذ {count} طرد',
    collectSuccess: 'تم أخذ الطرد. توجّه إلى الوجهة.',
    sessionTitle: 'عملية جمع',
    sessionReference: 'المرجع {ref}',
    sessionEmpty: 'لا توجد طرود في هذه العملية.',
    refreshCode: 'تحديث الرمز',
    goToPoint: 'فتح الطريق',
    senderLocationCapturedAtCollection: 'يُحدَّد موقعك تلقائيا في خطوة الصورة.',
    senderProofSummary: 'صورة وموقعك سيؤكدان الجمع من هذا العنوان.',
    releasePickup: 'إلغاء حجزي',
    releaseSuccess: 'تم إلغاء الحجز. يمكن لموزّع آخر أخذها.',
  },
  packageCreate: {
    intake: 'إضافة طرود',
    title: 'إنشاء طرد',
    description: 'إنشاء طرد المشغل وتسليمه الأولي بحالة منشأ.',
    actionDenied: 'الإجراء مرفوض',
    referenceDestination: 'المرجع والوجهة',
    operatorReference: 'مرجع المشغل',
    operatorReferenceHelp: 'اختياري. يتم توليده تلقائياً إذا ترك فارغاً.',
    internalReference: 'مرجع داخلي',
    generatedIfEmpty: 'يولد إذا كان فارغاً',
    internalReferenceHelp: 'اختياري. يستعمله 3asass للـ QR والمسح والدعم.',
    assignment: 'التعيين',
    relayAgentPayment: 'نقطة الاستلام، الوكيل والدفع',
    relayResidence: 'إقامة نقطة الاستلام',
    collectionMode: 'مكان جمع الطرد',
    relayOrigin: 'نقطة توزيع للاستلام',
    senderAddressOrigin: 'عنوان المرسل',
    pickupPoint: 'نقطة الاستلام',
    senderName: 'اسم المرسل',
    senderPhone: 'هاتف المرسل',
    senderAddress: 'عنوان الجمع',
    originCsvHelp: 'استعمل sender_address مع الاسم والهاتف والعنوان، أو relay مع الاسم والهاتف وpickup_agent_id.',
    senderPinNotice: 'سيتم إرسال رمز إيداع الطرد إلى هاتف المرسل عبر واتساب.',
    assignedAgent: 'الوكيل المعين',
    backendAutoAssign: 'اختيار تلقائي',
    assignedAgentHelp: 'اختياري. إن تُرك فارغا يُختار الوكيل النشط الأقل انشغالا في هذه النقطة.',
    noActiveAgent: 'لا يوجد وكيل نشط متاح لهذه الإقامة.',
    noPartner: 'لا يوجد شريك',
    partnerHelp: 'اختياري. يستعمل لتتبع رصيد الشريك ورسوم التسليم.',
    codAmountMad: 'مبلغ COD بالدرهم',
    recipient: 'المستلم',
    deliveryContact: 'معلومات التسليم',
    recipientName: 'اسم المستلم',
    recipientPhone: 'هاتف E.164',
    recipientAddress: 'عنوان المستلم',
    creating: 'جاري الإنشاء...',
    create: 'إنشاء طرد',
    afterCreation: 'بعد الإنشاء',
    backendDoes: 'ما سيحدث بعد ذلك',
    backendCreatesDelivery: 'يُنشأ توصيل تلقائيا في مرحلة «تم الإنشاء».',
    backendAssignsAgent: 'نحاول اختيار وكيل نشط من نفس النقطة وهو الأقل انشغالا.',
    backendIdempotency: 'إذا أرسلت مرتين بالخطأ فسيُنشأ طرد واحد فقط.',
    referenceExplanation: 'مرجع المشغل هو مرجع البائع الخارجي ويولد إذا غاب. المرجع الداخلي هو مرجعنا القصير للـ QR والمسح والدعم.',
    validationResidence: 'اختاروا إقامة نقطة الاستلام.',
    validationRecipientName: 'اسم المستلم إلزامي.',
    validationRecipientPhone: 'هاتف المستلم إلزامي.',
    validationRecipientAddress: 'عنوان المستلم إلزامي.',
    validationCod: 'مبلغ COD يجب أن يكون رقماً موجباً أو 0.',
    creationFailed: 'تعذر الإنشاء.',
    normalMode: 'عادي',
    excelMode: 'Excel / CSV',
    addPartnerCreditWarning: 'أضف رصيد الشريك قبل إنشاء طرود مدفوعة إضافية.'
  },
  agentCreatePackage: {
    title: 'طرد جديد',
    subtitle: 'امسح رمز الطرد أو اكتبه ثم املأ المعلومات.',
    backToDashboard: 'الرئيسية',
    back: 'رجوع',
    qrMode: 'مسح رمز QR',
    qrModeHint: 'بكاميرا الهاتف',
    textMode: 'كتابة الرمز',
    textModeHint: 'اكتب الرمز أو الصقه',
    enterTextLabel: 'رمز الطرد',
    textModePlaceholder: 'اكتب الرمز أو الصقه هنا…',
    processText: 'قراءة الرمز',
    scannedCode: 'الرمز المقروء',
    copyCode: 'نسخ الرمز',
    autoExtract: 'تعبئة تلقائية',
    trackingCode: 'رقم التتبع',
    trackingCodePlaceholder: 'الرقم المقروء',
    recipientName: 'اسم المستلم',
    recipientNamePlaceholder: 'الاسم الكامل',
    recipientPhone: 'الهاتف',
    recipientPhonePlaceholder: '+212600000000',
    recipientAddress: 'العنوان',
    recipientAddressPlaceholder: 'العنوان الكامل',
    createPackage: 'إنشاء الطرد',
    creating: 'جارٍ الإنشاء…',
    success: 'تم إنشاء الطرد.',
    failed: 'تعذر إنشاء الطرد.',
    copied: 'تم النسخ.',
    copyFailed: 'تعذر النسخ.',
    enterCode: 'أدخل رمزا.',
    extracted: 'تمت تعبئة الحقول.',
    extractFailed: 'تعذرت تعبئة الحقول. اكتب الاسم والهاتف والعنوان، كل واحد في سطر.',
    validationRecipientName: 'اسم المستلم مطلوب.',
    validationRecipientPhone: 'هاتف المستلم مطلوب.',
    validationRecipientAddress: 'عنوان المستلم مطلوب.',
    photoProof: 'صورة الطرد',
    validationPhoto: 'صورة الطرد مطلوبة.',
    ocrCamera: 'الكاميرا',
    ocrUpload: 'صورة',
    ocrManual: 'كتابة',
    ocrCapture: 'قراءة النص',
    ocrProcessing: 'جارٍ القراءة…',
    ocrRetake: 'إعادة الالتقاط',
    ocrUseText: 'استعمال هذا النص',
    ocrSelectImage: 'اختيار صورة',
    ocrSelectImageHint: 'صورة الطرد لقراءة النص',
    ocrReupload: 'صورة أخرى',
    ocrManualPlaceholder: 'اكتب النص أو الصقه هنا…',
    ocrCameraInit: 'جارٍ فتح الكاميرا…',
    ocrRetry: 'حاول مرة أخرى',
    ocrConfirmUse: 'استعمال هذه المعلومات',
    ocrTakePhoto: 'التقاط صورة'
  },
  agentCreate: {
    onboarding: 'تسجيل الوكيل',
    title: 'إنشاء وكيل',
    description: 'إنشاء حساب في الانتظار، ربط الإقامة، ثم جمع وثائق KYC.',
    agentList: 'قائمة الوكلاء',
    actionDenied: 'الإجراء مرفوض',
    information: 'المعلومات',
    operationalProfile: 'الملف التشغيلي',
    fullName: 'الاسم الكامل',
    e164Phone: 'هاتف E.164',
    language: 'اللغة',
    residence: 'الإقامة',
    kyc: 'KYC',
    fieldDocuments: 'وثائق جمعت في الميدان',
    identityDocument: 'وثيقة الهوية',
    identityDocumentHelp: 'JPG أو PNG أو PDF. الحد الأقصى 5 MB.',
    residenceProof: 'إثبات السكن',
    residenceProofHelp: 'JPG أو PNG أو PDF. يمكن إضافته لاحقاً.',
    facePhoto: 'صورة الوجه',
    facePhotoHelp: 'JPG أو PNG. الحد الأقصى 2 MB.',
    creating: 'جاري الإنشاء...',
    create: 'إنشاء وكيل',
    missingKyc: 'وثائق KYC إلزامية.',
    creationFailed: 'تعذر الإنشاء.'
  },
  packageDetail: {
    recipientPayment: 'دفع المستلم',
    returnCourier: 'موزّع الإرجاع',
    paidFee: 'دفعتَ',
    agentDescription: 'تتبع الوكيل من الاستلام إلى التسليم أو المشكل.',
    backendActions: 'الإجراءات الممكنة',
    loadFailed: 'تعذر تحميل الطرد.',
    myPackages: 'طرودي',
    returnCollectionPhotos: 'صور أخذ المرتجع',
    runnable: 'ممكن',
    detail: 'تفاصيل الطرد',
    tabTimeline: 'التتبع',
    tabProofs: 'الإثباتات',
    tabMap: 'الخريطة',
    tabReferences: 'المراجع',
    createdOn: 'أُنشئ في {date}',
    backToList: 'قائمة الطرود',
    copied: 'تم النسخ.',
    publicTracking: 'صفحة التتبع العامة',
    deliveryState: 'مرحلة التوصيل',
    assignedAgent: 'الوكيل المختار',
    exception: 'المشكل',
    none: 'لا يوجد',
    recipient: 'المستلم',
    phone: 'الهاتف',
    deliveryAddress: 'عنوان التوصيل',
    references: 'المراجع',
    packageIdentifiers: 'مراجع الطرد',
    delivery: 'التوصيل',
    milestones: 'مراحل الطرد',
    dropped: 'تم تسليمه في النقطة',
    relayDropped: 'سُلّم في النقطة',
    received: 'تم استلامه',
    agentReceived: 'استلمه الوكيل',
    outForDelivery: 'خرج للتوصيل',
    delivered: 'تم تسليمه',
    progression: 'التقدم',
    packageCreated: 'تم إنشاء الطرد',
    packageCreatedDescription: 'تم تسجيل الطرد للتوصيل.',
    dropConfirmed: 'تم تأكيد التسليم',
    dropConfirmedDescription: 'مسح الموزّع الطرد في النقطة وأنهى التسليم.',
    system: 'النظام',
    courier: 'الموزّع',
    loadDetailFailed: 'تعذر تحميل تفاصيل الطرد.',
    notFound: 'الطرد غير موجود',
    copyReference: 'نسخ المرجع',
    copyPhone: 'نسخ الرقم',
    internalQrReference: 'المرجع الداخلي / QR',
    internalReference: 'المرجع الداخلي:',
    operatorReference: 'رقم التتبع:',
    technicalIds: 'المعرفات التقنية',
    show: 'إظهار',
    hide: 'إخفاء',
    courierQrScan: 'رمز QR ليمسحه الموزّع',
    qrUnavailable: 'رمز QR غير متوفر.',
    downloadQr: 'تحميل رمز QR',
    availableActions: 'الإجراءات الممكنة',
    noActions: 'لا يوجد إجراء ممكن في هذه المرحلة.',
    timeline: 'التتبع',
    operationalHistory: 'سجل الطرد',
    adminNotePrompt: 'الملاحظة مطلوبة لهذا الإجراء',
    adminNoteRequired: 'الملاحظة مطلوبة.',
    selectActiveAgent: 'اختر وكيلا نشطا.',
    deliveryActionSynced: 'تم حفظ الإجراء.',
    backendRejected: 'لم يتم قبول الإجراء.',
    agentUpdated: 'تم تغيير الوكيل.',
    reassignmentRejected: 'لم يتم قبول تغيير الوكيل.',
    relayAddress: 'النقطة والعنوان',
    relayMap: 'خريطة النقطة',
    routeToDrop: 'الطريق إلى نقطة التسليم',
    routeToPickup: 'الطريق إلى مكان الجمع',
    routeToReturnPoint: 'الطريق إلى نقطة الإرجاع',
    takePickupPhoto: 'صوّر الطرد عند المرسل',
    confirmPickup: 'تأكيد الجمع',
      senderReturnSaved: 'تم تسليم الطرد إلى المرسل',
      senderReturnComplete: 'انتهى الإرجاع.',
      senderReturnHelp: 'سلّم الطرد للمرسل يدا بيد ثم سجل صورة وموقعك.',
      takeSenderReturnPhoto: 'التقاط صورة التسليم',
      senderReturnTo: 'للتسليم إلى المرسل',
      senderReturnStepSender: 'المرسل',
      senderReturnPhoto: 'صورة التسليم',
      senderReturnPhotoHelp: 'صوّر الطرد، ومعه الشخص إن أمكن.',
      senderReturnPhotoFirst: 'أضف الصورة أولاً',
      senderReturnUnavailable: 'هذا الطرد ليس في انتظار إرجاعه إلى المرسل.',
      backToParcel: 'العودة إلى الطرد',
      senderReturnFailed: 'لم يُسجَّل التسليم. تحقق من موقعك والاتصال ثم حاول مرة أخرى.',
    pickupLocationRequired: 'اسمح بالموقع لتأكيد الجمع.',
    pickupProofSaved: 'تم تأكيد الجمع وحفظ الإثبات.',
    pickupProofFailed: 'تعذر تأكيد الجمع. تحقق من الصورة والموقع ثم حاول مجددا.',
    dropProofs: 'إثباتات التسليم',
    uploadedPhotos: 'الصور المرسلة',
    noDropProof: 'لا توجد إثباتات تسليم لهذا الطرد.',
    returnDepositPhotos: 'صور تسليم المرتجع',
    route: 'الجولة',
    courierDescription: 'تتبع الموزّع من الإنشاء حتى التسليم في النقطة.',
    enRoute: 'في الطريق',
    enRouteDescription: 'غادر الموزّع وهو متجه إلى النقطة.',
    selectAgent: 'اختر وكيلا',
    reassignNote: 'ملاحظة لتوضيح التغيير',
    reassignAgent: 'تغيير الوكيل',
    returnPoint: 'نقطة الإرجاع', returnPointTitle: 'اختر أين سيأخذ الزبون الطرد', returnPointHint: 'نقطة الأصل تبقى {original}. اختر نقطة نشطة واشرح السبب.', returnPointReason: 'لماذا تغيّر نقطة الإرجاع؟', assignReturnPoint: 'اختيار نقطة الإرجاع', returnPointAssigned: 'تم اختيار نقطة الإرجاع.', returnPointAssignFailed: 'تعذر اختيار نقطة الإرجاع.',
    noMilestones: 'لم تُسجَّل أي مرحلة بعد.',
    returnRequests: 'طلبات الإرجاع',
    returnRequestsForPackage: 'الطلبات الخاصة بهذا الطرد',
    noReturnRequests: 'لا توجد طلبات إرجاع لهذا الطرد.',
    approveReturnRequest: 'قبول وبدء الإرجاع',
    rejectReturnRequest: 'رفض',
    returnApprovePrompt: 'ملاحظة لقبول هذا الإرجاع',
    returnRejectPrompt: 'ملاحظة لرفض هذا الإرجاع',
    returnApproved: 'تم قبول طلب الإرجاع.',
    returnRejected: 'تم رفض طلب الإرجاع.',
    reviewedAt: 'تم الرد في',
    adminNote: 'ملاحظة',
    returnStatuses: {
      pending: 'في الانتظار',
      approved: 'مقبول',
      rejected: 'مرفوض'
    },
    actions: {
      en_route: 'في الطريق',
      mark_en_route: 'في الطريق',
      drop: 'تسليم الموزّع',
      cancel: 'إلغاء',
      receive: 'استلام الوكيل',
      notify_resident: 'إخبار المستلم',
      start_delivery: 'بدء التوصيل',
      report_exception: 'الإبلاغ عن مشكل',
      capture_pod: 'التسليم للمستلم',
      request_return: 'طلب الإرجاع',
      open_dispute: 'فتح نزاع',
      retry_by_admin: 'إعادة المحاولة',
      return_to_sender: 'إرجاع إلى المرسل',
      deposit_return: 'تم تسليم المرتجع',
      collect_return: 'تم أخذ المرتجع',
      resolve_as_delivered: 'تسوية: تم التسليم',
      resolve_as_failed: 'تسوية: فشل',
      confirm_failed: 'تأكيد الفشل',
      accept_damaged: 'قبول مع ملاحظة',
      clear_agent: 'إعفاء الوكيل',
      confirm_loss_agent_fault: 'فقدان بسبب الوكيل',
      declare_cod_loss: 'التصريح بالفقدان'
    },
    returnIncidents: 'مشاكل الإرجاع',
    collectionTitle: 'عملية الجمع',
    collectionOpen: 'عرض عملية الجمع ورمزها',
    arrivalTitle: 'الوصول',
    arrivalOpen: 'عرض الوصول ورمز الموزّع'
  },
  returnRequests: {
    label: 'البلاغات والإرجاعات',
    title: 'المشاكل المبلَّغ عنها والإرجاعات',
    description: '{count} طلب في القائمة الحالية: بلاغات الزبائن بعد التسليم، وإرجاعات طُلبت بدون حساب.',
    loadFailed: 'تعذر تحميل طلبات الإرجاع.',
    empty: 'لا توجد بلاغات ولا إرجاعات لهذا الفلتر.',
    packageCode: 'كود الطرد',
    requester: 'صاحب الطلب',
    requestedAt: 'تاريخ الطلب',
    reviewedFrom: 'تمت المراجعة من',
    reviewedTo: 'تمت المراجعة إلى',
    searchPlaceholder: 'كود الطرد، الاسم، الهاتف، العنوان، الملاحظة...',
    reviewTitle: 'مراجعة الطلب',
    approveTitle: 'قبول وبدء الإرجاع',
    rejectTitle: 'رفض: يبقى الطرد مسلَّماً',
    reviewDescription: 'أضف ملاحظة داخلية قبل تأكيد هذا القرار.',
    reviewNotePlaceholder: 'ملاحظة الأدمن لهذا الطلب'
  },
  returnIncidents: {
    title: 'مشاكل الإرجاع', description: 'يبقى الطرد عند المسؤول الحالي حتى يستأنف المسؤول الإرجاع أو يغلقه.',
    loadFailed: 'تعذر تحميل مشاكل الإرجاع.', empty: 'لا توجد مشاكل إرجاع.', reportedBy: 'أبلغ عنه', custodian: 'المسؤول الحالي',
    custodyAtReport: 'الحالة عند التبليغ', resolution: 'القرار', viewEvidence: 'عرض صورة الإثبات', reasonPlaceholder: 'سبب قرار المسؤول (8 أحرف على الأقل)',
    chooseCourier: 'اختر موزعاً نشطاً', resume: 'استئناف الإرجاع', reassign: 'تغيير الموزّع بعد التسليم', closeLost: 'إغلاق كمفقود',
    actionFailed: 'فشل تنفيذ القرار.', resumeSuccess: 'تم استئناف الإرجاع.', reassignSuccess: 'تم تحويل الإرجاع إلى موزع جديد.', 'close-lostSuccess': 'تم إغلاق الإرجاع كمفقود.',
    statuses: { open: 'قيد المراجعة', resumed: 'مستأنف', reassigned: 'تم تغيير الموزّع', closed_lost: 'مفقود' }
  },
  cancellationRequests: {
    title: 'طلبات الإلغاء', description: 'الطرد الموجود في الشبكة لا يُلغى إلا بعد عودته فعليًا إلى المُرسل.',
    loadFailed: 'تعذّر تحميل طلبات الإلغاء.', empty: 'لا توجد طلبات إلغاء.', askedAt: 'تاريخ الطلب', stateWhenAsked: 'الحالة عند الطلب',
    parcelNow: 'الطرد حاليًا', decisionNote: 'القرار', notePlaceholder: 'سبب القرار (8 أحرف على الأقل)',
    approve: 'الموافقة والإرجاع', reject: 'رفض', approveSuccess: 'تمت الموافقة على الإلغاء، والطرد في طريقه إلى المُرسل.', rejectSuccess: 'تم رفض الطلب.',
    actionFailed: 'فشل القرار.', pendingCount: '{count} طلب في الانتظار.',
    waitForRelay: 'الطرد في الطريق. انتظر وصوله إلى نقطة استلام قبل الموافقة.',
    awaitingPhysicalReturn: 'تمت الموافقة. في انتظار وصول الطرد إلى المُرسل.', returnedAt: 'تم تسليمه إلى المُرسل في {at}.',
    statuses: { pending: 'للمراجعة', approved: 'في طريق العودة', rejected: 'مرفوض', completed: 'ملغى' }
  },
  partnerPortal: {
    balance: 'الرصيد',
    login: 'تسجيل الدخول',
    loginDescription: 'الدخول مخصص للشركاء الذين أنشأهم فريق 3asass.',
    loginTitle: 'دخول الشريك',
    lowCreditWarning: 'رصيدك أقل من الحد الأدنى {amount}. تواصل مع فريق 3asass لشحنه.',
    reportsDescription: 'ملخص الشهر: الطرود والنجاح والمدد والرسوم.',
    submitDescription: 'أنشئ طردا لزبونك. يُضاف حسابك كشريك تلقائيا.',
    portal: 'مساحة الشريك',
    dashboard: 'الرئيسية',
    packages: 'الطرود',
    submitPackage: 'إضافة طرد',
    residences: 'النقاط',
    creditAccount: 'رصيدي',
    reports: 'التقارير',
    profile: 'الملف الشخصي',
    partnerSignIn: 'تسجيل دخول الشريك',
    partnerSignInDescription: 'الوصول مخصص للشركاء الذين أنشأهم فريق 3asass.',
    signIn: 'تسجيل الدخول',
    packageDetail: 'تفاصيل الطرد',
    timeline: 'التتبع',
    packageProgress: 'أين وصل الطرد',
    timelineCreatedTitle: 'تم إنشاء الطرد',
    timelineCreatedDescription: 'سُجّل الطرد في 3asass وينتظر التكفل به.',
    timelineDroppedTitle: 'سُلّم في النقطة',
    timelineDroppedDescription: 'سلّم الموزّع الطرد في النقطة المحددة.',
    timelineReceivedTitle: 'استلمه الوكيل',
    timelineReceivedDescription: 'أكد الوكيل أنه استلم الطرد فعليا.',
    timelineOutTitle: 'خرج للتوصيل',
    timelineOutDescription: 'الطرد في طريقه إلى المستلم.',
    timelineDeliveredTitle: 'تم التسليم',
    timelineDeliveredDescription: 'تم تسليم الطرد مع إثبات التسليم.',
    timelineReturnRequestedTitle: 'تم طلب الإرجاع',
    timelineReturnRequestedDescription: 'قبل الفريق طلب إرجاع.',
    timelineReturnDepositedTitle: 'تم تسليم المرتجع',
    timelineReturnDepositedDescription: 'سلّم الوكيل الطرد المرتجع وهو جاهز للأخذ.',
    timelineReturnCollectedTitle: 'تم أخذ المرتجع',
    timelineReturnCollectedDescription: 'تم أخذ المرتجع وينتظر تأكيدك.',
    partnerConfirmed: 'أكده الشريك',
    returnReception: 'استلام المرتجع',
    waitingReturnPackages: 'مرتجعات تنتظر التأكيد',
    waitingReturnPackagesDescription: 'طرود عادت إليك وتنتظر تأكيدك.',
    confirmReturnReceived: 'تأكيد استلام المرتجع',
    confirmReturnReceivedDescription: 'أكد فقط بعد أن يصبح الطرد بين يديك.',
    returnAlreadyConfirmed: 'تم تأكيد المرتجع من قبل',
    returnConfirmedAt: 'تم التأكيد في {date}',
    returnReceiptConfirmed: 'تم تأكيد استلام المرتجع.',
    returnReceiptFailed: 'تعذر تأكيد الاستلام.',
    noWaitingReturns: 'لا توجد مرتجعات للتأكيد.',
    timelinePartnerReturnReceivedTitle: 'استلم الشريك المرتجع',
    timelinePartnerReturnReceivedDescription: 'أكد الشريك أنه استلم الطرد.',
    podVisibilityTitle: 'إثباتات التسليم',
    podReadyTitle: 'الإثبات متاح',
    podHiddenTitle: 'الإثبات غير متاح بعد',
    podVisibilityDescription: 'إثباتات هذا الطرد أدناه. اضغط على أحدها لتكبيره.',
    podPendingDescription: 'ستظهر الإثباتات هنا مع تقدم الطرد.',
    podDeliveredEmpty: 'تم تسليم الطرد لكن لا يوجد إثبات بعد.',
    podPendingEmpty: 'لا يوجد إثبات بعد.',
    deliveryPhoto: 'صورة التسليم',
    signature: 'التوقيع',
    dropPhoto: 'صورة التسليم في النقطة',
    receptionPhoto: 'صورة الاستلام',
    exceptionPhoto: 'صورة المشكل',
    title: 'بوابة الشريك',
    dashboardDescription: 'تابع رصيدك والطرود التي أرسلتها والتوصيلات الجارية.',
    creditBalance: 'رصيد الكريدي',
    submittedToday: 'المرسلة اليوم',
    inProgress: 'قيد التنفيذ',
    failed: 'الفاشلة',
    createPackage: 'إنشاء طرد',
    packageList: 'قائمة الطرود',
    createManyPackages: 'إنشاء عدة طرود',
    downloadTemplate: 'تحميل قالب CSV',
    importPackages: 'استيراد الطرود',
    creditDescription: 'الشحنات والرسوم والتصحيحات على حسابك.',
    requestMoreCredit: 'طلب رصيد إضافي',
    reservedFees: 'رسوم محجوزة',
    reservedFeesDescription: 'رسوم طرود لم تتم تسويتها بعد',
    available: 'المتاح',
    availableAfterFees: 'بعد الرسوم المحجوزة',
    successToday: 'الناجحة اليوم',
    deliveredToday: 'تم تسليم {count} اليوم',
    recentPackages: 'آخر الطرود',
    viewAll: 'عرض الكل',
    noPackagesSubmitted: 'لا توجد طرود بعد.',
    quickTracking: 'تتبع سريع',
    packageReference: 'مرجع الطرد',
    track: 'تتبع',
    chooseFromMap: 'اختيار من الخريطة',
    openRelayMapDescription: 'افتح خريطة النقاط قبل إنشاء الطرد التالي.',
    openMap: 'فتح الخريطة',
    threshold: 'الحد الأدنى',
    reservedFeesShort: 'رسوم محجوزة',
    availableCredit: 'الرصيد المتاح',
    usableForNewPackages: 'يمكن استعماله للطرود الجديدة',
    topupRequest: 'طلب شحن',
    topupDescription: 'أدخل المبلغ المطلوب ثم قم بالتحويل البنكي. يضيف الفريق الرصيد بعد تأكيد الدفع.',
    amountInMad: 'المبلغ بالدرهم',
    note: 'ملاحظة',
    notePlaceholder: 'مرجع التحويل، التاريخ المتوقع…',
    sendRequest: 'إرسال الطلب',
    topupSent: 'تم إرسال الطلب. قم بالتحويل بالمرجع الموضح أدناه.',
    bankTransferInstructions: 'كيفية التحويل البنكي',
    beneficiary: 'المستفيد',
    reference: 'المرجع',
    validation: 'التأكيد',
    adminConfirmsPayment: 'يؤكد الفريق عند وصول الدفعة.',
    searchRequests: 'ابحث عن طلب…',
    noTopupRequests: 'لا توجد طلبات شحن',
    noTopupRequestsDescription: 'ستظهر طلبات الشحن هنا.',
    requested: 'تاريخ الطلب',
    status: 'الحالة',
    adminNote: 'ملاحظة الفريق',
    creditHistory: 'سجل الرصيد',
    transactions: 'الحركات',
    creditHistoryDescription: 'الشحنات ورسوم التوصيل والرصيد بعد كل حركة.',
    monthlyReports: 'تقارير الشهر',
    noPackageActivity: 'لا توجد حركة للطرود',
    exportCsv: 'تنزيل بصيغة CSV',
    availableForNewPackages: 'متاح للطرود الجديدة',
    addCreditBeforePackages: 'أضف رصيدا قبل إنشاء طرود أخرى برسوم.',
    creationMode: 'طريقة الإنشاء',
    onePackage: 'طرد واحد',
    excelCsvImport: 'من ملف Excel / CSV',
    normal: 'واحدا واحدا',
    normalCreateHelp: 'لإنشاء طرد واحد يدويا.',
    excelCreateHelp: 'لإنشاء عدة طرود من ملف جاهز.',
    selectedResidence: 'النقطة المختارة',
    selectResidenceOnMap: 'اختر نقطة من الخريطة',
    selectResidenceOnMapDescription: 'المس علامة لاستعمال تلك النقطة لهذا الطرد.',
    residencesMap: 'خريطة النقاط',
    availableRelayPoints: 'النقاط المتاحة',
    residencesMapDescription: 'شاهد النقاط النشطة على الخريطة قبل اختيار وجهة الطرود.',
    coverage: 'المناطق المغطاة',
    gpsResidences: '{count} نقطة لها موقع GPS.',
    selectedRelay: 'النقطة المختارة',
    useForPackage: 'استعمالها لطرد',
    submitted: 'المرسلة',
    packagesCreatedThisMonth: 'الطرود المنشأة هذا الشهر',
    delivered: 'المسلّمة',
    successRate: 'نسبة النجاح {rate}%',
    packagesClosedAsFailed: 'طرود أُغلقت كفاشلة',
    averageTime: 'المدة المتوسطة',
    createdToDelivered: 'من الإنشاء إلى التسليم',
    feesCharged: 'الرسوم المحتسبة',
    partnerFeesSettledThisMonth: 'الرسوم المسدّدة هذا الشهر',
    loadReportFailed: 'تعذر تحميل التقرير.',
    downloadReportFailed: 'تعذر تنزيل ملف CSV.',
    packagesThisMonthAppearHere: 'ستظهر هنا طرود هذا الشهر.',
    state: 'المرحلة',
    created: 'تاريخ الإنشاء',
    deliveredAt: 'تاريخ التسليم',
    hours: 'الساعات',
    cod: 'المبلغ المطلوب',
    loadFailed: 'تعذر تحميل مساحتك.',
    profileTitle: 'ملف الشريك',
    profileDescription: 'عدّل معلومات الشركة وجهات الاتصال وكلمة المرور.',
    actionFailed: 'لم ينجح الأمر',
    companyInfo: 'معلومات الشركة',
    saveProfile: 'حفظ',
    contactCard: 'جهة الاتصال',
    portalEnabled: 'الدخول مفعّل',
    portalDisabled: 'الدخول معطّل',
    security: 'الأمان',
    changePassword: 'تغيير كلمة المرور',
    passwordDescription: 'يجب أن تتكون كلمة المرور من 12 حرفا على الأقل.',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور',
    passwordsDoNotMatch: 'كلمتا المرور غير متطابقتين.',
    savePassword: 'تغيير كلمة المرور',
    profileSaved: 'تم حفظ الملف.',
    profileSaveFailed: 'تعذر حفظ الملف.',
    passwordSaved: 'تم تغيير كلمة المرور.',
    passwordSaveFailed: 'تعذر تغيير كلمة المرور.',
    myPackages: 'طرودي',
    myPackagesDescription: 'طرودك مع مرحلتها ونقطة التسليم والمبلغ المطلوب.'
  },
  returns: {
    title: 'المرتجعات',
    agentLabel: 'الوكيل',
    courierLabel: 'الموزّع',
    agentDescription: 'طرود ستستلمها من المستلم، أو سلّمت إليك من قبل.',
    courierDescription: 'مرتجعات ستأخذها من الوكيل، ومرتجعات أخذتها من قبل.',
    loading: 'جارٍ التحميل…',
    empty: 'لا توجد طرود مرتجعة الآن.',
    loadFailed: 'تعذر تحميل القائمة.',
    startDeposit: 'مسح مرتجع لتسليمه',
    startCollection: 'مسح مرتجع لأخذه',
    agentDepositTitle: 'تسليم مرتجع',
    agentDepositProgress: 'جارٍ إرسال الصور…',
    agentDepositPageLabel: 'مرتجع عند الوكيل',
    agentDepositHeading: 'تسليم مرتجع',
    agentDepositDescription: 'امسح الطرد وصوّر حالته ثم أكد.',
    courierCollectTitle: 'أخذ مرتجع',
    courierCollectProgress: 'جارٍ إرسال الصور…',
    courierCollectPageLabel: 'مرتجع الموزّع',
    courierCollectHeading: 'أخذ مرتجع',
    courierCollectDescription: 'امسح المرتجعات عند الوكيل والتقط صورة ثم أكد.',
    returnPhotos: 'صور المرتجع',
    returnPhotosHelp: 'إلزامي. التقط صورة واحدة على الأقل لحالة الطرد.',
    returnCollectionPhotos: 'صور المرتجع المأخوذ',
    returnCollectionPhotosHelp: 'إلزامي. التقط صورة واحدة على الأقل للمرتجع.',
    removeFromBatch: 'حذف',
    removedFromBatch: 'تم حذف المرتجع.',
    invalidAgentReturn: 'لا يمكن تسليم هذا الطرد كمرتجع من هذه الشاشة.',
    invalidCourierReturn: 'لا يمكن أخذ هذا المرتجع من هذه الشاشة.',
    duplicateReturn: 'هذا المرتجع موجود في القائمة.',
    readyToDeposit: 'جاهز للتسليم.',
    readyToCollect: 'جاهز للأخذ.',
    added: 'تمت إضافة المرتجع.',
    notFound: 'لم يتم العثور على طرد بهذا الرمز.',
    photoRequired: 'أضف صورة واحدة على الأقل للمرتجع.',
    collectionPhotoRequired: 'أضف صورة واحدة على الأقل للمرتجع المأخوذ.',
    scanAtLeastOne: 'امسح مرتجعا واحدا على الأقل.',
    deliveryMissing: 'ليس لهذا الطرد توصيل.',
    depositing: 'جارٍ التسليم…',
    collecting: 'جارٍ الأخذ…',
    queuedDeposit: 'تم حفظ المرتجع في الهاتف وسيُرسل عند عودة الاتصال.',
    queuedCollection: 'تم حفظ العملية في الهاتف وستُرسل عند عودة الاتصال.',
    deposited: 'تم تسليم المرتجع.',
    collected: 'تم أخذ المرتجع.',
    depositRejected: 'لم يتم قبول التسليم. حاول مرة أخرى.',
    collectionRejected: 'لم يتم قبول الأخذ. حاول مرة أخرى.',
    rejectedCount: 'تم رفض {count} مرتجع.',
    depositedCount: 'تم تسليم {count} مرتجع.',
    collectedCount: 'تم أخذ {count} مرتجع.',
    depositComplete: 'تم تسليم المرتجع',
    collectionComplete: 'تم أخذ المرتجع',
    startNewDeposit: 'تسليم مرتجع آخر',
    startNewCollection: 'أخذ مرتجع آخر',
    confirmDeposit: 'تأكيد التسليم',
    confirmCollection: 'تأكيد الأخذ',
    statusSync: 'الإرسال',
    statusDeposited: 'تم تسليمه',
    statusCollected: 'تم أخذه',
    statusQueued: 'لا يوجد اتصال',
    statusFailed: 'خطأ',
    statusPending: 'في الانتظار',
    confirmationSummary: '{returns} مرتجع · {photos} صورة',
    viewDetails: 'عرض التفاصيل'
  },
  courierEarnings: {
    title: 'أرباحي كموزّع',
    balance: 'الأرباح المؤكدة',
    completed: 'الطرود المستلمة هذا الأسبوع',
    help: 'تُضاف أرباح الذهاب عندما يؤكد وكيل الوجهة الاستلام. رحلات الإرجاع غير مدفوعة.'
  },
  profile: {
    connectedAccount: 'معلومات حسابك.',
    operationalDescription: 'عدّل معلومات عملك.',
    actionFailed: 'لم ينجح الأمر',
    fullNameRequired: 'الاسم مطلوب.',
    phoneInvalid: 'أدخل رقما مع رمز البلد، مثل +212600000000.',
    residenceRequired: 'اختر نقطتك.',
    saved: 'تم حفظ الملف الشخصي.',
    saveFailed: 'تعذر حفظ الملف الشخصي.',
    loadFailed: 'تعذر تحميل ملفك الشخصي.',
    chooseDocument: 'اختر وثيقة واحدة على الأقل لاستبدالها.',
    kycSaved: 'تم حفظ الوثائق. يجب أن يتحقق مسؤول من هويتك مجددا.',
    kycSaveFailed: 'تعذر حفظ الوثائق.',
    kycDocuments: 'وثائق الهوية',
    editKycImages: 'تغيير صور الوثائق',
    replaceNeededFiles: 'استبدل الملفات اللازمة فقط. أي تغيير يجب التحقق منه مجددا.',
    displayName: 'الاسم الظاهر',
    saveName: 'حفظ'
  },
  agentOnboarding: {
    chooseDocument: 'اختر وثيقة واحدة على الأقل لاستبدالها.',
    chooseName: 'أدخل اسمك الكامل.',
    choosePhone: 'أدخل رقم هاتفك.',
    chooseResidence: 'اختر نقطتك.',
    currentDocument: 'الوثيقة الحالية',
    currentPhoto: 'الصورة الحالية',
    description: 'حسابك قيد الانتظار. ستستطيع استلام الطرود والمسح ورؤية أموالك بعد موافقة الفريق.',
    documentsSaved: 'تم حفظ الوثائق. يجب أن يتحقق منها الفريق مجددا.',
    identitySection: 'معلوماتك',
    kycSaveFailed: 'تعذر حفظ الوثائق.',
    label: 'تسجيل الوكيل',
    loadFailed: 'تعذر تحميل معلوماتك.',
    saveFailed: 'تعذر حفظ الملف الشخصي.',
    title: 'أكمل ملفك الشخصي',
    actionFailed: 'لم ينجح الأمر',
    fullName: 'الاسم الكامل',
    phone: 'الهاتف',
    preferredLanguage: 'اللغة',
    residenceZone: 'نقطتك',
    validationState: 'حالة ملفك',
    profileCompleted: 'الملف الشخصي مكتمل',
    identityDocReceived: 'تم استلام بطاقة الهوية',
    residenceProofReceived: 'تم استلام إثبات السكن',
    photoReceived: 'تم استلام الصورة',
    kycValidated: 'تم التحقق من الهوية من الفريق',
    escrowRecorded: 'تم تسجيل الضمان',
    saving: 'جارٍ الحفظ…',
    saveProfile: 'حفظ ملفي',
    documentsSection: 'وثائق الهوية',
    documentsDescription: 'أضف الوثائق المطلوبة أو استبدلها. أي تغيير يجب أن يتحقق منه الفريق مجددا.',
    identityDocument: 'بطاقة الهوية',
    proofOfResidence: 'إثبات السكن',
    facePhoto: 'صورة الوجه',
    openCurrentDocument: 'عرض الوثيقة الحالية',
    noCurrentDocument: 'لا توجد وثيقة',
    openCurrentPhoto: 'عرض الصورة الحالية',
    noCurrentPhoto: 'لا توجد صورة',
    saveDocuments: 'حفظ الوثائق'
  },
  scanner: {
    title: 'مسح طرد',
    hint: 'وجّه الكاميرا نحو رمز QR الخاص بالطرد، أو اكتب رمزه.',
    looking: 'جارٍ البحث عن الطرد…',
    notFound: 'لا يوجد طرد بهذا الرمز خاص بك.',
    failed: 'تعذّر التحقق من الرمز. حاول مرة أخرى.',
    again: 'مسح طرد آخر',
    details: 'عرض الطرد',
    reportProblem: 'الإبلاغ عن مشكلة',
    steps: {
      customer_handover: 'استلام الطرد من الزبون',
      show_collection_code: 'أرِ الموزّع الرمز',
      receive_arrival: 'استلام الطرد',
      start_delivery: 'الذهاب للتسليم',
      deliver: 'تسليم للمستلم',
      deposit_return: 'إيداع المرتجع',
      return_arrived: 'الطرد عندي',
      hand_back_to_customer: 'إرجاع الطرد للزبون',
      drop_off: 'تسليم الطرد للوكيل',
      collect_session: 'فتح عملية الجمع',
      accept_return: 'قبول هذا المرتجع',
      collect_return: 'أخذ المرتجع',
      confirm_sender_return: 'تسليم للمرسل'
    },
    waiting: {
      waiting_courier: 'هذا الطرد ينتظر الموزّع.',
      coming_courier: 'الموزّع يحضر هذا الطرد.',
      delivered: 'تم تسليم هذا الطرد. لا شيء للقيام به.',
      cancelled: 'تم إلغاء هذا الطرد.',
      with_team: 'الفريق يعالج مشكلة في هذا الطرد.',
      return_in_progress: 'هذا الطرد في طريق العودة. لا شيء مطلوب منك الآن.',
      nothing: 'لا شيء للقيام به مع هذا الطرد الآن.'
    }
  },
  senderReturns: {
    title: 'طرود عائدة ({count})',
    comingBack: 'الموزّع يعيد هذا الطرد. اضغط عندما يصل إليك.',
    arrived: 'الطرد عندي',
    arrivedDone: 'تم إخبار الزبون. يمكنه المجيء لأخذه.',
    askCode: 'اطلب من الزبون رمزه المكون من 4 أرقام.',
    stepCustomer: 'الزبون',
    stepProof: 'الرمز والصورة',
    codeFirst: 'أدخل رمز الزبون',
    photo: 'صورة التسليم',
    photoHelp: 'صوّر الطرد، ومعه الزبون إن أمكن.',
    unavailable: 'هذا الطرد غير جاهز للتسليم إلى الزبون.',
    backToReturns: 'العودة إلى الطرود العائدة',
    handBack: 'تسليم للزبون',
    handedBack: 'تم تسليم الطرد للزبون.',
    retry: 'حاول مرة أخرى',
    failed: 'لم يُحفظ. حاول مرة أخرى.'
  },
  simpleStatus: {
    requested: 'تم الطلب',
    dropped_off: 'تم تسليمه',
    on_the_way: 'في الطريق',
    delivered: 'تم تسليمه',
    returned: 'أعيد إلى المرسل',
    returnedHint: 'تم تسليم الطرد إلى المرسل.',
    problem: 'هناك مشكل ونحن نعمل على حله',
    problemHint: 'فريقنا يعمل على ذلك وسنبقيك على اطلاع.',
    cancelled: 'ملغى',
    journey: 'مراحل الطرد',
    returnJourney: 'مراحل الإرجاع',
    returnRequested: 'تم طلب الإرجاع',
    returnAtDestination: 'عند الوكيل',
    returnOnWay: 'في طريق العودة',
    returnReady: 'جاهز للاستلام',
    returnReceived: 'عاد إليك'
  },
  pageTitles: {
    pickupsShort: 'الإيداعات',
    home: 'الرئيسية',
    packages: 'الطرود',
    packageDetail: 'الطرد',
    scan: 'استلام طرد',
    createPackage: 'طرد جديد',
    handovers: 'الوصولات',
    handoverDetail: 'وصول',
    pickups: 'الإيداعات',
    pickupScan: 'الاستلام من الزبون',
    pickupHandover: 'التسليم للموزّع',
    pickupSession: 'طرود الموزّع',
    returns: 'المرتجعات',
    pod: 'التسليم للمستلم',
    bulkPod: 'تسليم عدة طرود',
    returnDeposit: 'استلام مرتجع',
    exception: 'الإبلاغ عن مشكل',
    sync: 'إرسال البيانات',
    wallet: 'أرباحي',
    profile: 'ملفي الشخصي',
    dropSessions: 'إيداعاتي',
    dropSessionsShort: 'إيداعات',
    dropSessionDetail: 'إيداع',
    drop: 'التسليم عند الوكيل',
    collections: 'عمليات الجمع',
    collectionDetail: 'عملية جمع',
    returnCollect: 'أخذ مرتجع',
    scanner: 'مسح',
    senderReturn: 'تسليم للمرسل',
    requests: 'الطلبات',
    requestNew: 'إرسال طرد',
    requestDetail: 'الطلب',
    dropOffs: 'إيداعاتي',
    payments: 'المدفوعات',
    courierMap: 'خريطة الطرود',
    agentMap: 'خريطة الطرود',
    back: 'رجوع',
    menu: 'القائمة'
  },
  pickupRequests: {
    loadFailed: 'تعذر تحميل الطلبات. حاول مرة أخرى.',
    title: 'طلبات جديدة ({count})',
    customer: 'الزبون',
    goingTo: 'إلى',
    call: 'اتصل بالزبون',
    answerBy: 'أجب قبل {time}',
    accept: 'قبول',
    decline: 'رفض',
    declineConfirm: 'هل ترفض هذا الطلب؟ سيختار الزبون نقطة أخرى.',
    keep: 'إبقاء',
    declineYes: 'نعم، ارفض',
    accepted: 'تم قبول الطلب. سيحضر لك الزبون الطرد.',
    declined: 'تم رفض الطلب.',
    answerFailed: 'لم يتم إرسال ردك. حاول مرة أخرى.'
  },
  agentPickups: {
    deliverTo: 'الوجهة',
    clientLabel: 'الزبون',
    title: 'إيداعات الزبائن',
    subtitle: 'طرود يسلمها لك الزبائن يدا بيد',
    tabIncoming: 'للاستلام',
    tabReady: 'للتسليم',
    tabSessions: 'عمليات الجمع',
    incomingEmpty: 'لا توجد طرود للاستلام',
    incomingEmptyHint: 'سيظهر الزبائن هنا بمجرد اختيارهم نقطتك لتسليم طرد.',
    readyEmpty: 'لا توجد طرود للتسليم',
    readyEmptyHint: 'أكد إيداع الزبون لتعرض طرده على موزّع.',
    sessionsEmpty: 'لا توجد عمليات جمع',
    sessionsEmptyHint: 'تظهر عمليات الجمع عندما يسلمك زبون طردا.',
    scanTitle: 'مسح الطرود',
    scanStepPackages: 'الطرود',
    scanStepPhoto: 'الصورة',
    scanStepConfirm: 'التأكيد',
    scanHint: 'امسح الطرود واحدا واحدا، ثم التقط صورة قبل التأكيد.',
    scanSelected: 'تم اختيار {count} طرد',
    scanRemove: 'حذف هذا الطرد',
    scanClearAll: 'حذف الكل',
    confirmHandover: 'تأكيد الإيداع',
    customerPresent: 'الزبون هنا وقد سلمني هذا الطرد',
    signatureRequired: 'توقيع الزبون مطلوب.',
    geolocationMissing: 'تعذر تحديد موقعك. فعّل خدمة الموقع.',
    photoRequired: 'الصورة مطلوبة.',
    photoBatchHint: 'صورة واحدة تكفي لجميع الطرود.',
    parcelNotYours: 'هذا الطرد ليس في قائمتك.',
    reasonNotPickupPackage: 'هذا الطرد لم يسلمه زبون.',
    reasonAgentMismatch: 'هذا الطرد مرتبط بنقطة أخرى.',
    reasonAlreadyPickupReady: 'هذا الطرد جاهز للموزّع بالفعل.',
    reasonInvalidState: 'هذا التأكيد غير ممكن في هذه المرحلة.',
    reasonPodRejected: 'تم رفض الإثبات لهذا الطرد.',
    reasonCodeInvalid: 'الرمز خاطئ. اطلبه من الزبون مرة أخرى.',
    reasonCodeLocked: 'رموز خاطئة كثيرة. حاول بعد 15 دقيقة.',
    customerCodeTitle: 'رمز الزبون',
    customerCodeHint: 'اطلب من الزبون الرمز المكوّن من 4 أرقام في تطبيقه.',
    customerCodeMissing: 'أدخل الرمز المكوّن من 4 أرقام لكل طرد.',
    notReadyForCollection: 'هذا الطرد ليس جاهزا للموزّع بعد.',
    queuedOffline: 'لا يوجد اتصال: سيتم إرسال التأكيد لاحقا.',
    sessionTitle: 'عملية جمع',
    sessionReference: 'المرجع {ref}',
    sessionParcelCount: '{count} طرد',
    sessionEmpty: 'لا توجد طرود في هذه العملية.',
    createSession: 'تجهيز عملية الجمع',
    sessionCreated: 'عملية الجمع جاهزة. أظهر الرمز للموزّع.',
    code: 'رمز التسليم',
    codeHint: 'أعط هذا الرمز للموزّع. صالح لمدة 15 دقيقة.',
    doneHint: 'أخذ الموزّع هذه الطرود. لا شيء متبقٍ للقيام به.',
    codeCopied: 'تم نسخ الرمز',
    codeRefreshed: 'الرمز الجديد جاهز',
    codeRefreshQueued: 'تم حفظ الرمز الجديد وسيعمل عند عودة الاتصال.',
    codeExpiresAt: 'صالح لمدة 15 دقيقة',
    codeExpired: 'انتهى الرمز. أنشئ رمزا جديدا.',
    codeMissing: 'لا يوجد رمز صالح',
    codeInvalid: 'رمز خاطئ',
    codeSixDigits: 'الرمز مكوّن من 6 أرقام.',
    waitForCourier: 'بانتظار الموزّع',
    showCodeToCourier: 'أظهر هذا الرمز للموزّع',
    assignedLivreur: 'الموزّع المختار',
    livreurRequired: 'اختر الموزّع الذي سيأخذ هذه الطرود.',
    noActiveLivreur: 'لا يوجد موزّع متاح',
    reassignLivreur: 'تغيير الموزّع',
    reassignDone: 'تم تغيير الموزّع.',
    excludeParcel: 'حذف هذا الطرد',
    includedParcels: '{count} طرد بداخلها',
    handoverTitle: 'إيداع الزبون',
    handoverHint: 'تحقق من الطرد والزبون قبل التأكيد.',
    typeBadgePickup: 'إيداع زبون',
    fromCustomer: 'سلمه الزبون',
    tabCollected: 'تم جمعها',
    statusWaiting: 'بانتظار الموزّع',
    statusCollected: 'أخذها الموزّع',
    collectedEmpty: 'لا توجد عمليات جمع منتهية',
    collectedEmptyHint: 'ستظهر هنا عمليات الجمع التي أنهاها الموزّع.',
    parcelsNoSession: 'طرود جاهزة بدون عملية جمع',
    openSessionHint: 'افتح لرؤية الرمز',
  },
  residences: {
    relay: 'نقطة الاستلام',
    title: 'الإقامات',
    description: 'أدر النقاط المتاحة لاختيار الوكلاء واستقبال الطرود.',
    add: 'إضافة إقامة',
    total: 'المجموع',
    active: 'نشطة',
    inactiveCount: '{count} معطلة',
    linkedAgents: 'وكلاء مرتبطون',
    linkedPackages: 'طرود مرتبطة',
    tableView: 'جدول',
    mapView: 'خريطة',
    mapTitle: 'خريطة الإقامات',
    mapSubtitle: 'كل نقاط الاستلام المتاحة',
    mapDescription: 'شاهد النقاط على الخريطة واختر واحدة وافتح ملفها.',
    coverage: 'التغطية',
    mappableCount: '{count} إقامة بإحداثيات GPS.',
    selectedRelay: 'نقطة الاستلام المختارة',
    address: 'العنوان',
    gps: 'GPS',
    actions: 'الإجراءات',
    inactive: 'معطلة',
    searchPlaceholder: 'الاسم، العنوان، المدينة...',
    emptyTitle: 'لا توجد إقامات',
    emptyDescription: 'أضيفوا إقامة لبدء تعيين الطرود.',
    edit: 'تعديل',
    deactivate: 'تعطيل',
    editTitle: 'تعديل إقامة',
    addTitle: 'إضافة إقامة',
    residenceId: 'معرف الإقامة',
    osmSearch: 'بحث OpenStreetMap',
    osmPlaceholder: 'إقامة، شارع، حي، مدينة...',
    searchRequired: 'أدخلوا عنواناً أو اسم إقامة.',
    noMoroccoResult: 'لا توجد نتيجة في المغرب.',
    geolocationUnavailable: 'تحديد الموقع في المتصفح غير متوفر.',
    geolocationFailed: 'تعذر جلب موقع المتصفح.',
    morocco: 'المغرب',
    name: 'الاسم',
    latitude: 'خط العرض',
    longitude: 'خط الطول',
    activeCheckbox: 'نشطة',
    mapHelp: 'اضغطوا على الخريطة لوضع العلامة. يمكنكم أيضاً التكبير وتحريك الخريطة.',
    openOsm: 'فتح في OpenStreetMap',
    osmDisclaimer: 'بيانات العنوان تأتي من OpenStreetMap. تحققوا دائماً من العنوان قبل الحفظ.',
    create: 'إنشاء',
    validationRequired: 'الاسم والعنوان والمدينة إلزامية.',
    invalidLatitude: 'خط العرض غير صالح.',
    invalidLongitude: 'خط الطول غير صالح.',
    actionFailed: 'تعذر تنفيذ الإجراء.'
  },
  partners: {
    title: 'الشركاء',
    description: 'حسابات المرسلين والرصيد والحالة ورسوم التوصيل.',
    partner: 'الشريك',
    create: 'شريك جديد',
    createPartner: 'إنشاء شريك',
    editPartner: 'تعديل الشريك',
    companyName: 'الشركة',
    contactName: 'اسم المسؤول',
    contactPhone: 'هاتف المسؤول',
    contactEmail: 'بريد المسؤول',
    contact: 'المسؤول',
    agent: 'الوكيل',
    credit: 'الرصيد',
    creditBalance: 'رصيد الكريدي',
    lowCreditThresholdMad: 'الحد الأدنى للرصيد قبل التنبيه (درهم)',
    threshold: 'الحد الأدنى',
    activePartners: 'شركاء نشطون',
    lowCredit: 'رصيد منخفض',
    creditBlocked: 'الرصيد نفد',
    availableCredit: 'الرصيد المتاح',
    reservedFees: 'رسوم محجوزة',
    balanceLabel: 'الرصيد',
    totalCredit: 'مجموع الرصيد',
    backToList: 'قائمة الشركاء',
    addCredit: 'إضافة رصيد',
    recordTopup: 'تسجيل الشحن',
    amount: 'المبلغ',
    amountMad: 'المبلغ (MAD)',
    note: 'ملاحظة',
    postedAt: 'التاريخ',
    postedFrom: 'من',
    postedTo: 'إلى',
    entryType: 'النوع',
    searchPlaceholder: 'الشركة أو المسؤول أو البريد أو الهاتف…',
    creditSearchPlaceholder: 'المرجع أو الملاحظة أو المستلم…',
    emptyTitle: 'لا يوجد شركاء',
    emptyDescription: 'سيظهر الشركاء الذين تنشئهم هنا.',
    noCreditEntries: 'لا توجد حركات رصيد',
    noCreditEntriesDescription: 'ستظهر هنا الشحنات ورسوم التوصيل.',
    noPartner: 'بدون شريك',
    portalPassword: 'كلمة مرور مساحة الشريك',
    portalPasswordUpdate: 'كلمة مرور جديدة',
    portalPasswordHelp: 'اختياري. 12 حرفا على الأقل. إن تُرك فارغا فلن يُنشأ الدخول أو يتغير.',
    portalPasswordInvalid: 'يجب أن تتكون كلمة المرور من 12 حرفا على الأقل.',
    portalEnabled: 'الدخول مفعّل',
    portalDisabled: 'الدخول معطّل',
    actionFailed: 'لم ينجح الأمر.',
    companyRequired: 'اسم الشركة مطلوب.',
    contactRequired: 'اسم المسؤول مطلوب.',
    phoneRequired: 'الهاتف مطلوب.',
    emailRequired: 'البريد الإلكتروني مطلوب.',
    thresholdInvalid: 'يجب أن يكون الحد الأدنى مبلغا موجبا.',
    amountInvalid: 'يجب أن يكون المبلغ أكبر من صفر.',
    noteRequired: 'أضف ملاحظة واضحة.',
    requested: 'المطلوب',
    copyPartnerId: 'نسخ معرّف الشريك',
    unsettledExposure: 'طرود لم تُسوَّ بعد',
    balanceAfterExposure: 'الرصيد بعد هذه الطرود',
    needsCreditAttention: 'الرصيد يحتاج انتباها',
    creditOperational: 'الرصيد كاف',
    submittedByPartner: 'أرسلها هذا الشريك',
    creditActivity: 'حركات الرصيد',
    topupsAndFees: 'الشحنات ورسوم التوصيل',
    financeViewHelp: 'نظرة سريعة قبل فتح التفاصيل.',
    credited: 'المضاف',
    feesDebited: 'الرسوم المخصومة',
    pendingTopup: 'شحن في الانتظار',
    latestMovement: 'آخر حركة',
    noCreditMovement: 'لا توجد حركة بعد.',
    topupRequests: 'طلبات الشحن',
    reviewQueue: 'للمراجعة',
    partnerAccess: 'دخول الشريك',
    statusActions: 'تغيير الحالة',
    statusActionsHelp: 'قرر هل يستطيع هذا الشريك الدخول وإنشاء الطرود.',
    portalActive: 'دخول الشريك مفعّل.',
    portalSuspended: 'دخول الشريك موقوف مؤقتا.',
    portalClosed: 'حساب الشريك مغلق.',
    statusImpact: 'لا يستطيع الشريك الموقوف أو المغلق إنشاء طرود. يبقى سجله ظاهرا للفريق.',
    searchTopupRequests: 'ابحث عن طلب شحن…',
    noTopupRequests: 'لا توجد طلبات شحن',
    noTopupRequestsDescription: 'ستظهر هنا طلبات شحن الشركاء.',
    bankTransferReceived: 'تم استلام التحويل البنكي.',
    approveTopupRequest: 'قبول طلب الشحن',
    rejectTopupRequest: 'رفض طلب الشحن',
    request: 'الطلب',
    noPartnerNote: 'لا توجد ملاحظة من الشريك.',
    rejectRequestPlaceholder: 'اشرح سبب الرفض…',
    approveRequest: 'قبول الطلب',
    rejectRequest: 'رفض الطلب',
    suspendPartner: 'إيقاف الشريك مؤقتا',
    closePartner: 'إغلاق الحساب',
    reactivatePartner: 'إعادة تفعيل الشريك',
    suspendPartnerHelp: 'يمنع الشريك مؤقتا من الدخول وإنشاء الطرود.',
    closePartnerHelp: 'يغلق الحساب ويمنع كل شيء. استعمله فقط إذا انتهى التعامل.',
    reactivatePartnerHelp: 'يعيد الدخول للشريك. يمكنه إنشاء طرود إن كان رصيده كافيا.',
    statusReasonRequired: 'اكتب سببا واضحا من 10 أحرف على الأقل.',
    statusReasonPlaceholder: 'اشرح سبب هذا الإجراء…',
    active: 'نشط',
    suspended: 'معلق',
    closed: 'مغلق',
    status: {
      active: 'نشط',
      suspended: 'معلق',
      closed: 'مغلق'
    },
    entry: {
      credit_topup: 'شحن',
      partner_fee_debit: 'رسوم التوصيل',
      credit_adjustment: 'تصحيح الرصيد'
    }
  },
  adminCustomers: {
    title: 'الزبائن',
    subtitle: 'حسابات الزبائن ورصيد التوصيل',
    searchPlaceholder: 'ابحث عن زبون…',
    empty: 'لا يوجد زبون.',
    balance: 'الرصيد',
    available: 'المتاح',
    exposed: 'المحجوز',
    threshold: 'حد التنبيه',
    totalPackages: 'مجموع الطرود',
    deliveredPackages: 'الطرود المسلّمة',
    lastSync: 'آخر تحديث',
    lastActivity: 'آخر نشاط',
    detailTitle: 'ملف الزبون',
    detailSubtitle: 'الرصيد والتوصيلات وطلبات الشحن',
    contact: 'التواصل',
    customerSince: 'زبون منذ',
    packagesSection: 'طرود الزبون',
    orderRequestsSection: 'طلبات الإرسال',
    returnsSection: 'طلبات الإرجاع',
    creditLedger: 'حركات الرصيد',
    creditLedgerEmpty: 'لا توجد حركات على الرصيد.',
    creditRequests: 'طلبات الشحن',
    creditRequestsEmpty: 'لا توجد طلبات شحن.',
    topupTitle: 'طلب شحن',
    topupAmount: 'المبلغ',
    topupNote: 'السبب',
    topupSubmit: 'إرسال إلى الزبون',
    approveRequest: 'قبول',
    rejectRequest: 'رفض',
    adminNote: 'ملاحظة الفريق',
    adminNotePlaceholder: 'يراها الفريق فقط',
    entryTypeCreditTopup: 'شحن',
    entryTypeDeliveryFeeDebit: 'رسوم التوصيل',
    entryTypeCreditAdjustment: 'تصحيح الرصيد',
    requestStatusPending: 'في الانتظار',
    requestStatusApproved: 'مقبول',
    requestStatusRejected: 'مرفوض',
    pickupEnabled: 'إيداعات الزبائن',
    pickupEnabledHint: 'سيتمكن الزبائن من اختيار هذا الوكيل كنقطة إيداع.',
    pickupEnabledOn: 'مفعّل',
    pickupEnabledOff: 'معطّل',
    configPickupTypeEnabled: 'إيداعات الزبائن (عام)',
    configPickupTypeEnabledHint: 'المفتاح العام. عند الإيقاف لا تُعرض نقاط إيداع ولا تُنشأ طرود للزبائن.',
    configCustomerFee: 'ثمن التوصيل الواحد للزبون',
    configCustomerFeeHint: 'يُسجَّل هذا الثمن عندما يقبل الوكيل طرد الزبون. وهو ليس إثباتا للدفع.',
    configSaved: 'تم حفظ الإعداد',
    orderRequestPickupPoint: 'نقطة الإيداع',
    orderRequestPickupHint: 'اختار الزبون نقطة إيداع. أبقها أو اختر غيرها.',
    orderRequestSelectPickupPoint: 'نقطة الإيداع',
    orderRequestNoPoints: 'لا يوجد وكيل يستطيع استلام هذا الطرد.',
    orderRequestPickupNone: 'توصيل مباشر إلى العنوان',
    packagePickupPoint: 'نقطة الإيداع',
    packagePickupAgent: 'الوكيل',
    packageHandoverAt: 'سُلّم للوكيل في',
    packageCollectedAt: 'أخذه الموزّع في',
    customerCreditExhausted: 'نفد الرصيد: على الزبون الشحن.',
  },
  publicTracking: {
    unavailable: 'التتبع غير متوفر',
    unavailableMessage: 'لم نجد هذا الرمز أو أن التتبع غير متوفر الآن.',
    label: 'تتبع الطرد',
    backHome: 'العودة إلى الرئيسية',
    package: 'الطرد',
    recipient: 'المستلم:',
    hiddenRecipient: 'مخفي حتى يصل إلى النقطة',
    operatorReference: 'رقم التتبع:',
    relay: 'نقطة التسليم',
    relayPending: 'ستظهر النقطة عندما يستلم الوكيل الطرد.',
    agent: 'الوكيل',
    agentPending: 'يظهر عند وصول الطرد إلى النقطة',
    dates: 'التواريخ',
    dropped: 'تم تسليمه في النقطة:',
    received: 'تم استلامه:',
    out: 'خرج للتوصيل:',
    delivered: 'تم تسليمه:',
    map: 'الخريطة',
    relayPosition: 'مكان النقطة',
    trackingTimeline: 'تقدم الطرد',
    createdTitle: 'تم إنشاء الطرد',
    createdDescription: 'تم تسجيل الطرد.',
    en_route: 'في الطريق:',
    enRouteTitle: 'في الطريق إلى النقطة',
    enRouteDescription: 'الموزّع أخذ الطرد وهو متجه إلى النقطة.',
    droppedTitle: 'سُلّم في النقطة',
    droppedDescription: 'سلّم الموزّع الطرد في النقطة.',
    receivedTitle: 'استلمه الوكيل',
    receivedDescription: 'أكد الوكيل أنه استلم الطرد.',
    outTitle: 'خرج للتوصيل',
    outDescription: 'الطرد في الطريق إلى المستلم.',
    deliveredTitle: 'تم التسليم',
    deliveredDescription: 'تم تسليم الطرد مع إثبات التسليم.',
    failedTitle: 'لم ينجح التوصيل',
    failedDescription: 'لم ينجح التوصيل.',
    noMapBeforeReceived: 'تظهر الخريطة عندما يستلم الوكيل الطرد.',
    returnRequest: 'طلب إرجاع',
    returnRequestTitle: 'طلب إرجاع',
    returnPageDescription: 'أدخل بياناتك ورمز الطرد. يراجع الفريق طلبك قبل بدء الإرجاع.',
    returnName: 'اسمك الكامل',
    returnPhone: 'هاتفك',
    returnAddress: 'عنوانك',
    returnPackageCode: 'رمز الطرد',
    returnNote: 'رسالة للفريق',
    returnSubmit: 'إرسال طلبي',
    returnFormRequired: 'الاسم والهاتف والعنوان ورمز الطرد مطلوبة.',
    returnSubmitted: 'تم إرسال الطلب.',
    returnSubmittedDetail: 'استلمنا طلبك. يراجعه فريق 3asass قبل بدء الإرجاع.',
    returnFailed: 'تعذر إرسال الطلب.'
  },
  documents: {
    view: 'عرض المستند',
    unavailable: 'المستند غير متوفر'
  },
  exception: {
    title: 'الإبلاغ عن مشكل',
    reason: 'السبب',
    operationalNote: 'تفاصيل (اختياري)',
    submit: 'إرسال',
    queued: 'تم حفظ المشكل في الهاتف وسيُرسل عند عودة الاتصال.',
    synced: 'تم إرسال المشكل.',
    rejected: 'لم يتم قبول المشكل. حاول مرة أخرى.',
    notAllowedForState: 'لا يمكنك الإبلاغ عن مشكل في هذه المرحلة.',
    recipientAbsent: 'المستلم غير موجود',
    refused: 'المستلم رفض',
    damagedAtReceipt: 'تالف عند الاستلام',
    damagedAtDelivery: 'تضرر في الطريق',
    lost: 'الطرد ضاع',
    wrongContent: 'محتوى غير مطابق أو مشبوه',
    unreachable: 'لا يمكن الاتصال بالمستلم',
    adminOverride: 'عُدّل من طرف الإدارة',
    returnApproved: 'تم قبول الإرجاع',
    returnRejected: 'تم رفض الإرجاع',
    photoLabel: 'صورة المشكل',
    photoHelp: 'اختياري ولكن يفضّل. التقط صورة تُظهر المشكل.',
    agentLabel: 'مشكل مع طرد',
    agentTitle: 'الإبلاغ عن مشكل',
    agentEligibleStates: 'ممكن عندما يكون الطرد مستلما أو في التوصيل أو فاشلا أو محل نزاع.',
    noPackageSelected: 'لم تختر أي طرد. ارجع إلى صفحة الطرد واختر «الإبلاغ عن مشكل».',
    courierLabel: 'مشكل في التسليم',
    courierTitle: 'الإبلاغ عن مشكل',
    courierDescription: 'استعمله إذا كان لطرد سُلّم للوكيل مشكل قبل استلامه.'
  },
  podMedia: {
    signedPod: 'إثبات موقّع',
    operationalProofs: 'إثباتات التسليم',
    courierDropPhoto: 'صورة تسليم الموزّع',
    courierDropPhotoAlt: 'صورة التسليم {index}',
    noDropPhoto: 'لا توجد صورة تسليم',
    courierPickupPhoto: 'صور الجمع',
    courierPickupPhotoAlt: 'صورة الجمع {index}',
    noCourierPickupPhoto: 'لا توجد صورة جمع',
    receptionPhotos: 'صور الاستلام',
    receptionPhotoAlt: 'صورة الاستلام {index}',
    noReceptionPhoto: 'لا توجد صورة استلام',
    deliveryPhoto: 'صورة التسليم',
    noPhoto: 'لا توجد صورة',
    signature: 'توقيع المستلم',
    noSignature: 'لا يوجد توقيع',
    customerHandoverPhotos: 'صور تسليم الزبون',
    customerHandoverPhotoAlt: 'صورة تسليم الزبون {index}',
    customerHandoverSignature: 'توقيع الزبون (التسليم عند الوكيل)',
    noCustomerHandoverSignature: 'لا يوجد توقيع للزبون.',
    noCustomerHandoverPhoto: 'لا توجد صورة لتسليم الزبون',
    exceptionsAndReturns: 'المشاكل والإرجاعات',
    incidentProofs: 'إثباتات المشكل',
    exceptionPhotos: 'صور المشكل',
    exceptionPhotoAlt: 'صورة المشكل {index}',
    noExceptionPhoto: 'لا توجد صورة للمشكل',
    returnAgentPhotos: 'صور المرتجع عند الوكيل',
    returnAgentPhotoAlt: 'صورة المرتجع عند الوكيل {index}',
    noReturnAgentPhoto: 'لا توجد صورة للمرتجع عند الوكيل',
    returnCourierPhotos: 'صور المرتجع الذي أخذه الموزّع',
    returnCourierPhotoAlt: 'صورة المرتجع المأخوذ {index}',
      senderReturnPhotos: 'صور تسليم الطرد للمرسل',
      senderReturnPhotoAlt: 'صورة تسليم الطرد للمرسل {index}',
    noReturnCourierPhoto: 'لا توجد صورة للمرتجع المأخوذ'
  },
  timeline: {
    history: 'سجل الطرد',
    lifecycle: 'المراحل',
    empty: 'لا توجد أحداث لهذا الطرد.',
    gpsPosition: 'الموقع على الخريطة',
    viewGps: 'عرض الموقع',
    transitions: {
      awaitingPickupToPickupReady: 'تم تأكيد تسليم الزبون عند الوكيل',
      pickupReadyToEnRoute: 'أخذ الموزّع الطرد من عند الوكيل',
      pickupToCancelled: 'تم إلغاء التسليم',
      pickupReadyToReceived: 'استُلم الطرد من الزبون في النقطة',
      enRouteToDropped: 'سلّم الموزّع الطرد في النقطة',
      droppedToReceived: 'استُلم الطرد في النقطة',
      receivedToOut: 'قيد التوصيل',
      receivedToOutHold: 'المستلم هنا: بدأ التسليم',
      outToDelivered: 'سُلّم إلى المستلم',
      outToDeliveredHold: 'استلمه المستلم',
      toFailed: 'فشل التوصيل',
      toReturnRequested: 'بدأ الإرجاع',
      returnRequestedToDeposited: 'أُودع الطرد المُعاد في النقطة',
      depositedToCollected: 'أخذ الموزّع الطرد المُعاد',
      toDisputed: 'فُتح نزاع',
      disputedToDelivered: 'سُوّي النزاع: تم التسليم',
      disputedToFailed: 'سُوّي النزاع: فشل',
      failedToReceived: 'محاولة توصيل جديدة',
      toCancelled: 'أُلغي الطرد',
      createdToEnRoute: 'أُخذ الطرد من المرسل'
    },
    actions: {
      transition: 'تغيير المرحلة',
      en_route: 'في الطريق إلى النقطة',
      partner_return: 'إرجاع إلى الشريك',
      state_changed: 'تغيرت المرحلة',
    },
    descriptions: {
      partnerReturn: 'أكد الشريك أنه استلم الطرد المرتجع.',
      auditEvent: 'تم تسجيل الإجراء في السجل.',
      system: 'النظام'
    },
    showAll: '+{count} مراحل',
    showLess: 'عرض أقل'
  },
  podUpload: {
    title: 'إثباتات التسليم',
    assets: 'ملفات الإثبات',
    addPhoto: 'إضافة صورة',
    ready: 'جاهز',
    missing: 'ناقص',
    uploaded: 'تم الإرسال'
  },
  logisticsUi: {
    photo: 'صورة',
    takePhoto: 'التقاط صورة',
    upload: 'اختيار ملف',
    removePhoto: 'حذف الصورة',
    compression: 'لحظة…',
    noFileSelected: 'لم يتم اختيار ملف',
    compressionUnavailable: 'تعذر تصغير الصورة. سيتم استعمال الصورة الأصلية.',
    photosSelected: 'تم اختيار {count} صورة',
    photoLimitReached: 'وصلت إلى الحد الأقصى: {max} صور.',
    removeAllPhotos: 'حذف كل الصور',
    proofPhoto: 'الصورة {index}',
    qrScanner: {
      label: 'ماسح رمز QR',
      httpsRequired: 'لا تعمل الكاميرا إلا باتصال آمن (HTTPS). اكتب الرمز أدناه.',
      cameraUnavailable: 'الكاميرا غير متاحة على هذا الجهاز.',
      cameraDenied: 'تم رفض الوصول إلى الكاميرا أو لم تبدأ بالعمل.'
    },
    packageVerification: 'التحقق من الطرد',
    start: 'ابدأ',
    stop: 'إيقاف',
    qrHelp: 'وجّه الكاميرا نحو رمز QR على الطرد.',
    manualPackageCode: 'أو اكتب رمز الطرد',
    confirm: 'تأكيد',
    signaturePad: 'مكان التوقيع',
    proofOfDelivery: 'إثبات التسليم',
    clear: 'مسح',
    signatureReady: 'تم أخذ التوقيع.',
    signatureTooSmall: 'التوقيع صغير جدا. وقّع بحجم أكبر داخل الإطار.',
    signatureRequired: 'توقيع الزبون مطلوب.'
  },
  sync: {
    synced: 'تم الإرسال',
    pending: 'في الانتظار',
    syncing: 'جارٍ الإرسال',
    failed: 'فشل الإرسال',
    conflict: 'مشكل يحتاج مراجعة',
    conflictProofRetained: 'الإثبات محفوظ على هذا الهاتف. اطلب المراجعة قبل إرساله من جديد.',
    inProgressRetry: 'الخادم ما زال يعمل. حاول بعد ثوان. الإثبات محفوظ.',
    offline: 'لا يوجد اتصال',
    title: 'إرسال البيانات',
    description: 'عند انقطاع الشبكة تُحفظ إجراءاتك في الهاتف وتُرسل عند عودة الاتصال.',
    emptyQueue: 'لا شيء للإرسال',
    syncNow: 'إرسال الآن'
  },
  wallet: {
    wallet: 'المحفظة',
    label: 'محفظتي',
    title: 'أموالي',
    description: 'رصيدك وعمولاتك وحركات أموالك.',
    backendUnavailable: 'الخدمة غير متاحة',
    noBackendAgent: 'لا يوجد وكيل',
    noBackendAgentDescription: 'ستظهر المحفظة عند وجود وكيل.',
    profit: 'أرباحي',
    totalCommissionDescription: 'مجموع العمولات عن الطرود المسلّمة.',
    packagesCount: '{count} طرد',
    noDeliveredProfit: 'لا أرباح بعد',
    noDeliveredProfitDescription: 'ستُضاف هنا عمولة كل طرد يتم تسليمه.',
    history: 'السجل',
    movements: 'الحركات',
    filters: {
      profit: 'الأرباح',
      cod: 'المبالغ المحصّلة',
      withdrawal: 'السحب',
      all: 'الكل'
    },
    searchPlaceholder: 'ابحث عن طرد أو نوع…',
    loadingHistory: 'جارٍ التحميل…',
    noEntries: 'لا توجد حركات',
    noEntriesDescription: 'لا توجد حركات تطابق هذا الفلتر.',
    summary: 'الملخص',
    availableToSettle: 'المتاح الآن',
    pendingPayout: 'بانتظار الدفع',
    completedThisWeek: 'المكتملة هذا الأسبوع',
    availableFromApi: 'الرصيد المتاح',
    reservedCod: 'مبالغ للتحصيل',
    withdrawableBalance: 'الرصيد القابل للسحب',
    deliveredWeek: 'المسلّمة هذا الأسبوع',
    statuses: {
      credited: 'مضاف',
      pending: 'في الانتظار',
      withdrawn: 'مسحوب'
    },
    movementsCount: '{count} حركة',
    loadFailed: 'تعذر تحميل المحفظة.',
    balance: 'الرصيد',
    available: 'المتاح',
    withdrawable: 'قابل للسحب',
    reserved: 'محجوز',
    courierFinance: 'أموالي',
    collections: 'المبالغ المحصّلة',
    courierDescription: 'عمولاتك ومدفوعاتك المرتبطة بجولاتك.',
      courierUnavailable: 'المحفظة قريبا',
      courierUnavailableDescription: 'محفظة الموزّع غير متاحة بعد.',
      requestWithdrawal: 'طلب سحب',
      withdrawalAmount: 'المبلغ بالدرهم',
      withdrawalMethod: 'طريقة الدفع',
      withdrawalNote: 'ملاحظة (اختياري)',
      mobileWallet: 'محفظة الهاتف',
      bankTransfer: 'تحويل بنكي',
      withdrawalHelp: 'يُحجز المبلغ فورا. يؤكد فريق 3asass الدفع أو يرفض الطلب.',
      withdrawalSubmitted: 'تم إرسال الطلب. يبقى المبلغ محجوزا حتى يقرر الفريق.',
      withdrawalFailed: 'تعذر إرسال طلب السحب.',
      withdrawalAmountInvalid: 'أدخل مبلغا أكبر من صفر.',
      withdrawalQueue: 'طلبات السحب',
      withdrawalQueueHelp: 'تحقق من المبلغ والمستفيد. للدفع أدخل مرجع التحويل، وللرفض أدخل السبب.',
      withdrawalQueueEmpty: 'لا توجد طلبات سحب.',
      withdrawalDecisionInput: 'مرجع الدفع أو سبب الرفض',
      withdrawalDecisionHint: 'هذا الحقل مرجع إن دفعت، وسبب إن رفضت.',
      markPaid: 'تسجيل كمدفوع',
      rejectWithdrawal: 'رفض الطلب',
      withdrawalPaid: 'تم تسجيل الدفع.',
      withdrawalRejected: 'تم رفض الطلب وعاد المبلغ إلى الرصيد.',
      withdrawalStatuses: { pending: 'في الانتظار', paid: 'مدفوع', rejected: 'مرفوض' }
  },
  layout: {
    adminControl: 'مساحة الإدارة',
    operationsPortal: 'مساحة العمل',
    secureAccess: 'دخول آمن',
    roleEntry: 'حساب واحد لكل تطبيقاتك.',
    authDescription: 'سجّل الدخول مرة واحدة وسيفتح حسابك تطبيق عملك.',
    fieldOtp: 'الدخول برمز',
    fieldOtpDescription: 'يسجل الوكلاء والموزّعون الدخول برمز يصلهم على هواتفهم.',
    admin2fa: 'تحقق مزدوج',
    admin2faDescription: 'تتطلب الإدارة كلمة مرور ورمز تحقق.',
    operationsConsole: 'لوحة 3asass.ma',
    backToRoles: 'العودة إلى اختيار المساحة'
  },
  errors: {
    requestFailed: 'لم ينجح الأمر',
    loadingFailed: 'تعذر التحميل',
    unauthenticated: 'انتهت جلستك. سجّل الدخول من جديد.',
    notFoundTitle: 'الصفحة غير موجودة',
    notFoundDescription: 'هذه الصفحة غير موجودة.',
    goHome: 'العودة إلى الرئيسية',
    noData: 'لا شيء للعرض',
    resultsWillAppear: 'ستظهر النتائج هنا.',
    search: 'بحث…'
  },
  actions: {
    scan_reception: 'مسح الطرد المستلم',
    confirm_reception: 'تأكيد الاستلام',
    start_delivery: 'بدء التوصيل',
    capture_pod: 'التسليم للمستلم',
    report_exception: 'الإبلاغ عن مشكل',
    request_return: 'طلب الإرجاع',
    deposit_return: 'تسليم المرتجع',
    mark_en_route: 'في الطريق',
    scan_drop: 'مسح التسليم',
    capture_lot_photo: 'صورة الطرود',
    confirm_handover: 'رمز الوكيل',
    close_drop: 'إنهاء التسليم',
    collect_return: 'أخذ المرتجع',
      confirm_sender_return: 'تسليم للمرسل',
    view_pod: 'عرض الإثبات',
    open_litigation: 'فتح نزاع',
    retry_by_admin: 'إعادة محاولة التوصيل',
    return_to_sender: 'إرجاع إلى المرسل',
    resolve_as_delivered: 'تسوية: تم التسليم',
    resolve_as_failed: 'تسوية: فشل',
    confirm_failed: 'تأكيد الفشل',
    accept_damaged: 'قبول مع ملاحظة',
    clear_agent: 'إعفاء الوكيل',
    confirm_loss_agent_fault: 'فقدان بسبب الوكيل',
    declare_cod_loss: 'التصريح بالفقدان',
    cancel: 'إلغاء',
    run_settlement: 'بدء التسوية',
    confirm_customer_handover: 'تأكيد التسليم',
    create_pickup_handover: 'تجهيز التسليم',
    collect_pickup: 'أخذ'
  },
  walletEntryTypes: {
    commission_earned: 'عمولة مكتسبة',
    cod_reserve: 'مبلغ للتحصيل',
    cod_release: 'تحرير مبلغ محصّل',
    cod_loss: 'مبلغ مفقود',
    float_topup: 'شحن الرصيد',
    platform_fee: 'رسوم 3asass',
    withdrawal_request: 'طلب سحب',
    withdrawal_paid: 'سحب مدفوع',
    withdrawal_reversal: 'سحب ملغى'
  },
  user: {
    login: {
      title: 'مساحة الزبون',
      help: 'سجّل الدخول بحساب 3asass الخاص بك.',
      submit: 'تسجيل الدخول',
      no_account: 'ليس لديك حساب؟',
      signup: 'إنشاء حساب'
    },
    dashboard: {
      welcome: 'مرحباً {name}',
      user: 'زبون',
      cards: {
        packages: {
          title: 'طرودي',
          desc: 'تابع طرودك بسهولة.'
        },
        tracking: {
          title: 'تتبع مباشر',
          desc: 'شاهد أين طردك.'
        },
        placeholder: {
          title: 'قريبا',
          desc: 'ستتوفر مزايا أخرى قريبا.'
        }
      },
      coming_soon: {
        title: 'قريبا',
        desc: 'ستتوفر مزايا أخرى قريبا.'
      }
    },
    nav: {
      dashboard: 'الرئيسية',
      profile: 'ملفي الشخصي'
    },
    logout: 'تسجيل الخروج'
  },
  platform: {
    packages: {
      label: 'طرودي',
      title: 'طرودي',
      description: '{count} طرد',
      empty: 'لا توجد طرود بعد',
      loadFailed: 'تعذر تحميل الطرود',
      createdAt: 'تاريخ الإنشاء',
      recipient: 'المستلم',
      relay: 'نقطة التسليم',
      relayName: 'اسم النقطة',
      relayAddress: 'عنوان النقطة',
      track: 'تتبع',
      timeline: 'التتبع',
      noTimeline: 'لا يوجد تتبع بعد',
      requestReturn: 'طلب إرجاع',
      requestCancellation: 'طلب الإلغاء',
      cancelRequestTitle: 'إلغاء الطرد',
      cancelRequestExplainer: 'الطرد لم يعد عندك. نطلب موافقة الفريق ثم يُعاد إليك الطرد قبل إلغائه.',
      cancelRequestReason: 'السبب (اختياري)',
      cancelRequestSubmit: 'إرسال الطلب',
      cancelRequestSubmitted: 'تم إرسال طلب الإلغاء.',
      cancelRequestFailed: 'تعذر إرسال الطلب.',
      cancelRequestPending: 'ننظر في طلبك. يواصل الطرد طريقه حتى نرد.',
      cancelRequestApproved: 'تم قبول الإلغاء. الطرد عائد إليك. افتح تعليمات الإرجاع لترى النقطة ورمزك عند وصول الطرد.',
      cancelRequestRejected: 'تم رفض الإلغاء. راجع التتبع لمعرفة أين وصل الطرد.',
      cancelRequestCompleted: 'تم إلغاء الطرد واسترجاعه.',
      packageInfo: 'معلومات الطرد',
      city: 'المدينة',
      assignedAgent: 'الوكيل',
      trackingCode: 'رمز التتبع',
    },
    label: 'المنصة',
    city: 'المدينة',
    noTimeline: 'لا يوجد جدول زمني متاح',
    packageInfo: 'معلومات الطرد',
    relayName: 'اسم نقطة الاستلام',
    relayAddress: 'عنوان نقطة الاستلام',
    requestReturn: 'طلب إرجاع',
    timeline: 'الجدول الزمني',
    track: 'تتبّع',
    assignedAgent: 'الوكيل المُكلَّف',
    dashboard: {
      title: 'مساحة المنصة',
      welcome: 'مرحبا {name}',
      user: 'مستخدم',
      cards: {
        landing: {
          title: 'منصة 3asass',
          desc: 'الوصول إلى المنصة المركزية 3asass.'
        },
        placeholder: {
          title: 'قريبا',
          desc: 'ستتوفر مزايا أخرى قريبا.'
        }
      },
      coming_soon: {
        title: 'قريبا',
        desc: 'ستتوفر مزايا أخرى قريبا.'
      }
    },
    nav: {
      dashboard: 'الرئيسية',
      requests: 'طلباتي',
      returnRequests: 'البلاغات',
      packages: 'الطرود',
    },
    logout: 'تسجيل الخروج',
    requests: {
      title: 'طلباتي',
      submitter: 'أرسله',
      description: '{count} طلب',
      newTitle: 'طلب جديد',
      newDescription: 'أرسل طلبا ليستلم وكيل طردك.',
      newRequest: 'طلب جديد',
      backToList: 'العودة إلى القائمة',
      whatNext: 'وماذا بعد؟',
      nextPending: 'نراجع طلبك. سنخبرك فور قبوله.',
      nextRejected: 'تم رفض هذا الطلب.',
      nextConverted: 'تم إنشاء طردك. تابعه أدناه.',
      nextCancelled: 'لقد ألغيت هذا الطلب.',
      keyFacts: 'الأساسيات',
      changeDestination: 'تغيير الوجهة',
      cancelRequest: 'إلغاء الطلب',
      deleteRequest: 'حذف الطلب',
      cancelParcel: 'إلغاء الطرد',
      cancelParcelBlocked: 'تم تسليم الطرد بالفعل ولم يعد ممكنا إلغاؤه.',
      cancelRequestConfirmTitle: 'إلغاء هذا الطلب؟',
      cancelRequestConfirmBody: 'سيتم إلغاء الطلب ولن يُنشأ أي طرد.',
      deleteRequestConfirmTitle: 'حذف هذا الطلب؟',
      deleteRequestConfirmBody: 'سيُحذف الطلب نهائيا.',
      cancelParcelConfirmTitle: 'إلغاء هذا الطرد؟',
      cancelParcelConfirmBody: 'لم يتم تسليم الطرد بعد وسيتم إلغاؤه.',
      confirmCancelAction: 'نعم، ألغِ',
      confirmDeleteAction: 'نعم، احذف',
      confirmChangeAction: 'تأكيد',
      outcomeCancelled: 'تم إلغاء الطلب',
      outcomeDeleted: 'تم حذف الطلب',
      outcomeParcelCancelled: 'تم إلغاء الطرد. لم يكن قد سُلّم بعد.',
      outcomeDestinationChanged: 'تم تغيير الوجهة',
      changeDestinationTitle: 'الوجهة الجديدة',
      changeDestinationHint: 'اختر النقطة التي ستستقبل الطرد.',
      editDetails: 'تعديل المعلومات',
      changePickup: 'تغيير نقطة الإيداع',
      changePickupTitle: 'نقطة الإيداع الجديدة',
      changePickupHint: 'اختر الوكيل الذي ستترك عنده الطرد.',
      noAlternativePickupHint: 'لا توجد نقطة إيداع أخرى الآن. حاول لاحقا أو تواصل معنا.',
      confirmPickupAction: 'تأكيد هذه النقطة',
      outcomePickupChanged: 'تم تغيير نقطة الإيداع',
      currentlyLabel: 'حاليا',
      moreDetails: 'تفاصيل أخرى',
      requestFacts: 'معلومات الطلب',
      reference: 'المرجع',
      submittedOn: 'تاريخ الإرسال',
      cashOnDelivery: 'يُدفع عند التسليم',
      relay: 'نقطة التسليم',
      zone: 'الحي',
      amountDue: 'المبلغ المطلوب',
      followPackage: 'تتبع الطرد',
      deliveryPoint: 'نقطة التسليم',
      deliveryPointHint: 'اختر النقطة التي تريد استلام طردك فيها. سيؤكد فريقنا اختيارك.',
      noResidencesHint: 'لا توجد نقطة متاحة الآن. يمكنك إرسال الطلب رغم ذلك.',
      detailTitle: 'تفاصيل الطلب',
      stepHandOverTitle: 'أين تسلّم الطرد',
      stepRecipientTitle: 'من سيستلم الطرد',
      stepRecipientHint: 'يتصل الموزّع بهذا الرقم قبل أن يأتي. اكتب عنوانا كاملا.',
      pickupAddress: 'عنوانك',
      pickupSearchAddress: 'العنوان المراد البحث عنه',
      pickupAddressHint: 'اختياري. يُستعمل لإيجاد أقرب النقاط إليك. تسلّم الطرد في النقطة التي تختارها.',
      recipient: 'المستلم',
      recipientName: 'اسم المستلم',
      recipientPhone: 'الهاتف',
      createdAt: 'تاريخ الإنشاء',
      recipientAddress: 'عنوان التوصيل',
      recipientAddressHint: 'سيذهب الموزّع إلى هذا العنوان.',
      notes: 'ملاحظات',
      notesPlaceholder: 'معلومات أخرى…',
      notesHint: 'اختياري: الطابق، رمز العمارة، الوقت المفضل…',
      submit: 'إرسال الطلب',
      summarySelected: 'نقطة الإيداع المختارة: {point}',
      summaryUnselected: 'لم تختر نقطة. ستُحدَّد عند قبول الطلب.',
      created: 'تم إرسال الطلب',
      createFailed: 'لم يتم إرسال الطلب',
      loadFailed: 'تعذر التحميل',
      rejectionReason: 'سبب الرفض',
      convertedPackage: 'الطرد المنشأ',
      viewPackage: 'عرض الطرد',
      approve: 'قبول',
      reject: 'رفض',
      approved: 'تم قبول الطلب',
      rejected: 'تم رفض الطلب',
      actionFailed: 'لم ينجح الأمر',
      approveTitle: 'قبول الطلب',
      approveDescription: 'اختر النقطة.',
      rejectTitle: 'رفض الطلب',
      rejectDescription: 'اكتب سبب الرفض.',
        residence: 'النقطة (المعرّف)',
        residencePlaceholder: 'معرّف النقطة',
        selectResidence: 'اختر نقطة من الخريطة',
        residencesLoadFailed: 'تعذر تحميل النقاط',
        selectedResidenceInfo: 'ستُربط النقطة المختارة على الخريطة بهذا الطلب.',
        destinationRequired: 'اختر نقطة الوجهة. بدونها لا يمكن قبول الطلب.',
        customerCredit: 'رصيد الزبون',
        codAmount: 'المبلغ المطلوب (سنتيم)',
      codPlaceholder: '0',
      adminLabel: 'الطلبات',
      adminTitle: 'طلبات الزبائن',
      searchPlaceholder: 'بحث…',
      empty: 'لا توجد طلبات بعد',
      statuses: {
        pending: 'في الانتظار',
        approved: 'مقبول',
        rejected: 'مرفوض',
        converted: 'تم إنشاء الطرد',
        cancelled: 'ملغى',
        declined: 'اختر نقطة أخرى',
      },
    },
    returnRequests: {
      title: 'بلاغاتي',
      description: '{count} بلاغ',
      loadFailed: 'تعذر تحميل البلاغات',
      empty: 'لا توجد بلاغات بعد',
      searchPlaceholder: 'ابحث بالرمز أو الاسم أو الهاتف أو العنوان…',
      packageCode: 'الطرد',
      packageStatus: 'مرحلة الطرد',
      status: 'الرد على البلاغ',
      requestedAt: 'تاريخ الطلب',
      reviewedAt: 'تاريخ الرد',
      openPackage: 'عرض الطرد',
    },
  },
  platformPickup: {
    pendingTitle: 'إيداعاتي',
    pendingHint: 'تابع طرودك التي ستسلّمها، وألغِ التي تنتظر تأكيدك.',
    chosenPoint: 'النقطة المختارة',
    awaitingApproval: 'في انتظار الرد',
    filterAll: 'الكل',
    filterCancellable: 'قابلة للإلغاء',
    listSummary: '{total} إيداع · {cancellable} قابل للإلغاء',
    cancellableBadge: 'قابل للإلغاء',
    agentLabel: 'الوكيل',
    noPickupsTitle: 'لا توجد إيداعات جارية',
    noPickupsDescription: 'ستظهر هنا الطرود التي ستسلّمها عند إنشائك واحدا.',
    noneCancellableTitle: 'لا شيء للإلغاء',
    cancelBlockedHint: 'لم يعد بإمكانك الإلغاء: الوكيل استلم الطرد بالفعل.',
    backToPackages: 'عرض طرودي',
    stepTitle: 'اختر أين تسلّم طردك',
    stepHint: 'تترك الطرد عند وكيل ثم يأخذه موزّع ويوصله إلى وجهته.',
    stepLabel: 'نقطة الإيداع',
    pickPoint: 'اختر نقطة إيداع',
    changePoint: 'تغيير النقطة',
    noPoints: 'لا توجد نقطة إيداع متاحة',
    noPointsHint: 'لا يوجد وكيل قرب هذا العنوان يستقبل الطرود حاليا.',
    noPointsDisabled: 'خدمة الإيداع غير متاحة بعد.',
    searchArea: 'ابحث في هذه المنطقة',
    useMyLocation: 'استخدام موقعي',
    locating: 'جارٍ تحديد موقعك…',
    locationLocated: 'تم تحديد موقعك. النقاط مرتبة حولك.',
    locationUnsupported: 'متصفحك لا يستطيع تحديد موقعك.', locationInsecure: 'لا يعمل تحديد الموقع إلا باتصال آمن (https).',
    locationDenied: 'تم رفض الوصول إلى الموقع. اسمح به أو اكتب عنوانك.',
    locationTimeout: 'استغرق تحديد موقعك وقتا طويلا. حاول مجددا أو اكتب عنوانك.',
    mapInstruction: 'المس الخريطة أو حرّك العلامة لتغيير منطقة البحث.',
    radiusKm: 'ضمن {distance} كم منك',
    pointDistance: 'على بعد {distance} كم',
    pointSelected: 'النقطة المختارة',
    nearest: 'الأقرب',
    residenceOnly: 'في عمارتي فقط',
    cardTitle: 'نقطة الإيداع',
    cardWaiting: 'ينتظر عند الوكيل',
    cardReady: 'الموزّع قادم لأخذه',
    cardCollected: 'في الطريق',
    cardCancelled: 'ملغى',
    creditTitle: 'رصيدي',
    creditSubtitle: 'الرصيد يُستعمل لدفع ثمن التوصيل ولا يُسترجع.',
    creditBalance: 'رصيد الكريدي',
    creditAvailable: 'الرصيد المتاح',
    creditExposed: 'الرصيد المحجوز',
    creditThreshold: 'حد التنبيه',
    creditFeePerDelivery: '{amount} {currency} لكل توصيل',
    topupTitle: 'شحن رصيدي',
    topupAmount: 'المبلغ المطلوب',
    topupAmountPlaceholder: 'المبلغ بالدرهم',
    topupNote: 'سبب الطلب',
    topupNotePlaceholder: 'مثال: عدة طرود هذا الأسبوع',
    topupSubmit: 'طلب شحن',
    topupHistory: 'سجل الشحن',
    topupRequests: 'طلبات الشحن الخاصة بي',
    topupPending: 'في الانتظار',
    topupApproved: 'مقبول',
    topupRejected: 'مرفوض',
    downloadCsv: 'تحميل ملف CSV',
    cancelTitle: 'إلغاء طلبي',
    cancelHint: 'ألغِ هذا الطلب قبل أن يؤكد الوكيل الإيداع.',
    cancelReason: 'لماذا تلغي؟',
    cancelReasonPlaceholder: 'أخبرنا بالسبب',
    cancelSubmit: 'تأكيد الإلغاء',
    cancelConfirmTitle: 'تأكيد الإلغاء',
    cancelConfirmBody: 'سيتم إلغاء طلبك ولا يمكن التراجع.',
    cancelSuccess: 'تم إلغاء الطلب',
    insufficientCredit: 'رصيدك لا يكفي لهذا التوصيل.',
    typeOffNotice: 'هذه الخدمة غير متاحة لهذا النوع من الإرسال.',
  },
}

const maSpecific = {
  adminAgentDetail: {
    deliveriesLabel: 'التوصيلات',
    successRateLabel: 'نسبة النجاح',
    residenceProofShort: 'إثبات السكنى',
    residenceProofHelp: 'فاتورة، شهادة ولا إثبات فالبلاصة.',
    residenceProof: 'إثبات السكنى',
    reserved: 'محجوز',
    wallet: 'المحفظة',
    sheet: 'ملف الكارديان',
    backendUnavailable: 'الخدمة ماشي متاحة',
    actionDenied: 'العملية ترفضات',
    loadFailed: 'ما قدرناش نحملو الكارديان.',
    actionFailed: 'ما نجحاتش.',
    mediaLoadFailed: 'ما قدرناش نحملو وثائق الهوية.',
    copyAgentId: 'نسخ ID ديال الكارديان',
    copyResidenceId: 'نسخ ID ديال النقطة',
    guaranteeAvailable: 'الضمانة المتاحة',
    relay: 'النقطة',
    exceptions: 'المشاكل: {rate}%',
    checklist: 'اللي خاصو يتشاف',
    preactivation: 'قبل التفعيل',
    kyc: 'الهوية',
    agentDocuments: 'وثائق الكارديان',
    validateKyc: 'أكد الهوية',
    agentInfo: 'معلومات الكارديان',
    profileDetails: 'تفاصيل البروفيل',
    agentInfoHelp: 'بدل البروفيل بلا ما تعاود تصاوب الحساب.',
    saveInfo: 'سجل',
    escrow: 'الضمانة',
    cashManagement: 'الفلوس اللي تسلمو',
    escrowHelp: 'سجل الفلوس اللي عطا الكارديان للمسؤول د التيران.',
    amountMad: 'المبلغ (درهم)',
    escrowNote: 'ملاحظة ضرورية، بحال: ضمانة البداية تسلمات كاش',
    record: 'سجل',
    escrowRule: 'مبلغ كثر من 0 درهم وملاحظة فيها 10 حروف على الأقل',
    escrowHistory: 'سجل الضمانات',
    escrowHistoryHelp: 'شحنات الضمانة اللي تسجلو فالمحفظة.',
    noEscrow: 'ماكاينة حتى ضمانة مسجلة لهاد الكارديان.',
    statusActions: 'بدل الحالة',
    statusActionsHelp: 'وقف مؤقت ولا وقف نهائي.',
    suspensionReason: 'سبب الوقف',
    requiredReason: 'السبب ضروري',
    suspend: 'وقف مؤقتا',
    confirmationName: 'السمية الكاملة باش تعطل',
    disable: 'عطل',
    suspensionRule: 'الوقف المؤقت: سبب فيه 10 حروف على الأقل. التعطيل: نفس السبب والسمية الكاملة بالضبط.',
    reassignResidence: 'بدل النقطة',
    reassign: 'بدل',
    returnsCap: 'الحد د الإرجاعات',
    adjust: 'بدل',
    unavailableDate: 'التاريخ ما معروفش',
    profileCompleted: 'البروفيل كامل',
    identityDoc: 'بطاقة التعريف',
    facePhotoShort: 'تصويرة الوجه',
    kycValidated: 'الهوية مأكدة',
    escrowRecorded: 'الضمانة مسجلة',
  },
  agentCreate: {
    residenceProofHelp: 'JPG، PNG ولا PDF. يمكن تزيدو من بعد.',
    residenceProof: 'إثبات السكنى',
    onboarding: 'تسجيل الكارديان',
  },
  packageCreate: {
    validationCod: 'مبلغ COD خاصو يكون رقم موجب ولا 0.',
    codAmountMad: 'مبلغ COD بالدرهم',
    intake: 'زيد كوليات',
    backendAutoAssign: 'اختيار أوتوماتيكي',
    assignedAgentHelp: 'اختياري. إلا بقا خاوي كيتختار الكارديان الخدام اللي عندو أقل خدمة فهاد النقطة.',
    backendDoes: 'شنو غادي يوقع من بعد',
    backendCreatesDelivery: 'كيتصاوب توصيل بوحدو فمرحلة «تصاوب».',
    backendAssignsAgent: 'كنحاولو نختارو كارديان خدام من نفس النقطة، اللي عندو أقل خدمة.',
    backendIdempotency: 'إلا صيفطتي جوج مرات بالغلط، غير كولي واحد غادي يتصاوب.',
  },
  auditViewer: {
    outcomes: {
      success: 'نجح',
      warning: 'خاص مراجعة',
      error: 'فشل'
    },
    legend: {
      wallet: 'المحفظة',
      exception: 'مشكل',
      package: 'كولي',
      auth: 'دخول',
    },
    label: 'السجل',
    title: 'كاليندري د العمليات',
    description: 'شوف العمليات المهمة نهار بنهار. فلتر بالدور، العملية، الموضوع ولا السبب ومن بعد حل التفاصيل.',
    loadFailed: 'ما قدرناش نحملو السجل.',
    filters: {
      actionPlaceholder: 'تبديل مرحلة، دخول، تعديل…',
      subjectPlaceholder: 'كولي، كارديان، محفظة…',
      reason: 'كود السبب',
    },
    focus: {
      empty: 'كليكي على حدث فالكاليندري ولا سطر فالجدول باش تشوف التفاصيل.',
    },
    table: {
      emptyTitle: 'ماكاين والو فالسجل',
      emptyDescription: 'العمليات المهمة غادي يبانو هنا.',
    },
  },
  common: {
    back: 'رجع',
    copied: 'تنسخ.',
    steps: 'المراحل',
    completed: 'مكمّل',
    installFromBrowser: 'التنزيل ممكن بChrome',
    sendVerificationCode: 'صيفط ليا كود',
    codeSentTo: 'الكود تصيفط ل {phone}',
    language: 'اللغة',
    french: 'الفرنسية',
    english: 'الإنجليزية',
    arabic: 'العربية',
    moroccan: 'الدارجة',
    profile: 'البروفيل',
    logout: 'خروج',
    healthySync: 'كلشي تصيفط',
    admin: 'الأدمن',
    agent: 'الكارديان',
    courier: 'الليفرور',
    partner: 'الشريك',
    partners: 'الشركاء',
    agents: 'الكارديانات',
    relay: 'النقطة',
    platform: 'البلاطفرم',
    account: 'الحساب',
    fieldManager: 'ماناجر ديال التيران',
    startPilot: 'بدا تجربة',
    phoneNumber: 'نمرة التيليفون',
    verificationCode: 'الكود اللي توصلتي بيه',
    resend: 'عاود صيفط',
    pleaseWait: 'تسنى شوية…',
    date: 'التاريخ',
    retry: 'عاود جرب',
    filtering: 'مفلتر بـ',
    searchPackages: 'المرجع، المستلم، النقطة…',
    verifyAndContinue: 'أكد وكمل',
    continue: 'كمل',
    previous: 'اللي قبل',
    next: 'اللي من بعد',
    loadMore: 'شوف كثر',
    loadingMore: 'كيتحمل…',
    filter: 'فلتر',
    reset: 'مسح الكل',
    all: 'الكل',
    allStates: 'كل المراحل',
    today: 'اليوم',
    thisWeek: 'هاد السيمانة',
    thisMonth: 'هاد الشهر',
    city: 'المدينة',
    notProvided: 'ما تعطاش',
    showFullText: 'بيّن العنوان كامل',
    showLess: 'بيّن أقل',
    required: 'ضروري',
    save: 'سجل',
    saved: 'تسجل',
    saving: 'كيتسجل…',
    confirm: 'أكد',
    confirmAction: 'أكد',
    cancel: 'لغي',
    close: 'سد',
    suspend: 'وقف مؤقتا',
    reactivate: 'فعل من جديد',
    approve: 'قبل',
    reject: 'رفض',
    action: 'عملية',
    actions: 'العمليات',
    type: 'النوع',
    amount: 'المبلغ',
    reason: 'السبب',
    status: 'الحالة',
    viewDetail: 'شوف التفاصيل',
    loadingImpossible: 'ما قدرناش نشحنو',
    openMenu: 'حل المينو',
    workspaceShell: 'مساحة الخدمة',
    search: 'قلب...',
    loading: 'كيشحن',
    copiedWithLabel: 'تنسخ {label}.',
    copy: 'نسخ',
    reasonCodes: {
      policyViolation: 'مخالفة القواعد',
      fraudSuspected: 'شك فالغش',
      inactivity: 'ما كاينش نشاط',
      escrowInsufficient: 'الضمان ما كافيش',
      other: 'آخر'
    },
    cod: 'الدفع عند الاستلام',
    kyc: 'التحقق ديال الهوية',
    ok: 'مزيان',
    mad: 'درهم',
    platformName: 'ثلاثاس',
    agentPrefix: 'الكارديان:',
    partnerPrefix: 'الشريك:',
    residenceIdPrefix: 'الإقامة:',
    packageId: 'ID ديال الكولي',
    deliveryId: 'ID ديال التوصيل',
    accountActions: 'الحساب ديالي',
    installApp: 'نزّل التطبيق',
    resendIn: 'عاود صيفط من بعد {seconds} ثانية',
    selectedFile: 'الملف اللي ختاريتي',
    selectedPdf: 'ملف PDF اللي ختاريتي',
    addFile: 'زيد ملف',
    replace: 'بدل',
    choose: 'ختار',
    chooseFile: 'ختار ملف',
    edit: 'بدل',
    refresh: 'حدث'
  },
  packageType: {
    normal: 'عادي',
    untracked: 'بلا تتبع',
    pickup: 'إيداع الزبون'
  },
  sampleDashboard: {
    title: 'داشبورد',
    description: 'شل عام ديال التطبيق مع حالات تحميل قابلة للاستعمال.',
    foundation: 'الأساس',
    skeletons: 'سكيليتونات',
    emptyState: 'حالة خاوية',
    placeholderTitle: 'محتوى مؤقت',
    placeholderDescription: 'هاد الصفحة كتجنب الموديولات ديال الخدمة.'
  },
  sampleSettings: {
    title: 'الإعدادات',
    description: 'كونترول عام باش نتأكدو من الكومبونونات المشتركة.',
    interface: 'الواجهة',
    interfaceDescription: 'خانات محايدة لتجربة الكومبونونات.',
    textInput: 'خانة نص',
    textarea: 'منطقة النص',
    selectOption: 'ختار خيار',
    default: 'ديفو',
    compact: 'مضغوط',
    enableOption: 'فعل الخيار عام',
    application: 'التطبيق',
    applicationDescription: 'أمثلة ديال PWA والنوتيفيكاسيون.',
    notificationExample: 'مثال نوتيفيكاسيون',
    showToast: 'بين إشعار',
    offlinePage: 'صفحة أوفلاين'
  },
  contact: {
    backHome: 'رجع للرئيسية',
    label: 'طلق التجربة',
    title: 'وجد التجربة ديال 3asass فزون حقيقية.',
    description: 'التجربة خاصها تبين حاجة بسيطة: بيبان أقل، فشل أقل، إثباتات كثر، وفلوس التوصيل أسهل فالمراجعة.',
    cityZone: 'مدينة ولا زون ديال التجربة',
    cityZoneValue: 'مراكش، كازا، الرباط...',
    packageVolume: 'عدد الكوليات المتوقع',
    packageVolumeValue: 'كوليات فالنهار ولا فالسيمانة',
    residenceNetwork: 'شبكة النقط',
    residenceNetworkValue: 'عدد العمارات ولا الكارديانات',
    currentOperation: 'الخدمة الحالية',
    currentOperationValue: 'الفشل، فلوس التوصيل، الإرجاعات، الإثباتات',
    formTitle: 'طلب التجربة',
    formDescription: 'هاد الفورم مازال ما تربطش. الإرسال موقوف دابا.',
    company: 'الشركة',
    companyPlaceholder: 'سمية الشركة',
    contact: 'كونتاكت',
    contactPlaceholder: 'سمية، تلفون ولا إيميل',
    pilotZone: 'زون التجربة',
    pilotZonePlaceholder: 'المدينة، الحي، عدد النقط',
    volumeContext: 'العدد والسياق',
    volumeContextPlaceholder: 'مثلا: 300 كولي فالسيمانة، بزاف د الفلوس اللي خاصها تتجمع، بزاف د الفشل…',
    submitSoon: 'صيفط الطلب قريباً',
    disabledNote: 'ما كيتصيفط حتى ميساج دابا.',
  },
  nav: {
    groups: { operations: 'الخدمة', network: 'الشبكة', finance: 'الفلوس', system: 'النظام' },
    overview: 'نظرة عامة',
    settings: 'الإعدادات',
    packages: 'الكوليات',
    createPackage: 'صاوب',
    returnRequests: 'التبليغات والرجوعات',
    returnIncidents: 'رجوعات معطلة',
    cancellationRequests: 'طلبات الإلغاء',
    orderRequests: 'طلبات المنصة',
    partners: 'الشركاء',
    customers: 'الزبناء',
    exceptions: 'المشاكل',
    agents: 'الكارديانات',
    residences: 'النقط',
    couriers: 'الليفرورات',
    settlements: 'التسويات',
    withdrawals: 'السحوبات',
    configuration: 'الإعدادات',
    platformConfig: 'الإعدادات',
    audit: 'السجل',
    dashboard: 'داشبورد',
    route: 'الدورة',
    drop: 'التسليم',
    sessions: 'التسليمات',
    handovers: 'اللي جاو',
    returns: 'الإرجاعات',
    scan: 'سكاني',
    sync: 'الإرسال',
    balance: 'الرصيد',
    submitPackage: 'زيد كولي',
    creditAccount: 'الكريدي',
    reports: 'التقارير',
    profile: 'البروفيل',
    logOut: 'خروج',
    home: 'الرئيسية',
    money: 'الفلوس',
    pickups: 'الإيداعات'
  },
  pwa: {
    home: 'الرئيسية',
    roles: {
      agent: 'الكارديان',
      courier: 'الليفرور',
      customer: 'الزبون',
    },
    greeting: 'السلام {name}',
    greetingFallback: 'السلام',
    buckets: {
      action: 'خاصك دير',
      problems: 'المشاكل',
      done: 'اللي سالاو',
      incoming: 'اللي جايين',
      ready: 'واجدين للتسليم',
      pickup: 'باش تجمعهم',
    },
    scan: 'سكاني',
    packagesNav: 'الكوليات',
    pickups: 'الإيداعات',
    lifecycle: { all: 'كل المراحل' },
    filters: { title: 'فلتر', stageHint: 'بيّن غير الكوليات ديال مرحلة وحدة.' },
    returns: 'الإرجاعات',
    money: 'الفلوس',
    profile: 'البروفيل ديالي',
    logout: 'خروج',
    online: 'كاين النيت',
    offline: 'ماكاينش النيت',
    wallet: {
      available: 'الرصيد اللي تقدر تاخد',
      reservedCod: 'الفلوس اللي خاصك تاخد',
      weeklyDelivered: 'اللي تسلمو هاد السيمانة',
      earnings: 'الربح ديالي',
      perParcel: 'على كل كولي',
      seeEarnings: 'شوف الربح ديالي',
      viewDetails: 'شوف التفاصيل',
    },
    actions: {
      scan: 'سكاني',
      scanDesc: 'بكود QR',
      more: 'عمليات أخرى ({count})',
      create: 'صاوب',
      createDesc: 'كولي جديد',
      handovers: 'اللي جاو',
      handoversDesc: 'الكوليات اللي توصلو',
      returns: 'الإرجاعات',
      returnsDesc: 'الكوليات اللي رجعو',
    },
    todayDeliveries: {
      title: 'باش توصل اليوم',
      empty: 'ماكاين حتى كولي باش توصل اليوم.',
      cod: 'المبلغ اللي خاصك تاخد',
      phone: 'التيليفون',
      address: 'العنوان',
    },
    packages: {
      title: 'الكوليات ديالي',
      searchPlaceholder: 'قلب على كولي…',
      filterAll: 'الكل',
      filterPending: 'كيتسناو',
      filterInProgress: 'فالطريق',
      filterDelivered: 'توصلو',
      empty: 'ماكاين حتى كولي.',
      loadFailed: 'ما قدرناش نحملو الكوليات.',
      bulk: {
        title: 'ختار بزاف د الكوليات',
        hint: 'حدد بزاف د الكوليات وردد العملية مرة وحدة.',
        enter: 'ختار الكوليات',
        exit: 'سالا',
        selectLoaded: 'ختار الكل ({count})',
        selectedCount: 'ختاريتي {count} د الكوليات',
        noEligible: 'حتى كولي من هادو ما يمكنش دير هاد العملية.',
        clear: 'حيد التحديد كامل',
        remove: 'حيدو',
        reviewTitle: 'الكوليات اللي ختاريتي',
        reviewEmpty: 'مازال ما ختاريتي والو.'
      },
    },
  },
  dashboard: {
    loadAgentWalletFailed: 'ما قدرناش نحملو المحفظة ديالك.',
    courierLabel: 'الليفرور',
    courierTitle: 'الدورة ديالي اليوم',
    courierDescription: 'سكاني الكوليات عند الكارديان، صور ومن بعد سالي التسليم.',
    startDrop: 'بدا تسليم',
    packageSearchPlaceholder: 'الكود، المستلم، التيليفون، العنوان…',
    loadingPackages: 'كيتحمل…',
    loadingRoute: 'كيتحمل…',
    noPackagesWithFilters: 'ماكاين حتى كولي بهاد الفلاتر.',
    loadAgentPackagesFailed: 'ما قدرناش نحملو الكوليات ديالك.',
    loadRouteFailed: 'ما قدرناش نحملو الدورة.',
    backendActionPending: 'هاد العملية مازال ماشي متاحة.',
    actionQueued: 'العملية تحفظات فالتيليفون وغادي تتصيفط ملي يرجع النيت.',
    actionSynced: 'العملية تصيفطات.',
    actionRejected: 'العملية ما تقبلاتش.',
    returnRequestedByResident: 'الإرجاع خاصو يتطلب الأول من صفحة التتبع ولا من الفريق. من بعد تقدر تحطو.',
    enRouteStarted: 'نتا فالطريق للنقطة.',
    bulkStartDelivery: 'بدا التوصيل ({count})',
    bulkMarkEnRoute: 'فالطريق ({count})',
    loadTodayDeliveriesFailed: 'ما قدرناش نحملو توصيلات اليوم.',
    agentLabel: 'الكارديان',
    agentTitle: 'كوليات خاصك تعالج',
    agentDescription: 'الاستقبال، التسليم، المشاكل والفلوس من النقطة ديالك.'
  },
  auth: {
    phoneInvalid: 'دخل نمرة مع كود البلاد، بحال +212600000000.',
    fieldTitle: 'الدخول',
    fieldDescription: 'دخل نمرة التيليفون ديالك.',
    authenticatorCode: 'كود Authenticator',
    agentTitle: 'دخول الكارديان',
    agentDescription: 'دخل النمرة اللي مسجلة للنقطة ديالك.',
    agentTestPhone: 'كارديان تيست لوكال: +212600000010',
    courierTitle: 'دخول الليفرور',
    courierDescription: 'دخل نمرة التيليفون ديالك. إلا ماعندكش حساب غادي يتصاوب.',
    courierTestPhone: 'ليفور تيست لوكال: +212600000020',
    adminTitle: 'دخول الأدمن',
    workEmail: 'الإيميل ديال الخدمة',
    password: 'الكلمة السرية',
    adminTest: 'أدمن تيست لوكال: admin{\'@\'}example.com / password',
    setupAuthenticatorDescription: 'حل Google Authenticator ولا Authy، زيد حساب، ومن بعد سكانا هاد كود QR.',
    authenticatorQrAlt: 'كود QR ديال إعداد Authenticator',
    openSetupLink: 'حل لينك الإعداد',
    secretKey: 'المفتاح السري',
    activate2fa: 'فعل 2FA ودخل'
  },
  maps: {
    position: 'البلاصة',
    currentLocation: 'البلاصة ديالك',
    currentLocationUnavailable: 'ما قدرناش نلقاو البلاصة ديالك.',
    addressNotFound: 'العنوان ماكاينش.',
    routeCalculating: 'كنقلبو على الطريق…',
    routeUnavailable: 'الطريق ماكاينش.',
    basemapLabel: 'نوع الخريطة',
    basemap_streets: 'الشوارع',
    basemap_light: 'فاتحة',
    basemap_dark: 'غامقة',
    basemap_satellite: 'الستلايت',
    basemapFallback: 'الخريطة المفصلة ماكايناش. كتبان خريطة عادية.',
    openGoogleMaps: 'حل فGoogle Maps',
    regionLabel: 'الخريطة',
    routeRegionLabel: 'خريطة الطريق ل{place}',
    basemapHint: 'ختار الخريطة اللي كتبان مزيان.',
    locateMe: 'فين أنا؟',
    expand: 'كبّر الخريطة',
    collapse: 'صغّر الخريطة',
    zoomIn: 'كبّر',
    zoomOut: 'صغّر',
    credits: 'مصادر الخريطة',
    destination: 'الوجهة',
    departure: 'البداية',
    navigate: 'سير',
    arrivalLabel: 'الوصول تقريبا',
    kind: { agent: 'الكارديان', residence: 'النقطة', parcel: 'الكولي', collection: 'نقطة الجمع', place: 'البلاصة', return: 'نقطة الرجوع', pickupPoint: 'نقطة الجمع', deliveryPoint: 'نقطة التوصيل' },
    stopNumber: 'الوقفة {number}',
    previousStop: 'الوقفة اللي قبل',
    nextStop: 'الوقفة اللي من بعد',
    pointsCount: '{count} د النقط فالخريطة',
    pointsListLabel: 'النقط',
    selectOnMap: 'كليكي على علامة باش تشوف التفاصيل.',
    previousPoint: 'النقطة اللي قبل',
    nextPoint: 'النقطة اللي من بعد'
  },
  state: {
      created: 'تصاوب',
      en_route: 'فالطريق',
      dropped: 'تحط فالنقطة',
    received: 'تسلم',
    out_for_delivery: 'خرج للتوصيل',
    delivered: 'توصل',
    returned: 'تردّ للمرسل',
    returnedHint: 'الكولي تسلمو المرسل.',
    failed: 'ما نجحش',
    return_requested: 'الإرجاع تطلب',
    return_deposited: 'الإرجاع تحط',
    return_collected: 'الإرجاع تاخد',
    disputed: 'فيه مشكل',
    cancelled: 'تلغى',
    awaiting_pickup: 'كيتسنى التسليم',
    pickup_ready: 'واجد باش يتاخد'
  },
  category: {
    badge: 'مرحبا بيك فـ 3asass',
    title: 'شنو بغيتي؟',
    description: 'ختار الخدمة اللي محتاج.',
    enter: 'دخل',
    comingSoon: 'قريب',
    footer: '3asass — التوصيل ساهل وقريب ليك.',
    cards: {
      logistics: {
        title: 'اللوجيستيك',
        description: 'التوصيل قريب ليك: كارديانات، ليفرورات وتتبع مباشر.'
      },
      services: {
        title: 'الخدمات',
        description: 'خدمات للعمارات والسكان ديالها.'
      },
      marketplace: {
        title: 'السوق',
        description: 'بلاصة للبيع والشرا بين الساكنة والتجار.'
      }
    }
  },
  home: {
    hero: {
      badge: 'حل لوجيستيك جديد',
      titleBefore: 'نقصو',
      titleHighlight: 'فشل',
      titleAfter: ' التوصيل.',
      description: 'كنخليو الكارديانات د العمارات نقط تسليم. الليفرور كيحط الكولي عند كارديان موثوق، المستلم كيوصلو ميساج فواتساب، الإثبات كيتاخد والفلوس اللي خاصها تتجمع كتبقى مضبوطة.',
    },
    tracking: {
      placeholder: 'كود الكولي',
      aria: 'كود الكولي',
      submit: 'تبع الكولي ديالي'
    },
    returnRequest: {
      title: 'طلب الإرجاع',
      description: 'توصلتي بكولي وبغيتي ترجعو؟ صيفط لينا طلب.'
    },
    dashboard: {
      title: 'نبض الأدمن',
      live: 'لايف',
      delivered24h: 'توصلو (24 ساعة)',
      deliveredTrend: '+12.5% على البارح',
      codSecured: 'COD مأمن',
      reconcileToday: 'خاص يتطابق اليوم',
      packageRef: 'الكولي #3AS-2041',
      inTransit: 'فالطريق',
      receivedGuardian: 'توصلو الكارديان',
      notified: 'تصيفط الإشعار',
      exceptionAlert: 'كاين مشكل واحد فزون أنفا.',
      view: 'شوف'
    },
    problem: {
      titleBefore: 'آخر كيلومتر',
      titleHighlight: 'مكسور',
      description: 'الليفرورات ما محتاجينش مكالمات أكثر. محتاجين نقطة استلام موثوقة. 3asass كيحول بلاصة موجودة أصلاً لنقطة مراقبة متبعة.',
      cards: {
        failures: {
          title: 'فشل التوصيل كيتعاود',
          desc: 'ليفورات كيتسناو قدام بيبان مسدودين.'
        },
        transparency: {
          title: 'الشفافية ناقصة',
          desc: 'كوليات كيتعلمو فشلو بلا كونتكست موثوق.'
        },
        cash: {
          title: 'تسيير الكاش (COD)',
          desc: 'الكاش لي تخلص صعيب بزاف يتراقب ويتطابق.'
        },
        time: {
          title: 'وقت الليفرور كيمشي ضايع',
          desc: 'الرجوعات والمشاكل متفرقين بين المكالمات وواتساب.'
        }
      }
    },
    lifecycle: {
      badge: 'دورة الحياة ديال 3asass',
      titleLine1: 'الكولي فوسط',
      titleLine2: 'العملية.',
      description: 'فكل مرحلة، 3asass عارف شكون عندو الكولي، فاش رزيدونس كاين، شنو البروف، شحال ديال الكاش تخلص، وشنو الكوميسيون المستحق.',
      cta: 'شوف الدوك التقنية',
      items: {
        created: {
          state: 'مخلوق',
          label: 'تجيب من عند التاجر'
        },
        dropped: {
          state: 'متحط',
          label: 'تسكانا من الليفرور فالنقطة'
        },
        received: {
          state: 'متوصل',
          label: 'تأكد من الكارديان'
        },
        out: {
          state: 'خدام',
          label: 'تصيفط الإشعار للساكن'
        },
        delivered: {
          state: 'توصل',
          label: 'POD والكوميسيون تأكدو'
        }
      }
    },
    surfaces: {
      titleLine1: 'ثلاث واجهات،',
      titleLine2: 'حقيقة وحدة.',
      description: 'كل واحد عندو دور مناسب للخدمة ديالو، وكيتزامن فالوقت الحقيقي.',
      agent: {
        title: 'PWA ديال الكارديان',
        subtitle: 'للكارديان',
        metric: '42 كولي',
        items: {
          scan: 'سكانا كود QR',
          notify: 'صيفط إشعار للساكن',
          proof: 'شد التوقيع والتصويرة',
          wallet: 'طلب سحب من الواليت'
        }
      },
      courier: {
        title: 'PWA ديال الليفرور',
        subtitle: 'لليفور',
        metric: '8 دروبات',
        items: {
          route: 'شوف النقطة لي خاص تزور',
          scan: 'سكانا اللوط',
          photos: 'صور الكوليات',
          close: 'سد التورنية'
        }
      },
      admin: {
        title: 'بورتال الأدمن',
        subtitle: 'للعمليات',
        metric: '3 مشاكل',
        items: {
          track: 'تبع جميع الكوليات',
          proofs: 'شوف البروفات',
          wallets: 'خلص الواليتات',
          audit: 'دير أوديت للمشاكل'
        }
      }
    },
    proof: {
      titleLine1: 'البروف فوسط',
      titleLine2: 'الثقة.',
      description: 'بروف التوصيل ماشي تفصيل: كيحمي الأوبيراتور، التاجر، الساكن، والكارديان. حتى بلا ريزو، الأكسيونات كيبقاو مسجلين لوكال وكيتزامنو من بعد.',
      guarantee: '100% ديال التتبع مضمون',
      items: {
        signature: 'توقيع الساكن',
        photo: 'تصويرة الكولي',
        gps: 'بلاصة GPS',
        cod: 'مبلغ COD',
        offline: 'المزامنة أوفلاين',
        whatsapp: 'ميساج واتساب'
      }
    },
    portalCards: {
      title: 'ختار البلاصة ديالك',
      description: 'ختار شكون نتا باش تكمل.',
      agent: {
        title: 'الكارديان',
        description: 'استقبل الكوليات، سلمهم وتبع الفلوس ديالك.',
        cta: 'نزّل التطبيق'
      },
      courier: {
        title: 'الليفرور',
        description: 'حط الكوليات، جمع الإرجاعات وتبع الدورات ديالك.',
        cta: 'نزّل التطبيق'
      },
      admin: {
        title: 'الإدارة',
        description: 'تبع الخدمة، الكارديانات والمنصة.',
        cta: 'بلاصة الإدارة'
      },
      partner: {
        title: 'الشريك',
        description: 'تبع الكوليات، الفواتير والحساب ديالك.',
        cta: 'بلاصة الشريك'
      },
      user: {
        title: 'الزبون',
        description: 'صيفط كولي وتبعو.',
        cta: 'بلاصة الزبون'
      }
    }
  },
  download: {
    badge: 'تطبيق للتيليفون',
    agentTitle: 'نزّل تطبيق الكارديان',
    courierTitle: 'نزّل تطبيق الليفرور',
    agentDescription: 'نزّل 3asass فالتيليفون ديالك ومن بعد دخل بالنمرة ديالك.',
    courierDescription: 'نزّل 3asass فالتيليفون ديالك باش تسكاني الكوليات، تأكد التسليم وتبع الإرجاعات.',
    login: 'كمل للدخول',
    loginTitle: 'دخل',
    loginDescription: 'دخل لبلاصتك بنمرة التيليفون ديالك.',
    installTitle: 'نزّل',
    installDescription: 'حط التطبيق فالتيليفون ديالك.',
    installFallback: 'مع Chrome التنزيل مباشر. مع Firefox ولا Safari استعمل القائمة ديال المتصفح باش تزيد التطبيق للشاشة الرئيسية.',
    installHelp: {
      button: 'نزّل من هاد المتصفح',
      title: 'نزّل 3asass',
      description: 'إلا التنزيل ما بداش بوحدو، استعمل القائمة ديال المتصفح.',
      steps: {
        chromiumMenu: 'حل القائمة ديال المتصفح (التلات نقط، لفوق ولا لتحت).',
        chromiumInstall: 'كليكي على «تثبيت التطبيق» ولا «إضافة للشاشة الرئيسية».',
        firefoxMenu: 'حل القائمة ديال Firefox.',
        firefoxAdd: 'كليكي على «تثبيت» ولا «إضافة للشاشة الرئيسية».',
        safariShare: 'فiPhone كليكي على بوطون المشاركة فSafari.',
        safariAdd: 'ختار «إضافة للشاشة الرئيسية» ومن بعد أكد.'
      }
    },
    panelTitle: 'تنزيل سريع',
    panelDescription: 'التطبيق كيتنزل من Chrome بلا ما تدوز على Play Store.',
    menuDescription: 'دخول سريع لواجهات 3asass.',
    workflowMenuDescription: 'شوف كيفاش خدام دورة الحياة ديال الكولي.',
    agentMenuDescription: 'نزّل وحل بلاصة الكارديان.',
    courierMenuDescription: 'نزّل وحل بلاصة الليفرور.',
    partnerMenuDescription: 'دخل لبورتال الشريك.',
    contactMenuDescription: 'تاصل بالتيم باش تبدا التجربة.',
    adminMenuDescription: 'دخول خاص غير بالعمليات.',
    steps: {
      open: 'حل هاد الصفحة فChrome فالتيليفون ديالك.',
      install: 'كليكي على «تثبيت التطبيق» ولا «إضافة للشاشة الرئيسية».',
      login: 'حل أيقونة 3asass ودخل بالنمرة ديالك.'
    },
    cards: {
      installTitle: 'أيقونة فالتيليفون ديالك',
      installText: '3asass كيتحل بحال شي تطبيق عادي.',
      offlineTitle: 'بلا نيت',
      offlineText: 'ملي كيتقطع النيت، العمليات ديالك كتبقى محفوظة وكتتصيفط ملي يرجع.',
      secureTitle: 'دخول آمن',
      secureText: 'كتدخل بكود كيوصلك فالتيليفون والمعلومات ديالك محمية.'
    }
  },
  platformConfig: {
    courierWaitInput: 'أكثر وقت يتسنى فيه الليفرور (بالدقايق)',
    courierWaitHelp: 'من بعدو، الكولي الواجد عند الكارديان كيبان ف المشاكل. بين 15 و1440 دقيقة (120 = جوج سوايع).',
    requestAcceptInput: 'الوقت اللي عند الكارديان باش يجاوب (بالدقايق)',
    requestAcceptHelp: 'من بعدو، الطلب كيتّرفض عليه والكليان كيختار نقطة أخرى. بين 5 و1440 دقيقة (30 = 30 دقيقة، 720 = 12 ساعة).',
    label: 'مالية الأدمن',
    title: 'إعدادات الفلوس',
    description: 'حدد مصاريف الشريك، كوميسيون الكارديان على كل تسليم، خلاص الليفرور من بعد الاستلام فالنقطة، ومصاريف الزبون اللي كتتسجل وقت الإيداع.',
    loadFailed: 'ما قدرناش نشحنو الإعدادات.',
    saveFailed: 'ما قدرناش نحفظو الإعدادات.',
    saved: 'تحفظات إعدادات الفلوس.',
    actionImpossible: 'ماشي ممكن',
    partnerFee: 'مصاريف الشريك',
    partnerFeeDescription: 'مبلغ كيتنقص من كريدي الشريك على كل كولي توصل وتسوى.',
    agentCommission: 'كوميسيون الكارديان',
    agentCommissionDescription: 'مبلغ كيتزاد على كل تسليم كيكملو الكارديان، ملي الزبون يحط الكولي ولا ملي يتوصل المستلم.',
    platformRevenue: 'ربح البلاطفرم',
    platformRevenueDescription: 'تقدير لكولي ديال شريك: المصاريف ناقص جوج كوميسيونات ديال الكارديان وكوميسيون الليفرور.',
    settlementSettings: 'إعدادات التسوية',
    nextSettlements: 'المبالغ لي غادي يتطبقو فالتسويات الجاية',
    lastRead: 'آخر قراءة {time}',
    partnerFeeInput: 'مصاريف الشريك لكل توصيل (درهم)',
    partnerFeeHelp: 'مثال: 15 MAD غادي تخزن 1500 سنتيم.',
    agentCommissionInput: 'كوميسيون الكارديان لكل توصيل (MAD)',
    agentCommissionHelp: 'مثال: 10 MAD غادي تزيد للكارديان من بعد التسوية.',
    courierCommissionInput: 'أجرة الليفرور على كل كولي توصل (MAD)',
    courierCommissionHelp: 'كتتخلص مرة وحدة من بعد ما يأكد كارديان الوجهة الاستلام. الثمن كيتحفظ وقت الإنشاء والرجوع ما فيهش الخلاص.',
    negativeTitle: 'إعدادات خاسرة',
    negativeDescription: 'كوميسيونات الكارديان والليفرور كبر من مصاريف الشريك. غادي نخسرو {amount} على كل كولي.',
    exampleTitle: 'مثال بهاد القيم',
    exampleDescription: 'كولي ديال شريك: المصاريف {partnerFee}، جوج كوميسيونات ديال الكارديان د {agentCommission}، كوميسيون الليفرور {courierCommission}، الربح التقريبي {platformRevenue}.',
    existingSettlementsNote: 'الكوليات لي تسواو من قبل ما كيتعاودش حسابهم. هاد المبالغ كيتطبقو على التسويات الجاية.'
  },
  adminExceptions: {
    courierLateTitle: 'كوليات كيتسناو ليفرور ({count})',
    courierLateHint: 'واجدين عند الكارديان من كثر من {wait}. صيفط ليفرور ولا عيط للكارديان.',
    courierLateWaiting: 'كيتسنى من {time}',
    label: 'الليستة ديال الاستثناءات',
    title: 'المشاكل خاصهم يت عالجو',
    description: 'الفشل والمشاكل اللي بلغو عليها الكارديانات، الليفرورات ولا الفريق.',
    exception: 'مشكل',
    exceptionCode: 'كود المشكل',
    open: 'محلولين',
    failedPage: 'فاشلين فالصفحة',
    disputesPage: 'نزاعات فالصفحة',
    searchPlaceholder: 'كود، مول الكولي، تليفون، عنوان، كارديان...',
    emptyTitle: 'ما كاين حتى مشكل',
    emptyDescription: 'الكوليات لي فشلو ولا فيهم نزاع غادي يبانو هنا.',
    loadFailed: 'ما قدرناش نشحنو ليستة المشاكل.',
    resolved: 'المشكل تعالج.',
    resolutionRejected: 'القرار ما تقبلش.',
    resolutionDescription: 'زيد ملاحظة ديال العملية. غادي تتسجل فالأوديت.',
    resolutionPlaceholder: 'قرار الأدمن، عيطة للزبون، تبرير...',
    resolutionHelp: '3 حروف على الأقل. التعديلات بلا ملاحظة كيترفضو.',
  },
  adminDashboard: {
    label: 'اللوحة',
    title: 'الخدمة دابا',
    description: 'شوف شنو واقف، تبع الكارديانات الخدامين، حل الكوليات المستعجلين ومشي للتسويات ولا السجل.',
    backendUnavailable: 'الخدمة ماشي متاحة',
    loadFailed: 'ما قدرناش نحملو اللوحة.',
    loadQueueFailed: 'ما قدرناش نحملو لائحة الكوليات.',
    notAvailable: '—',
    refreshHint: 'كيتحدث كل 30 ثانية',
    importCsv: 'استورد ملف CSV',
    createPackage: 'صاوب كولي',
    loadingQueue: 'كيتحمل…',
    emptyQueue: 'ماكاين حتى كولي بهاد الفلتر.',
    kpis: {
      handoverTime: 'وقت التسليم',
      handoverHelp: 'قريب: من التسليم حتى الاستلام.',
      firstAttempt: 'نجحو من أول مرة',
      firstAttemptHelp: 'اللي توصلو اليوم بالمقارنة مع المشاكل المفتوحة.',
      podCompletion: 'الإثباتات الكاملة',
      podHelp: 'توصلنا بـ {count} إثباتات',
      activeAgents: 'الكارديانات الخدامين',
      activeAgentsHelp: 'حسابات الكارديانات الخدامين دابا.',
      exceptionRate: 'نسبة المشاكل',
      exceptionHelp: '{count} كوليات خاصهم معالجة'
    },
    search: {
      label: 'قلب على كولي',
      title: 'لقا وحل بسرعة',
      placeholder: 'المرجع، المستلم، التيليفون، الكارديان، النقطة…',
      submit: 'قلب'
    },
    filters: {
      active: 'الخدامين',
      dropped: 'اللي تحطو',
      received: 'اللي تسلمو',
      out: 'فالتوصيل',
      returns: 'الإرجاعات',
      exceptions: 'المشاكل'
    },
    decisions: {
      title: 'كيتسنى قرارك',
      cancellations: 'طلبات الإلغاء',
      cancellationsHint: 'كليان باغي يرجع الكولي ديالو',
      reports: 'المشاكل المبلّغ عليها',
      reportsHint: 'تبليغات الكليانة من بعد التسليم، ورجوعات بلا حساب',
      incidents: 'رجوعات معطلة',
      incidentsHint: 'رجوع فطريقو لقى مشكل',
      none: 'ما كاين والو كيتسنى قرارك.',
      returnsInProgress: 'رجوع واحد فالطريق | {count} رجوعات فالطريق'
    },
    exceptions: {
      label: 'مستعجل',
      title: 'مشاكل خاصها معالجة',
      empty: 'ماكاين حتى مشكل مفتوح.',
      open: 'شوف كل المشاكل'
    },
    cod: {
      label: 'الفلوس اللي خاصها تتجمع',
      description: 'المجموع اللي خاص يتجمع للكوليات اللي باينين.'
    },
    agents: {
      label: 'خريطة الكارديانات',
      title: 'المناطق المغطاة',
      cityLine: '{agents} كارديان · {deliveries} توصيلات خدامين',
      activeDeliveries: '{count} خدامين'
    },
    settlement: {
      label: 'التسوية',
      title: 'وجد التسوية',
      description: 'شوف المعاينة، تأكد من المبالغ وبدا التسوية إلا كان الفرق مقبول.',
      open: 'حل التسويات'
    },
    audit: {
      label: 'السجل',
      title: 'شكون دار شنو',
      description: 'شوف العمليات ديال الفريق، تبديل المراحل، الأسباب والأحداث الحساسة.',
      open: 'حل السجل'
    },
    snapshot: {
      active: 'الخدامين',
      delivered: 'اللي توصلو اليوم',
      proofs: 'الإثباتات'
    }
  },
  settlements: {
    title: 'التسويات',
    description: 'راجع الكوليات اللي سالاو وما تسواوش، نقص مصاريف اللي توصلو، زيد الكوميسيون ديال الكارديانات وسد التسوية.',
    loadFailed: 'ما قدرناش نحملو التسويات.',
    loadDetailFailed: 'ما قدرناش نحملو هاد التسوية.',
    runFailed: 'ما قدرناش نبداو التسوية.',
    runStarted: 'التسوية بدات.',
    reviewWarning: 'شي كوليات خاصهم مراجعة.',
    running: 'كتتسوى…',
    run: 'بدا التسوية',
    backToSettlements: 'رجع للتسويات',
    detailTitle: 'تفاصيل التسوية',
    toSettle: 'خاصها تتسوى',
    toSettleDescription: 'كوليات سالاو وما تسواوش باقي.',
    partnerDebitDescription: 'مصاريف غادي تنقص من كريدي الشركاء.',
    agentCommissionDescription: 'مبلغ غادي يتزاد لما يقدر الكارديان يسحب.',
    operationalRule: 'كيفاش كتخدم',
    ruleTitle: 'التسوية كتسد الكوليات اللي سالاو',
    ruleDescription: 'الكولي اللي توصل كيتنقص من الشريك، كيتخلص منو الكارديان وكيربح منو التطبيق. اللي ما نجحش ولا تلغى ولا رجع كيتسد بلا مصاريف.',
    permanentAudit: 'كيتحفظ فالسجل',
    history: 'السجل',
    runsTitle: 'التسويات اللي تدارو',
    runColumn: 'التسوية',
    deliveries: 'التوصيلات',
    partnerFees: 'مصاريف الشركاء',
    agentCommissions: 'كوميسيون الكارديانات',
    completedAt: 'سالات فـ',
    failedCount: '{count} ما نجحوش',
    emptyRuns: 'ماكاين حتى تسوية باقي.',
    runCount: '{count} د التسويات',
    settledDeliveries: 'التوصيلات اللي تسواو',
    partnerDebit: 'نقص من كريدي الشركاء',
    partnerCreditConsumed: 'كريدي الشركاء تستعمل.',
    agentBalanceCredited: 'المبلغ تزاد لما يقدرو يسحبو الكارديانات.',
    completedOn: 'سالات فـ {date}',
    toReview: 'خاصها مراجعة',
    unsettledLines: 'سطور ما تسواوش بوحدهم',
    unknownDelivery: 'توصيل ما معروفش',
    partnerNotProvided: 'الشريك ما تعطاش',
    errorNotProvided: 'الخطأ ما تعطاش',
    requiredFee: 'المصاريف اللي خاصها تتخلص',
    currentCredit: 'الكريدي الحالي',
    estimatedAvailable: 'المتاح (تقريبا)',
    fixAndRerun: 'صلح المشكل ومن بعد بدا التسوية من جديد.',
    includedDeliveries: 'التوصيلات اللي فيها',
    deliveredAt: 'توصل ف',
    noPartner: 'ماكاين حتى شريك',
    noAttachedPackages: 'ماكاين حتى كولي فهاد التسوية.',
    creditDebits: 'اللي تنقص من الكريدي',
    creditedCommissions: 'الكوميسيون اللي تزاد',
    recordedRevenue: 'الربح اللي تسجل',
    noPartnerDebit: 'ماتنقص والو من الشركاء.',
    noAgentCommission: 'ماكاين حتى كوميسيون د الكارديانات.',
    noPlatformRevenue: 'ماكاين حتى ربح للتطبيق.',
    status: {
      completed: 'سالات',
      running: 'خدامة',
      pendingReview: 'خاصها مراجعة',
      failed: 'ما نجحاتش'
    }
  },
  partners: {
    reservedFees: 'مصاريف محجوزة',
    requested: 'المطلوب',
    copyPartnerId: 'نسخ ID ديال الشريك',
    unsettledExposure: 'كوليات ما تسواوش باقي',
    balanceAfterExposure: 'الرصيد من بعد هاد الكوليات',
    needsCreditAttention: 'الكريدي خاصو انتباه',
    creditOperational: 'الكريدي كافي',
    submittedByPartner: 'تصيفطو من هاد الشريك',
    creditActivity: 'حركات الكريدي',
    topupsAndFees: 'الشحنات ومصاريف التوصيل',
    financeViewHelp: 'نظرة سريعة قبل ما تحل التفاصيل.',
    credited: 'اللي تزاد',
    feesDebited: 'المصاريف اللي تنقصو',
    pendingTopup: 'شحن كيتسنى',
    latestMovement: 'آخر حركة',
    noCreditMovement: 'ماكاين حتى حركة باقي.',
    topupRequests: 'طلبات الشحن',
    reviewQueue: 'للمراجعة',
    partnerAccess: 'دخول الشريك',
    statusActions: 'بدل الحالة',
    statusActionsHelp: 'قرر واش هاد الشريك يقدر يدخل ويصاوب الكوليات.',
    portalActive: 'دخول الشريك خدام.',
    portalSuspended: 'دخول الشريك موقوف مؤقتا.',
    portalClosed: 'حساب الشريك مسدود.',
    statusImpact: 'الشريك الموقوف ولا المسدود ما بقاش يقدر يصاوب كوليات. السجل ديالو كيبقى باين للفريق.',
    searchTopupRequests: 'قلب على طلب شحن…',
    noTopupRequests: 'ماكاين حتى طلب شحن',
    noTopupRequestsDescription: 'طلبات الشحن ديال الشركاء غادي يبانو هنا.',
    bankTransferReceived: 'التحويل البنكي توصلنا بيه.',
    approveTopupRequest: 'قبل طلب الشحن',
    rejectTopupRequest: 'رفض طلب الشحن',
    request: 'الطلب',
    noPartnerNote: 'ماكاينة حتى ملاحظة من الشريك.',
    rejectRequestPlaceholder: 'شرح علاش كترفض…',
    approveRequest: 'قبل الطلب',
    rejectRequest: 'رفض الطلب',
    suspendPartner: 'وقف الشريك مؤقتا',
    closePartner: 'سد الحساب',
    reactivatePartner: 'فعل الشريك من جديد',
    suspendPartnerHelp: 'كيمنع الشريك مؤقتا من الدخول وتصاوب الكوليات.',
    closePartnerHelp: 'كيسد الحساب وكيمنع كلشي. استعملو غير إلا التعامل سالا.',
    reactivatePartnerHelp: 'كيرجع الدخول للشريك. يقدر يصاوب كوليات إلا كان الكريدي ديالو كافي.',
    statusReasonRequired: 'كتب سبب واضح فيه 10 حروف على الأقل.',
    statusReasonPlaceholder: 'شرح علاش كاتدير هاد العملية…',
    companyName: 'الشركة',
    contactName: 'سمية المسؤول',
    contactPhone: 'تيليفون المسؤول',
    contactEmail: 'إيميل المسؤول',
    description: 'حسابات المرسلين، الكريدي، الحالة ومصاريف التوصيل.',
    create: 'شريك جديد',
    createPartner: 'صاوب شريك',
    contact: 'المسؤول',
    creditBalance: 'رصيد الكريدي',
    lowCreditThresholdMad: 'الحد الأدنى د الكريدي قبل التنبيه (درهم)',
    threshold: 'الحد الأدنى',
    lowCredit: 'كريدي ناقص',
    creditBlocked: 'الكريدي سالا',
    availableCredit: 'الكريدي المتاح',
    totalCredit: 'مجموع الكريدي',
    backToList: 'لائحة الشركاء',
    addCredit: 'زيد الكريدي',
    recordTopup: 'سجل الشحن',
    searchPlaceholder: 'الشركة، المسؤول، الإيميل، التيليفون…',
    creditSearchPlaceholder: 'المرجع، الملاحظة، المستلم…',
    emptyDescription: 'الشركاء اللي كتصاوب غادي يبانو هنا.',
    noCreditEntries: 'ماكاين حتى حركة د الكريدي',
    noCreditEntriesDescription: 'الشحنات ومصاريف التوصيل غادي يبانو هنا.',
    portalPassword: 'كلمة السر ديال بلاصة الشريك',
    portalPasswordUpdate: 'كلمة سر جديدة',
    portalPasswordHelp: 'اختياري. 12 حرف على الأقل. إلا بقات خاوية الدخول ما غاديش يتصاوب ولا يتبدل.',
    portalPasswordInvalid: 'كلمة السر خاصها تكون 12 حرف على الأقل.',
    portalEnabled: 'الدخول خدام',
    portalDisabled: 'الدخول موقوف',
    actionFailed: 'ما نجحاتش.',
    companyRequired: 'سمية الشركة ضرورية.',
    contactRequired: 'سمية المسؤول ضرورية.',
    phoneRequired: 'التيليفون ضروري.',
    emailRequired: 'الإيميل ضروري.',
    thresholdInvalid: 'الحد الأدنى خاصو يكون مبلغ موجب.',
    amountInvalid: 'المبلغ خاصو يكون كبر من صفر.',
    noteRequired: 'زيد ملاحظة واضحة.',
    entry: {
      credit_topup: 'شحن',
      partner_fee_debit: 'مصاريف التوصيل',
      credit_adjustment: 'تصحيح الكريدي',
    }
  },
  adminCustomers: {
    title: 'الزبناء',
    subtitle: 'حسابات الزبناء والكريدي د التوصيل',
    searchPlaceholder: 'قلب على زبون…',
    empty: 'ماكاين حتى زبون.',
    balance: 'الرصيد',
    available: 'المتاح',
    exposed: 'المحجوز',
    threshold: 'الحد اللي كنعلمو فيه',
    totalPackages: 'مجموع الكوليات',
    deliveredPackages: 'الكوليات اللي توصلو',
    lastSync: 'آخر تحديث',
    lastActivity: 'آخر نشاط',
    detailTitle: 'ملف الزبون',
    detailSubtitle: 'الكريدي، التوصيلات وطلبات الشحن',
    contact: 'التواصل',
    customerSince: 'زبون من',
    packagesSection: 'كوليات الزبون',
    orderRequestsSection: 'طلبات الإرسال',
    returnsSection: 'طلبات الإرجاع',
    creditLedger: 'حركات الكريدي',
    creditLedgerEmpty: 'ماكاين حتى حركة فالكريدي.',
    creditRequests: 'طلبات الشحن',
    creditRequestsEmpty: 'ماكاين حتى طلب شحن.',
    topupTitle: 'طلب شحن',
    topupAmount: 'المبلغ',
    topupNote: 'السبب',
    topupSubmit: 'صيفط للزبون',
    approveRequest: 'قبل',
    rejectRequest: 'رفض',
    adminNote: 'ملاحظة الفريق',
    adminNotePlaceholder: 'كيشوفها غير الفريق',
    entryTypeCreditTopup: 'شحن',
    entryTypeDeliveryFeeDebit: 'مصاريف التوصيل',
    entryTypeCreditAdjustment: 'تصحيح الكريدي',
    requestStatusPending: 'كيتسنى',
    requestStatusApproved: 'تقبل',
    requestStatusRejected: 'ترفض',
    pickupEnabled: 'إيداعات الزبناء',
    pickupEnabledHint: 'الزبناء غادي يقدرو يختارو هاد الكارديان كنقطة إيداع.',
    pickupEnabledOn: 'خدام',
    pickupEnabledOff: 'موقوف',
    configPickupTypeEnabled: 'إيداعات الزبناء (عام)',
    configPickupTypeEnabledHint: 'المفتاح الرئيسي. إلا طفيتيه ما غاديش تبان نقط إيداع وما غاديش يتصاوبو كوليات للزبناء.',
    configCustomerFee: 'ثمن التوصيلة الوحدة للزبون',
    configCustomerFeeHint: 'هاد الثمن كيتسجل ملي الكارديان يقبل الكولي ديال الزبون. ماشي إثبات ديال الخلاص.',
    configSaved: 'الإعداد تسجل',
    orderRequestPickupPoint: 'نقطة الإيداع',
    orderRequestPickupHint: 'الزبون ختار نقطة إيداع. خليها ولا ختار وحدة أخرى.',
    orderRequestSelectPickupPoint: 'نقطة الإيداع',
    orderRequestNoPoints: 'ماكاين حتى كارديان يقدر يستقبل هاد الكولي.',
    orderRequestPickupNone: 'توصيل مباشر للعنوان',
    packagePickupPoint: 'نقطة الإيداع',
    packagePickupAgent: 'الكارديان',
    packageHandoverAt: 'تسلّم للكارديان فـ',
    packageCollectedAt: 'خدا الليفرور فـ',
    customerCreditExhausted: 'الكريدي سالا: خاص الزبون يعمر.',
  },
  publicTracking: {
    unavailable: 'التتبع ماكاينش',
    unavailableMessage: 'ما لقينا هاد الكود، ولا التتبع ماكاينش دابا.',
    label: 'تتبع الكولي',
    backHome: 'رجع للرئيسية',
    package: 'الكولي',
    recipient: 'المستلم:',
    hiddenRecipient: 'مخبي حتى يوصل للنقطة',
    operatorReference: 'نمرة التتبع:',
    relay: 'نقطة التسليم',
    relayPending: 'النقطة غادي تبان ملي الكارديان يتسلم الكولي.',
    agent: 'الكارديان',
    agentPending: 'كيبان ملي الكولي يوصل للنقطة',
    dates: 'التواريخ',
    dropped: 'تحط:',
    received: 'تسلم:',
    out: 'خرج للتوصيل:',
    delivered: 'توصل:',
    map: 'الخريطة',
    relayPosition: 'فين كاينة النقطة',
    trackingTimeline: 'تقدم الكولي',
    createdTitle: 'الكولي تصاوب',
    createdDescription: 'الكولي تسجل.',
    en_route: 'فالطريق:',
    enRouteTitle: 'فالطريق للنقطة',
    enRouteDescription: 'الليفرور خد الكولي وماشي للنقطة.',
    droppedTitle: 'تحط فالنقطة',
    droppedDescription: 'الليفرور حط الكولي فالنقطة.',
    receivedTitle: 'تسلمو الكارديان',
    receivedDescription: 'الكارديان أكد أنه تسلم الكولي.',
    outTitle: 'خرج للتوصيل',
    outDescription: 'الكولي فالطريق للمستلم.',
    deliveredTitle: 'توصل',
    deliveredDescription: 'الكولي تسلم مع إثبات التسليم.',
    failedTitle: 'التوصيل ما نجحش',
    failedDescription: 'التوصيل ما نجحش.',
    noMapBeforeReceived: 'الخريطة كتبان ملي الكارديان يتسلم الكولي.',
    returnRequest: 'طلب الإرجاع',
    returnRequestTitle: 'طلب الإرجاع',
    returnPageDescription: 'دخل المعلومات ديالك وكود الكولي. الفريق كيشوف الطلب قبل ما يبدا الإرجاع.',
    returnName: 'السمية الكاملة ديالك',
    returnPhone: 'التيليفون ديالك',
    returnAddress: 'العنوان ديالك',
    returnPackageCode: 'كود الكولي',
    returnNote: 'ميساج للفريق',
    returnSubmit: 'صيفط الطلب ديالي',
    returnFormRequired: 'السمية، التيليفون، العنوان وكود الكولي ضروريين.',
    returnSubmitted: 'الطلب تصيفط.',
    returnSubmittedDetail: 'وصلنا الطلب ديالك. فريق 3asass غادي يشوفو قبل ما يبدا الإرجاع.',
    returnFailed: 'ما قدرناش نصيفطو الطلب.'
  },
  documents: {
    view: 'شوف الدوكيمون',
    unavailable: 'الدوكيمون ما متوفرش'
  },
  exception: {
    title: 'بلغ على مشكل',
    reason: 'السبب',
    operationalNote: 'تفاصيل (اختياري)',
    submit: 'صيفط',
    queued: 'المشكل تحفظ فالتيليفون وغادي يتصيفط ملي يرجع النيت.',
    synced: 'المشكل تصيفط.',
    rejected: 'المشكل ما تقبلش. عاود جرب.',
    notAllowedForState: 'ما يمكنش ليك تبلغ على مشكل فهاد المرحلة.',
    recipientAbsent: 'المستلم ماكاينش',
    refused: 'المستلم رفض',
    damagedAtReceipt: 'وصل فيه ضرر',
    damagedAtDelivery: 'تضرر فالطريق',
    lost: 'الكولي ضاع',
    wrongContent: 'المحتوى ماشي هو المطلوب ولا مشكوك فيه',
    unreachable: 'ما قدرناش نتاصلو بالمستلم',
    adminOverride: 'بدلاتو الإدارة',
    returnApproved: 'تقبل الرجوع',
    returnRejected: 'ترفض الرجوع',
    photoLabel: 'تصويرة المشكل',
    photoHelp: 'اختياري ولكن مزيان. صور تصويرة كتبين المشكل.',
    agentLabel: 'مشكل مع كولي',
    agentTitle: 'بلغ على مشكل',
    agentEligibleStates: 'ممكن ملي الكولي يكون متسلم، خارج للتوصيل، ما نجحش ولا فيه مشكل.',
    noPackageSelected: 'ما ختاريتي حتى كولي. رجع لصفحة الكولي وختار «بلغ على مشكل».',
    courierLabel: 'مشكل فالتسليم',
    courierTitle: 'بلغ على مشكل',
    courierDescription: 'استعملها إلا كان مشكل فكولي تحط عند الكارديان قبل ما يتسلم.'
  },
  podMedia: {
    signedPod: 'إثبات مع التوقيع',
    operationalProofs: 'إثباتات التسليم',
    courierDropPhoto: 'تصويرة التسليم ديال الليفرور',
    courierDropPhotoAlt: 'تصويرة التسليم {index}',
    noDropPhoto: 'ماكاينة تصويرة التسليم',
    courierPickupPhoto: 'تصاور الجمع',
    courierPickupPhotoAlt: 'تصويرة الجمع {index}',
    noCourierPickupPhoto: 'ماكاينة تصويرة الجمع',
    receptionPhotos: 'تصاور الاستلام',
    receptionPhotoAlt: 'تصويرة الاستلام {index}',
    noReceptionPhoto: 'ماكاينة تصويرة الاستلام',
    deliveryPhoto: 'تصويرة التسليم',
    noPhoto: 'ماكاينة تصويرة',
    signature: 'التوقيع ديال المستلم',
    noSignature: 'ماكاين توقيع',
    customerHandoverPhotos: 'تصاور تسليم الزبون',
    customerHandoverPhotoAlt: 'تصويرة تسليم الزبون {index}',
    customerHandoverSignature: 'التوقيع ديال الزبون (التسليم عند الكارديان)',
    noCustomerHandoverSignature: 'ماكاين توقيع ديال الزبون.',
    noCustomerHandoverPhoto: 'ماكاينة تصويرة د تسليم الزبون',
    exceptionsAndReturns: 'المشاكل والإرجاعات',
    incidentProofs: 'إثباتات المشكل',
    exceptionPhotos: 'تصاور المشكل',
    exceptionPhotoAlt: 'تصويرة المشكل {index}',
    noExceptionPhoto: 'ماكاينة تصويرة المشكل',
    returnAgentPhotos: 'تصاور الإرجاع عند الكارديان',
    returnAgentPhotoAlt: 'تصويرة الإرجاع عند الكارديان {index}',
    noReturnAgentPhoto: 'ماكاينة تصويرة الإرجاع عند الكارديان',
    returnCourierPhotos: 'تصاور الإرجاع اللي خدا الليفرور',
    returnCourierPhotoAlt: 'تصويرة الإرجاع اللي تاخد {index}',
      senderReturnPhotos: 'تصاور تسليم الكولي للمرسل',
      senderReturnPhotoAlt: 'تصويرة تسليم الكولي للمرسل {index}',
    noReturnCourierPhoto: 'ماكاينة تصويرة الإرجاع اللي تاخد'
  },
  timeline: {
    history: 'السجل ديال الكولي',
    lifecycle: 'المراحل',
    empty: 'ماكاين حتى حدث لهاد الكولي.',
    gpsPosition: 'البلاصة فالخريطة',
    viewGps: 'شوف البلاصة',
    transitions: {
      awaitingPickupToPickupReady: 'تأكد أن الزبون سلم عند الكارديان',
      pickupReadyToEnRoute: 'الليفرور خد الكولي من عند الكارديان',
      pickupToCancelled: 'التسليم تلغى',
      pickupReadyToReceived: 'الكولي تستقبل من الكليان فالنقطة',
      enRouteToDropped: 'ليفرور خلّى الكولي فالنقطة',
      droppedToReceived: 'الكولي تستقبل فالنقطة',
      receivedToOut: 'خارج للتوصيل',
      receivedToOutHold: 'المستلم وصل: بدا التسليم',
      outToDelivered: 'تسلم للمستلم',
      outToDeliveredHold: 'المستلم دّاه',
      toFailed: 'التوصيل ما نجحش',
      toReturnRequested: 'بدا الرجوع',
      returnRequestedToDeposited: 'الكولي الراجع تحط فالنقطة',
      depositedToCollected: 'ليفرور خد الكولي الراجع',
      toDisputed: 'تحل مشكل',
      disputedToDelivered: 'المشكل تحل: تسلم',
      disputedToFailed: 'المشكل تحل: ما نجحش',
      failedToReceived: 'محاولة توصيل جديدة',
      toCancelled: 'الكولي تلغى',
      createdToEnRoute: 'الكولي تاخد من عند المرسل'
    },
    actions: {
      transition: 'تبدلات المرحلة',
      en_route: 'فالطريق للنقطة',
      partner_return: 'إرجاع للشريك',
      state_changed: 'تبدلات المرحلة',
    },
    descriptions: {
      partnerReturn: 'الشريك أكد أنه تسلم الكولي اللي رجع.',
      auditEvent: 'العملية تسجلات فالسجل.',
      system: 'النظام'
    },
    showAll: '+{count} مراحل',
    showLess: 'بين أقل'
  },
  podUpload: {
    title: 'إثباتات التسليم',
    assets: 'ملفات الإثبات',
    addPhoto: 'زيد تصويرة',
    ready: 'واجد',
    missing: 'ناقص',
    uploaded: 'تصيفط'
  },
  logisticsUi: {
    photo: 'تصويرة',
    takePhoto: 'صور',
    upload: 'ختار ملف',
    removePhoto: 'حيد التصويرة',
    compression: 'شوية…',
    noFileSelected: 'ما ختاريتي حتى ملف',
    compressionUnavailable: 'ما قدرناش نصغرو التصويرة. غادي نستعملو التصويرة الأصلية.',
    photosSelected: 'ختاريتي {count} د التصاور',
    photoLimitReached: 'وصلتي للحد ديال {max} د التصاور.',
    removeAllPhotos: 'حيد التصاور كاملين',
    proofPhoto: 'التصويرة {index}',
    qrScanner: {
      label: 'سكانير QR',
      httpsRequired: 'الكاميرا كتخدم غير بإتصال آمن (HTTPS). كتب الكود لتحت.',
      cameraUnavailable: 'الكاميرا ماشي متاحة فهاد الجهاز.',
      cameraDenied: 'الوصول للكاميرا ترفض ولا الكاميرا ما بداتش.'
    },
    packageVerification: 'تأكد من الكولي',
    start: 'بدا',
    stop: 'وقف',
    qrHelp: 'حط الكاميرا قدام كود QR ديال الكولي.',
    manualPackageCode: 'ولا كتب كود الكولي',
    confirm: 'أكد',
    signaturePad: 'بلاصة التوقيع',
    proofOfDelivery: 'إثبات التسليم',
    clear: 'مسح',
    signatureReady: 'التوقيع تاخد.',
    signatureTooSmall: 'التوقيع صغير بزاف. وقع كبر داخل الإطار.',
    signatureRequired: 'التوقيع ديال الزبون ضروري.'
  },
  layout: {
    adminControl: 'بلاصة الإدارة',
    operationsPortal: 'بلاصة الخدمة',
    secureAccess: 'دخول آمن',
    roleEntry: 'حساب واحد لكل التطبيقات ديالك.',
    authDescription: 'دخل مرة وحدة والحساب ديالك غادي يحل التطبيق ديال الخدمة ديالك.',
    fieldOtp: 'الدخول بكود',
    fieldOtpDescription: 'الكارديانات والليفرورات كيدخلو بكود كيوصلهم فالتيليفون.',
    admin2fa: 'تأكيد مزدوج',
    admin2faDescription: 'الإدارة كتطلب كلمة سرية وكود تأكيد.',
    operationsConsole: 'لوحة 3asass.ma',
    backToRoles: 'رجع لاختيار البلاصة'
  },
  errors: {
    requestFailed: 'ما نجحاتش',
    loadingFailed: 'ما قدرناش نحملو',
    unauthenticated: 'الجلسة ديالك سالات. دخل من جديد.',
    notFoundTitle: 'الصفحة ماكايناش',
    notFoundDescription: 'هاد الصفحة ماكايناش.',
    goHome: 'رجع للرئيسية',
    noData: 'ماكاين والو',
    resultsWillAppear: 'النتائج غادي يبانو هنا.',
    search: 'قلب…'
  },
  packageDetail: {
    recipientPayment: 'اللي خاص المستلم يخلص',
    returnCourier: 'الليفرور ديال الإرجاع',
    paidFee: 'خلصتي',
    agentDescription: 'التتبع ديال الكارديان من التسلم حتى التسليم ولا المشكل.',
    backendActions: 'العمليات الممكنة',
    loadFailed: 'ما قدرناش نحملو الكولي.',
    myPackages: 'الكوليات ديالي',
    runnable: 'ممكنين',
    relayDropped: 'تحط فالنقطة',
    agentReceived: 'تسلمو الكارديان',
    progression: 'التقدم',
    packageCreated: 'الكولي تصاوب',
    packageCreatedDescription: 'الكولي تسجل للتوصيل.',
    dropConfirmed: 'التسليم تأكد',
    dropConfirmedDescription: 'الليفرور سكانا الكولي فالنقطة وسالا التسليم.',
    system: 'النظام',
    courier: 'الليفرور',
    returnRequests: 'طلبات الإرجاع',
    returnRequestsForPackage: 'الطلبات ديال هاد الكولي',
    noReturnRequests: 'ماكاين حتى طلب إرجاع لهاد الكولي.',
    approveReturnRequest: 'قبل وبدا الإرجاع',
    rejectReturnRequest: 'رفض',
    returnApprovePrompt: 'ملاحظة باش تقبل هاد الإرجاع',
    returnRejectPrompt: 'ملاحظة باش ترفض هاد الإرجاع',
    returnApproved: 'طلب الإرجاع تقبل.',
    returnRejected: 'طلب الإرجاع ترفض.',
    reviewedAt: 'تجاوب فـ',
    adminNote: 'ملاحظة',
    returnStatuses: {
      pending: 'كيتسنى',
      approved: 'مقبول',
      rejected: 'مرفوض'
    },
    actions: {
      en_route: 'فالطريق',
      mark_en_route: 'فالطريق',
      drop: 'تسليم الليفرور',
      cancel: 'لغي',
      receive: 'تسلم الكارديان',
      notify_resident: 'علم المستلم',
      start_delivery: 'بدا التوصيل',
      report_exception: 'بلغ على مشكل',
      capture_pod: 'عطي للمستلم',
      request_return: 'طلب الإرجاع',
      open_dispute: 'حل مشكل',
      retry_by_admin: 'عاود جرب',
      return_to_sender: 'رجعو للمرسل',
      deposit_return: 'الإرجاع تحط',
      collect_return: 'الإرجاع تاخد',
      resolve_as_delivered: 'حل: توصل',
      resolve_as_failed: 'حل: ما نجحش',
      confirm_failed: 'أكد أن ما نجحش',
      accept_damaged: 'قبل مع ملاحظة',
      clear_agent: 'عفي الكارديان',
      confirm_loss_agent_fault: 'الضياع بسبب الكارديان',
      declare_cod_loss: 'صرح بالضياع'
    },
    loadDetailFailed: 'ما قدرناش نحملو تفاصيل الكولي.',
    notFound: 'الكولي ماكاينش',
    copyReference: 'نسخ المرجع',
    copyPhone: 'نسخ النمرة',
    internalQrReference: 'المرجع الداخلي / QR',
    internalReference: 'المرجع الداخلي:',
    operatorReference: 'نمرة التتبع:',
    technicalIds: 'المعرفات التقنية',
    show: 'بيّن',
    hide: 'خبي',
    courierQrScan: 'كود QR باش يسكانيه الليفرور',
    qrUnavailable: 'كود QR ماكاينش.',
    downloadQr: 'نزّل كود QR',
    availableActions: 'العمليات الممكنة',
    noActions: 'ماكاين حتى عملية ممكنة فهاد المرحلة.',
    timeline: 'التتبع',
    operationalHistory: 'السجل ديال الكولي',
    adminNotePrompt: 'الملاحظة ضرورية لهاد العملية',
    adminNoteRequired: 'الملاحظة ضرورية.',
    selectActiveAgent: 'ختار كارديان خدام.',
    deliveryActionSynced: 'العملية تسجلات.',
    backendRejected: 'العملية ما تقبلاتش.',
    agentUpdated: 'الكارديان تبدل.',
    reassignmentRejected: 'تبديل الكارديان ما تقبلش.',
    relayAddress: 'النقطة والعنوان',
    relayMap: 'خريطة النقطة',
    routeToDrop: 'الطريق لنقطة التسليم',
    routeToPickup: 'الطريق لبلاصة الجمع',
    routeToReturnPoint: 'الطريق لنقطة الإرجاع',
    takePickupPhoto: 'صور الكولي عند المرسل',
    confirmPickup: 'أكد الجمع',
      senderReturnSaved: 'الكولي تسلم للمرسل',
      senderReturnComplete: 'الإرجاع سالا.',
      senderReturnHelp: 'عطي الكولي للمرسل فيدو، من بعد سجل تصويرة والبلاصة ديالك.',
      takeSenderReturnPhoto: 'صور التسليم',
      senderReturnTo: 'تسلّمو للمرسل',
      senderReturnStepSender: 'المرسل',
      senderReturnPhoto: 'تصويرة التسليم',
      senderReturnPhotoHelp: 'صور الكولي، ومعاه الشخص إلا قدرتي.',
      senderReturnPhotoFirst: 'زيد التصويرة الأول',
      senderReturnUnavailable: 'هاد الكولي ماشي ناقص ليرجع للمرسل.',
      backToParcel: 'رجع للكولي',
      senderReturnFailed: 'التسليم ما تسجلش. تأكد من البلاصة ديالك والنيت وعاود جرب.',
    pickupLocationRequired: 'سمح بالموقع باش تأكد الجمع.',
    pickupProofSaved: 'الجمع تأكد والإثبات تسجل.',
    pickupProofFailed: 'ما قدرناش نأكدو الجمع. تأكد من التصويرة والبلاصة وعاود جرب.',
    dropProofs: 'إثباتات التسليم',
    uploadedPhotos: 'التصاور اللي تصيفطو',
    noDropProof: 'ماكاين حتى إثبات تسليم لهاد الكولي.',
    returnDepositPhotos: 'تصاور تسليم الإرجاع',
    returnCollectionPhotos: 'تصاور أخذ الإرجاع',
    route: 'الدورة',
    courierDescription: 'التتبع ديال الليفرور من التصاوب حتى التسليم فالنقطة.',
    enRoute: 'فالطريق',
    enRouteDescription: 'الليفرور مشا وكيتجه للنقطة.',
    detail: 'تفاصيل الكولي',
    tabTimeline: 'التتبع',
    tabProofs: 'الإثباتات',
    tabMap: 'الخريطة',
    tabReferences: 'المراجع',
    createdOn: 'تصاوب فـ {date}',
    backToList: 'لائحة الكوليات',
    copied: 'تنسخ.',
    publicTracking: 'صفحة التتبع العامة',
    deliveryState: 'مرحلة التوصيل',
    assignedAgent: 'الكارديان المختار',
    exception: 'المشكل',
    none: 'والو',
    recipient: 'المستلم',
    phone: 'التيليفون',
    deliveryAddress: 'عنوان التوصيل',
    references: 'المراجع',
    packageIdentifiers: 'مراجع الكولي',
    delivery: 'التوصيل',
    milestones: 'مراحل الكولي',
    dropped: 'تحط فالنقطة',
    received: 'تسلم',
    outForDelivery: 'خرج للتوصيل',
    delivered: 'توصل',
    noMilestones: 'مازال ما تسجلات حتى مرحلة.',
    selectAgent: 'ختار كارديان',
    reassignNote: 'ملاحظة باش تشرح التبديل',
    reassignAgent: 'بدل الكارديان',
    returnPoint: 'نقطة الإرجاع', returnPointTitle: 'ختار فين الزبون غادي ياخد الكولي', returnPointHint: 'النقطة الأصلية كتبقى {original}. ختار نقطة خدامة وشرح علاش.', returnPointReason: 'علاش بدلتي نقطة الإرجاع؟', assignReturnPoint: 'ختار نقطة الإرجاع', returnPointAssigned: 'نقطة الإرجاع تختارات.', returnPointAssignFailed: 'ما قدرناش نختارو نقطة الإرجاع.',
                                                                                                                                                                                                                                                                                                                               returnIncidents: 'مشاكل الإرجاع',
                                                                                                                                                                                                                                                                                                                               collectionTitle: 'الجمع',
                                                                                                                                                                                                                                                                                                                               collectionOpen: 'شوف الجمع والكود ديالو',
                                                                                                                                                                                                                                                                                                                               arrivalTitle: 'الوصول',
                                                                                                                                                                                                                                                                                                                               arrivalOpen: 'شوف الوصول وكود الليفرور'
  },
  adminCourierDetail: {
    sheet: 'ملف الليفرور',
    backendUnavailable: 'الخدمة ماشي متاحة',
    actionDenied: 'العملية ترفضات',
    loadFailed: 'ما قدرناش نحملو الليفرور.',
    suspendFailed: 'ما قدرناش نبلوكيو.',
    reactivateFailed: 'ما قدرناش نرجّعو فعال.',
    dropsToday: 'الإيداعات اليوم',
    dropsTodayHelp: 'الإيداعات المسجلة فالنهار.',
    lastActivity: 'آخر نشاط',
    account: 'الحساب',
    noActivity: 'ما كاين حتى نشاط',
    dateUnavailable: 'التاريخ ما متوفرش',
    dropHistory: 'تاريخ الإيداعات',
    dropHistoryHelp: 'آخر التسليمات ديال اليوم غادي يبانو هنا.',
    noDetailedDrops: 'ماكاين حتى تسليم مفصل لهاد الليفرور.',
    suspension: 'بلوكاج',
    suspensionHelp: 'كيمنع الليفرور من الدخول فالحين.',
    reasonPlaceholder: 'السبب ضروري، 10 أحرف على الأقل',
    suspend: 'وقف الليفرور مؤقتا',
    suspensionRule: 'البلوكاج خاصو سبب ديال 10 أحرف على الأقل.',
    reactivation: 'رجوع للفعالية',
    reactivationHelp: 'ممكن غير إلا كان الليفرور موقوف.',
    reactivate: 'فعل الليفرور من جديد'
  },
  adminLists: {
    dropsDay: 'إيداعات اليوم',
    relayAgents: 'كارديانات النقط',
    agentManagement: 'إدارة الكارديانات',
    active: 'نشيطين',
    pending: 'كيتسناو',
    suspended: 'مبلوكين',
    status: 'الحالة',
    load: 'الحمل',
    relay: 'النقطة',
    loadAgentsFailed: 'ما قدرناش نحملو الكارديانات.',
    agentSearch: 'السمية، التيليفون، النقطة…',
    noAgents: 'ماكاين حتى كارديان',
    agentsEmpty: 'الكارديانات اللي كتصاوب غادي يبانو هنا.',
    validated: 'مصادق عليه',
    toValidate: 'للتصديق',
    couriersTitle: 'الليفرورات',
    couriersDescription: 'تبع حسابات الليفرورات، الوقف والتسليمات.',
    dropsToday: 'الإيداعات اليوم',
    lastActivity: 'آخر نشاط'
  },
  packages: {
    assignedAgent: 'الكارديان المعين',
    close: 'سد',
    create: 'خلق كولوا',
    csvDescription: 'كيخلق كوليات بالجملة. السطور الصحيحة كيخلقو حتى التوصيل ديالهم فالوضع المنشأ.',
    csvFile: 'ملف CSV',
    csvTitle: 'استيراد ملف CSV',
    description: 'قلب، فلتر وتبع الكوليات.',
    detail: 'التفاصيل',
    errors: 'الأخطاء',
    expectedColumns: 'الأعمدة المطلوبة',
    expectedColumnsDescription: 'residence_id, cod_amount_mad, recipient_name, recipient_phone, recipient_address. الحقول operator_tracking_ref و internal_ref و partner_id و agent_id اختيارية.',
    importCsv: 'استيراد CSV',
    importing: 'كيتستورد...',
    line: 'السطر',
    reference: 'المرجع',
    residence: 'النقطة',
    skipped: 'تجاهلنا',
    status: 'الحالة',
    template: 'نموذج',
    unassigned: 'ماشي معين',
    codMadHelp: 'كتب المبلغ بالدرهم، مثلا 125 يعني 125 درهم. كيتحول بوحدو.',
    open: 'حل',
    packages: 'الكوليات',
    package: 'الكولي',
    agentLabel: 'الكارديان:',
    recipient: 'المستلم',
    unknownRecipient: 'ما عرفناش المستلم',
    relay: 'النقطة',
    state: 'الحالة',
    type: 'النوع',
    currentPage: 'الصفحة الحالية',
    created: 'تخلق',
    active: 'خدام',
    issues: 'مشاكل',
    searchPlaceholder: 'المرجع، المستلم، التيليفون…',
    emptyTitle: 'ماكاين حتى كولي',
    emptyDescription: 'الكوليات اللي تصاوبو غادي يبانو هنا.',
    createdAt: 'تاريخ الإنشاء',
    createdFrom: 'تخلق من',
    createdTo: 'تخلق حتى',
    codPage: 'المبلغ اللي خاصو يتخلص'
  },
  parcelMap: {
    subtitle: 'الكوليات والجمع ديالك فخريطة وحدة.',
    agentSubtitle: 'الكوليات ديالك فخريطة وحدة.',
    listLabel: 'الكوليات والجمع',
    parcelPoint: 'فين غادي الكولي',
    collectionPoint: 'فين تجمعو',
    open: 'حل',
    searchPlaceholder: 'الريفيرانس، المستلم ولا العنوان…',
    widenHint: 'حرك الخريطة ولا قلب باش تشوف بعيد.',
    showAll: 'عرض الكل',
    selectHint: 'كليكي على كولي فالخريطة باش يبان هنا.',
    empty: 'ماكاين حتى كولي فالخريطة',
    emptyHint: 'الكوليات غادي يبانو هنا ملي يتلقى العنوان ديالهم.'
  },
  courierPickups: {
    title: 'الجمع',
    subtitle: 'خود الكوليات من عند الكارديانات ولا من عند المرسلين',
    tabPending: 'باش تجمع',
    tabCollected: 'اللي جمعتي',
    pendingEmpty: 'ماكاين حتى جمع كيتسنى',
    pendingEmptyHint: 'الجمعات الجديدة غادي يبانو هنا.',
    collectedEmpty: 'مازال ما سالا حتى جمع',
    pointLabel: 'نقطة الإيداع',
    parcelCount: '{count} د الكوليات',
    distanceKm: '{distance} كم',
    collectTitle: 'خود الكولي',
    collectStepScan: 'سكاني',
    collectStepCode: 'الكود',
    collectStepConfirm: 'أكد',
    codeLabel: 'كود التسليم',
    codePrompt: 'دخل الكود اللي كيوريك الكارديان',
    codeWrong: 'الكود غالط',
    codeExpired: 'الكود سالا',
    codeExpiredHint: 'طلب كود جديد من الكارديان ومن بعد حدث الصفحة.',
    codeMissing: 'ماكاين حتى كود تدخل',
    collectPhotos: 'تصاور الجمع',
    collectPhotosHelp: 'صور الكوليات اللي عطاك الكارديان.',
    collectPhotoRequired: 'زيد تصويرة د الكوليات اللي تسلمتي.',
    collectConfirm: 'خود {count} د الكوليات',
    collectSuccess: 'الكولي تاخد. سير للوجهة.',
    sessionTitle: 'جمع',
    sessionReference: 'المرجع {ref}',
    sessionEmpty: 'ماكاين حتى كولي فهاد الجمع.',
    refreshCode: 'جدد الكود',
    goToPoint: 'حل الطريق',
    senderLocationCapturedAtCollection: 'البلاصة ديالك كتتحدد بوحدها فخطوة التصويرة.',
    senderProofSummary: 'تصويرة والبلاصة ديالك غادي يأكدو الجمع من هاد العنوان.',
    releasePickup: 'لغي الحجز ديالي',
    releaseSuccess: 'الحجز تلغى. ليفرور آخر يقدر ياخدها.',
  },
  returnRequests: {
    label: 'التبليغات والرجوعات',
    title: 'المشاكل المبلَّغ عليها والرجوعات',
    description: '{count} طلب فالليستة الحالية: تبليغات الكليانة من بعد التسليم، ورجوعات تطلبو بلا حساب.',
    loadFailed: 'ما قدرناش نشحنو طلبات الرجوع.',
    empty: 'ما كاين حتى تبليغ ولا رجوع بهاد الفلتر.',
    packageCode: 'كود الكولي',
    requester: 'مول الطلب',
    requestedAt: 'تطلب ف',
    reviewedFrom: 'تراجع من',
    reviewedTo: 'تراجع حتى',
    searchPlaceholder: 'كود الكولي، السمية، التيليفون، العنوان، الملاحظة...',
    reviewTitle: 'راجع الطلب',
    approveTitle: 'قبل وبدا الرجوع',
    rejectTitle: 'رفض: الكولي كيبقى تسلم',
    reviewDescription: 'زيد ملاحظة داخلية قبل ما تأكد القرار.',
    reviewNotePlaceholder: 'ملاحظة الأدمن لهاد الطلب'
  },
  returnIncidents: {
    title: 'مشاكل الرجوع', description: 'الكولي كيبقى عند المسؤول الحالي حتى الأدمن يستأنف الرجوع ولا يسدو.',
    loadFailed: 'ما قدرناش نشحنو مشاكل الرجوع.', empty: 'ما كايناش مشاكل فالرجوع.', reportedBy: 'بلغ عليه', custodian: 'المسؤول الحالي',
    custodyAtReport: 'الحالة ملي تبلغ عليها', resolution: 'القرار', viewEvidence: 'شوف صورة الإثبات', reasonPlaceholder: 'سبب قرار الأدمن (8 حروف على الأقل)',
    chooseCourier: 'اختار ليفور نشيط', resume: 'كمل الرجوع', reassign: 'بدل الليفرور من بعد التسليم', closeLost: 'سدّو كمفقود',
    actionFailed: 'القرار ما تنفذش.', resumeSuccess: 'تكمل الرجوع.', reassignSuccess: 'تحول الرجوع لليفور جديد.', 'close-lostSuccess': 'تسد الرجوع كمفقود.',
    statuses: { open: 'خاصو المراجعة', resumed: 'تكمل', reassigned: 'الليفرور تبدل', closed_lost: 'مفقود' }
  },
  cancellationRequests: {
    title: 'طلبات الإلغاء', description: 'الطرد لي راه فالشبكة ما كيتلغاش غير من بعد ما يرجع فعليًا للمُرسل.',
    loadFailed: 'ما تحملوش طلبات الإلغاء.', empty: 'ما كاين حتى طلب إلغاء.', askedAt: 'تاريخ الطلب', stateWhenAsked: 'الحالة وقت الطلب',
    parcelNow: 'الطرد دابا', decisionNote: 'القرار', notePlaceholder: 'سبب القرار (8 حروف على الأقل)',
    approve: 'قبل ورجّع', reject: 'رفض', approveSuccess: 'تقبل الإلغاء، والطرد راجع للمُرسل.', rejectSuccess: 'ترفض الطلب.',
    actionFailed: 'القرار ما نجحش.', pendingCount: '{count} طلب كيتسنى.',
    waitForRelay: 'الطرد فالطريق. تسنا حتى يوصل لنقطة قبل ما تقبل.',
    awaitingPhysicalReturn: 'تقبل. كنتسناو الطرد يوصل للمُرسل.', returnedAt: 'تسلّم للمُرسل ف {at}.',
    statuses: { pending: 'للمراجعة', approved: 'كيرجع', rejected: 'مرفوض', completed: 'ملغى' }
  },
  handovers: {
    resendSenderCode: 'عاود صيفط الكود',
    resendOnlyWhileWaiting: 'ممكن غير ملي الكولي كيتسنى المرسل.',
    senderCodeResending: 'كيتصيفط…',
    senderCodeResent: 'الكود تصيفط للمرسل مرة أخرى.',
    senderCodeResendFailed: 'ما قدرناش نعاودو نصيفطو الكود.',
    searchPlaceholder: 'المرجع، الكولي، الليفرور، الكارديان…',
    agentLabel: 'اللي جاو',
    agentTitle: 'اللي جاو',
    agentDescription: 'حل الوصول باش تختار الكوليات اللي غادي تقبل، زيد التصاور ودخل كود الليفرور.',
    courierLabel: 'الإيداعات ديالي',
    courierTitle: 'سجل الإيداعات',
    courierDescription: 'لقا هنا كل إيداع عند الكارديان، الكوليات اللي حطيتي والكود إلا احتجتيه.',
    handover: 'وصول',
    courierFallback: 'الليفرور',
    total: 'المجموع',
    received: 'اللي توصلو',
    alreadyReceived: 'توصلو من قبل',
    pendingToReceive: 'باش تستقبل',
    waiting: 'كيتسناو',
    codTotal: 'الفلوس اللي خاصك تاخد',
    cod: 'كيتخلص عند التسليم',
    pending: 'باش تستقبل',
    partial: 'جزء منهم',
    dropped: 'تحط',
    loading: 'كيتحمل…',
    loadingDetail: 'كيتحمل…',
    noResults: 'ما كاين والو بحال اللي قلبتي عليه.',
    emptyAgent: 'ماكاين والو باش تستقبل دابا. ملي الليفرور يجيب ليك كوليات غادي يبانو هنا.',
    emptyCourier: 'مازال ما درتي حتى إيداع.',
    loadFailed: 'ما قدرناش نحملو اللائحة.',
    courierLoadFailed: 'ما قدرناش نحملو الإيداعات ديالك.',
    newDrop: 'إيداع جديد',
    newCode: 'كود جديد',
    codeRefreshed: 'الكود الجديد واجد.',
    codeRefreshFailed: 'ما قدرناش نصاوبو كود جديد.',
    detailTitle: 'تفاصيل الوصول',
    backToHandovers: 'اللي جاو',
    keepCodeVisible: 'خلي هاد الكود باين حتى الكارديان يستقبل الكوليات كاملين.',
    confirmationTitle: 'أكد الوصول',
    confirmationDescription: 'استقبل الكوليات اللي ختاريتي.',
    dropProgress: 'كيتصيفط. خلي هاد الصفحة محلولة.',
    selectedSummary: '{packages} كولي · {photos} تصويرة',
    packageCounts: '{packages} كولي · {received} توصلو · {pending} كيتسناو',
    expiresAt: 'صالح حتى {time}',
    batchPackages: 'كوليات هاد الإيداع',
    parcelReturningHint: 'هاد الكولي راجع. غادي يبان ليك من بعد ما الوكيل يحطو.',
    batchAgent: 'الكارديان ديال هاد الإيداع',
    batchAgentHelp: 'كل الكوليات اللي كتسكاني هنا خاصهم يكونو عند هاد الكارديان.',
    packagesToAccept: 'الكوليات اللي غادي تقبل',
    packagesToAcceptDescription: 'حيد غير الكوليات اللي ما غاديش تستقبل دابا. غادي يبقاو من بعد.',
    noneSelected: 'ما ختاريتي حتى كولي. رجع على الأقل كولي واحد.',
    nonCod: 'ما كاين والو باش تاخد',
    removeFromReception: 'ما تستقبلش هاد الكولي',
    removedCount: 'تحيدو {count} د الكوليات',
    removeFromBatch: 'حيد',
    removedFromBatch: 'الكولي تحيد.',
    restore: 'رجع',
    alreadyReceivedCount: '{count} د الكوليات د هاد الوصول توصلو من قبل.',
    receptionPhotos: 'تصاور الكوليات اللي توصلو',
    receptionPhotosHelp: 'ضروري. صور على الأقل تصويرة وحدة د الكوليات اللي توصلو.',
    physicalCode: 'كود الليفرور',
    physicalCodeHelp: 'قارن هاد الكود مع الشاشة ديال الليفرور قبل ما تستقبل.',
    confirmPackages: 'أكد {count} د الكوليات',
    notFound: 'هاد الوصول ماكاينش.',
    photoRequired: 'زيد على الأقل تصويرة وحدة.',
    noDeliverySelected: 'ما ختاريتي حتى كولي باش تستقبل.',
    receiveRejected: 'الاستقبال ما تقبلش. عاود جرب.',
    receiveSuccess: 'توصلو {count} د الكوليات.',
    invalidCourierDrop: 'هاد الكولي ما يمكنش يتحط من هاد الشاشة.',
    duplicatePackage: 'هاد الكولي كاين ديجا فاللائحة.',
    agentRequired: 'هاد الكولي مازال ما عندو كارديان. طلب من فريق 3asass يختار واحد ومن بعد سكانيه من جديد.',
    agentMismatch: 'هاد الكولي ل {packageAgent}. وهاد الإيداع ل {batchAgent}.',
    readyToDrop: 'واجد للتسليم.',
    addedToBatch: 'الكولي تزاد.',
    dropPhotoRequired: 'زيد على الأقل تصويرة وحدة د الكوليات.',
    scanAtLeastOne: 'سكاني على الأقل كولي واحد.',
    singleAgentRequired: 'الإيداع الواحد فيه غير كوليات ديال نفس الكارديان.',
    deliveryMissing: 'هاد الكولي ما عندو توصيل.',
    deliveryMissingInBatch: 'واحد د الكوليات ما عندو توصيل.',
    codeMessage: '{reference} · الكود: {code}',
    dropRejected: 'الإيداع ما تقبلش. عاود جرب.',
    failedCount: 'ترفضو {count} د الكوليات. صلح وعاود جرب.',
    droppedCount: 'تحطو {count} د الكوليات.',
    dropPhotos: 'تصاور الكوليات اللي حطيتي',
    dropPhotosHelp: 'صور على الأقل تصويرة وحدة د الكوليات.',
    showCodeToAgent: 'وري هاد الكود للكارديان. خاصو يدخلو فالشاشة ديالو باش يأكد الاستقبال.',
    doneHint: 'الكارديان استلم هاد الكوليات. ما بقا ما تدير.',
    removedFromReception: 'الكولي تحيد.',
    readyToReceiveOne: 'الكولي واجد للاستقبال.',
    scanOneFirst: 'سكاني الأول كولي تحط.',
    singleReceiveLabel: 'استقبال كولي',
    singleReceiveTitle: 'سكاني كولي',
    singleReceiveDescription: 'استقبل كولي واحد بالكود اللي عطاك الليفرور.',
    selectedPackage: 'الكولي اللي ختاريتي',
    linkedHandover: 'الوصول المربوط: {reference}',
    askCourierCode: 'طلب من الليفرور الكود اللي باين فالشاشة ديالو.',
    confirmOnePackage: 'أكد هاد الكولي',
    scanOneEmpty: 'سكاني QR ديال كولي تحط، ولا كتب الكود ديالو.',
    confirmDrop: 'أكد الإيداع',
    stepScan: 'سكاني',
    stepPackages: 'الكوليات',
    stepPhoto: 'التصويرة',
    stepCode: 'الكود',
    stepSignature: 'التوقيع',
    stepConfirm: 'أكد',
    nextStep: 'من بعد: {step}',
    sessionMismatch: 'هاد الكولي فوصول آخر. سكاني كوليات ديال وصول واحد فكل مرة.',
    scanMoreHelp: 'سكاني كولي آخر ولا دوز للخطوة اللي من بعد.',
    scannedCount: 'تسكانيو {count} د الكوليات',
    dropComplete: 'الإيداع سالا',
    dropQueued: 'الإيداع تحفظ فالتيليفون وغادي يتصيفط ملي يرجع النيت.',
    startNewDrop: 'إيداع جديد',
    senderCode: 'كود المرسل',
    senderCodeHelp: 'المرسل كيعطي هاد الكود للكارديان ملي يحط الكولي.'
  },
  geolocation: {
    insecureConnection: 'البلاصة كتخدم غير بإتصال آمن (https). حل التطبيق بـ https.',
    permissionRequired: 'سمح بالموقع فالمتصفح، من بعد كليكي على «حدد البلاصة ديالي».',
    label: 'البلاصة ديالي',
    title: 'فين نتا',
    notCaptured: 'البلاصة ما تحددات',
    unavailable: 'ما قدرناش نلقاو البلاصة ديالك',
    capture: 'حدد البلاصة ديالي',
    capturing: 'كنقلبو…',
  },

  pod: {
    validationTitle: 'تأكيد التسليم',
    validationDescription: 'كنصيفطو الإثبات، الفلوس اللي خديتي والكوميسيون ديالك…',
    label: 'التسليم للمستلم',
    captureProof: 'خود الإثبات',
    description: 'التوقيع، التصويرة، البلاصة ديالك والفلوس اللي خديتي ضروريين قبل الإرسال.',
    loadingPackage: 'كيتحمل الكولي…',
    deliveryMissing: 'التوصيل ماكاينش.',
    signatureRequired: 'التوقيع ضروري.',
    photoRequired: 'التصويرة ضرورية.',
    geolocationRequired: 'شعل الموقع، من بعد كليكي على «حدد البلاصة ديالي».',
    cashRequired: 'دخل الفلوس اللي خديتي.',
    cashInvalid: 'المبلغ ماشي صحيح.',
    cashExpected: 'المبلغ خاصو يكون {amount}.',
    queued: 'الإثبات تحفظ فالتيليفون وغادي يتصيفط ملي يرجع النيت.',
    synced: 'الإثبات تصيفط.',
    rejected: 'الإثبات ترفض. شوف الخانات وعاود جرب.',
    dropPhoto: 'تصويرة التسليم',
    dropPhotoHelp: 'التصويرة كتصغر فالتيليفون ومن بعد كتتصيفط.',
    cod: 'المبلغ اللي خاصك تاخد',
    cashCollection: 'الفلوس اللي خديتي',
    expectedAmount: 'المبلغ اللي خاصك تاخد: {amount}',
    noCod: 'ماكاين والو باش تاخد على هاد الكولي.',
    cashPlaceholder: 'الفلوس اللي خديتي',
    noCashPlaceholder: 'ماكاين والو باش تاخد',
    cashMismatch: 'المبلغ خاصو يكون بالضبط هو المطلوب.',
    validateDelivery: 'أكد التسليم',
    stepProof: 'الإثبات',
    stepSignature: 'التوقيع'
  },
  bulkPod: {
    podAction: 'الإثباتات ({count})',
    title: 'سلم بزاف د الكوليات',
    label: 'إثبات واحد',
    description: 'تصويرة وحدة، توقيع واحد والبلاصة ديالك لكل الكوليات اللي ختاريتي.',
    selectedSummary: 'ختاريتي {count} د الكوليات',
    proofOnce: 'نفس الإثبات غادي يتستعمل لكل كولي.',
    remove: 'حيد',
    removed: 'الكولي تحيد.',
    submit: 'أكد ({count})',
    confirmTitle: 'كيتصيفط',
    confirmDescription: 'كل كولي غادي يتسجل أنه توصل مع الإثبات ديالو.',
    resultTitle: 'الإثباتات تسجلو',
    resultSummary: 'توصلو {count} د الكوليات',
    queued: 'ماكاينش النيت: الإثباتات غادي يتصيفطو فأقرب وقت.',
    backToPackages: 'رجع للكوليات',
    reasonNotAvailable: 'هاد الكولي ماشي فاللائحة ديالك.',
    missingTargets: 'ما ختاريتي حتى كولي.'
  },
  courierEarnings: {
    title: 'الربح ديالي كليفرور',
    balance: 'الربح المؤكد',
    completed: 'الكوليات اللي توصلو هاد السيمانة',
    help: 'الربح ديال الذهاب كيتزاد ملي كارديان الوجهة يأكد الاستلام. الإرجاع ما كيتخلصش.'
  },
  profile: {
    connectedAccount: 'معلومات الحساب ديالك.',
    operationalDescription: 'بدل معلومات الخدمة ديالك.',
    actionFailed: 'ما نجحاتش',
    fullNameRequired: 'السمية ضرورية.',
    phoneInvalid: 'دخل نمرة مع كود البلاد، بحال +212600000000.',
    residenceRequired: 'ختار النقطة ديالك.',
    saved: 'البروفيل تسجل.',
    saveFailed: 'ما قدرناش نسجلو البروفيل.',
    loadFailed: 'ما قدرناش نحملو البروفيل ديالك.',
    chooseDocument: 'ختار على الأقل وثيقة وحدة باش تبدلها.',
    kycSaved: 'الوثائق تسجلو. خاص مسؤول يتأكد من الهوية ديالك من جديد.',
    kycSaveFailed: 'ما قدرناش نسجلو الوثائق.',
    kycDocuments: 'وثائق الهوية',
    editKycImages: 'بدل تصاور الوثائق',
    replaceNeededFiles: 'بدل غير الملفات اللي خاصك. أي تبديل خاصو يتراجع من جديد.',
    displayName: 'السمية اللي كتبان',
    saveName: 'سجل'
  },
  agentOnboarding: {
    chooseDocument: 'ختار على الأقل وثيقة وحدة باش تبدلها.',
    chooseName: 'دخل السمية الكاملة ديالك.',
    choosePhone: 'دخل نمرة التيليفون ديالك.',
    chooseResidence: 'ختار النقطة ديالك.',
    currentDocument: 'الوثيقة الحالية',
    currentPhoto: 'التصويرة الحالية',
    description: 'الحساب ديالك كيتسنى. غادي تقدر تستقبل الكوليات، تسكاني وتشوف الفلوس ديالك من بعد ما الفريق يقبل.',
    documentsSaved: 'الوثائق تسجلو. خاص الفريق يتأكد منهم من جديد.',
    identitySection: 'المعلومات ديالك',
    kycSaveFailed: 'ما قدرناش نسجلو الوثائق.',
    label: 'تسجيل الكارديان',
    loadFailed: 'ما قدرناش نحملو المعلومات ديالك.',
    saveFailed: 'ما قدرناش نسجلو البروفيل.',
    title: 'كمّل البروفيل ديالك',
    actionFailed: 'ما نجحاتش',
    fullName: 'السمية الكاملة',
    phone: 'التيليفون',
    preferredLanguage: 'اللغة',
    residenceZone: 'النقطة ديالك',
    validationState: 'فين وصل الملف ديالك',
    profileCompleted: 'البروفيل كامل',
    identityDocReceived: 'بطاقة التعريف توصلات',
    residenceProofReceived: 'إثبات السكنى توصل',
    photoReceived: 'التصويرة توصلات',
    kycValidated: 'الهوية تأكدات من الفريق',
    escrowRecorded: 'الضمانة تسجلات',
    saving: 'كيتسجل…',
    saveProfile: 'سجل البروفيل ديالي',
    documentsSection: 'وثائق الهوية',
    documentsDescription: 'زيد الوثائق المطلوبة ولا بدلها. أي تبديل خاص الفريق يتأكد منو من جديد.',
    identityDocument: 'بطاقة التعريف',
    proofOfResidence: 'إثبات السكنى',
    facePhoto: 'تصويرة الوجه',
    openCurrentDocument: 'شوف الوثيقة الحالية',
    noCurrentDocument: 'ماكاينة حتى وثيقة',
    openCurrentPhoto: 'شوف التصويرة الحالية',
    noCurrentPhoto: 'ماكاينة حتى تصويرة',
    saveDocuments: 'سجل الوثائق'
  },
  scanner: {
    title: 'سكاني كولي',
    hint: 'وجّه الكاميرا للـ QR ديال الكولي، ولا كتب الكود ديالو.',
    looking: 'كنقلب على الكولي…',
    notFound: 'ما كاين حتى كولي بهاد الكود عندك.',
    failed: 'ما قدرناش نتأكدو من الكود. عاود جرب.',
    again: 'سكاني كولي آخر',
    details: 'شوف الكولي',
    reportProblem: 'بلغ على مشكل',
    steps: {
      customer_handover: 'خود الكولي من الزبون',
      show_collection_code: 'بيّن الكود للليفرور',
      receive_arrival: 'استلم الكولي',
      start_delivery: 'سير وصّل',
      deliver: 'عطي الكولي للمستلم',
      deposit_return: 'خلّي الكولي المرجوع',
      return_arrived: 'الكولي عندي',
      hand_back_to_customer: 'رجّع الكولي للزبون',
      drop_off: 'خلّي الكولي عند الوكيل',
      collect_session: 'حل التجميع',
      accept_return: 'قبل هاد الرجوع',
      collect_return: 'خود الكولي المرجوع',
      confirm_sender_return: 'عطيه للمرسل'
    },
    waiting: {
      waiting_courier: 'هاد الكولي كيتسنى الليفرور.',
      coming_courier: 'الليفرور جاي بهاد الكولي.',
      delivered: 'هاد الكولي تسلّم. ما كاين ما تدير.',
      cancelled: 'هاد الكولي تلغى.',
      with_team: 'الفريق كيعالج مشكل فهاد الكولي.',
      return_in_progress: 'هاد الكولي راجع. ما خاصك تدير والو دابا.',
      nothing: 'ما كاين ما تدير فهاد الكولي دابا.'
    }
  },
  senderReturns: {
    title: 'كوليات راجعين ({count})',
    comingBack: 'الليفرور جاي بهاد الكولي. كليكي ملي يوصل عندك.',
    arrived: 'الكولي عندي',
    arrivedDone: 'الزبون تعلم. يقدر يجي ياخدو.',
    askCode: 'طلب من الزبون الكود ديالو ديال 4 د الأرقام.',
    stepCustomer: 'الزبون',
    stepProof: 'الكود والتصويرة',
    codeFirst: 'دخل كود الزبون',
    photo: 'تصويرة التسليم',
    photoHelp: 'صور الكولي، ومعاه الزبون إلا قدرتي.',
    unavailable: 'هاد الكولي ماشي واجد يرجع للزبون.',
    backToReturns: 'رجع للكولايات الراجعين',
    handBack: 'عطيه للزبون',
    handedBack: 'الكولي تسلم للزبون.',
    retry: 'عاود جرب',
    failed: 'ما تسجلش. عاود جرب.'
  },
  simpleStatus: {
    requested: 'تطلب',
    dropped_off: 'تسلم',
    on_the_way: 'فالطريق',
    delivered: 'توصل',
    returned: 'تردّ للمرسل',
    returnedHint: 'الكولي تسلمو المرسل.',
    problem: 'كاين مشكل وحنا كنحلوه',
    problemHint: 'الفريق ديالنا خدام عليه وغادي نبقاو نعلموك.',
    cancelled: 'تلغى',
    journey: 'مراحل الكولي',
    returnJourney: 'مراحل الإرجاع',
    returnRequested: 'الإرجاع تطلب',
    returnAtDestination: 'عند الكارديان',
    returnOnWay: 'راجع فالطريق',
    returnReady: 'واجد باش تاخدو',
    returnReceived: 'رجع ليك'
  },
  pageTitles: {
    pickupsShort: 'الإيداعات',
    home: 'الرئيسية',
    packages: 'الكوليات',
    packageDetail: 'الكولي',
    scan: 'استقبل كولي',
    createPackage: 'كولي جديد',
    handovers: 'اللي جاو',
    handoverDetail: 'وصول',
    pickups: 'الإيداعات',
    pickupScan: 'استلم من الزبون',
    pickupHandover: 'عطي لليفرور',
    pickupSession: 'كوليات الليفرور',
    returns: 'الإرجاعات',
    pod: 'عطي للمستلم',
    bulkPod: 'عطي بزاف د الكوليات',
    returnDeposit: 'استقبل إرجاع',
    exception: 'بلغ على مشكل',
    sync: 'صيفط المعلومات',
    wallet: 'الربح ديالي',
    profile: 'البروفيل ديالي',
    dropSessions: 'الإيداعات ديالي',
    dropSessionsShort: 'الإيداعات',
    dropSessionDetail: 'إيداع',
    drop: 'حط عند الكارديان',
    collections: 'الجمع',
    collectionDetail: 'جمع',
    returnCollect: 'خود إرجاع',
    scanner: 'سكاني',
    requests: 'الطلبات',
    requestNew: 'صيفط كولي',
    requestDetail: 'الطلب',
    dropOffs: 'الإيداعات ديالي',
    payments: 'الخلاص',
    courierMap: 'خريطة الكوليات',
    agentMap: 'خريطة الكوليات',
    back: 'رجع',
    menu: 'القائمة'
  },
  pickupRequests: {
    loadFailed: 'ما قدرناش نحملو الطلبات. عاود جرب.',
    title: 'طلبات جداد ({count})',
    customer: 'الزبون',
    goingTo: 'ل',
    call: 'عيط للزبون',
    answerBy: 'جاوب قبل {time}',
    accept: 'قبل',
    decline: 'رفض',
    declineConfirm: 'واش ترفض هاد الطلب؟ الزبون غادي يختار نقطة أخرى.',
    keep: 'خليه',
    declineYes: 'إيه، رفض',
    accepted: 'الطلب تقبل. الزبون غادي يجيب ليك الكولي.',
    declined: 'الطلب ترفض.',
    answerFailed: 'الجواب ديالك ما تصيفطش. عاود جرب.'
  },
  agentPickups: {
    deliverTo: 'فين غادي',
    clientLabel: 'الزبون',
    title: 'إيداعات الزبناء',
    subtitle: 'كوليات كيعطيوك الزبناء فيدك',
    tabIncoming: 'باش تستقبل',
    tabReady: 'باش تعطي',
    tabSessions: 'الجمع',
    incomingEmpty: 'ماكاين حتى كولي باش تستقبل',
    incomingEmptyHint: 'الزبناء غادي يبانو هنا ملي يختارو النقطة ديالك باش يحطو كولي.',
    readyEmpty: 'ماكاين حتى كولي باش تعطي',
    readyEmptyHint: 'أكد الإيداع ديال الزبون باش الكولي يتعرض على الليفرور.',
    sessionsEmpty: 'ماكاين حتى جمع',
    sessionsEmptyHint: 'الجمعات كيبانو ملي شي زبون يعطيك كولي.',
    scanTitle: 'سكاني الكوليات',
    scanStepPackages: 'الكوليات',
    scanStepPhoto: 'التصويرة',
    scanStepConfirm: 'التأكيد',
    scanHint: 'سكاني الكوليات واحد بواحد، من بعد صور قبل ما تأكد.',
    scanSelected: 'ختاريتي {count} د الكوليات',
    scanRemove: 'حيد هاد الكولي',
    scanClearAll: 'حيد الكل',
    confirmHandover: 'أكد الإيداع',
    customerPresent: 'الزبون هنا وعطاني هاد الكولي',
    signatureRequired: 'التوقيع ديال الزبون ضروري.',
    geolocationMissing: 'ما لقيناش البلاصة ديالك. شعل الموقع.',
    photoRequired: 'التصويرة ضرورية.',
    photoBatchHint: 'تصويرة وحدة كافية للكوليات كاملين.',
    parcelNotYours: 'هاد الكولي ماشي فاللائحة ديالك.',
    reasonNotPickupPackage: 'هاد الكولي ماشي من الكوليات اللي كيحطو الزبناء.',
    reasonAgentMismatch: 'هاد الكولي مربوط بنقطة أخرى.',
    reasonAlreadyPickupReady: 'هاد الكولي واجد ديجا للليفرور.',
    reasonInvalidState: 'هاد التأكيد ماشي ممكن فهاد المرحلة.',
    reasonPodRejected: 'الإثبات ترفض لهاد الكولي.',
    reasonCodeInvalid: 'الكود غالط. عاود طلبو من الزبون.',
    reasonCodeLocked: 'بزاف د الأكواد الغالطين. عاود من بعد 15 دقيقة.',
    customerCodeTitle: 'كود الزبون',
    customerCodeHint: 'طلب من الزبون الكود ديال 4 د الأرقام اللي فالتطبيق ديالو.',
    customerCodeMissing: 'دخل الكود ديال 4 د الأرقام لكل كولي.',
    notReadyForCollection: 'هاد الكولي مازال ماشي واجد للليفرور.',
    queuedOffline: 'ماكاينش النيت: التأكيد غادي يتصيفط من بعد.',
    sessionTitle: 'جمع',
    sessionReference: 'المرجع {ref}',
    sessionParcelCount: '{count} د الكوليات',
    sessionEmpty: 'ماكاين حتى كولي فهاد الجمع.',
    createSession: 'واجد الجمع',
    sessionCreated: 'الجمع واجد. وري الكود للليفرور.',
    code: 'كود التسليم',
    codeHint: 'عطي هاد الكود للليفرور. كيبقى خدام 15 دقيقة.',
    doneHint: 'الليفرور خد هاد الكوليات. ما بقا ما تدير.',
    codeCopied: 'الكود تنسخ',
    codeRefreshed: 'الكود الجديد واجد',
    codeRefreshQueued: 'الكود الجديد تحفظ. غادي يخدم ملي يرجع النيت.',
    codeExpiresAt: 'خدام 15 دقيقة',
    codeExpired: 'الكود سالا. صاوب كود جديد.',
    codeMissing: 'ماكاين حتى كود صالح',
    codeInvalid: 'كود غالط',
    codeSixDigits: 'الكود فيه 6 د الأرقام.',
    waitForCourier: 'كنتسناو الليفرور',
    showCodeToCourier: 'وري هاد الكود للليفرور',
    assignedLivreur: 'الليفرور المختار',
    livreurRequired: 'ختار الليفرور اللي غادي ياخد هاد الكوليات.',
    noActiveLivreur: 'ماكاين حتى ليفرور متاح',
    reassignLivreur: 'بدل الليفرور',
    reassignDone: 'الليفرور تبدل.',
    excludeParcel: 'حيد هاد الكولي',
    includedParcels: '{count} د الكوليات فيها',
    handoverTitle: 'إيداع الزبون',
    handoverHint: 'شوف الكولي والزبون قبل ما تأكد.',
    typeBadgePickup: 'إيداع الزبون',
    fromCustomer: 'حطو الزبون',
    tabCollected: 'اللي تجمعو',
    statusWaiting: 'كنتسناو الليفرور',
    statusCollected: 'الليفرور خداها',
    collectedEmpty: 'ماكاين حتى جمع سالا',
    collectedEmptyHint: 'الجمعات اللي سالاهم الليفرور غادي يبانو هنا.',
    parcelsNoSession: 'كوليات واجدين بلا جمع',
    openSessionHint: 'حل باش تشوف الكود',
  },
  sync: {
    synced: 'تصيفط',
    pending: 'كيتسنى',
    syncing: 'كيتصيفط',
    failed: 'الإرسال ما نجحش',
    conflict: 'مشكل خاصو يتشاف',
    conflictProofRetained: 'الإثبات باقي فهاد التيليفون. طلب المراجعة قبل ما تعاود تصيفطو.',
    inProgressRetry: 'السيرفر مازال خدام. عاود جرب من بعد شوية. الإثبات محفوظ.',
    offline: 'ماكاينش النيت',
    title: 'صيفط المعلومات',
    description: 'ملي ماكاينش النيت، العمليات ديالك كتبقى فالتيليفون وكتصيفط ملي يرجع النيت.',
    emptyQueue: 'ماكاين والو باش يتصيفط',
    syncNow: 'صيفط دابا',
  },
  wallet: {
    label: 'المحفظة ديالي',
    title: 'الفلوس ديالي',
    description: 'الرصيد ديالك، الكوميسيون وحركة الفلوس ديالك.',
    backendUnavailable: 'الخدمة ماشي متاحة',
    noBackendAgent: 'ما لقينا حتى كارديان',
    noBackendAgentDescription: 'المحفظة غادي تبان ملي يكون كاين كارديان.',
    profit: 'الربح ديالي',
    totalCommissionDescription: 'مجموع الكوميسيون اللي خدمتي على الكوليات اللي توصلو.',
    packagesCount: '{count} د الكوليات',
    noDeliveredProfit: 'مازال ما كاين ربح',
    noDeliveredProfitDescription: 'الكوميسيون ديال كل كولي توصل غادي تزاد هنا.',
    history: 'السجل',
    movements: 'الحركات',
    filters: {
      profit: 'الربح',
      cod: 'الفلوس اللي خديتي',
      withdrawal: 'السحب',
      all: 'الكل'
    },
    searchPlaceholder: 'قلب على كولي ولا نوع…',
    loadingHistory: 'كيتحمل…',
    noEntries: 'ماكاين حتى حركة',
    noEntriesDescription: 'ماكاين حتى حركة مع هاد الفلتر.',
    wallet: 'المحفظة',
    summary: 'الملخص',
    availableToSettle: 'اللي تقدر تاخد دابا',
    pendingPayout: 'كيتسنى الخلاص',
    completedThisWeek: 'اللي سالاو هاد السيمانة',
    availableFromApi: 'الرصيد المتاح',
    reservedCod: 'الفلوس اللي خاصك تاخد',
    withdrawableBalance: 'الرصيد اللي تقدر تسحب',
    deliveredWeek: 'اللي توصلو هاد السيمانة',
    statuses: {
      credited: 'تزاد',
      pending: 'كيتسنى',
      withdrawn: 'تسحب'
    },
    movementsCount: '{count} د الحركات',
    loadFailed: 'ما قدرناش نحملو المحفظة.',
    courierFinance: 'الفلوس ديالي',
    collections: 'الفلوس اللي خديتي',
    courierDescription: 'الكوميسيون والخلاصات المرتبطين بالدورات ديالك.',
      courierUnavailable: 'المحفظة قريب',
      courierUnavailableDescription: 'محفظة الليفرور ماشي متاحة باقي.',
      requestWithdrawal: 'طلب السحب',
      withdrawalAmount: 'المبلغ بالدرهم',
      withdrawalMethod: 'كيفاش تتخلص',
      withdrawalNote: 'ملاحظة (اختياري)',
      mobileWallet: 'محفظة الهاتف',
      bankTransfer: 'تحويل بنكي',
      withdrawalHelp: 'المبلغ كيتحجز دغيا. فريق 3asass كيأكد الخلاص ولا كيرفض الطلب.',
      withdrawalSubmitted: 'الطلب تصيفط. المبلغ غادي يبقى محجوز حتى يقرر الفريق.',
      withdrawalFailed: 'ما قدرناش نصيفطو طلب السحب.',
      withdrawalAmountInvalid: 'دخل مبلغ كبر من صفر.',
      withdrawalQueue: 'طلبات السحب',
      withdrawalQueueHelp: 'تأكد من المبلغ والمستفيد. باش تخلص دخل مرجع التحويل، وباش ترفض دخل السبب.',
      withdrawalQueueEmpty: 'ماكاين حتى طلب سحب.',
      withdrawalDecisionInput: 'مرجع الخلاص ولا سبب الرفض',
      withdrawalDecisionHint: 'هاد الخانة هي المرجع إلا خلصتي، والسبب إلا رفضتي.',
      markPaid: 'سجل أنه تخلص',
      rejectWithdrawal: 'رفض الطلب',
      withdrawalPaid: 'الخلاص تسجل.',
      withdrawalRejected: 'الطلب ترفض والفلوس رجعو للرصيد.',
      withdrawalStatuses: { pending: 'كيتسنى', paid: 'تخلص', rejected: 'مرفوض' }
  },
  partnerPortal: {
    balance: 'الرصيد',
    login: 'دخل',
    loginDescription: 'الدخول مخصص للشركاء اللي صاوبهم فريق 3asass.',
    loginTitle: 'دخول الشريك',
    lowCreditWarning: 'الكريدي ديالك تحت الحد الأدنى {amount}. تاصل بفريق 3asass باش يعمرو.',
    reportsDescription: 'ملخص الشهر: الكوليات، النجاح، المدد والرسوم.',
    submitDescription: 'صاوب كولي للزبون ديالك. الحساب ديالك كشريك كيتزاد بوحدو.',
    portal: 'بلاصة الشريك',
    partnerSignIn: 'دخول الشريك',
    dashboard: 'الرئيسية',
    packages: 'الكوليات',
    submitPackage: 'زيد كولي',
    creditAccount: 'الكريدي ديالي',
    reports: 'التقارير',
    profile: 'البروفيل',
    packageDetail: 'تفاصيل الكولي',
    timeline: 'التتبع',
    packageProgress: 'فين وصل الكولي',
    timelineCreatedTitle: 'الكولي تصاوب',
    timelineCreatedDescription: 'الكولي تسجل فـ 3asass وكيتسنى باش يتكلفو بيه.',
    timelineDroppedTitle: 'تحط فالنقطة',
    timelineDroppedDescription: 'الليفرور حط الكولي فالنقطة المحددة.',
    timelineReceivedTitle: 'تسلمو الكارديان',
    timelineReceivedDescription: 'الكارديان أكد أنه تسلم الكولي.',
    timelineOutTitle: 'خرج للتوصيل',
    timelineOutDescription: 'الكولي ماشي للمستلم.',
    timelineDeliveredTitle: 'توصل',
    timelineDeliveredDescription: 'الكولي توصل ومعاه إثبات التسليم.',
    timelineReturnRequestedTitle: 'الإرجاع تطلب',
    timelineReturnRequestedDescription: 'الفريق قبل طلب الإرجاع.',
    timelineReturnDepositedTitle: 'الإرجاع تحط',
    timelineReturnDepositedDescription: 'الكارديان حط الكولي الراجع وواجد باش يتاخد.',
    timelineReturnCollectedTitle: 'الإرجاع تاخد',
    timelineReturnCollectedDescription: 'الإرجاع تاخد وكيتسنى التأكيد ديالك.',
    partnerConfirmed: 'الشريك أكدو',
    returnReception: 'استلام الإرجاع',
    waitingReturnPackages: 'إرجاعات خاصها تأكيد',
    waitingReturnPackagesDescription: 'كوليات رجعو ليك وكيتسناو التأكيد ديالك.',
    confirmReturnReceived: 'أكد استلام الإرجاع',
    confirmReturnReceivedDescription: 'أكد غير من بعد ما يوصلك الكولي فيدك.',
    returnAlreadyConfirmed: 'الإرجاع تأكد من قبل',
    returnConfirmedAt: 'تأكد فـ {date}',
    returnReceiptConfirmed: 'استلام الإرجاع تأكد.',
    returnReceiptFailed: 'ما قدرناش نأكدو الاستلام.',
    noWaitingReturns: 'ماكاين حتى إرجاع باش تأكد.',
    timelinePartnerReturnReceivedTitle: 'الشريك تسلم الإرجاع',
    timelinePartnerReturnReceivedDescription: 'الشريك أكد أنه تسلم الكولي.',
    podVisibilityTitle: 'إثباتات التسليم',
    podReadyTitle: 'الإثبات كاين',
    podHiddenTitle: 'الإثبات ماكاينش باقي',
    podVisibilityDescription: 'إثباتات هاد الكولي لتحت. كليكي على واحد باش تكبرو.',
    podPendingDescription: 'الإثباتات غادي يبانو هنا بتقدم الكولي.',
    podDeliveredEmpty: 'الكولي توصل ولكن مازال ماكاين حتى إثبات.',
    podPendingEmpty: 'ماكاين حتى إثبات باقي.',
    deliveryPhoto: 'تصويرة التوصيل',
    signature: 'التوقيع',
    dropPhoto: 'تصويرة التسليم فالنقطة',
    receptionPhoto: 'تصويرة الاستلام',
    exceptionPhoto: 'تصويرة المشكل',
    requestMoreCredit: 'طلب كريدي زيادة',
    reservedFees: 'مصاريف محجوزة',
    reservedFeesDescription: 'مصاريف كوليات ما تسواوش باقي',
    available: 'المتاح',
    availableAfterFees: 'من بعد المصاريف المحجوزة',
    successToday: 'اللي نجحو اليوم',
    deliveredToday: 'توصلو {count} اليوم',
    recentPackages: 'آخر الكوليات',
    viewAll: 'شوف الكل',
    noPackagesSubmitted: 'ماكاين حتى كولي باقي.',
    quickTracking: 'تتبع سريع',
    packageReference: 'مرجع الكولي',
    track: 'تبع',
    residences: 'النقط',
    chooseFromMap: 'ختار من الخريطة',
    openRelayMapDescription: 'حل خريطة النقط قبل ما تصاوب الكولي الجاي.',
    openMap: 'حل الخريطة',
    threshold: 'الحد الأدنى',
    reservedFeesShort: 'مصاريف محجوزة',
    availableCredit: 'الكريدي المتاح',
    usableForNewPackages: 'يتستعمل للكوليات الجداد',
    topupRequest: 'طلب الشحن',
    topupDescription: 'كتب المبلغ اللي بغيتي ومن بعد دير التحويل البنكي. الفريق كيزيد الكريدي ملي كيتأكد الخلاص.',
    amountInMad: 'المبلغ بالدرهم',
    note: 'ملاحظة',
    notePlaceholder: 'مرجع التحويل، التاريخ المتوقع…',
    sendRequest: 'صيفط الطلب',
    topupSent: 'الطلب تصيفط. دير التحويل بالمرجع اللي لتحت.',
    bankTransferInstructions: 'كيفاش دير التحويل البنكي',
    beneficiary: 'المستفيد',
    reference: 'المرجع',
    validation: 'التأكيد',
    adminConfirmsPayment: 'الفريق كيأكد ملي كيوصل الخلاص.',
    searchRequests: 'قلب على طلب…',
    noTopupRequests: 'ماكاين حتى طلب شحن',
    noTopupRequestsDescription: 'طلبات الشحن ديالك غادي يبانو هنا.',
    requested: 'تطلب فـ',
    status: 'الحالة',
    adminNote: 'ملاحظة الفريق',
    creditHistory: 'سجل الكريدي',
    transactions: 'الحركات',
    creditHistoryDescription: 'الشحنات، مصاريف التوصيل والرصيد من بعد كل حركة.',
    monthlyReports: 'تقارير الشهر',
    noPackageActivity: 'ماكاينة حتى حركة د الكوليات',
    exportCsv: 'نزل بصيغة CSV',
    availableForNewPackages: 'متاح للكوليات الجداد',
    addCreditBeforePackages: 'زيد الكريدي قبل ما تصاوب كوليات خرين فيهم المصاريف.',
    creationMode: 'كيفاش تصاوب',
    onePackage: 'كولي واحد',
    excelCsvImport: 'من ملف Excel / CSV',
    normal: 'واحد بواحد',
    normalCreateHelp: 'باش تصاوب كولي واحد بيدك.',
    excelCreateHelp: 'باش تصاوب بزاف د الكوليات من ملف واجد.',
    selectedResidence: 'النقطة اللي ختاريتي',
    selectResidenceOnMap: 'ختار نقطة من الخريطة',
    selectResidenceOnMapDescription: 'كليكي على علامة باش تستعمل هاد النقطة لهاد الكولي.',
    residencesMap: 'خريطة النقط',
    availableRelayPoints: 'النقط المتاحة',
    residencesMapDescription: 'شوف النقط الخدامين فالخريطة قبل ما تختار فين تصيفط الكوليات.',
    coverage: 'المناطق اللي كنغطيو',
    gpsResidences: '{count} نقطة عندها موقع GPS.',
    selectedRelay: 'النقطة اللي ختاريتي',
    useForPackage: 'استعملها لكولي',
    submitted: 'اللي تصيفطو',
    packagesCreatedThisMonth: 'الكوليات اللي تصاوبو هاد الشهر',
    delivered: 'اللي توصلو',
    successRate: 'نسبة النجاح {rate}%',
    packagesClosedAsFailed: 'كوليات تسدو بحال فاشلين',
    averageTime: 'المدة المتوسطة',
    createdToDelivered: 'من التصاوب حتى التوصيل',
    feesCharged: 'المصاريف المحسوبة',
    partnerFeesSettledThisMonth: 'المصاريف اللي تخلصو هاد الشهر',
    loadReportFailed: 'ما قدرناش نحملو التقرير.',
    downloadReportFailed: 'ما قدرناش نزلو ملف CSV.',
    packagesThisMonthAppearHere: 'الكوليات ديال هاد الشهر غادي يبانو هنا.',
    state: 'المرحلة',
    created: 'تصاوب فـ',
    deliveredAt: 'توصل فـ',
    hours: 'الساعات',
    cod: 'المبلغ المطلوب',
    loadFailed: 'ما قدرناش نحملو البلاصة ديالك.',
    profileTitle: 'بروفيل الشريك',
    profileDescription: 'بدل معلومات الشركة، التيليفونات وكلمة السر.',
    actionFailed: 'ما نجحاتش',
    companyInfo: 'معلومات الشركة',
    saveProfile: 'سجل',
    contactCard: 'التواصل',
    portalEnabled: 'الدخول خدام',
    portalDisabled: 'الدخول موقوف',
    security: 'الأمان',
    changePassword: 'بدل كلمة السر',
    passwordDescription: 'كلمة السر خاصها تكون 12 حرف على الأقل.',
    currentPassword: 'كلمة السر الحالية',
    newPassword: 'كلمة السر الجديدة',
    confirmPassword: 'أكد كلمة السر',
    passwordsDoNotMatch: 'جوج كلمات السر ماشي بحال بحال.',
    savePassword: 'بدل كلمة السر',
    profileSaved: 'البروفيل تسجل.',
    profileSaveFailed: 'ما قدرناش نسجلو البروفيل.',
    passwordSaved: 'كلمة السر تبدلات.',
    passwordSaveFailed: 'ما قدرناش نبدلو كلمة السر.',
    myPackages: 'الكوليات ديالي',
    myPackagesDescription: 'الكوليات ديالك مع المرحلة، نقطة التسليم والمبلغ اللي خاص يتخلص.',
    dashboardDescription: 'تبع الكريدي ديالك، الكوليات اللي صيفطتي والتوصيلات اللي جارين.',
    creditDescription: 'الشحنات، الرسوم والتصحيحات فالحساب ديالك.',
    submittedToday: 'اللي تصيفطو اليوم',
    inProgress: 'جاري',
    failed: 'اللي ما نجحوش',
    creditBalance: 'رصيد الكريدي'
  },
  returns: {
    title: 'الإرجاعات',
    agentLabel: 'الكارديان',
    courierLabel: 'الليفرور',
    agentDescription: 'كوليات غادي تستقبلهم من المستلم، ولا تحطو عندك من قبل.',
    courierDescription: 'إرجاعات غادي تاخدهم من عند الكارديان، وإرجاعات تاخدو من قبل.',
    loading: 'كيتحمل…',
    empty: 'ماكاين حتى كولي راجع دابا.',
    loadFailed: 'ما قدرناش نحملو اللائحة.',
    startDeposit: 'سكاني إرجاع باش تحطو',
    startCollection: 'سكاني إرجاع باش تاخدو',
    agentDepositTitle: 'حط إرجاع',
    agentDepositProgress: 'كيتصيفطو التصاور…',
    agentDepositPageLabel: 'إرجاع عند الكارديان',
    agentDepositHeading: 'حط إرجاع',
    agentDepositDescription: 'سكاني الكولي، صور الحالة ديالو ومن بعد أكد.',
    courierCollectTitle: 'خود إرجاع',
    courierCollectProgress: 'كيتصيفطو التصاور…',
    courierCollectPageLabel: 'إرجاع الليفرور',
    courierCollectHeading: 'خود إرجاع',
    courierCollectDescription: 'سكاني الإرجاعات عند الكارديان، صور ومن بعد أكد.',
    returnPhotos: 'تصاور الإرجاع',
    returnPhotosHelp: 'ضروري. صور على الأقل تصويرة وحدة د الحالة ديال الكولي.',
    returnCollectionPhotos: 'تصاور الإرجاع اللي تاخد',
    returnCollectionPhotosHelp: 'ضروري. صور على الأقل تصويرة وحدة د الإرجاع.',
    removeFromBatch: 'حيد',
    removedFromBatch: 'الإرجاع تحيد.',
    invalidAgentReturn: 'هاد الكولي ما يمكنش يتحط كإرجاع من هاد الشاشة.',
    invalidCourierReturn: 'هاد الإرجاع ما يمكنش يتاخد من هاد الشاشة.',
    duplicateReturn: 'هاد الإرجاع كاين ديجا فاللائحة.',
    readyToDeposit: 'واجد باش يتحط.',
    readyToCollect: 'واجد باش يتاخد.',
    added: 'الإرجاع تزاد.',
    notFound: 'ما لقينا حتى كولي بهاد الكود.',
    photoRequired: 'زيد على الأقل تصويرة وحدة د الإرجاع.',
    collectionPhotoRequired: 'زيد على الأقل تصويرة وحدة د الإرجاع اللي تاخد.',
    scanAtLeastOne: 'سكاني على الأقل إرجاع واحد.',
    deliveryMissing: 'هاد الكولي ما عندو توصيل.',
    depositing: 'كيتحط…',
    collecting: 'كيتاخد…',
    queuedDeposit: 'الإرجاع تحفظ فالتيليفون وغادي يتصيفط ملي يرجع النيت.',
    queuedCollection: 'العملية تحفظات فالتيليفون وغادي تتصيفط ملي يرجع النيت.',
    deposited: 'الإرجاع تحط.',
    collected: 'الإرجاع تاخد.',
    depositRejected: 'التسليم ما تقبلش. عاود جرب.',
    collectionRejected: 'الأخذ ما تقبلش. عاود جرب.',
    rejectedCount: 'ترفضو {count} د الإرجاعات.',
    depositedCount: 'تحطو {count} د الإرجاعات.',
    collectedCount: 'تاخدو {count} د الإرجاعات.',
    depositComplete: 'الإرجاع تحط',
    collectionComplete: 'الإرجاع تاخد',
    startNewDeposit: 'حط إرجاع آخر',
    startNewCollection: 'خود إرجاع آخر',
    confirmDeposit: 'أكد التسليم',
    confirmCollection: 'أكد الأخذ',
    statusSync: 'الإرسال',
    statusDeposited: 'تحط',
    statusCollected: 'تاخد',
    statusQueued: 'ماكاينش النيت',
    statusFailed: 'خطأ',
    statusPending: 'كيتسنى',
    confirmationSummary: '{returns} إرجاع · {photos} تصويرة',
    viewDetails: 'شوف التفاصيل'
  },
  agentCreatePackage: {
    title: 'كولي جديد',
    subtitle: 'سكاني ولا كتب كود الكولي ومن بعد عمر المعلومات.',
    backToDashboard: 'الرئيسية',
    back: 'رجع',
    qrMode: 'سكاني كود QR',
    qrModeHint: 'بالكاميرا ديال التيليفون',
    textMode: 'كتب الكود',
    textModeHint: 'كتب الكود ولا لصقو',
    enterTextLabel: 'كود الكولي',
    textModePlaceholder: 'كتب الكود ولا لصقو هنا…',
    processText: 'قرا الكود',
    scannedCode: 'الكود اللي تقرا',
    copyCode: 'نسخ الكود',
    autoExtract: 'عمر بوحدو',
    trackingCode: 'نمرة التتبع',
    trackingCodePlaceholder: 'النمرة اللي تقراات',
    recipientName: 'سمية المستلم',
    recipientNamePlaceholder: 'السمية الكاملة',
    recipientPhone: 'التيليفون',
    recipientPhonePlaceholder: '+212600000000',
    recipientAddress: 'العنوان',
    recipientAddressPlaceholder: 'العنوان الكامل',
    createPackage: 'صاوب الكولي',
    creating: 'كيتصاوب…',
    success: 'الكولي تصاوب.',
    failed: 'ما قدرناش نصاوبو الكولي.',
    copied: 'تنسخ.',
    copyFailed: 'ما قدرناش ننسخو.',
    enterCode: 'دخل كود.',
    extracted: 'الخانات تعمرو.',
    extractFailed: 'ما قدرناش نعمرو الخانات. كتب السمية والتيليفون والعنوان، كل واحد فسطر.',
    validationRecipientName: 'سمية المستلم ضرورية.',
    validationRecipientPhone: 'تيليفون المستلم ضروري.',
    validationRecipientAddress: 'عنوان المستلم ضروري.',
    photoProof: 'تصويرة الكولي',
    validationPhoto: 'تصويرة الكولي ضرورية.',
    ocrCamera: 'الكاميرا',
    ocrUpload: 'تصويرة',
    ocrManual: 'كتب',
    ocrCapture: 'قرا النص',
    ocrProcessing: 'كنقراو…',
    ocrRetake: 'عاود صور',
    ocrUseText: 'استعمل هاد النص',
    ocrSelectImage: 'ختار تصويرة',
    ocrSelectImageHint: 'تصويرة د الكولي باش نقراو النص',
    ocrReupload: 'تصويرة أخرى',
    ocrManualPlaceholder: 'كتب النص ولا لصقو هنا…',
    ocrCameraInit: 'كنحلو الكاميرا…',
    ocrRetry: 'عاود جرب',
    ocrConfirmUse: 'استعمل هاد المعلومات',
    ocrTakePhoto: 'صور'
  },
  actions: {
    scan_reception: 'سكاني الكولي اللي توصل',
    confirm_reception: 'أكد التسلم',
    start_delivery: 'بدا التوصيل',
    capture_pod: 'عطي للمستلم',
    report_exception: 'بلغ على مشكل',
    request_return: 'طلب الإرجاع',
    deposit_return: 'حط الإرجاع',
    mark_en_route: 'فالطريق',
    scan_drop: 'سكاني التسليم',
    capture_lot_photo: 'تصويرة الكوليات',
    confirm_handover: 'كود الكارديان',
    close_drop: 'سالي التسليم',
    collect_return: 'خود الإرجاع',
      confirm_sender_return: 'عطيه للمرسل',
    view_pod: 'شوف الإثبات',
    open_litigation: 'حل مشكل',
    retry_by_admin: 'عاود جرب التوصيل',
    return_to_sender: 'رجعو للمرسل',
    resolve_as_delivered: 'حل: توصل',
    resolve_as_failed: 'حل: ما نجحش',
    confirm_failed: 'أكد أن ما نجحش',
    accept_damaged: 'قبل مع ملاحظة',
    clear_agent: 'عفي الكارديان',
    confirm_loss_agent_fault: 'الضياع بسبب الكارديان',
    declare_cod_loss: 'صرح بالضياع',
    cancel: 'لغي',
    run_settlement: 'بدا التسوية',
    confirm_customer_handover: 'أكد التسليم',
    create_pickup_handover: 'واجد التسليم',
    collect_pickup: 'خود'
  },
  walletEntryTypes: {
    commission_earned: 'كوميسيون ربحتي',
    cod_reserve: 'فلوس خاصك تاخد',
    cod_release: 'الفلوس اللي خديتي تحررو',
    cod_loss: 'فلوس ضاعو',
    float_topup: 'شحن الرصيد',
    platform_fee: 'رسوم 3asass',
    withdrawal_request: 'طلب سحب',
    withdrawal_paid: 'سحب تخلص',
    withdrawal_reversal: 'السحب تلغى'
  },
  user: {
    login: {
      title: 'بلاصة الزبون',
      help: 'دخل بحساب 3asass ديالك.',
      submit: 'دخول',
      no_account: 'ماعندكش حساب؟',
      signup: 'صاوب حساب'
    },
    dashboard: {
      welcome: 'سلام {name}',
      user: 'زبون',
      cards: {
        packages: {
          title: 'الكوليات ديالي',
          desc: 'تبع الكوليات ديالك بسهولة.'
        },
        tracking: {
          title: 'تتبع مباشر',
          desc: 'شوف فين وصل الكولي ديالك.'
        },
        placeholder: {
          title: 'قريب',
          desc: 'مزايا خرين قريب.'
        }
      },
      coming_soon: {
        title: 'قريب',
        desc: 'مزايا خرين قريب.'
      }
    },
    nav: {
      dashboard: 'الرئيسية',
      profile: 'البروفيل ديالي'
    },
    logout: 'خروج'
  },
  platform: {
    packages: {
      label: 'الكوليات ديالي',
      title: 'الكوليات ديالي',
      description: '{count} د الكوليات',
      empty: 'ماكاين حتى كولي باقي',
      loadFailed: 'ما قدرناش نحملو الكوليات',
      createdAt: 'تصاوب فـ',
      recipient: 'المستلم',
      relay: 'نقطة التسليم',
      relayName: 'سمية النقطة',
      relayAddress: 'عنوان النقطة',
      track: 'تبع',
      timeline: 'التتبع',
      noTimeline: 'مازال ما كاين تتبع',
      requestReturn: 'طلب الإرجاع',
      requestCancellation: 'طلب الإلغاء',
      cancelRequestTitle: 'لغي الكولي',
      cancelRequestExplainer: 'الكولي ما بقاش عندك. كنطلبو الموافقة من الفريق ومن بعد الكولي كيتردّ ليك قبل ما يتلغى.',
      cancelRequestReason: 'السبب (اختياري)',
      cancelRequestSubmit: 'صيفط الطلب',
      cancelRequestSubmitted: 'طلب الإلغاء تصيفط.',
      cancelRequestFailed: 'ما قدرناش نصيفطو الطلب.',
      cancelRequestPending: 'كنشوفو الطلب ديالك. الكولي كيكمل طريقو حتى نجاوبوك.',
      cancelRequestApproved: 'الإلغاء تقبل. الكولي راجع ليك. حل تعليمات الإرجاع باش تشوف النقطة والكود ديالك ملي يوصل الكولي.',
      cancelRequestRejected: 'الإلغاء ترفض. شوف التتبع باش تعرف فين وصل الكولي.',
      cancelRequestCompleted: 'الكولي تلغى ورجع ليك.',
      packageInfo: 'معلومات الكولي',
      city: 'المدينة',
      assignedAgent: 'الكارديان',
      trackingCode: 'كود التتبع',
    },
    label: 'المنصة',
    city: 'المدينة',
    noTimeline: 'ما كاين حتى وقتيات',
    packageInfo: 'معلومات الكولي',
    relayName: 'سمية النقطة',
    relayAddress: 'عنوان النقطة',
    requestReturn: 'طلب الإرجاع',
    timeline: 'الوقتيات',
    track: 'تبع',
    assignedAgent: 'الكارديان المكلّف',
    dashboard: {
      title: 'مساحة المنصة',
      welcome: 'سلام {name}',
      user: 'مستخدم',
      cards: {
        landing: {
          title: 'منصة 3asass',
          desc: 'الوصول للمنصة المركزية 3asass.'
        },
        placeholder: {
          title: 'قريب',
          desc: 'مزايا خرين قريب.'
        }
      },
      coming_soon: {
        title: 'قريب',
        desc: 'مزايا خرين قريب.'
      }
    },
    nav: {
      dashboard: 'الرئيسية',
      requests: 'الطلبات ديالي',
      returnRequests: 'التبليغات',
      packages: 'الكوليات',
    },
    logout: 'خروج',
    requests: {
      title: 'الطلبات ديالي',
      submitter: 'تصيفط من طرف',
      description: '{count} د الطلبات',
      newTitle: 'طلب جديد',
      newDescription: 'صيفط طلب باش كارديان يستقبل الكولي ديالك.',
      newRequest: 'طلب جديد',
      backToList: 'رجع للائحة',
      whatNext: 'وشنو من بعد؟',
      nextPending: 'كنشوفو الطلب ديالك. غادي نعلموك ملي يتقبل.',
      nextRejected: 'هاد الطلب ترفض.',
      nextConverted: 'الكولي ديالك تصاوب. تبعو لتحت.',
      nextCancelled: 'نتا لغيتي هاد الطلب.',
      keyFacts: 'المهم',
      changeDestination: 'بدل الوجهة',
      cancelRequest: 'لغي الطلب',
      deleteRequest: 'حيد الطلب',
      cancelParcel: 'لغي الكولي',
      cancelParcelBlocked: 'الكولي تسلم من قبل. ما بقاش ممكن يتلغى.',
      cancelRequestConfirmTitle: 'تلغي هاد الطلب؟',
      cancelRequestConfirmBody: 'الطلب غادي يتلغى وما غادي يتصاوب حتى كولي.',
      deleteRequestConfirmTitle: 'تحيد هاد الطلب؟',
      deleteRequestConfirmBody: 'الطلب غادي يتحيد نهائيا.',
      cancelParcelConfirmTitle: 'تلغي هاد الكولي؟',
      cancelParcelConfirmBody: 'الكولي مازال ما تحطش. غادي يتلغى.',
      confirmCancelAction: 'إيه، لغي',
      confirmDeleteAction: 'إيه، حيد',
      confirmChangeAction: 'أكد',
      outcomeCancelled: 'الطلب تلغى',
      outcomeDeleted: 'الطلب تحيد',
      outcomeParcelCancelled: 'الكولي تلغى. مازال ما كان تحط.',
      outcomeDestinationChanged: 'الوجهة تبدلات',
      changeDestinationTitle: 'الوجهة الجديدة',
      changeDestinationHint: 'ختار النقطة اللي غادي تستقبل الكولي.',
      editDetails: 'بدل المعلومات',
      changePickup: 'بدل نقطة الإيداع',
      changePickupTitle: 'نقطة الإيداع الجديدة',
      changePickupHint: 'ختار الكارديان اللي غادي تخلي عندو الكولي.',
      noAlternativePickupHint: 'ماكاينة حتى نقطة إيداع أخرى دابا. عاود من بعد ولا تاصل بينا.',
      confirmPickupAction: 'أكد هاد النقطة',
      outcomePickupChanged: 'نقطة الإيداع تبدلات',
      currentlyLabel: 'دابا',
      moreDetails: 'تفاصيل كثر',
      requestFacts: 'معلومات الطلب',
      reference: 'المرجع',
      submittedOn: 'تصيفطات فـ',
      cashOnDelivery: 'كيتخلص عند التسليم',
      relay: 'نقطة التسليم',
      zone: 'الحي',
      amountDue: 'المبلغ اللي خاصك تخلص',
      followPackage: 'تبع الكولي',
      deliveryPoint: 'نقطة التسليم',
      deliveryPointHint: 'ختار النقطة اللي بغيتي تستقبل فيها الكولي. الفريق ديالنا غادي يأكد الاختيار ديالك.',
      noResidencesHint: 'ماكاينة حتى نقطة دابا. تقدر تصيفط الطلب مع ذلك.',
      detailTitle: 'تفاصيل الطلب',
      stepHandOverTitle: 'فين غادي تحط الكولي',
      stepRecipientTitle: 'شكون غادي يستقبل الكولي',
      stepRecipientHint: 'الليفرور كيعيط على هاد النمرة قبل ما يجي. كتب العنوان كامل.',
      pickupAddress: 'العنوان ديالك',
      pickupSearchAddress: 'العنوان اللي كتقلب عليه',
      pickupAddressHint: 'اختياري. كيتستعمل باش نلقاو أقرب النقط ليك. كتحط الكولي فالنقطة اللي كتختار.',
      recipient: 'المستلم',
      recipientName: 'سمية المستلم',
      recipientPhone: 'التيليفون',
      createdAt: 'تصاوبات فـ',
      recipientAddress: 'عنوان التوصيل',
      recipientAddressHint: 'الليفرور غادي يمشي لهاد العنوان.',
      notes: 'ملاحظات',
      notesPlaceholder: 'معلومات خرى…',
      notesHint: 'اختياري: الطابق، كود العمارة، الوقت اللي بغيتي…',
      submit: 'صيفط الطلب',
      summarySelected: 'نقطة الإيداع اللي ختاريتي: {point}',
      summaryUnselected: 'ما ختاريتي حتى نقطة. غادي تتحدد ملي يتقبل الطلب.',
      created: 'الطلب تصيفط',
      createFailed: 'الطلب ما تصيفطش',
      loadFailed: 'ما قدرناش نحملو',
      rejectionReason: 'علاش تّرفض',
      convertedPackage: 'الكولي اللي تصاوب',
      viewPackage: 'شوف الكولي',
      approve: 'قبل',
      reject: 'رفض',
      approved: 'الطلب تقبل',
      rejected: 'الطلب ترفض',
      actionFailed: 'ما نجحاتش',
      approveTitle: 'قبل الطلب',
      approveDescription: 'ختار النقطة.',
      rejectTitle: 'رفض الطلب',
      rejectDescription: 'كتب علاش كترفض.',
        residence: 'النقطة (ID)',
        residencePlaceholder: 'ID ديال النقطة',
        selectResidence: 'ختار نقطة من الخريطة',
        residencesLoadFailed: 'ما قدرناش نحملو النقط',
        selectedResidenceInfo: 'النقطة اللي ختاريتي فالخريطة غادي تتربط بهاد الطلب.',
        destinationRequired: 'ختار نقطة الوجهة. بلاها ما يمكنش يتقبل الطلب.',
        customerCredit: 'الكريدي ديال الزبون',
        codAmount: 'المبلغ اللي خاص يتخلص (سنتيم)',
      codPlaceholder: '0',
      adminLabel: 'الطلبات',
      adminTitle: 'طلبات الزبناء',
      searchPlaceholder: 'قلب…',
      empty: 'ماكاين حتى طلب باقي',
      statuses: {
        pending: 'كيتسنى',
        approved: 'تقبل',
        rejected: 'ترفض',
        converted: 'الكولي تصاوب',
        cancelled: 'تلغى',
        declined: 'ختار نقطة أخرى',
      },
    },
    returnRequests: {
      title: 'التبليغات ديالي',
      description: '{count} د التبليغات',
      loadFailed: 'ما قدرناش نحملو التبليغات',
      empty: 'ماكاين حتى تبليغ باقي',
      searchPlaceholder: 'قلب بالكود، السمية، التيليفون ولا العنوان…',
      packageCode: 'الكولي',
      packageStatus: 'مرحلة الكولي',
      status: 'الجواب على التبليغ',
      requestedAt: 'تطلب فـ',
      reviewedAt: 'تجاوب فـ',
      openPackage: 'شوف الكولي',
    },
  },
  platformPickup: {
    pendingTitle: 'الإيداعات ديالي',
    pendingHint: 'تبع الكوليات اللي خاصك تحط، ولغي اللي مازال كيتسناو التأكيد ديالك.',
    chosenPoint: 'النقطة اللي ختاريتي',
    awaitingApproval: 'كيتسنى الجواب',
    filterAll: 'الكل',
    filterCancellable: 'اللي تقدر تلغي',
    listSummary: '{total} إيداع · {cancellable} تقدر تلغي',
    cancellableBadge: 'تقدر تلغي',
    agentLabel: 'الكارديان',
    noPickupsTitle: 'ماكاين حتى إيداع دابا',
    noPickupsDescription: 'الكوليات اللي خاصك تحط غادي يبانو هنا ملي تصاوب واحد.',
    noneCancellableTitle: 'ماكاين والو باش تلغي',
    cancelBlockedHint: 'ما بقاش تقدر تلغي: الكارديان تسلم الكولي من قبل.',
    backToPackages: 'شوف الكوليات ديالي',
    stepTitle: 'ختار فين غادي تحط الكولي ديالك',
    stepHint: 'كتخلي الكولي عند كارديان ومن بعد ليفرور كياخدو ويوصلو للوجهة.',
    stepLabel: 'نقطة الإيداع',
    pickPoint: 'ختار نقطة إيداع',
    changePoint: 'بدل النقطة',
    noPoints: 'ماكاينة حتى نقطة إيداع',
    noPointsHint: 'ماكاين حتى كارديان قريب من هاد العنوان كيستقبل الكوليات دابا.',
    noPointsDisabled: 'الإيداع مازال ماشي متاح.',
    searchArea: 'قلب فهاد المنطقة',
    useMyLocation: 'استعمل البلاصة ديالي',
    locating: 'كنقلبو على البلاصة ديالك…',
    locationLocated: 'لقينا البلاصة ديالك. النقط مرتبين حواليك.',
    locationUnsupported: 'المتصفح ديالك ما كيقدرش يلقى البلاصة ديالك.', locationInsecure: 'البلاصة كتخدم غير بإتصال آمن (https).',
    locationDenied: 'الوصول للبلاصة ترفض. سمح بيه ولا كتب العنوان ديالك.',
    locationTimeout: 'تحديد البلاصة ديالك دار بزاف د الوقت. عاود جرب ولا كتب العنوان ديالك.',
    mapInstruction: 'كليكي على الخريطة ولا حرك العلامة باش تبدل المنطقة.',
    radiusKm: 'فـ {distance} كم منك',
    pointDistance: 'على بعد {distance} كم',
    pointSelected: 'النقطة اللي ختاريتي',
    nearest: 'الأقرب',
    residenceOnly: 'غير فالعمارة ديالي',
    cardTitle: 'نقطة الإيداع',
    cardWaiting: 'كيتسنى عند الكارديان',
    cardReady: 'الليفرور جاي ياخدو',
    cardCollected: 'فالطريق',
    cardCancelled: 'تلغى',
    creditTitle: 'الكريدي ديالي',
    creditSubtitle: 'الكريدي كيخلص التوصيل وما كيتردّش.',
    creditBalance: 'رصيد الكريدي',
    creditAvailable: 'الكريدي اللي عندك',
    creditExposed: 'الكريدي المحجوز',
    creditThreshold: 'الحد اللي كننبهوك فيه',
    creditFeePerDelivery: '{amount} {currency} لكل توصيل',
    topupTitle: 'زيد فالكريدي',
    topupAmount: 'شحال بغيتي',
    topupAmountPlaceholder: 'المبلغ بالدرهم',
    topupNote: 'علاش بغيتي',
    topupNotePlaceholder: 'مثلا: بزاف د الكوليات هاد السيمانة',
    topupSubmit: 'طلب الشحن',
    topupHistory: 'سجل الشحن',
    topupRequests: 'طلبات الشحن ديالي',
    topupPending: 'كيتسنى',
    topupApproved: 'تقبل',
    topupRejected: 'ترفض',
    downloadCsv: 'نزّل ملف CSV',
    cancelTitle: 'لغي الطلب ديالي',
    cancelHint: 'لغي هاد الطلب قبل ما الكارديان يأكد الإيداع.',
    cancelReason: 'علاش بغيتي تلغي؟',
    cancelReasonPlaceholder: 'قولنا علاش',
    cancelSubmit: 'أكد الإلغاء',
    cancelConfirmTitle: 'أكد الإلغاء',
    cancelConfirmBody: 'الطلب ديالك غادي يتلغى وما يمكنش تراجع.',
    cancelSuccess: 'الطلب تلغى',
    insufficientCredit: 'الكريدي ديالك ما كافيش لهاد التوصيل.',
    typeOffNotice: 'هاد الخدمة ماشي متاحة لهاد النوع د الإرسال.',
  },
  residences: {
    description: 'سير النقط المتاحة باش تختار الكارديانات وتستقبل الكوليات.',
    mapDescription: 'شوف النقط فالخريطة، ختار وحدة وحل الملف ديالها.',
  },
}

function buildMessages() {
  const maOverrides = mergeMessages(arOverrides, maSpecific)
  const ar = mergeMessages(baseMessages.fr, arOverrides)
  const ma = mergeMessages(baseMessages.fr, maOverrides)
  return {
    fr: applyShortLabels('fr', { ...baseMessages.fr, activityHistory: activityHistoryMessages.fr, live: liveMessages.fr, repairs: repairMessages.fr, customer: customerMessages.fr, offline: offlineMessages.fr, homeExtra: homeExtraMessages.fr, apiErrors: apiErrorMessages.fr, console: consoleMessages.fr, pricing: pricingMessages.fr, journey: journeyMessages.fr, fieldJourney: journeyFieldMessages.fr }),
    en: applyShortLabels('en', { ...baseMessages.en, activityHistory: activityHistoryMessages.en, live: liveMessages.en, repairs: repairMessages.en, customer: customerMessages.en, offline: offlineMessages.en, homeExtra: homeExtraMessages.en, apiErrors: apiErrorMessages.en, console: consoleMessages.en, pricing: pricingMessages.en, journey: journeyMessages.en, fieldJourney: journeyFieldMessages.en }),
    ar: applyShortLabels('ar', { ...ar, activityHistory: activityHistoryMessages.ar, live: liveMessages.ar, repairs: repairMessages.ar, customer: customerMessages.ar, offline: offlineMessages.ar, homeExtra: homeExtraMessages.ar, apiErrors: apiErrorMessages.ar, console: consoleMessages.ar, pricing: pricingMessages.ar, journey: journeyMessages.ar, fieldJourney: journeyFieldMessages.ar }),
    ma: applyShortLabels('ma', toDarija({ ...ma, activityHistory: activityHistoryMessages.ma, live: liveMessages.ma, repairs: repairMessages.ma, customer: customerMessages.ma, offline: offlineMessages.ma, homeExtra: homeExtraMessages.ma, apiErrors: apiErrorMessages.ma, console: consoleMessages.ma, pricing: pricingMessages.ma, journey: journeyMessages.ma, fieldJourney: journeyFieldMessages.ma }))
  }
}

export const messages = buildMessages()
